export const PlattsData = [
	[
		"PAKI PAKI 1",
		30.169113,
		70.934628,
		"PLATTS - Refinery - Pakistan - Multan - Parco - {Mahmood Kot}",
		null,
		null,
		null,
		null,
		null,
		260.22,
		284.87,
		48.7,
		12267.53,
		52.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		73.68,
		null,
		9.92,
		3619.9,
		null,
		null,
		null,
		null,
		null,
		null,
		57.68,
		null,
		7.71,
		2814.38,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.2,
		805.52,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mubadala Investment Company",
		"40",
		null,
		"Active",
		null,
		31.87,
		17.67,
		14,
		6.99,
		2.55,
		2.7,
		39.7977023,
		22.06543457,
		17.48251748,
		8.72877123,
		3.18431568,
		3.37162837,
		75.76,
	],
	[
		"PAKI PAKI 2",
		30.169113,
		70.934628,
		"PLATTS - Refinery - United States - Meraux - Valero",
		9.73,
		10.14,
		1.33,
		485.9,
		1.39,
		420.47,
		441.32,
		58.44,
		21033.14,
		61.32,
		2.46,
		null,
		0.37,
		133.36,
		null,
		0,
		null,
		0,
		0,
		null,
		80.07,
		null,
		10.94,
		3993.03,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		16.58,
		null,
		2.16,
		786.89,
		null,
		61.03,
		null,
		8.42,
		3072.77,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		48.96,
		42.37,
		13.31,
		13.46,
		5.02,
		0.52,
		40.52980132,
		35.07450331,
		11.01821192,
		11.14238411,
		4.15562914,
		0.43046358,
		123.63,
	],
	[
		"REFMVAATS-PFR",
		45.14289,
		10.848764,
		"PLATTS - Refinery - Italy - Mantova - Air Products",
		null,
		null,
		null,
		null,
		null,
		15,
		15.87,
		15,
		15,
		15.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMVAIZI-PFR",
		45.14907,
		10.82213,
		"PLATTS - Refinery - Italy - Mantova - Italiana Energia and Servizi",
		18,
		18.89,
		2.5,
		908.83,
		2.61,
		0,
		-0.01,
		-0.01,
		-0.01,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"MOL",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMVNCCI-PFR",
		37.94125,
		-87.90944,
		"PLATTS - Refinery - United States - Mount Vernon - Countrymark Cooperative Inc.",
		null,
		null,
		null,
		null,
		null,
		89.48,
		94.12,
		12.04,
		4371.11,
		12.69,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		25.03,
		null,
		3.25,
		1188.03,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		25.03,
		null,
		3.25,
		1188.03,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Countrymark Cooperative Inc.",
		"100",
		null,
		"Active",
		null,
		7.18,
		16.07,
		0.21,
		2.31,
		-0.21,
		0,
		26.09960015,
		58.41512177,
		0.76335878,
		8.39694656,
		-0.76335878,
		0,
		25.57,
	],
	[
		"REFMYNSTM-PFR",
		32.0183,
		47.0696,
		"PLATTS - Refinery - Iraq - Maysan - Satarem",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1215.3,
		1312.25,
		729.4,
		29512.9,
		777.36,
		"Wahan_Satarem",
		"85_15",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMYRSFT-PFR",
		51.891307,
		29.321945,
		"PLATTS - Refinery - Belarus - Mozyr - Slavneft",
		27,
		29.33,
		3.52,
		1283.89,
		3.82,
		1062.74,
		1157.16,
		429.14,
		37208.15,
		461.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		180.29,
		null,
		24.85,
		9076.83,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		180.29,
		null,
		24.85,
		9076.83,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Slavneft_Belarus Government_OAO 'MOR +_Other Investors",
		"42_42_12_4",
		null,
		"Active",
		null,
		76.31,
		50.19,
		48.89,
		3.02,
		5.57,
		1.55,
		38.44719871,
		25.28718259,
		24.63220476,
		1.52156389,
		2.80632809,
		0.78093511,
		185.55,
	],
	[
		"REFMZ2ATS-PFR",
		38.0139,
		-122.1339,
		"PLATTS - Refinery - United States - Martinez (2) - Air Products",
		null,
		null,
		null,
		null,
		null,
		90,
		95.22,
		90,
		90,
		95.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMZAYPF-PFR",
		-33.067569,
		-68.970483,
		"PLATTS - Refinery - Argentina - Mendoza - YPF - {Lujan de Cuyo}",
		5,
		5.37,
		0.68,
		250,
		0.74,
		360.56,
		394.69,
		80.3,
		16688.69,
		87.21,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80.55,
		null,
		11.14,
		4066.58,
		null,
		45.2,
		49.26,
		5.98,
		2108.52,
		6.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80.55,
		null,
		11.14,
		4066.58,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF",
		"100",
		null,
		"Active",
		null,
		41.94,
		32.96,
		1.09,
		6.19,
		1.69,
		9.92,
		43.6875,
		34.33333333,
		1.13541667,
		6.44791667,
		1.76041667,
		10.33333333,
		93.79,
	],
	[
		"REFMZNNIO-PFR",
		36.3159,
		51.8969,
		"PLATTS - Refinery - Iran - Mazandaran - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		406.53,
		446.77,
		91.58,
		17763.04,
		99.64,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMZORZO-PFR",
		38.20389,
		15.26861,
		"PLATTS - Refinery - Italy - Milazzo - Raffineria Di Milazzo",
		null,
		null,
		null,
		null,
		null,
		741.56,
		777.66,
		227.65,
		30082.53,
		237.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		129,
		null,
		17.26,
		6297.14,
		null,
		null,
		null,
		null,
		null,
		null,
		5.76,
		null,
		0.76,
		280.66,
		null,
		65.74,
		null,
		8.54,
		3119.94,
		null,
		50.94,
		null,
		7.02,
		2564.7,
		null,
		6.58,
		null,
		0.9,
		331.84,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI_Kuwait Petroleum Corp.",
		"50_50",
		null,
		"Active",
		null,
		79.86,
		56.36,
		14.34,
		9.26,
		7.18,
		11.36,
		50.86624204,
		35.89808917,
		9.13375796,
		5.89808917,
		4.57324841,
		7.23566879,
		178.36,
	],
	[
		"REFNAAOYU-PFR",
		26.350687,
		127.960263,
		"PLATTS - Refinery - Japan - Naha - Okinawa Sekiyu",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNADNAD-PFR",
		45.27455,
		19.87118,
		"PLATTS - Refinery - Serbia - Novi Sad - Nis-Rafinerija Nafte Novi Sad",
		null,
		null,
		null,
		null,
		null,
		164.33,
		178.48,
		23.19,
		8262.12,
		25.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazpromneft_Petroleum Industry Of Serbia",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNAFICO-PFR",
		32.001,
		44.33,
		"PLATTS - Refinery - Iraq - Najaf - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		90.36,
		98.44,
		27.14,
		3696.55,
		29.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		20,
		null,
		2.76,
		1006.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		20,
		null,
		2.76,
		1006.9,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		6.71,
		4.86,
		7.73,
		2.43,
		1.05,
		0.68,
		26.84,
		19.44,
		30.92,
		9.72,
		4.2,
		2.72,
		23.45,
	],
	[
		"REFNALBWO-PFR",
		40.8373,
		-111.9217,
		"PLATTS - Refinery - United States - North Slaterville Canal - Big West Oil Co",
		null,
		null,
		null,
		null,
		null,
		72.29,
		76.01,
		9.65,
		3530.68,
		10.17,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		21.94,
		null,
		3.03,
		1107.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		21.94,
		null,
		3.03,
		1107.41,
		null,
		null,
		null,
		null,
		null,
		null,
		"Flying J",
		"100",
		null,
		"Active",
		null,
		9.41,
		11.76,
		1.39,
		0.33,
		-0.59,
		0,
		38.96480331,
		48.69565217,
		5.75569358,
		1.36645963,
		-2.44306418,
		0,
		22.3,
	],
	[
		"REFNAMCDL-PFR",
		10.827532,
		79.810987,
		"PLATTS - Refinery - India - Nagappattinam - Chennai Petroleum Corp. Ltd. - {Narimanam}",
		null,
		null,
		null,
		null,
		null,
		599.42,
		660.22,
		84.73,
		30154.71,
		93.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp._Other Investors_NIOC",
		"51.9_32.7_15.4",
		null,
		"Active",
		null,
		0.54,
		0,
		0.76,
		0.27,
		0.07,
		0.65,
		23.17596567,
		0,
		32.61802575,
		11.58798283,
		3.00429185,
		27.89699571,
		2.32,
	],
	[
		"REFNBONLS-PFR",
		29.8622,
		121.6204,
		"PLATTS - Refinery - China - Ningbo - Ningbo Daxie Liwan Petrochemicals",
		null,
		null,
		null,
		null,
		null,
		928.3,
		998.36,
		223.98,
		41489.95,
		239.25,
		13.5,
		null,
		2,
		732.17,
		null,
		13.5,
		null,
		2,
		731.09,
		null,
		90,
		null,
		12.7,
		4634.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		62.99,
		null,
		8.69,
		3171.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC_Liwan Group_Ningbo Beilun Power Fuel Company",
		"51_24.5_24.5",
		null,
		"Active",
		null,
		29.48,
		17.68,
		15.26,
		6.69,
		10.37,
		8.64,
		29.48,
		17.68,
		15.26,
		6.69,
		10.37,
		8.64,
		88.12,
	],
	[
		"REFNBOSEC-PFR",
		29.871043,
		121.534213,
		"PLATTS - Refinery - China - Ningbo - Sinopec",
		969,
		1036.24,
		326.49,
		37271.68,
		346.89,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNBOZSL-PFR",
		29.8622,
		121.6204,
		"PLATTS - Refinery - China - Ningbo - Zhoushan Petrochemical",
		null,
		null,
		null,
		null,
		null,
		123.01,
		134.92,
		16.73,
		6103.55,
		18.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNCGPTC-PFR",
		30.98700694,
		103.9419246,
		"PLATTS - Refinery - China - Nanchong - PetroChina",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNCOSHL-PFR",
		30.001028,
		-90.399153,
		"PLATTS - Refinery - United States - Norco - Shell",
		null,
		null,
		null,
		null,
		null,
		862.58,
		908.63,
		162.61,
		40915.49,
		171.49,
		1.53,
		null,
		0.23,
		82.84,
		null,
		0,
		null,
		0,
		0,
		null,
		179.18,
		null,
		23.37,
		8530.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0.16,
		null,
		0.02,
		7.74,
		null,
		172.13,
		null,
		22.38,
		8169.87,
		null,
		3.36,
		null,
		0.46,
		169.28,
		null,
		2,
		null,
		0.28,
		101.15,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		76.89,
		135.05,
		2.32,
		24.78,
		0.31,
		0.51,
		33.77404902,
		59.32091716,
		1.01906352,
		10.88465255,
		0.13616797,
		0.22401827,
		239.87,
	],
	[
		"REFNDTBAY-PFR",
		48.78618,
		11.75331,
		"PLATTS - Refinery - Germany - Neustadt - Bayern Oil",
		null,
		null,
		null,
		null,
		null,
		0.04,
		0.07,
		-0.03,
		3.89,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP-Amoco Corporation_ENI_PDVSA_Veba",
		"61.37_20_12.5_6.13",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNENRUE-PFR",
		-38.3695,
		-69.8323,
		"PLATTS - Refinery - Argentina - Neuquen - Refinery Comahue",
		34.02,
		37.24,
		4.56,
		1647.88,
		4.96,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Medanito_Rovella",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNESKCA-PFR",
		40.856525,
		14.308863,
		"PLATTS - Refinery - Italy - Naples - Kuwait Raff. E Chimica",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNETMRF-PFR",
		33.309713,
		-92.655486,
		"PLATTS - Refinery - United States - Norphlet - Macmillan Ring-Free Oil Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Macmillan Ring-Free Oil Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNGOVIC-PFR",
		0.2946,
		32.5413,
		"PLATTS - Refinery - Uganda - Nalukolongo - Victoria Candles",
		null,
		null,
		null,
		null,
		null,
		2.64,
		2.88,
		0.38,
		135.98,
		0.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Victoria Candles_Arabian Lubricants Company Ltd",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNGYAPA-PFR",
		5.0633,
		6.3786,
		"PLATTS - Refinery - Nigeria - Yenegoa - Azikel Petroleum Ltd., Abuja",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		22.01,
		24.11,
		2.91,
		1060.64,
		3.19,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Azikel Group",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNHAODA-PFR",
		-14.5481,
		40.6255,
		"PLATTS - Refinery - Mozambique - Nacala-a-Velha - Oilmoz LDA",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1547.35,
		1671.75,
		642.91,
		52531.43,
		678.41,
		"Oilmoz LDA",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNHIJNO-PFR",
		35.414054,
		139.653796,
		"PLATTS - Refinery - Japan - Negishi - ENEOS",
		null,
		null,
		null,
		null,
		null,
		1113.29,
		1171.62,
		490.61,
		36559.03,
		513.21,
		4.5,
		null,
		0.67,
		244.06,
		null,
		4.85,
		null,
		0.72,
		262.69,
		null,
		194.19,
		null,
		26.54,
		9686.07,
		null,
		null,
		null,
		null,
		null,
		null,
		84,
		null,
		11.23,
		4098.93,
		null,
		0,
		null,
		0,
		0,
		null,
		76.24,
		null,
		10.52,
		3838.46,
		null,
		24.6,
		null,
		3.4,
		1241.93,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		null,
		"Active",
		null,
		57.14,
		77.32,
		29.29,
		40.74,
		4.84,
		17.72,
		24.08836052,
		32.59559041,
		12.34770878,
		17.17465537,
		2.04038616,
		7.47017411,
		227.05,
	],
	[
		"REFNHKTRT-PFR",
		60.983581,
		76.4485,
		"PLATTS - Refinery - Russia - Nizhnevartovsk - TNK-Rosneft",
		null,
		null,
		null,
		null,
		null,
		43,
		47.02,
		5.73,
		2084.58,
		6.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30.7,
		null,
		4.24,
		1545.92,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30.7,
		null,
		4.24,
		1545.92,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Tyumen Oil",
		"50_50",
		null,
		"Active",
		null,
		7.1,
		3.7,
		15.2,
		2.08,
		0.62,
		1.92,
		21.84615385,
		11.38461538,
		46.76923077,
		6.4,
		1.90769231,
		5.90769231,
		30.62,
	],
	[
		"REFNIKNRY-PFR",
		69.363938,
		88.134718,
		"PLATTS - Refinery - Russia - Norilsk - Norilsk Refinery",
		null,
		null,
		null,
		null,
		null,
		2,
		2.15,
		0.27,
		100,
		0.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Norilsk Refinery",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNIYKIY-PFR",
		53.100658,
		49.895707,
		"PLATTS - Refinery - Russia - Novo-Kuybyshevskiy - Rosneft",
		null,
		null,
		null,
		null,
		null,
		738.09,
		806.49,
		225.76,
		30615.21,
		244.33,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		122.29,
		null,
		16.87,
		6156.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		122.29,
		null,
		16.87,
		6156.86,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		null,
		"Active",
		null,
		43.81,
		27.06,
		33.09,
		10.01,
		10.19,
		6.42,
		27.53960272,
		17.01030928,
		20.80085492,
		6.29243148,
		6.4055821,
		4.03570531,
		130.57,
	],
	[
		"REFNK2TAT-PFR",
		55.6413,
		51.816,
		"PLATTS - Refinery - Russia - Nizhnekamsk (2) - Tatneftegaz - {Taneco}",
		471.28,
		513.25,
		151.39,
		18756.69,
		163.46,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Taneco_Tatneftegaz_Tatarstan Government",
		"51_40_9",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNKARFT-PFR",
		42.8246,
		132.8926,
		"PLATTS - Refinery - Russia - Nakhodka - Rosneft",
		1542,
		1691.75,
		306,
		73402.34,
		333.53,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNKEIMP-PFR",
		42.835253,
		-80.049248,
		"PLATTS - Refinery - Canada - Nanticoke - Imperial Oil",
		null,
		null,
		null,
		null,
		null,
		366.72,
		385.22,
		49.18,
		17921.8,
		51.71,
		8.59,
		null,
		1.27,
		465.86,
		null,
		0,
		null,
		0,
		0,
		null,
		85.89,
		null,
		11.55,
		4214.36,
		null,
		null,
		null,
		null,
		null,
		null,
		24.82,
		null,
		3.32,
		1210.87,
		null,
		37.22,
		null,
		4.84,
		1766.71,
		null,
		0,
		null,
		0,
		0,
		null,
		15.27,
		null,
		2.12,
		770.92,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Imperial Oil",
		"69.9_30.1",
		null,
		"Active",
		null,
		22.63,
		51.24,
		1.69,
		5.77,
		-3.38,
		6.74,
		25.14444444,
		56.93333333,
		1.87777778,
		6.41111111,
		-3.75555556,
		7.48888889,
		84.71,
	],
	[
		"REFNKICHN-PFR",
		60.693611,
		-151.393611,
		"PLATTS - Refinery - United States - Nikiski - Chevron",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNKIMUM-PFR",
		60.685031,
		-151.368825,
		"PLATTS - Refinery - United States - Nikiski - Marathon Petroleum - {Kenai}",
		null,
		null,
		null,
		null,
		null,
		154.02,
		161.75,
		32.09,
		6971.38,
		33.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		55.69,
		null,
		7.68,
		2802.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0.35,
		null,
		0.05,
		16.73,
		null,
		55.34,
		null,
		7.63,
		2785.88,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tesoro",
		"100",
		null,
		"Active",
		null,
		20,
		18.47,
		12.35,
		9.11,
		1.95,
		0.65,
		29.97601918,
		27.68285372,
		18.51019185,
		13.65407674,
		2.92266187,
		0.97422062,
		62.52,
	],
	[
		"REFNLABRY-PFR",
		-12.9693,
		28.6366,
		"PLATTS - Refinery - Zambia - Ndola - Bwana Mkubwa Oil Refinery",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		180.1,
		197.62,
		23.86,
		8672.1,
		26.18,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phoenix Materials Ltd_Maysen and Borowski Claymont JV",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNLAITD-PFR",
		-13.039197,
		28.67978,
		"PLATTS - Refinery - Zambia - Ndola - Indeni Petr. Refining Co. Ltd",
		null,
		null,
		null,
		null,
		null,
		40.82,
		45.04,
		5.36,
		1960.66,
		5.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.69,
		251.72,
		null,
		19,
		21.17,
		2.52,
		920.06,
		2.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.69,
		251.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zambian Govt.",
		"100",
		0,
		"Active",
		null,
		3.02,
		2.09,
		1.29,
		0.8,
		0.06,
		0,
		37.75,
		26.125,
		16.125,
		10,
		0.75,
		0,
		7.26,
	],
	[
		"REFNLAUWN-PFR",
		-12.9693,
		28.6366,
		"PLATTS - Refinery - Zambia - Ndola - Unknown",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		180.1,
		197.61,
		23.86,
		8672.11,
		26.19,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNLEPPR-PFR",
		43.85006,
		-104.2136,
		"PLATTS - Refinery - United States - Newcastle - Par Petroleum",
		null,
		null,
		null,
		null,
		null,
		42.56,
		44.71,
		5.57,
		2034.97,
		5.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		14.72,
		null,
		1.91,
		698.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		14.72,
		null,
		1.91,
		698.86,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Par Petroleum",
		"100",
		null,
		"Active",
		null,
		6.44,
		9.21,
		0.18,
		0.2,
		-0.61,
		0,
		39.72856262,
		56.81677977,
		1.11042566,
		1.23380629,
		-3.76310919,
		0,
		15.42,
	],
	[
		"REFNLINST-PFR",
		60.44788,
		22.089968,
		"PLATTS - Refinery - Finland - Naantali - Neste Oil",
		49.02,
		51.86,
		37.06,
		778.83,
		39.21,
		0,
		0,
		-0.01,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Neste Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNLLNEW-PFR",
		34.369576,
		-118.520908,
		"PLATTS - Refinery - United States - Newhall - Newhall Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Newhall Refining Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNLSIMP-PFR",
		65.282811,
		-126.850249,
		"PLATTS - Refinery - Canada - Norman Wells - Imperial Oil",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Exxon Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNMNABN-PFR",
		58.921326,
		17.965169,
		"PLATTS - Refinery - Sweden - Nynashamn - A.B. Nynas",
		null,
		null,
		null,
		null,
		null,
		120.3,
		127.93,
		28.75,
		5736.37,
		30.53,
		14,
		null,
		2.08,
		759.28,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.36,
		859.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.28,
		100.68,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_Neste Oil",
		"50_50",
		null,
		"Active",
		null,
		2.26,
		0,
		1.28,
		0.96,
		0.08,
		2,
		12.55555556,
		0,
		7.11111111,
		5.33333333,
		0.44444444,
		11.11111111,
		6.6,
	],
	[
		"REFNNAPTC-PFR",
		12.41389,
		15.10014,
		"PLATTS - Refinery - Chad - Ndjamena - PetroChina",
		76.4,
		83.84,
		10.66,
		3892.74,
		11.7,
		44,
		48.36,
		6.15,
		2249.39,
		6.77,
		1,
		null,
		0.15,
		54.23,
		null,
		10,
		null,
		1.48,
		541.55,
		null,
		11,
		null,
		1.63,
		595.78,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PetroChina_Chad Government",
		"60_40",
		null,
		"Active",
		null,
		4.38,
		4.67,
		2.43,
		0.65,
		1.87,
		0.18,
		31.28571429,
		33.35714286,
		17.35714286,
		4.64285714,
		13.35714286,
		1.28571429,
		14.18,
	],
	[
		"REFNNGSEC-PFR",
		32.061,
		118.7916,
		"PLATTS - Refinery - China - Nanjing - Sinopec",
		1302.6,
		1398.31,
		355.27,
		55925.14,
		378.63,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNNISNL-PFR",
		5.55,
		6.5833,
		"PLATTS - Refinery - Nigeria - Ndoni - Shayaz Nigeria Ltd.",
		620.9,
		681.15,
		158.27,
		26315.09,
		173.06,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shayaz Nigeria Ltd.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNNSATS-PFR",
		30.029611,
		-89.902052,
		"PLATTS - Refinery - United States - New Orleans - Air Products",
		null,
		null,
		null,
		null,
		null,
		70,
		74.06,
		70,
		70,
		74.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNNYOEZ-PFR",
		56.10272,
		44.15423,
		"PLATTS - Refinery - Russia - Nizhny - Oao Lukoil-Nizhegorodnefteorgsintez - {Nizhny Novorod - Norsi - Kstovo}",
		null,
		null,
		null,
		null,
		null,
		1271.79,
		1394.65,
		261.28,
		59520.05,
		284.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		290,
		null,
		40,
		14600,
		null,
		191,
		209.8,
		26.99,
		9850.44,
		29.67,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		290,
		null,
		40,
		14600,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil_Other Investors",
		"86_14",
		null,
		"Active",
		null,
		82.6,
		82.55,
		66.2,
		18.95,
		-4.33,
		21.98,
		27.68653214,
		27.66977274,
		22.18944828,
		6.35181337,
		-1.45136422,
		7.36743313,
		267.94,
	],
	[
		"REFNODARO-PFR",
		58.521,
		31.2758,
		"PLATTS - Refinery - Russia - Novgorod - Avro",
		200.1,
		219.78,
		27.41,
		9970.44,
		30.08,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Avro",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNOIPTR-PFR",
		14.16653,
		108.90268,
		"PLATTS - Refinery - Vietnam - Nhon Hoi - PTT Aromatics and Refining",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1240.6,
		1373.43,
		168.72,
		61364.38,
		186.75,
		"PTT Aromatics and Refining",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNOKICE-PFR",
		55.5348,
		28.6451,
		"PLATTS - Refinery - Belarus - Novopolotsk - Interservice",
		51.03,
		55.83,
		6.81,
		2471.84,
		7.43,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Interservice",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNOKNAC-PFR",
		55.495581,
		28.53707,
		"PLATTS - Refinery - Belarus - Novopolotsk - Naftan Refining Company",
		24,
		26.95,
		3.81,
		1390.48,
		4.28,
		735.47,
		805.2,
		144.91,
		34977.93,
		157.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		146.71,
		null,
		20.24,
		7385.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		146.71,
		null,
		20.24,
		7385.93,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Belarus Government",
		"100",
		null,
		"Active",
		null,
		64.9,
		22.66,
		46.9,
		2.61,
		10.01,
		0.12,
		40.18327039,
		14.03009102,
		29.03844963,
		1.61599901,
		6.19775865,
		0.07429881,
		147.19,
	],
	[
		"REFNONPAM-PFR",
		19.341742,
		105.798087,
		"PLATTS - Refinery - Vietnam - Nghi Son - Nghi Son Refinery and Petrochemical LLC",
		null,
		null,
		null,
		null,
		null,
		809.55,
		887.22,
		245.8,
		33562.24,
		266.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		121.51,
		null,
		16.66,
		6079.45,
		null,
		625.56,
		687.48,
		88.75,
		32286.92,
		97.51,
		0,
		null,
		0,
		0,
		null,
		18.01,
		null,
		2.34,
		854.35,
		null,
		0,
		null,
		0,
		0,
		null,
		103.5,
		null,
		14.3,
		5225.1,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company_Kuwait Petroleum Corp._Petro-Vietnam_Mitsui Petrochemical",
		"35.1_35.1_25.1_4.7",
		null,
		"Active",
		28.4,
		44.95,
		52.02,
		2.03,
		7.21,
		12.08,
		0,
		33.30122981,
		38.53904282,
		1.50392651,
		5.34153208,
		8.949474,
		0,
		118.26,
	],
	[
		"REFNOUSGE-PFR",
		20.933333,
		-17.033333,
		"PLATTS - Refinery - Mauritania - Nouadhibou - Soc. Maur. Des Ind. Du Raffinage",
		32.99,
		36.38,
		4.26,
		1557.08,
		4.7,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Soc. Nat. Ind. Miniere Mauritanie",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNPEFHR-PFR",
		64.735054,
		-147.345115,
		"PLATTS - Refinery - United States - North Pole - Flint Hills Resources",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Koch Industries",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNPEPST-PFR",
		64.733284,
		-147.344816,
		"PLATTS - Refinery - United States - North Pole - Petro Star Inc.",
		null,
		null,
		null,
		null,
		null,
		17.5,
		18.25,
		2.39,
		875,
		2.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		13.6,
		null,
		1.88,
		684.91,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		13.6,
		null,
		1.88,
		684.91,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro Star Inc.",
		"100",
		null,
		"Active",
		null,
		1.76,
		0,
		0,
		4.08,
		0,
		0,
		10.79754601,
		0,
		0,
		25.03067485,
		0,
		0,
		5.84,
	],
	[
		"REFNRANKK-PFR",
		26.226963,
		127.782524,
		"PLATTS - Refinery - Japan - Nishihara - Nansei Sekiyu K.K.",
		201.45,
		213.22,
		30.22,
		9355.28,
		31.99,
		-0.01,
		0,
		0,
		-0.03,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Taiyo Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNRHNDL-PFR",
		26.580683,
		93.789088,
		"PLATTS - Refinery - India - Numaligarh - Numaligarh Refineries Ltd.",
		null,
		null,
		null,
		null,
		null,
		695.1,
		761.7,
		184.56,
		29766.46,
		199.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		53.29,
		null,
		6.93,
		2529.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		53.29,
		null,
		6.93,
		2529.38,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oil India_Government of Assam_Other Investors",
		"80.16_15.5_4.34",
		null,
		"Active",
		null,
		28.4,
		8.8,
		0.5,
		5.04,
		2.65,
		3.91,
		57.7001219,
		17.87891101,
		1.01584722,
		10.23973994,
		5.38399025,
		7.94392523,
		49.28,
	],
	[
		"REFNRIRUP-PFR",
		44.339912,
		28.64992,
		"PLATTS - Refinery - Romania - Navodari - Rompetrol Group - {Petromidia}",
		null,
		null,
		null,
		null,
		null,
		513.87,
		544.34,
		174.55,
		20026.55,
		183.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		95.51,
		null,
		12.95,
		4726.05,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		28.65,
		null,
		3.74,
		1360.04,
		null,
		66.86,
		null,
		9.22,
		3366.01,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KazMunayGaz_Romanian Government_Other Investors",
		"54.63_44.69_0.68",
		null,
		"Active",
		null,
		47.96,
		37.71,
		4.21,
		5.07,
		9.63,
		3.07,
		45.680541,
		35.91770645,
		4.00990571,
		4.82903134,
		9.17230212,
		2.92408801,
		107.65,
	],
	[
		"REFNSKRLC-PFR",
		55.0282,
		82.9235,
		"PLATTS - Refinery - Russia - Novosibirsk - Refinery Barabinskyi LLC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		225.1,
		247.89,
		30.89,
		11234.65,
		33.99,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		225.1,
		247.89,
		30.89,
		11234.65,
		33.99,
		"Novosibirsk Government",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNSYKUP-PFR",
		31.044,
		46.2576,
		"PLATTS - Refinery - Iraq - Nasiriya - Khalid Group",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		436.22,
		479.52,
		59.34,
		21575.82,
		65.14,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Total",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFNTARKK-PFR",
		37.952336,
		139.086265,
		"PLATTS - Refinery - Japan - Niigata - Rekisei Koyu K.K.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rekisei Koyu K.K.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNTASWS-PFR",
		37.948224,
		139.083571,
		"PLATTS - Refinery - Japan - Niigata - Showa-Shell Sekiyu K.K.",
		null,
		null,
		null,
		null,
		null,
		-0.04,
		-0.04,
		0,
		-0.5,
		0.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Showa Sekiyu K.K.",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNTHSTO-PFR",
		-39.074259,
		174.020214,
		"PLATTS - Refinery - New Zealand - New Plymouth - Shell Todd Oil Services Ltd",
		null,
		null,
		null,
		null,
		null,
		27,
		28.16,
		3.18,
		1159.42,
		3.31,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		27,
		null,
		3.51,
		1281.53,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		27,
		null,
		3.51,
		1281.53,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrol. Corp. N.Z._Shell_Todd",
		"68.75_18.75_12.5",
		null,
		"Active",
		null,
		5.99,
		10.33,
		0,
		4.63,
		2.45,
		3.69,
		22.18518519,
		38.25925926,
		0,
		17.14814815,
		9.07407407,
		13.66666667,
		27.09,
	],
	[
		"REFNTTWIN-PFR",
		18.138,
		-15.905,
		"PLATTS - Refinery - Mauritania - Nouakchott - Winfield Resources Limited",
		744.6,
		817.24,
		101.67,
		36894.2,
		111.62,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Winfield Resources Limited",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNVKYSI-PFR",
		47.834527,
		39.858091,
		"PLATTS - Refinery - Russia - Novoshakhtinsk - Yug Rusi",
		null,
		null,
		null,
		null,
		null,
		261.25,
		286.64,
		35.88,
		13037.91,
		39.31,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94,
		null,
		12.97,
		4732.41,
		null,
		563.9,
		612.68,
		355.27,
		12682.38,
		382.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94,
		null,
		12.97,
		4732.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yug Rusi",
		"100",
		null,
		"Active",
		null,
		26.31,
		17.56,
		23.66,
		6.27,
		5.52,
		7.43,
		26.89359092,
		17.94950424,
		24.18481039,
		6.40907697,
		5.64244097,
		7.59480732,
		86.76,
	],
	[
		"REFNWAEIA-PFR",
		5.6581,
		6.4958,
		"PLATTS - Refinery - Nigeria - Ndokwa - Energia Nigeria - {Kwale - Umuseti}",
		null,
		null,
		null,
		null,
		null,
		5,
		5.45,
		0.68,
		250,
		0.75,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		25,
		27.25,
		3.4,
		1250,
		3.75,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Energia Nigeria",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNWLERG-PFR",
		40.61091,
		-80.62969,
		"PLATTS - Refinery - United States - Newell - Ergon",
		null,
		null,
		null,
		null,
		null,
		75.84,
		79.73,
		23.93,
		3046.19,
		25.27,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		23.83,
		null,
		3.1,
		1131.13,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		23.83,
		null,
		3.1,
		1131.13,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ergon",
		"100",
		null,
		"Active",
		null,
		8.54,
		7.07,
		0,
		0,
		0.12,
		0.81,
		34.71544715,
		28.7398374,
		0,
		0,
		0.48780488,
		3.29268293,
		16.54,
	],
	[
		"REFNXNBGY-PFR",
		29.26127,
		-97.78701,
		"PLATTS - Refinery - United States - Nixon - Blue Dolphin Energy",
		15,
		15.64,
		2.05,
		750,
		2.14,
		16.49,
		17.23,
		2.23,
		813.91,
		2.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Blue Dolphin Energy",
		"100",
		null,
		"Active",
		null,
		3.01,
		0,
		2.22,
		1.34,
		0.22,
		2.9,
		24.47154472,
		0,
		18.04878049,
		10.89430894,
		1.78861789,
		23.57723577,
		9.68,
	],
	[
		"REFNYANAF-PFR",
		48.647878,
		24.584558,
		"PLATTS - Refinery - Ukraine - Nadvornaya - Naftokhimik Prykarpattia",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0,
		-0.01,
		0.59,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ukrainian State_Rommannor Investments Ltd_Weavernal Holdings Ltd_Deneiro Ventures Ltd_Dommennium Enterprices Ltd",
		"28.96_19_19_19_14.04",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFNZKTGZ-PFR",
		55.599505,
		51.967744,
		"PLATTS - Refinery - Russia - Nizhnekamsk - Tatneftegaz. - {Taneco}",
		null,
		null,
		null,
		null,
		null,
		1412.34,
		1553.35,
		382.56,
		59862.68,
		415.62,
		22,
		null,
		3.27,
		1193.16,
		null,
		0,
		null,
		0,
		0,
		null,
		205,
		null,
		28.51,
		10406.27,
		null,
		20,
		21.47,
		2.75,
		1000,
		2.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		183,
		null,
		25.24,
		9213.1,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Taneco_Tatneftegaz_Tatarstan Government",
		"51_40_9",
		null,
		"Active",
		null,
		96.76,
		57,
		24.02,
		10.4,
		5.9,
		5.85,
		46.36764424,
		27.31454859,
		11.51044662,
		4.98370711,
		2.82729538,
		2.80333525,
		199.92,
	],
	[
		"REFNZKTIF-PFR",
		55.63333,
		51.81667,
		"PLATTS - Refinery - Russia - Nizhnekamsk - TAIF",
		null,
		null,
		null,
		null,
		null,
		681.69,
		742.49,
		270.44,
		24793.41,
		291.82,
		56,
		null,
		8.32,
		3037.15,
		null,
		0,
		null,
		0,
		0,
		null,
		162,
		null,
		22.95,
		8373.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		106,
		null,
		14.63,
		5336.55,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"TAIF_Tatarstan Government",
		"75_25",
		null,
		"Active",
		null,
		66.68,
		35.95,
		9.87,
		14.01,
		7.91,
		12.87,
		39.97601918,
		21.55275779,
		5.91726619,
		8.39928058,
		4.74220624,
		7.71582734,
		147.29,
	],
	[
		"REFOAEPDA-PFR",
		43.395639,
		-79.735268,
		"PLATTS - Refinery - Canada - Oakville - Petro-Canada",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		-0.02,
		0.02,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Canada",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOCKJBC-PFR",
		55.915374,
		-4.451674,
		"PLATTS - Refinery - United Kingdom - Old Kilpatrick - J.O. Buchanan and Co Ltd.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"J.O. Buchanan and Co Ltd.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAAKNIO-PFR",
		34.008051,
		49.476779,
		"PLATTS - Refinery - Iran - Arak - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		897.36,
		988.1,
		177.35,
		42076.23,
		193.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		228.55,
		null,
		31.52,
		11506.09,
		null,
		678.64,
		741.27,
		388.45,
		17428.77,
		418.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		228.55,
		null,
		31.52,
		11506.09,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		85.67,
		69.84,
		23.46,
		15.06,
		20.81,
		14.45,
		36.45531915,
		29.71914894,
		9.98297872,
		6.40851064,
		8.85531915,
		6.14893617,
		229.3,
	],
	[
		"REFAARSRY-PFR",
		28.208183,
		-0.156123,
		"PLATTS - Refinery - Algeria - Adrar - Soralchin Oil Refinery",
		null,
		null,
		null,
		null,
		null,
		35,
		37.85,
		13.44,
		1266.83,
		14.21,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.91,
		332.24,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.91,
		332.24,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Sonatrach",
		"70_30",
		null,
		"Active",
		null,
		3.46,
		2.03,
		0.24,
		0.3,
		1.06,
		0.8,
		43.25,
		25.375,
		3,
		3.75,
		13.25,
		10,
		7.87,
	],
	[
		"REFABNNIO-PFR",
		30.349828,
		48.277978,
		"PLATTS - Refinery - Iran - Abadan - National Iranian Oil Co.",
		-250,
		-268.38,
		-34.25,
		-12500,
		-36.76,
		1569.83,
		1725.38,
		332.95,
		71960.52,
		362.76,
		72.94,
		null,
		10.84,
		3955.89,
		null,
		1,
		null,
		0.15,
		54.15,
		null,
		292.76,
		null,
		41.17,
		15026.51,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		218.82,
		null,
		30.18,
		11016.47,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		100.45,
		67.72,
		101.54,
		11.39,
		2.01,
		5.41,
		33.48333333,
		22.57333333,
		33.84666667,
		3.79666667,
		0.67,
		1.80333333,
		288.52,
	],
	[
		"REFAASGST-PFR",
		-9.6612,
		-36.6502,
		"PLATTS - Refinery - Brazil - Alagoas - Global Coast",
		10,
		10.42,
		1.36,
		500,
		1.42,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Global Coast",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFADANTD-PFR",
		5.0802,
		6.6507,
		"PLATTS - Refinery - Nigeria - Ahoada - Niger Delta Petroleum Resources Ltd - {Obgele}",
		null,
		null,
		null,
		null,
		null,
		20.81,
		22.83,
		2.74,
		996.62,
		3,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Niger Delta Petroleum Resources Ltd",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAGASAR-PFR",
		38.78353,
		26.95547,
		"PLATTS - Refinery - Turkey - Aliaga - SOCAR - {STAR}",
		null,
		null,
		null,
		null,
		null,
		787.43,
		827.59,
		280.24,
		30097.45,
		294.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		171.85,
		null,
		22.71,
		8289.94,
		null,
		null,
		null,
		null,
		null,
		null,
		59.46,
		null,
		7.95,
		2901.46,
		null,
		93.65,
		null,
		12.18,
		4445.03,
		null,
		18.74,
		null,
		2.58,
		943.46,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		77.64,
		18.03,
		3.68,
		28.56,
		8.24,
		21.95,
		44.36571429,
		10.30285714,
		2.10285714,
		16.32,
		4.70857143,
		12.54285714,
		158.1,
	],
	[
		"REFABAJOC-PFR",
		29.5267,
		35.0078,
		"PLATTS - Refinery - Jordan - Aqaba - Jordan Petroleum Refinery Co.",
		804.38,
		877.08,
		294.2,
		30530.04,
		317.69,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jordanian Govt.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAILSSF-PFR",
		27.048719,
		49.606886,
		"PLATTS - Refinery - Saudi Arabia - Al Jubail - SASREF - {Saudi Aramco Shell Refining Company}",
		null,
		null,
		null,
		null,
		null,
		1142.3,
		1247.62,
		399.4,
		43651.42,
		431.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		277.75,
		null,
		38.31,
		13983.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		277.75,
		null,
		38.31,
		13983.11,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco_Shell",
		"50_50",
		null,
		"Active",
		null,
		135.2,
		52.63,
		66.17,
		29.42,
		10.17,
		19.97,
		43.02170178,
		16.74727932,
		21.05581366,
		9.36167505,
		3.23617387,
		6.35461083,
		313.56,
	],
	[
		"REFABEKAM-PFR",
		50.2796,
		57.2125,
		"PLATTS - Refinery - Kazakhstan - Aktobe - KazMunayGaz",
		null,
		null,
		null,
		null,
		null,
		9,
		9.67,
		1.27,
		466.8,
		1.37,
		0,
		null,
		0,
		0,
		null,
		1.65,
		null,
		0.25,
		89.45,
		null,
		1.65,
		null,
		0.25,
		89.45,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KazMunayGaz",
		"100",
		null,
		"Active",
		null,
		0.43,
		0.44,
		0.54,
		0.13,
		0.11,
		0,
		22.87234043,
		23.40425532,
		28.72340426,
		6.91489362,
		5.85106383,
		0,
		1.66,
	],
	[
		"REFAADWRE-PFR",
		46.620317,
		21.760813,
		"PLATTS - Refinery - Romania - Arad - West Petrol Rafinare",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"West Petrol Rafinare",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAILSTR-PFR",
		26.95887,
		49.49757,
		"PLATTS - Refinery - Saudi Arabia - Al Jubail - SATORP - {Saudi Aramco Total Refining & Petrochemical Co}",
		null,
		null,
		null,
		null,
		null,
		2069.44,
		2250.91,
		829.04,
		73375.98,
		888.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		337.51,
		null,
		46.56,
		16991.87,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		337.51,
		null,
		46.56,
		16991.87,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco_Total",
		"62.5_37.5",
		null,
		"Active",
		null,
		186.83,
		87.15,
		11.46,
		50.93,
		15.92,
		29.28,
		48.92246458,
		22.82070753,
		3.00086412,
		13.33630103,
		4.16873969,
		7.66712928,
		381.55,
	],
	[
		"REFALXALX-PFR",
		31.049167,
		29.671081,
		"PLATTS - Refinery - Egypt - Alexandria - Alexandria Petroleum Company - {ANRPC}",
		44.7,
		49.45,
		7.34,
		2422.33,
		8.12,
		196.44,
		214.95,
		27.2,
		9550.32,
		29.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		90,
		null,
		12.41,
		4531.03,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		90,
		null,
		12.41,
		4531.03,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		21.38,
		20.08,
		19.7,
		7.14,
		1.24,
		2.18,
		28.05406115,
		26.34824826,
		25.84962603,
		9.36884923,
		1.62708306,
		2.86051699,
		71.71,
	],
	[
		"REFAAHAZR-PFR",
		32.786176,
		12.696641,
		"PLATTS - Refinery - Libya - Az Zawiyah - Azzawiya Oil Refinery Company",
		null,
		null,
		null,
		null,
		null,
		205.74,
		227.31,
		27.19,
		9920.65,
		30.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		14,
		null,
		1.82,
		664.5,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		14,
		null,
		1.82,
		664.5,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		444.85,
		488.29,
		68.45,
		21176.25,
		74.68,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		13.6,
		5.93,
		13.89,
		7.3,
		0.71,
		7.4,
		27.2,
		11.86,
		27.78,
		14.6,
		1.42,
		14.8,
		48.83,
	],
	[
		"REFAMAVRO-PFR",
		43.3771495,
		-84.6631789,
		"PLATTS - Refinery - United States - Alma - Valero",
		null,
		null,
		null,
		null,
		null,
		0.03,
		0.01,
		0,
		-0.03,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Diamond Shamrock_Ultramar",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAANTFT-PFR",
		58.6084,
		125.3882,
		"PLATTS - Refinery - Russia - Aldan - Tuimaadaneft",
		109.06,
		119.6,
		14.76,
		5367.02,
		16.17,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tuimaadaneft",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAABAPR-PFR",
		12.985842,
		42.733557,
		"PLATTS - Refinery - Eritrea - Assab - Assab Petroleum Refinery",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ethiopian Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFANOYOS-PFR",
		-19.589,
		-65.7544,
		"PLATTS - Refinery - Bolivia - Altiplano - YPF Bolivianos",
		68.04,
		74.66,
		9.07,
		3298.56,
		9.95,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF Bolivianos",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAAYKOD-PFR",
		51.172195,
		53.019411,
		"PLATTS - Refinery - Kazakhstan - Aksay - Kondensat",
		46.02,
		50.69,
		5.56,
		2023.53,
		6.13,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kondensat",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAAISEL-PFR",
		52.658746,
		84.939245,
		"PLATTS - Refinery - Russia - Altai Krai - Siberian Barrel",
		null,
		null,
		null,
		null,
		null,
		2,
		2.15,
		0.27,
		100,
		0.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		67.03,
		73.11,
		9.19,
		3343.6,
		10.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Siberian Barrel",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFACEP66-PFR",
		29.684482,
		-89.980994,
		"PLATTS - Refinery - United States - Alliance - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		14.86,
		15.74,
		2.03,
		754.58,
		2.22,
		2.12,
		null,
		0.31,
		114.8,
		null,
		0.61,
		null,
		0.09,
		33.05,
		null,
		113,
		null,
		15.2,
		5549.72,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		52.06,
		null,
		6.77,
		2471.18,
		null,
		57,
		null,
		7.86,
		2869.66,
		null,
		1.21,
		null,
		0.17,
		61.03,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		69.53,
		150.49,
		2.44,
		28.02,
		-5.97,
		1.16,
		29.15915286,
		63.11176347,
		1.02327532,
		11.75089117,
		-2.50366953,
		0.48647515,
		245.68,
	],
	[
		"REFAAMSER-PFR",
		52.403347,
		4.829411,
		"PLATTS - Refinery - Netherlands - Amsterdam - Smid En Hollander",
		null,
		null,
		null,
		null,
		null,
		23.8,
		25.37,
		3.52,
		1279.81,
		3.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Smid En Hollander",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAONNPC-PFR",
		8.8845,
		27.9579,
		"PLATTS - Refinery - South Sudan - Akon - Nilepet Corp.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		28.02,
		30.68,
		3.8,
		1374.52,
		4.12,
		"Nilepet Corp._Eyat Oilfield Services Co. Ltd.",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAAUKAM-PFR",
		43.6521,
		51.158,
		"PLATTS - Refinery - Kazakhstan - Aktau - KazMunayGaz",
		null,
		null,
		null,
		null,
		null,
		46,
		49.88,
		6.65,
		2424.1,
		7.2,
		0,
		null,
		0,
		0,
		null,
		13.51,
		null,
		2,
		731.66,
		null,
		13.51,
		null,
		2,
		731.66,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KazMunayGaz",
		"100",
		null,
		"Active",
		null,
		2.94,
		0.6,
		6.75,
		0.54,
		0.11,
		0,
		19.15309446,
		3.90879479,
		43.97394137,
		3.51791531,
		0.71661238,
		0,
		10.93,
	],
	[
		"REFAATMLH-PFR",
		39.8314,
		44.7041,
		"PLATTS - Refinery - Armenia - Ararat - Mika Limited Holding",
		null,
		null,
		null,
		null,
		null,
		3,
		3.22,
		0.43,
		158.4,
		0.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mika Limited Holding",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFARPADE-PFR",
		51.324699,
		4.289753,
		"PLATTS - Refinery - Belgium - Antwerp - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		178,
		188.32,
		178,
		178,
		188.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFABJSI2-PFR",
		5.4091,
		-4.0422,
		"PLATTS - Refinery - Ivory Coast - Abidjan - Soc. Ivoirienne De Raffinage",
		162.12,
		177.85,
		21.93,
		7954.85,
		24.05,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Soc. Ivoirienne De Raffinage_Energy Allied International_WCW International",
		"34_33_33",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFABIABO-PFR",
		24.431994,
		54.507993,
		"PLATTS - Refinery - United Arab Emirates - Abu Dhabi - Abu Dhabi Oil Refining Co",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0,
		0,
		0.28,
		-0.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		46,
		null,
		6.14,
		2243.32,
		null,
		null,
		null,
		null,
		null,
		null,
		45,
		null,
		6.01,
		2195.86,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ADNOC_ENI_OMV",
		"65_20_15",
		null,
		"Active",
		null,
		16.49,
		8.69,
		23.29,
		4.5,
		3.2,
		2.1,
		27.48333333,
		14.48333333,
		38.81666667,
		7.5,
		5.33333333,
		3.5,
		58.3,
	],
	[
		"REFADEPRY-PFR",
		-35.106282,
		138.47957,
		"PLATTS - Refinery - Australia - Adelaide - Petroleum Refineries Pty.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.03,
		0.03,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFARPBGC-PFR",
		51.33349,
		4.286127,
		"PLATTS - Refinery - Belgium - Antwerp - Belgian Refining Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.02,
		-0.01,
		0,
		3,
		null,
		0.45,
		162.7,
		null,
		0,
		null,
		0,
		0,
		null,
		24,
		null,
		3.27,
		1195.35,
		null,
		null,
		null,
		null,
		null,
		null,
		1,
		null,
		0.13,
		48.8,
		null,
		8,
		null,
		1.04,
		379.71,
		null,
		12,
		null,
		1.66,
		604.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gunvor",
		"100",
		null,
		"Active",
		null,
		24.46,
		4.66,
		20.11,
		3.9,
		3.28,
		4.42,
		37.0157385,
		7.05205811,
		30.43280872,
		5.90193705,
		4.96368039,
		6.68886199,
		60.83,
	],
	[
		"REFAB3NIO-PFR",
		30.3636,
		48.2591,
		"PLATTS - Refinery - Iran - Abadan (3) - National Iranian Oil Co.",
		678.46,
		741.37,
		170.49,
		29299.55,
		184.71,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFABJSIV-PFR",
		5.259758,
		-3.992393,
		"PLATTS - Refinery - Ivory Coast - Abidjan - Soc. Ivoirienne De Raffinage",
		5,
		6.08,
		0.79,
		292,
		0.98,
		161.76,
		178.9,
		22.14,
		8064.54,
		24.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		69.99,
		null,
		9.68,
		3533.89,
		null,
		0,
		0,
		0.08,
		25.51,
		0.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		69.99,
		null,
		9.68,
		3533.89,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nat. Petr. Ops Co. Of Ivory Coast_Total_Sonangol_Burkina Faso Govt_Other Investors",
		"48_25.35_20_5_1.65",
		null,
		"Active",
		null,
		22.89,
		14.87,
		10.5,
		17.74,
		1.08,
		0,
		32.7046721,
		21.24589227,
		15.00214316,
		25.34647807,
		1.54307758,
		0,
		67.09,
	],
	[
		"REFABLPRD-PFR",
		32.5440343,
		-99.7696979,
		"PLATTS - Refinery - United States - Abilene - Pride Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Soberbio",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFADNSUK-PFR",
		55.644689,
		-4.817562,
		"PLATTS - Refinery - United Kingdom - Ardrossan - Shell UK",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFARSEFF-PFR",
		36.736422,
		3.125781,
		"PLATTS - Refinery - Algeria - Algiers - Enterprise National De Raff - {NAFTEC - El Harrach}",
		65.18,
		71.06,
		8.46,
		3091.15,
		9.23,
		171.67,
		189.87,
		22.34,
		8130.79,
		24.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		58,
		null,
		7.54,
		2752.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		58,
		null,
		7.54,
		2752.93,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		9.75,
		4.16,
		6.42,
		1.41,
		1.5,
		3.96,
		34.82142857,
		14.85714286,
		22.92857143,
		5.03571429,
		5.35714286,
		14.14285714,
		27.2,
	],
	[
		"REFADRVRO-PFR",
		34.20329,
		-97.10675,
		"PLATTS - Refinery - United States - Ardmore - Valero",
		null,
		null,
		null,
		null,
		null,
		334.31,
		351.63,
		67.73,
		15186.29,
		71.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80.62,
		null,
		10.69,
		3901.72,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		54.55,
		null,
		7.09,
		2588.95,
		null,
		26.08,
		null,
		3.6,
		1312.77,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		29.44,
		54.09,
		0.34,
		3.49,
		-1.68,
		0,
		33.3522148,
		61.27789736,
		0.38518183,
		3.95377818,
		-1.90325139,
		0,
		85.67,
	],
	[
		"REFACKRFT-PFR",
		56.23515,
		90.418263,
		"PLATTS - Refinery - Russia - Achinsk - Rosneft",
		null,
		null,
		null,
		null,
		null,
		669.64,
		731.23,
		248.88,
		24729.05,
		268.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		129.85,
		null,
		17.91,
		6537.51,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		129.85,
		null,
		17.91,
		6537.51,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		null,
		"Active",
		null,
		41.3,
		16.26,
		33.44,
		4.25,
		3.68,
		9.86,
		32.55557307,
		12.81727889,
		26.35976667,
		3.35014977,
		2.90083557,
		7.77234747,
		108.8,
	],
	[
		"REFAESMUM-PFR",
		48.4945,
		-122.5661,
		"PLATTS - Refinery - United States - Anacortes - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		378.31,
		398.05,
		51.37,
		18741.15,
		54.06,
		8.54,
		null,
		1.27,
		462.96,
		null,
		0,
		null,
		0,
		0,
		null,
		93,
		null,
		12.33,
		4501.36,
		null,
		null,
		null,
		null,
		null,
		null,
		8.41,
		null,
		1.12,
		410.43,
		null,
		69.95,
		null,
		9.1,
		3320.25,
		null,
		1.69,
		null,
		0.23,
		85.29,
		null,
		4.41,
		null,
		0.61,
		222.44,
		null,
		352.4,
		368.48,
		48.37,
		17508.68,
		50.59,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		21.94,
		64.42,
		1.88,
		22.24,
		-5.35,
		0.83,
		19.20854491,
		56.39992996,
		1.64594642,
		19.47119594,
		-4.68394327,
		0.72666783,
		105.95,
	],
	[
		"REFASKAIL-PFR",
		56.162106,
		86.06128,
		"PLATTS - Refinery - Russia - Anzhersk - Anzherskay Oil",
		null,
		null,
		null,
		null,
		null,
		20,
		21.48,
		2.74,
		1000,
		2.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		18,
		null,
		2.34,
		854.36,
		null,
		60.06,
		66.45,
		8.07,
		2922.42,
		8.92,
		0,
		null,
		0,
		0,
		null,
		18,
		null,
		2.34,
		854.36,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Anzherskay Oil",
		"100",
		null,
		"Active",
		null,
		5.47,
		3.19,
		5.65,
		1.07,
		0,
		1.23,
		29.71211298,
		17.32753938,
		30.68984248,
		5.81205866,
		0,
		6.68115155,
		16.61,
	],
	[
		"REFACRNAG-PFR",
		5.56,
		-0.2057,
		"PLATTS - Refinery - Ghana - Accra - New Alpha Ghana Ltd. - {Prampram}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		444.28,
		488.18,
		59.72,
		21719.54,
		65.64,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ghanaian Govt._New Alpha Ghana Ltd.",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAEWEFF-PFR",
		35.809656,
		-0.259589,
		"PLATTS - Refinery - Algeria - Arzew - Enterprise National De Raff - {NAFTEC}",
		null,
		null,
		null,
		null,
		null,
		247.61,
		272.33,
		33.67,
		12270.18,
		37.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		81,
		null,
		10.57,
		3859.01,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		76,
		null,
		9.88,
		3607.28,
		null,
		5,
		null,
		0.69,
		251.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		37.9,
		21.11,
		8.04,
		4.11,
		8.77,
		-0.01,
		47.375,
		26.3875,
		10.05,
		5.1375,
		10.9625,
		-0.0125,
		79.91,
	],
	[
		"REFADYIC2-PFR",
		31.9853,
		44.9236,
		"PLATTS - Refinery - Iraq - Al Diwaniya - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		122,
		131.96,
		17.28,
		6308.7,
		18.69,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAESSSA-PFR",
		48.46646,
		-122.5592,
		"PLATTS - Refinery - United States - Anacortes - Holly-Frontier",
		null,
		null,
		null,
		null,
		null,
		510.04,
		537.19,
		70.5,
		25160.38,
		74.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		105.16,
		null,
		13.96,
		5096.77,
		null,
		null,
		null,
		null,
		null,
		null,
		35.91,
		null,
		4.8,
		1752.08,
		null,
		49.76,
		null,
		6.47,
		2361.63,
		null,
		8.07,
		null,
		1.11,
		406.31,
		null,
		11.42,
		null,
		1.58,
		576.76,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		24.05,
		78.58,
		1.62,
		22.81,
		-2.38,
		0,
		19.08881657,
		62.37002937,
		1.28581633,
		18.10461148,
		-1.88903881,
		0,
		124.67,
	],
	[
		"REFAEAJUS-PFR",
		44.45424,
		40.21619,
		"PLATTS - Refinery - Russia - Adygea - JSC Antaeus",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		330.2,
		362.16,
		45.55,
		16549.78,
		49.9,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Antei",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAESADE-PFR",
		48.467364,
		-122.555133,
		"PLATTS - Refinery - United States - Anacortes - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		15,
		15.87,
		15,
		15,
		15.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFATANIO-PFR",
		35.7566,
		51.3576,
		"PLATTS - Refinery - Iran - Anahita - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		447.02,
		491.15,
		60.77,
		22169.98,
		66.7,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAILNMC-PFR",
		27.06023,
		49.565338,
		"PLATTS - Refinery - Saudi Arabia - Al Jubail - National Methanol Co. - {Ibn Sina}",
		null,
		null,
		null,
		null,
		null,
		21,
		22.55,
		2.48,
		906.03,
		2.67,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC_Hoeschst Celanese_Texas Eastern",
		"50_25_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAGKRFT-PFR",
		52.515512,
		103.92894,
		"PLATTS - Refinery - Russia - Angarsk - Rosneft",
		null,
		null,
		null,
		null,
		null,
		849.03,
		930.34,
		156.65,
		40464.95,
		170.73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		170,
		null,
		23.45,
		8558.62,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		170,
		null,
		23.45,
		8558.62,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Other Investors",
		"80_20",
		null,
		"Active",
		null,
		58.02,
		41.54,
		28.91,
		12.27,
		8.95,
		10.11,
		32.37361902,
		23.17821672,
		16.13101216,
		6.84633411,
		4.99386229,
		5.64111148,
		159.79,
	],
	[
		"REFAUTAOR-PFR",
		31.002843,
		29.844283,
		"PLATTS - Refinery - Egypt - Asyut - Asyut Oil Refining Company",
		80,
		87.17,
		11.38,
		4154.08,
		12.4,
		336.93,
		369.52,
		124.24,
		12463.58,
		135.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		52,
		null,
		7.17,
		2617.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		52,
		null,
		7.17,
		2617.93,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		9.97,
		9.88,
		15.11,
		3.87,
		1.13,
		1.09,
		24.10541586,
		23.88781431,
		36.53288201,
		9.35686654,
		2.73210832,
		2.63539652,
		41.06,
	],
	[
		"REFAIAHER-PFR",
		32.84633,
		-104.3937,
		"PLATTS - Refinery - United States - Artesia - Holly-Frontier",
		null,
		null,
		null,
		null,
		null,
		349.93,
		367.85,
		54.73,
		16647.93,
		57.61,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		100.45,
		null,
		13.63,
		4974.67,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		28.67,
		null,
		3.73,
		1360.64,
		null,
		71.79,
		null,
		9.9,
		3614.04,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Holly-Frontier",
		"100",
		null,
		"Active",
		null,
		47,
		61.37,
		2.62,
		0,
		-5.55,
		0,
		41.77406453,
		54.54626255,
		2.32868189,
		0,
		-4.93289485,
		0,
		105.45,
	],
	[
		"REFAGECPS-PFR",
		61.2163,
		-149.8949,
		"PLATTS - Refinery - United States - Anchorage - ConocoPhillips",
		null,
		null,
		null,
		null,
		null,
		14,
		14.6,
		1.91,
		700,
		2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		11.1,
		null,
		1.53,
		558.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		11.1,
		null,
		1.53,
		558.86,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips Petroleum",
		"100",
		null,
		"Active",
		null,
		2.46,
		2.95,
		5.34,
		1.19,
		0.18,
		0.11,
		18.4962406,
		22.18045113,
		40.15037594,
		8.94736842,
		1.35338346,
		0.82706767,
		12.23,
	],
	[
		"REFAILSAF-PFR",
		27.059887,
		49.594028,
		"PLATTS - Refinery - Saudi Arabia - Al Jubail - Saudi Petroch. Co Sadaf",
		null,
		null,
		null,
		null,
		null,
		21,
		22.54,
		2.48,
		906.02,
		2.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC_Shell",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAKNGOM-PFR",
		46.774771,
		48.107099,
		"PLATTS - Refinery - Russia - Astrakhan - Gazprom - {Astrahan}",
		null,
		null,
		null,
		null,
		null,
		273.75,
		299.01,
		32.83,
		11924.46,
		35.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		39,
		null,
		5.07,
		1851.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		39,
		null,
		5.07,
		1851.11,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom",
		"100",
		0,
		"Active",
		null,
		6.99,
		16.15,
		1.86,
		2.7,
		0.68,
		10.98,
		17.50563486,
		40.44578012,
		4.65815177,
		6.76183321,
		1.70298022,
		27.49812171,
		39.36,
	],
	[
		"REFBASPDV-PFR",
		8.1667,
		-69.8333,
		"PLATTS - Refinery - Venezuela - Barinas - PDVSA",
		391.65,
		429.68,
		70.94,
		19100.65,
		77.44,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		551.65,
		599.89,
		179.15,
		22200.65,
		192.06,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAILSEO-PFR",
		27.065225,
		49.573262,
		"PLATTS - Refinery - Saudi Arabia - Al Jubail - Saudi-Eur. Petroch. Co",
		null,
		null,
		null,
		null,
		null,
		42.02,
		45.12,
		4.97,
		1813.36,
		5.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC_Arab Petroleum Investment Corp_ENI_Fortum",
		"70_10_10_10",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAHIILL-PFR",
		34.974909,
		136.834996,
		"PLATTS - Refinery - Japan - Aichi - Idemitsu Showa Shell - {Idemitsu Kosan Company}",
		null,
		null,
		null,
		null,
		null,
		474.97,
		501.93,
		117.2,
		20808.76,
		123.95,
		0.1,
		null,
		0.01,
		5.25,
		null,
		2.01,
		null,
		0.3,
		108.82,
		null,
		108.95,
		null,
		14.77,
		5391.97,
		null,
		null,
		null,
		null,
		null,
		null,
		56,
		null,
		7.49,
		2732.62,
		null,
		5.22,
		null,
		0.68,
		247.71,
		null,
		42.63,
		null,
		5.88,
		2146.12,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company",
		"100",
		null,
		"Active",
		null,
		44.17,
		46.27,
		5.77,
		23.81,
		-2.44,
		13.87,
		33.14324304,
		34.71899152,
		4.32955654,
		17.86598634,
		-1.83086966,
		10.40744354,
		131.46,
	],
	[
		"REFBDERAD-PFR",
		44.85435,
		20.53171,
		"PLATTS - Refinery - Serbia - Belgrade - Rafinerija Nafte Beograd",
		null,
		null,
		null,
		null,
		null,
		1.6,
		1.75,
		0.22,
		81.3,
		0.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rafinerija Nafte Beograd",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAJIAOC-PFR",
		28.407133,
		48.534223,
		"PLATTS - Refinery - Saudi Arabia - Al Khafji - Arabian Oil Co., Ltd",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Arabian Oil Co., Ltd",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALTEXM-PFR",
		-37.849479,
		144.848728,
		"PLATTS - Refinery - Australia - Altona - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		-0.03,
		0,
		0.03,
		-0.02,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		72,
		null,
		9.38,
		3425.42,
		null,
		null,
		null,
		null,
		null,
		null,
		6,
		null,
		0.8,
		292.78,
		null,
		66,
		null,
		8.58,
		3132.64,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		25.37,
		40.48,
		0.55,
		13.11,
		2.83,
		0,
		30.56626506,
		48.77108434,
		0.6626506,
		15.79518072,
		3.40963855,
		0,
		82.35,
	],
	[
		"REFAIRSTH-PFR",
		44.9994,
		41.1294,
		"PLATTS - Refinery - Russia - Armavir - South Oil Company",
		30,
		32.21,
		4.11,
		1500,
		4.41,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"South Oil Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAJUSRE-PFR",
		-10.9162,
		-37.0775,
		"PLATTS - Refinery - Brazil - Aracaju - South Atlantic Refining",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		632.4,
		662.72,
		221.3,
		24209.56,
		232.46,
		"South Atlantic Refining",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFALXEGP-PFR",
		31.199,
		29.8944,
		"PLATTS - Refinery - Egypt - Alexandria - EGPC",
		778.5,
		853.35,
		240.6,
		31215.52,
		262.87,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALXECO-PFR",
		31.098297,
		29.863109,
		"PLATTS - Refinery - Egypt - Alexandria - El Ameriyah Oil Refining Co",
		null,
		null,
		null,
		null,
		null,
		178.37,
		196.81,
		23.78,
		8672.24,
		26.21,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		8.28,
		3020.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		8.28,
		3020.69,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		15.03,
		12.48,
		9.83,
		5.14,
		1.87,
		1.42,
		27.21347094,
		22.59641499,
		17.79829803,
		9.3065363,
		3.38584103,
		2.57106645,
		45.76,
	],
	[
		"REFAKYFST-PFR",
		44.883372,
		38.82376,
		"PLATTS - Refinery - Russia - Afipsky - ForteInvest",
		null,
		null,
		null,
		null,
		null,
		724.34,
		791.77,
		195.59,
		30823.89,
		211.89,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		106,
		null,
		14.62,
		5336.55,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		106,
		null,
		14.62,
		5336.55,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SAFMAR Group_Sberbank",
		"92_8",
		null,
		"Active",
		null,
		33.38,
		11.34,
		40.93,
		3.7,
		2.9,
		7.28,
		30.4007286,
		10.32786885,
		37.27686703,
		3.36976321,
		2.64116576,
		6.63023679,
		99.52,
	],
	[
		"REFALAYOM-PFR",
		14.6711,
		48.9199,
		"PLATTS - Refinery - Yemen - Al Mukalla - Yemen Oil and Minerals Corp.",
		227.6,
		250.65,
		29.29,
		10691.25,
		32.23,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yemen Oil and Minerals Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAMLICO-PFR",
		36.1676,
		42.5825,
		"PLATTS - Refinery - Iraq - Al Mawsil - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		6.1,
		6.55,
		0.86,
		314.24,
		0.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALSCSA-PFR",
		36.186469,
		-5.396139,
		"PLATTS - Refinery - Spain - Algeciras - Cepsa - {San Roque}",
		null,
		null,
		null,
		null,
		null,
		891.7,
		936.6,
		308.96,
		34411.74,
		324.08,
		12.54,
		null,
		1.87,
		679.65,
		null,
		0,
		null,
		0,
		0,
		null,
		196.33,
		null,
		26.42,
		9642.17,
		null,
		null,
		null,
		null,
		null,
		null,
		5.85,
		null,
		0.78,
		285.37,
		null,
		98.58,
		null,
		12.82,
		4679.12,
		null,
		62.66,
		null,
		8.65,
		3154.51,
		null,
		16.71,
		null,
		2.31,
		843.53,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mubadala Investment Company",
		"95.89",
		null,
		"Active",
		null,
		96.29,
		47.27,
		33.1,
		39.95,
		4.33,
		5.41,
		40.97446809,
		20.11489362,
		14.08510638,
		17,
		1.84255319,
		2.30212766,
		226.33,
	],
	[
		"REFANDICO-PFR",
		34.317547,
		45.399628,
		"PLATTS - Refinery - Iraq - Alwand - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALSMEL-PFR",
		36.1311,
		-5.4487,
		"PLATTS - Refinery - Spain - Algeciras - Magtel",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		357.2,
		374.48,
		48.64,
		17685.5,
		51.02,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"National Iranian Oil Co._Magtel",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFANEAMI-PFR",
		38.937569,
		45.659388,
		"PLATTS - Refinery - Iran - Aras Free Zone - Aras Shimi",
		null,
		null,
		null,
		null,
		null,
		2.7,
		2.94,
		0.36,
		129.46,
		0.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Aras Shimi",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFANEATA-PFR",
		38.9302,
		45.6326,
		"PLATTS - Refinery - Iran - Aras Free Zone - Agri Tejarat Aras Co.",
		null,
		null,
		null,
		null,
		null,
		15.41,
		16.9,
		2.11,
		764.87,
		2.3,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Agri Tejarat Aras Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFARAOLC-PFR",
		6.2183,
		6.9532,
		"PLATTS - Refinery - Nigeria - Anambra - Orient Refining and Petroch. PLC",
		103.5,
		113.51,
		13.68,
		4994.3,
		15.01,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Orient Refining and Petroch. PLC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFARCPTS-PFR",
		-25.567631,
		-49.358206,
		"PLATTS - Refinery - Brazil - Araucaria - Petrobras - {REPAR - Presidente Getulio Vargas}",
		null,
		null,
		null,
		null,
		null,
		631.42,
		664.44,
		114.14,
		30277.3,
		120.27,
		71.62,
		null,
		10.64,
		3884.48,
		null,
		0,
		null,
		0,
		0,
		null,
		168.6,
		null,
		23.58,
		8605.44,
		null,
		20,
		21.16,
		2.79,
		1016.71,
		2.95,
		0,
		null,
		0,
		0,
		null,
		56.24,
		null,
		7.31,
		2669.2,
		null,
		35.8,
		null,
		4.94,
		1802.4,
		null,
		4.94,
		null,
		0.68,
		249.36,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		74.33,
		43.61,
		12.95,
		10.38,
		13.46,
		7.02,
		44.08659549,
		25.86595492,
		7.68090154,
		6.15658363,
		7.98339265,
		4.16370107,
		161.75,
	],
	[
		"REFAREEET-PFR",
		59.3057,
		27.9362,
		"PLATTS - Refinery - Estonia - Auvere - Eesti Energia",
		50.03,
		54.2,
		13.8,
		2113.57,
		14.89,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Eesti Energia",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFARPTEN-PFR",
		51.268782,
		4.323012,
		"PLATTS - Refinery - Belgium - Antwerp - Total Fina Raff. Antwerpen",
		null,
		null,
		null,
		null,
		null,
		1366.66,
		1437.62,
		299.13,
		63092.07,
		313.75,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		270,
		null,
		35.81,
		13070.63,
		null,
		3,
		3.17,
		0.42,
		152.51,
		0.44,
		4,
		null,
		0.53,
		195.19,
		null,
		180,
		null,
		23.41,
		8543.56,
		null,
		70,
		null,
		9.66,
		3524.14,
		null,
		16,
		null,
		2.21,
		807.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		157.78,
		63.07,
		17.67,
		19.83,
		19.03,
		28.81,
		49.15417926,
		19.64858718,
		5.50484439,
		6.17776255,
		5.9285336,
		8.97535749,
		306.19,
	],
	[
		"REFANYCBO-PFR",
		42.6239466,
		-73.7594146,
		"PLATTS - Refinery - United States - Albany - Cirillo Brothers Oil Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cirillo Brothers Oil Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFARPVO2-PFR",
		51.25175,
		4.364862,
		"PLATTS - Refinery - Belgium - Antwerp - Vitol",
		null,
		null,
		null,
		null,
		null,
		0.03,
		0.03,
		0.03,
		0.03,
		0.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroplus",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFARPEXM-PFR",
		51.25546,
		4.339846,
		"PLATTS - Refinery - Belgium - Antwerp - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		1321.6,
		1387.29,
		584.02,
		43679.86,
		611.32,
		15,
		null,
		2.23,
		813.52,
		null,
		0,
		null,
		0,
		0,
		null,
		244,
		null,
		33.59,
		12258.95,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		29,
		null,
		3.77,
		1376.46,
		null,
		200,
		null,
		27.59,
		10068.97,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		111.96,
		40.44,
		52.59,
		17.75,
		13.16,
		29.85,
		37.19601329,
		13.43521595,
		17.4717608,
		5.89700997,
		4.37209302,
		9.91694352,
		265.75,
	],
	[
		"REFAOSHEL-PFR",
		38.033355,
		23.604769,
		"PLATTS - Refinery - Greece - Aspropirgos - Hellenic Petroleum",
		null,
		null,
		null,
		null,
		null,
		595.69,
		627.15,
		87.96,
		28885.85,
		92.64,
		1,
		null,
		0.15,
		54.23,
		null,
		0,
		null,
		0,
		0,
		null,
		118.22,
		null,
		15.77,
		5754.88,
		null,
		null,
		null,
		null,
		null,
		null,
		7,
		null,
		0.94,
		341.58,
		null,
		66,
		null,
		8.58,
		3132.64,
		null,
		44.22,
		null,
		6.1,
		2226.43,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hellenic Petroleum",
		"100",
		null,
		"Active",
		null,
		53.55,
		46.19,
		26.8,
		19.87,
		14.27,
		8,
		37.71126761,
		32.52816901,
		18.87323944,
		13.99295775,
		10.04929577,
		5.63380282,
		168.67,
	],
	[
		"REFARPVOL-PFR",
		51.25175,
		4.364862,
		"PLATTS - Refinery - Belgium - Antwerp - Vitol",
		null,
		null,
		null,
		null,
		null,
		69,
		73.74,
		10.34,
		3778.64,
		11.06,
		7,
		null,
		1.04,
		379.64,
		null,
		0,
		null,
		0,
		0,
		null,
		9,
		null,
		1.32,
		480.33,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.28,
		100.69,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Fortum_PDVSA",
		"50_50",
		null,
		"Active",
		null,
		3.81,
		0.41,
		2.45,
		0.76,
		0.22,
		0.7,
		31.75,
		3.41666667,
		20.41666667,
		6.33333333,
		1.83333333,
		5.83333333,
		8.35,
	],
	[
		"REFASHEPC-PFR",
		10.8319,
		40.4503,
		"PLATTS - Refinery - Ethiopia - Awash - Ethiopian Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		382,
		420.1,
		53.12,
		19021.84,
		58.44,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ethiopian Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFASWIC2-PFR",
		31.3079,
		45.2827,
		"PLATTS - Refinery - Iraq - As Samawah - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		154,
		169.44,
		21.73,
		7569.27,
		23.88,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFATEGDY-PFR",
		31.18158,
		-87.43998,
		"PLATTS - Refinery - United States - Atmore - Goodway Refining",
		null,
		null,
		null,
		null,
		null,
		5,
		5.21,
		0.68,
		250,
		0.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.59,
		null,
		0.34,
		122.82,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		2.59,
		null,
		0.34,
		122.82,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Goodway Refining",
		"100",
		null,
		"Active",
		null,
		0.79,
		0.12,
		0.19,
		0.12,
		0,
		0.48,
		33.19327731,
		5.04201681,
		7.98319328,
		5.04201681,
		0,
		20.16806723,
		1.7,
	],
	[
		"REFAUASCH-PFR",
		37.212358,
		15.170354,
		"PLATTS - Refinery - Italy - Augusta - Sonatrach",
		null,
		null,
		null,
		null,
		null,
		509.45,
		535.52,
		70.82,
		25764.49,
		74.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		158,
		null,
		21.1,
		7699.8,
		null,
		null,
		null,
		null,
		null,
		null,
		25.08,
		null,
		3.35,
		1223.79,
		null,
		75.24,
		null,
		9.78,
		3571.12,
		null,
		51.41,
		null,
		7.09,
		2588.36,
		null,
		6.27,
		null,
		0.87,
		316.53,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		41.58,
		43.69,
		17.67,
		6.96,
		1.17,
		10.41,
		33,
		34.67460317,
		14.02380952,
		5.52380952,
		0.92857143,
		8.26190476,
		121.46,
	],
	[
		"REFAT2KAM-PFR",
		47.1053,
		51.9245,
		"PLATTS - Refinery - Kazakhstan - Atyrau (2) - KazMunayGaz",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		498.24,
		547.7,
		67.42,
		24523.7,
		74.06,
		"China National Petroleum Corp._KazMunayGaz",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFATYTOT-PFR",
		37.0460077,
		-97.0199019,
		"PLATTS - Refinery - United States - Arkansas City - Total",
		null,
		null,
		null,
		null,
		null,
		0,
		0.02,
		0.01,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFATUKAM-PFR",
		47.073149,
		51.924234,
		"PLATTS - Refinery - Kazakhstan - Atyrau - KazMunayGaz",
		null,
		null,
		null,
		null,
		null,
		488.36,
		537.38,
		107.59,
		22198.01,
		117.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		87.01,
		null,
		11.32,
		4129.87,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		87.01,
		null,
		11.32,
		4129.87,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KazMunayGaz_Other Investors",
		"99.3_0.7",
		null,
		"Active",
		null,
		33.31,
		19.72,
		32.42,
		0.43,
		5.76,
		0.34,
		33.69070497,
		19.94538283,
		32.79053302,
		0.43491453,
		5.8258319,
		0.34388591,
		91.98,
	],
	[
		"REFAUIPDV-PFR",
		10.06284,
		-64.86238,
		"PLATTS - Refinery - Venezuela - Anzoategui - PDVSA",
		315.41,
		345.7,
		46.72,
		16170.23,
		51.11,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_Lukoil",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAURAEC-PFR",
		52.6638,
		126.0452,
		"PLATTS - Refinery - Russia - Amur - Amur Energy Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		413.58,
		454.09,
		56.07,
		20399.21,
		61.53,
		"Amur Energy Co._Menglan Galaxy Energy",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAZRKNP-PFR",
		28.71949,
		48.29558,
		"PLATTS - Refinery - Kuwait - Al-Zour - Kuwait National Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		2188,
		2395.33,
		802.78,
		80796.91,
		868.19,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		130,
		139.56,
		17.81,
		6500,
		19.12,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAZRPNY-PFR",
		28.7127,
		48.3364,
		"PLATTS - Refinery - Kuwait - Al-Zour - Petrochemical Industries Company",
		726.4,
		797.95,
		99.39,
		36124.21,
		109.06,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBADICO-PFR",
		33.274923,
		44.432363,
		"PLATTS - Refinery - Iraq - Baghdad - Iraq National Oil Co - {Daura/Doura}",
		3.4,
		3.65,
		3.4,
		3.4,
		3.65,
		302.32,
		329.97,
		40.48,
		14773.45,
		44.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		120,
		null,
		16.55,
		6041.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		120,
		null,
		16.55,
		6041.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		22.49,
		28.02,
		58.65,
		12.36,
		1.31,
		0.23,
		17.03787879,
		21.22727273,
		44.43181818,
		9.36363636,
		0.99242424,
		0.17424242,
		123.06,
	],
	[
		"REFBABNIO-PFR",
		27.171516,
		56.078095,
		"PLATTS - Refinery - Iran - Bandar Abbas (2) - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		947.8,
		1038.04,
		172.94,
		44082.98,
		188.3,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		525,
		null,
		69.99,
		25546.33,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		307.12,
		null,
		39.94,
		14577.46,
		null,
		217.88,
		null,
		30.05,
		10968.88,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		176.68,
		131.89,
		147.15,
		36.76,
		20.11,
		14.16,
		32.70458879,
		24.41367566,
		27.23839846,
		6.80450919,
		3.72248857,
		2.62110583,
		526.74,
	],
	[
		"REFBAHICO-PFR",
		30.45333,
		47.66189,
		"PLATTS - Refinery - Iraq - Basrah - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		845.07,
		927.71,
		122.06,
		41973.12,
		133.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		140,
		null,
		19.31,
		7048.28,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		140,
		null,
		19.31,
		7048.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		33.27,
		21.45,
		84.87,
		15.94,
		3.76,
		0.48,
		19.57058824,
		12.61764706,
		49.92352941,
		9.37647059,
		2.21176471,
		0.28235294,
		159.77,
	],
	[
		"REFBBYPFN-PFR",
		49.293534,
		-122.987013,
		"PLATTS - Refinery - Canada - Burnaby - Parkland Fuel Corporation",
		null,
		null,
		null,
		null,
		null,
		142.32,
		149.86,
		18.82,
		6866.01,
		19.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		38,
		null,
		5,
		1826.59,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		30.4,
		null,
		3.95,
		1442.91,
		null,
		0,
		null,
		0,
		0,
		null,
		7.6,
		null,
		1.05,
		383.68,
		null,
		null,
		null,
		null,
		null,
		null,
		"Parkland Fuel Corporation",
		"100",
		null,
		"Active",
		null,
		14.73,
		28.27,
		1.27,
		3.29,
		-0.01,
		1.14,
		28.60194175,
		54.89320388,
		2.46601942,
		6.38834951,
		-0.01941748,
		2.21359223,
		48.68,
	],
	[
		"REFBAOPOR-PFR",
		43.32749,
		-3.10941,
		"PLATTS - Refinery - Spain - Bilbao - Petronor",
		27,
		28.16,
		3.7,
		1350,
		3.86,
		843.51,
		888.17,
		290.08,
		32992.61,
		305.21,
		26.48,
		null,
		3.93,
		1435.77,
		null,
		0,
		null,
		0,
		0,
		null,
		208.26,
		null,
		28.27,
		10316.64,
		null,
		null,
		null,
		null,
		null,
		null,
		7.06,
		null,
		0.94,
		344.48,
		null,
		90.89,
		null,
		11.81,
		4314.07,
		null,
		70.59,
		null,
		9.73,
		3554.09,
		null,
		13.23,
		null,
		1.83,
		668.23,
		null,
		null,
		null,
		null,
		null,
		null,
		"Repsol_Bilbao Bizkaia Kutxa S.A.",
		"86_14",
		null,
		"Active",
		null,
		101.59,
		52.99,
		12.57,
		40.47,
		12.84,
		13.24,
		43.04661017,
		22.45338983,
		5.32627119,
		17.14830508,
		5.44067797,
		5.61016949,
		233.7,
	],
	[
		"REFBAMIPC-PFR",
		30.5575696,
		49.1994381,
		"PLATTS - Refinery - Iran - Bandar Imam - Iran NPC",
		null,
		null,
		null,
		null,
		null,
		11.5,
		12.35,
		1.36,
		496.16,
		1.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iran NPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBCAESA-PFR",
		-38.746523,
		-62.299001,
		"PLATTS - Refinery - Argentina - Bahia Blanca - Eg3 S.A. - {Ricardo Elicabe - BBR}",
		null,
		null,
		null,
		null,
		null,
		83.43,
		91.5,
		11.17,
		4079.54,
		12.25,
		0,
		null,
		0,
		0,
		null,
		3.27,
		null,
		0.49,
		177.23,
		null,
		18,
		null,
		2.53,
		920.73,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		14.73,
		null,
		2.04,
		743.5,
		null,
		null,
		null,
		null,
		null,
		null,
		"Compania General Combustibles_Isaura_Astra S.A. Argentina_Repsol_Other Investors",
		"32.5_32.5_17.06_15.44_2.5",
		null,
		"Active",
		null,
		8.15,
		6.22,
		1.61,
		1.55,
		1.11,
		1.63,
		37.04545455,
		28.27272727,
		7.31818182,
		7.04545455,
		5.04545455,
		7.40909091,
		20.27,
	],
	[
		"REFBATPAX-PFR",
		22.6554,
		89.7972,
		"PLATTS - Refinery - Bangladesh - Bagerhat - Petromax",
		null,
		null,
		null,
		null,
		null,
		5.5,
		6,
		0.72,
		260.78,
		0.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petromax",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBDNPFN-PFR",
		51.95334,
		-114.0231,
		"PLATTS - Refinery - Canada - Bowden - Parkland Fuel Corporation",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Parkland Fuel Corporation",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBANGOM-PFR",
		54.8574,
		57.144,
		"PLATTS - Refinery - Russia - Bashkortostan - Gazprom",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		327.18,
		358.81,
		44.43,
		16151,
		48.67,
		"Gazprom",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBAUPSB-PFR",
		47.273663,
		22.542561,
		"PLATTS - Refinery - Romania - Bacau - Petrolsub SA",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rafirom",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALDBHR-PFR",
		25.4381,
		81.8338,
		"PLATTS - Refinery - India - Allahabad - Bharat Petroleum",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		792.24,
		861.64,
		207.26,
		34385.92,
		222.92,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bharat Petroleum",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFALOTEX-PFR",
		35.2061398,
		-101.7943166,
		"PLATTS - Refinery - United States - Amarillo - Texaco",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Texaco Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALSLUR-PFR",
		36.186891,
		-5.390073,
		"PLATTS - Refinery - Spain - Algeciras - Lubrisur",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mobil_Cepsa_Elf_Abu Dhabi IPIC",
		"50_28.65_15.35_6",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFALXMOR-PFR",
		31.0225,
		29.765278,
		"PLATTS - Refinery - Egypt - Alexandria - MIDOR",
		null,
		null,
		null,
		null,
		null,
		618.21,
		679.46,
		210.69,
		23786.87,
		230.48,
		33,
		null,
		4.9,
		1789.73,
		null,
		0,
		null,
		0,
		0,
		null,
		100,
		null,
		14.13,
		5159.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.12,
		47.47,
		null,
		66,
		null,
		9.1,
		3322.77,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC_Petrojet_Enppi_Suez Canal Bank",
		"78_10_10_2",
		null,
		"Active",
		null,
		58.32,
		35.11,
		1.11,
		10.29,
		7.62,
		0,
		52.28617536,
		31.47749686,
		0.99515869,
		9.22538999,
		6.83162991,
		0,
		112.46,
	],
	[
		"REFANCARA-PFR",
		43.63873,
		13.37966,
		"PLATTS - Refinery - Italy - Ancona - Api Raffineria Di Ancona S.P.A. - {Falconara Marittima}",
		null,
		null,
		null,
		null,
		null,
		576.62,
		605.24,
		332.64,
		14609.42,
		347.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		50,
		null,
		6.9,
		2517.24,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		50,
		null,
		6.9,
		2517.24,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"API",
		"100",
		null,
		"Active",
		null,
		24.98,
		12.67,
		2.99,
		2.84,
		4.05,
		3.79,
		41.07876994,
		20.83538892,
		4.91695445,
		4.67028449,
		6.6600888,
		6.23252754,
		51.32,
	],
	[
		"REFANGPTC-PFR",
		25.04536,
		102.70981,
		"PLATTS - Refinery - China - Anning - PetroChina",
		51.92,
		55.94,
		8.38,
		2727.32,
		9.04,
		878.34,
		949.54,
		120.86,
		43599.96,
		130.56,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		205.44,
		null,
		28.4,
		10364.22,
		null,
		770.24,
		833.46,
		107.26,
		38634.94,
		116.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		51.36,
		null,
		7.08,
		2585.7,
		null,
		154.08,
		null,
		21.32,
		7778.54,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Saudi Aramco",
		"50_50",
		null,
		"Active",
		null,
		67.04,
		47.22,
		5.38,
		17.42,
		27.52,
		27.08,
		30.64825821,
		21.58727256,
		2.45954101,
		7.96379263,
		12.58114657,
		12.37999451,
		191.64,
	],
	[
		"REFAODPDL-PFR",
		31.84231,
		34.68246,
		"PLATTS - Refinery - Israel - Ashdod - PAZ Oil Company Ltd.",
		null,
		null,
		null,
		null,
		null,
		324.91,
		341.1,
		70.9,
		14906.53,
		74.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		69.44,
		null,
		9.25,
		3375.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		41.66,
		null,
		5.42,
		1977.55,
		null,
		27.78,
		null,
		3.83,
		1398.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PAZ Oil Company Ltd.",
		"100",
		null,
		"Active",
		null,
		28.76,
		34.38,
		29.4,
		11.2,
		4.88,
		7.23,
		33.56676004,
		40.12605042,
		34.31372549,
		13.07189542,
		5.69561158,
		8.43837535,
		115.85,
	],
	[
		"REFAOMNTD-PFR",
		4.9409,
		7.8412,
		"PLATTS - Refinery - Nigeria - Akwa Ibom - Niger Delta Petroleum Resources Ltd - {Ogbelle}",
		null,
		null,
		null,
		null,
		null,
		178.15,
		196.11,
		23.77,
		8619.83,
		26.17,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Niger Delta Petroleum Resources Ltd",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFAPYEOL-PFR",
		7.075574,
		-73.88166,
		"PLATTS - Refinery - Colombia - Apiay - Ecopetrol",
		null,
		null,
		null,
		null,
		null,
		2,
		2.15,
		0.27,
		100,
		0.29,
		1,
		null,
		0.15,
		54.23,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.15,
		54.23,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ecopetrol",
		"100",
		null,
		"Active",
		null,
		0.1,
		0,
		0.7,
		0.1,
		0,
		0.1,
		10,
		0,
		70,
		10,
		0,
		10,
		1,
	],
	[
		"REFAQGSEC-PFR",
		30.528602,
		117.019622,
		"PLATTS - Refinery - China - Anqing - Sinopec - {Anqing Petrochemical Works}",
		null,
		null,
		null,
		null,
		null,
		756.62,
		823.32,
		105.52,
		38336.68,
		114.81,
		35.66,
		null,
		5.3,
		1934.04,
		null,
		0,
		null,
		0,
		0,
		null,
		142.64,
		null,
		20.07,
		7324.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71.32,
		null,
		9.84,
		3590.65,
		null,
		35.66,
		null,
		4.93,
		1800.29,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		50.42,
		43.9,
		2.05,
		11.55,
		14.6,
		3.79,
		38.04708723,
		33.12707516,
		1.54693631,
		8.71566556,
		11.01720495,
		2.85994567,
		126.3,
	],
	[
		"REFARPOEN-PFR",
		51.309364,
		4.304118,
		"PLATTS - Refinery - Belgium - Antwerp - Oxeno Antwerpen",
		null,
		null,
		null,
		null,
		null,
		4.64,
		4.91,
		0.55,
		200.19,
		0.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Degussa",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFAUACRM-PFR",
		37.6721542,
		-96.9912719,
		"PLATTS - Refinery - United States - Augusta - Coastal Refining and Marketing Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The Coastal Corporation",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBABNI2-PFR",
		27.175345,
		56.080296,
		"PLATTS - Refinery - Iran - Bandar Abbas (2) - National Iranian Oil Co. - {Persian Gulf Star}",
		null,
		null,
		null,
		null,
		null,
		1025.27,
		1120.22,
		280.98,
		36936.16,
		303.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		267.59,
		291.89,
		84.73,
		9055.54,
		91.52,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBAISBC-PFR",
		21.470444,
		109.064459,
		"PLATTS - Refinery - China - Beihai - Sinopec Beihai Company",
		null,
		null,
		null,
		null,
		null,
		437.26,
		471.39,
		68.81,
		21776.14,
		74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		139.8,
		null,
		18.18,
		6635.31,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		139.8,
		null,
		18.18,
		6635.31,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		186.24,
		199.62,
		25.01,
		9041.41,
		26.8,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		45.35,
		43.26,
		0.69,
		8.58,
		17.3,
		11.42,
		35.17958265,
		33.55829649,
		0.53525716,
		6.65580638,
		13.42021565,
		8.8588938,
		126.6,
	],
	[
		"REFBCAYPF-PFR",
		-38.7182,
		-62.2662,
		"PLATTS - Refinery - Argentina - Bahia Blanca - YPF",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		538.3,
		589.14,
		73.06,
		26551.12,
		79.88,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBDAHND-PFR",
		30.25,
		75,
		"PLATTS - Refinery - India - Bhatinda - Hindustan Petroleum - {HMEL (HPCL-Mittal Energy Ltd)}",
		null,
		null,
		null,
		null,
		null,
		1630.37,
		1774.7,
		630.17,
		59382.02,
		676.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		231,
		null,
		31.86,
		11629.65,
		null,
		574.68,
		626.38,
		272.74,
		17412.69,
		292.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		231,
		null,
		31.86,
		11629.65,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mittal Energy_Other Investors_Indian Government",
		"49_26_25",
		null,
		"Active",
		null,
		95.81,
		37.73,
		12.56,
		25.16,
		8.84,
		40.12,
		39.2294149,
		15.44855259,
		5.14269336,
		10.30176473,
		3.61953896,
		16.42713835,
		220.24,
	],
	[
		"REFBGEEXM-PFR",
		30.48579,
		-91.17812,
		"PLATTS - Refinery - United States - Baton Rouge - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		2384.31,
		2509.19,
		829.44,
		90528.26,
		869.88,
		38.72,
		null,
		5.75,
		2099.99,
		null,
		0,
		null,
		0,
		0,
		null,
		470.92,
		null,
		64.04,
		23373.82,
		null,
		null,
		null,
		null,
		null,
		null,
		78.88,
		null,
		10.55,
		3848.99,
		null,
		126.06,
		null,
		16.39,
		5983.27,
		null,
		227.26,
		null,
		31.35,
		11441.56,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		153.05,
		288.15,
		4.29,
		55.25,
		8.9,
		0.02,
		30.8139886,
		58.01405303,
		0.86371781,
		11.12363849,
		1.79186213,
		0.00402666,
		509.66,
	],
	[
		"REFBIMPTS-PFR",
		-19.976764,
		-44.096806,
		"PLATTS - Refinery - Brazil - Betim - Petrobras - {REGAP - Gabriel Passos}",
		null,
		null,
		null,
		null,
		null,
		444.45,
		467.37,
		68.13,
		21698.36,
		71.67,
		86.99,
		null,
		12.93,
		4717.94,
		null,
		0,
		null,
		0,
		0,
		null,
		138.7,
		null,
		19.94,
		7276.29,
		null,
		119.92,
		126.36,
		33.33,
		4917.39,
		35.23,
		0,
		null,
		0,
		0,
		null,
		15.6,
		null,
		2.03,
		740.35,
		null,
		36.11,
		null,
		4.98,
		1818,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		62.32,
		33.54,
		9.99,
		8.49,
		11.18,
		3.56,
		44.93150685,
		24.18168709,
		7.20259553,
		6.12112473,
		8.06056236,
		2.5666907,
		129.09,
	],
	[
		"REFBJAEOL-PFR",
		7.072019,
		-73.878229,
		"PLATTS - Refinery - Colombia - Barrancabermeja - Ecopetrol",
		null,
		null,
		null,
		null,
		null,
		702.24,
		762.59,
		207.97,
		29634.45,
		223.28,
		53.76,
		null,
		7.99,
		2915.66,
		null,
		0,
		null,
		0,
		0,
		null,
		179.2,
		null,
		25.05,
		9142.69,
		null,
		542.95,
		589.28,
		307.52,
		14747.42,
		331.04,
		0,
		null,
		0,
		0,
		null,
		35,
		null,
		4.55,
		1661.25,
		null,
		0,
		null,
		0,
		0,
		null,
		90.44,
		null,
		12.51,
		4565.78,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ecopetrol",
		"100",
		null,
		"Active",
		null,
		67.49,
		63.93,
		45.44,
		15.75,
		13.99,
		8.22,
		30.67727273,
		29.05909091,
		20.65454545,
		7.15909091,
		6.35909091,
		3.73636364,
		214.82,
	],
	[
		"REFBJIIC2-PFR",
		35.005764,
		43.492896,
		"PLATTS - Refinery - Iraq - Baiji - Iraq National Oil Co",
		811.35,
		886.66,
		230.22,
		33312.43,
		249.11,
		675.33,
		732.47,
		214.94,
		27743.12,
		231.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		50,
		null,
		6.9,
		2517.24,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		50,
		null,
		6.9,
		2517.24,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		7.32,
		3.84,
		19.73,
		3.77,
		0.36,
		1.83,
		19.01298701,
		9.97402597,
		51.24675325,
		9.79220779,
		0.93506494,
		4.75324675,
		36.85,
	],
	[
		"REFBJIICO-PFR",
		34.998161,
		43.487533,
		"PLATTS - Refinery - Iraq - Baiji - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBKDGOR-PFR",
		35.3870351,
		-119.0509796,
		"PLATTS - Refinery - United States - Bakersfield - Gibson Oil and Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gibson Oil and Refining Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBLNPRT-PFR",
		-1.24556,
		116.8214,
		"PLATTS - Refinery - Indonesia - Balikpapan - Pertamina - {Kalimantan}",
		null,
		null,
		null,
		null,
		null,
		964.89,
		1041.72,
		265.25,
		42021.89,
		283.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		197.8,
		null,
		26.54,
		9687.09,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		98.9,
		null,
		12.86,
		4694.21,
		null,
		0,
		null,
		0,
		0,
		null,
		98.9,
		null,
		13.68,
		4992.88,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		94.51,
		53.37,
		22.41,
		22.31,
		2.89,
		17.42,
		43.35321101,
		24.48165138,
		10.27981651,
		10.23394495,
		1.32568807,
		7.99082569,
		212.91,
	],
	[
		"REFBMLSAR-PFR",
		1.1061,
		104.0378,
		"PLATTS - Refinery - Indonesia - Batam Island - SOCAR",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1958.2,
		2128.1,
		504.62,
		83653.32,
		541.19,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBNABRL-PFR",
		24.25592,
		78.17453,
		"PLATTS - Refinery - India - Bina - BORL - {Bharat Oman Refineries Ltd.}",
		0,
		0,
		0,
		0,
		0,
		528.94,
		575.2,
		185.5,
		20079.32,
		198.56,
		0.72,
		null,
		0.1,
		38.82,
		null,
		0,
		null,
		0,
		0,
		null,
		130,
		null,
		17.72,
		6466.34,
		null,
		536.68,
		582.7,
		202.8,
		19604.7,
		216.88,
		8.12,
		null,
		1.08,
		395.74,
		null,
		23.86,
		null,
		3.1,
		1132.18,
		null,
		97.32,
		null,
		13.42,
		4899.62,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bharat Petroleum",
		"100",
		0,
		"Active",
		null,
		85.46,
		29.3,
		4.68,
		16.18,
		8.98,
		5.64,
		54.24654056,
		18.59845119,
		2.97067411,
		10.27040752,
		5.70013965,
		3.58004316,
		150.22,
	],
	[
		"REFBNTEXM-PFR",
		30.05884,
		-94.07697,
		"PLATTS - Refinery - United States - Beaumont - ExxonMobil",
		695.1,
		727.01,
		94.68,
		34522.76,
		99.01,
		2217.79,
		2323.49,
		749.72,
		83327.56,
		784,
		68.25,
		null,
		10.14,
		3701.68,
		null,
		0,
		null,
		0,
		0,
		null,
		287,
		null,
		38.62,
		14096.09,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		214.67,
		null,
		27.92,
		10189.07,
		null,
		4.08,
		null,
		0.56,
		205.34,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		86.27,
		126.38,
		2.62,
		27.81,
		15.18,
		10.03,
		29.19063409,
		42.76240103,
		0.88651282,
		9.40989375,
		5.13636056,
		3.39378764,
		268.3,
	],
	[
		"REFBOKBPC-PFR",
		13.685889,
		100.595861,
		"PLATTS - Refinery - Thailand - Bangkok - Bangchak Petroleum Co.",
		20,
		20.86,
		2.74,
		1000,
		2.85,
		363.53,
		384.48,
		83.25,
		15795.25,
		88.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		86.71,
		null,
		11.42,
		4166.22,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		69.79,
		null,
		9.08,
		3312.73,
		null,
		0,
		null,
		0,
		0,
		null,
		16.91,
		null,
		2.34,
		853.48,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Thai Ministry Of Finance_Vayupak_PTT",
		"51.6_21_15_12.4",
		null,
		"Active",
		null,
		43.57,
		18.05,
		19.28,
		10.42,
		4.85,
		6.85,
		39.60909091,
		16.40909091,
		17.52727273,
		9.47272727,
		4.40909091,
		6.22727273,
		103.01,
	],
	[
		"REFBOMADE-PFR",
		51.508785,
		4.254076,
		"PLATTS - Refinery - Netherlands - Bergen-Op-Zoom - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		27,
		28.57,
		27,
		27,
		28.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBOUBAL-PFR",
		37.68285921,
		117.61518801,
		"PLATTS - Refinery - China - Binzhou - Befar Binyang Petrochemical",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Befar Binyang Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBOUBOX-PFR",
		37.10431125,
		118.22346893,
		"PLATTS - Refinery - China - Binzhou - Boxing Yongxin Petrochemical",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Boxing Yongxin Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBRTADE-PFR",
		29.62213,
		-95.04346,
		"PLATTS - Refinery - United States - Bayport - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		100,
		105.8,
		100,
		100,
		105.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBGNBRP-PFR",
		26.48566,
		90.546828,
		"PLATTS - Refinery - India - Bongaigaon - Bongaigaon Ref. and Petrochem.Ltd",
		86.9,
		96.24,
		31.23,
		3241.58,
		33.73,
		178.29,
		195.9,
		43.64,
		7779.63,
		47.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		44,
		null,
		5.72,
		2088.42,
		null,
		63.64,
		70.05,
		8.26,
		3003.63,
		9.08,
		0,
		null,
		0,
		0,
		null,
		44,
		null,
		5.72,
		2088.42,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp._Other Investors",
		"74.46_25.54",
		null,
		"Active",
		null,
		18.77,
		13.03,
		1.34,
		4.9,
		5,
		2.98,
		39.10416667,
		27.14583333,
		2.79166667,
		10.20833333,
		10.41666667,
		6.20833333,
		46.02,
	],
	[
		"REFBGSEXM-PFR",
		45.8119,
		-108.4342,
		"PLATTS - Refinery - United States - Billings - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		241.47,
		255.3,
		56.41,
		10761.96,
		59.71,
		19.64,
		null,
		2.92,
		1065.43,
		null,
		0,
		null,
		0,
		0,
		null,
		51.28,
		null,
		7.16,
		2614.09,
		null,
		null,
		null,
		null,
		null,
		null,
		3.86,
		null,
		0.52,
		188.16,
		null,
		13.53,
		null,
		1.76,
		642.28,
		null,
		6.13,
		null,
		0.85,
		308.84,
		null,
		8.11,
		null,
		1.12,
		409.37,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		20.34,
		27.81,
		0.49,
		1.9,
		-1.58,
		0,
		36.02550478,
		49.25611052,
		0.86787106,
		3.36521431,
		-2.79844137,
		0,
		48.96,
	],
	[
		"REFBLGLBR-PFR",
		43.498813,
		5.177046,
		"PLATTS - Refinery - France - Berre-Letang - LyondellBasell Refining",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0,
		-0.03,
		0.01,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Access Industries",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBNHKNT-PFR",
		14.1525,
		108.924,
		"PLATTS - Refinery - Vietnam - Binh Dinh - KST Energy Development",
		627.36,
		692.72,
		88.18,
		32045.64,
		97.3,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"RPC_Khang Thong",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBNIIND-PFR",
		25.4315,
		86.0284,
		"PLATTS - Refinery - India - Barauni - Indian Oil Corp.",
		24.5,
		26.3,
		3.36,
		1225,
		3.6,
		462.44,
		501.93,
		166.78,
		17652.22,
		178.31,
		0,
		null,
		0,
		0,
		null,
		7.81,
		null,
		1.16,
		422.82,
		null,
		110.13,
		null,
		14.76,
		5388.26,
		null,
		563.78,
		613.03,
		241.26,
		18827.06,
		258.56,
		0,
		null,
		0,
		0,
		null,
		64.93,
		null,
		8.44,
		3081.72,
		null,
		29.59,
		null,
		4.08,
		1489.56,
		null,
		7.81,
		null,
		1.08,
		394.16,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		20,
		52.06,
		26.64,
		8.92,
		13.75,
		11.72,
		9.29,
		39.24022009,
		20.07989749,
		6.72344916,
		10.3640612,
		8.8339489,
		7.00233662,
		122.38,
	],
	[
		"REFBOYSAT-PFR",
		-35.4333,
		149.0783,
		"PLATTS - Refinery - Australia - Bonython - Santos",
		null,
		null,
		null,
		null,
		null,
		25,
		26.07,
		2.94,
		1073.53,
		3.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.3,
		474.64,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.3,
		474.64,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Santos_Delhi_Origin",
		"66.6_20.2_13.2",
		null,
		"Active",
		null,
		2.22,
		3.96,
		0,
		1.65,
		1.04,
		1.38,
		22.2,
		39.6,
		0,
		16.5,
		10.4,
		13.8,
		10.25,
	],
	[
		"REFBRNMBL-PFR",
		13.079256,
		-59.608946,
		"PLATTS - Refinery - Barbados - Bridgetown - Mobil",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mobil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBSPAON-PFR",
		32.26932,
		-101.4206,
		"PLATTS - Refinery - United States - Big Springs - Alon",
		5,
		5.21,
		0.68,
		250,
		0.71,
		245.85,
		259.41,
		33.35,
		12113.94,
		35.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		64.55,
		null,
		8.52,
		3109.59,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		48.63,
		null,
		6.32,
		2308.42,
		null,
		15.91,
		null,
		2.19,
		801.17,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alon",
		"100",
		null,
		"Active",
		null,
		18.08,
		35.82,
		1.13,
		6.06,
		0.4,
		0.8,
		25.04155125,
		49.61218837,
		1.56509695,
		8.3933518,
		0.55401662,
		1.10803324,
		62.29,
	],
	[
		"REFBTASFF-PFR",
		37.256218,
		9.889616,
		"PLATTS - Refinery - Tunisia - Bizerta - Soc. Tunisienne Des Ind. De Raff",
		null,
		null,
		null,
		null,
		null,
		39.96,
		43.7,
		5.39,
		1962.74,
		5.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		22,
		null,
		2.86,
		1044.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		22,
		null,
		2.86,
		1044.21,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tunisian Govt.",
		"100",
		null,
		"Active",
		null,
		1.59,
		0.35,
		1.31,
		0.32,
		0.1,
		1.27,
		31.8,
		7,
		26.2,
		6.4,
		2,
		25.4,
		4.94,
	],
	[
		"REFBWNEXM-PFR",
		29.745062,
		-95.010496,
		"PLATTS - Refinery - United States - Baytown - ExxonMobil",
		18,
		18.77,
		2.47,
		900,
		2.57,
		2674.78,
		2815.01,
		790.21,
		109026.24,
		829.92,
		54.63,
		null,
		8.12,
		2963.02,
		null,
		0,
		null,
		0,
		0,
		null,
		497.78,
		null,
		65.86,
		24040.4,
		null,
		60,
		62.57,
		8.22,
		3000,
		8.57,
		0,
		null,
		0,
		0,
		null,
		427.9,
		null,
		55.64,
		20310,
		null,
		15.24,
		null,
		2.1,
		767.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		0,
		"Active",
		null,
		166.92,
		236.1,
		6.55,
		44.22,
		22.97,
		12.33,
		33.85320543,
		47.88366763,
		1.32841179,
		8.96830065,
		4.65856775,
		2.50065914,
		489.09,
	],
	[
		"REFBZNWZA-PFR",
		35.56589258,
		45.42916158,
		"PLATTS - Refinery - Iraq - Bazian - WZA",
		56.06,
		60.96,
		7.43,
		2689.16,
		8.06,
		169.13,
		185.81,
		22.36,
		8109.36,
		24.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30,
		null,
		4.14,
		1510.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30,
		null,
		4.14,
		1510.34,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"WZA",
		"100",
		null,
		"Active",
		null,
		10.48,
		4.76,
		15.75,
		3.56,
		1.29,
		0.1,
		27.94666667,
		12.69333333,
		42,
		9.49333333,
		3.44,
		0.26666667,
		35.94,
	],
	[
		"REFCABCET-PFR",
		22.0712,
		-79.49757,
		"PLATTS - Refinery - Cuba - Cabaiguan - Cupet - {Sergio Soto}",
		null,
		null,
		null,
		null,
		null,
		3.6,
		3.86,
		0.52,
		189.34,
		0.56,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.14,
		50.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.14,
		50.34,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cupet",
		"100",
		null,
		"Active",
		null,
		0.22,
		0,
		0.3,
		0.06,
		0,
		0.19,
		22,
		0,
		30,
		6,
		0,
		19,
		0.77,
	],
	[
		"REFCANSEC-PFR",
		38.93332,
		118.5333,
		"PLATTS - Refinery - China - Caofeidian - Sinopec",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		909.5,
		979.84,
		227.02,
		39005.9,
		242.54,
		"Sinopec_Hebei Government",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBOUCHB-PFR",
		37.21342114,
		118.12873586,
		"PLATTS - Refinery - China - Binzhou - Chambroad Petrochemical",
		null,
		null,
		null,
		null,
		null,
		307.27,
		331.63,
		60,
		14519.26,
		64.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Jingbo Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCASPTS-PFR",
		-29.9216,
		-51.18,
		"PLATTS - Refinery - Brazil - Canoas - Petrobras - {REFAP - Alberto Pasqualini}",
		null,
		null,
		null,
		null,
		null,
		518.64,
		545.56,
		126.89,
		22934.48,
		133.8,
		47.34,
		null,
		7.03,
		2567.48,
		null,
		0,
		null,
		0,
		0,
		null,
		143.7,
		null,
		19.89,
		7259.63,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		55.79,
		null,
		7.25,
		2648,
		null,
		28.85,
		null,
		3.98,
		1452.7,
		null,
		11.72,
		null,
		1.62,
		591.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		66.18,
		45.78,
		2.92,
		8.47,
		13.76,
		5.77,
		46.05427975,
		31.85803758,
		2.03201113,
		5.89422408,
		9.57550452,
		4.01530967,
		142.89,
	],
	[
		"REFCBAJNO-PFR",
		35.516089,
		140.047809,
		"PLATTS - Refinery - Japan - Chiba - ENEOS - {Kykuto Petroleum}",
		null,
		null,
		null,
		null,
		null,
		514.92,
		545.43,
		125.62,
		22659.62,
		132.98,
		0.08,
		null,
		0.01,
		4.47,
		null,
		1.71,
		null,
		0.25,
		92.62,
		null,
		92.9,
		null,
		12.6,
		4599.67,
		null,
		null,
		null,
		null,
		null,
		null,
		48,
		null,
		6.42,
		2342.25,
		null,
		3.59,
		null,
		0.47,
		170.42,
		null,
		36.28,
		null,
		5,
		1826.48,
		null,
		3.24,
		null,
		0.45,
		163.43,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tonengeneral Sekiyu K.K.",
		"100",
		null,
		"Active",
		null,
		34.69,
		29.23,
		14.27,
		19.55,
		4.4,
		10.86,
		30.58273825,
		25.76919686,
		12.58044609,
		17.2352993,
		3.87904434,
		9.57418672,
		113,
	],
	[
		"REFBOZADO-PFR",
		38.8781,
		-6.9702,
		"PLATTS - Refinery - Spain - Badajoz - Alfonso Gallardo",
		403.67,
		424.55,
		117.13,
		16659.13,
		123.56,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alfonso Gallardo",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCCENNG-PFR",
		47.799215,
		-53.993085,
		"PLATTS - Refinery - Canada - Come By Chance - North Atlantic Refining",
		379.12,
		398.94,
		100.65,
		17260.37,
		106.23,
		48,
		50.64,
		23.83,
		1414.24,
		25.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		35,
		null,
		4.6,
		1678.32,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		29.07,
		null,
		3.78,
		1379.91,
		null,
		5.93,
		null,
		0.82,
		298.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SilverRange",
		"100",
		null,
		"Active",
		null,
		50.72,
		39.66,
		23.37,
		6.5,
		4.12,
		1.93,
		40.90322581,
		31.98387097,
		18.84677419,
		5.24193548,
		3.32258065,
		1.55645161,
		126.31,
	],
	[
		"REFBRASCH-PFR",
		36.87931,
		6.949282,
		"PLATTS - Refinery - Algeria - Biskra - Sonatrach",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		281.1,
		307.86,
		37.48,
		13640.05,
		41.05,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBRECHN-PFR",
		39.238946,
		-76.569146,
		"PLATTS - Refinery - United States - Baltimore - Chevron",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBRKSFT-PFR",
		53.2424,
		34.3668,
		"PLATTS - Refinery - Russia - Bryansk - Slavneft",
		274.16,
		300.71,
		37.21,
		13528.36,
		40.76,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom_Rosneft_Tyumen Oil",
		"50_25_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBS3ICO-PFR",
		30.4952,
		47.8091,
		"PLATTS - Refinery - Iraq - Basrah (3) - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		125,
		134.19,
		17.12,
		6250,
		18.38,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBSDNOR-PFR",
		45.129391,
		17.984859,
		"PLATTS - Refinery - Bosnia-Herzegovina - Bosanski Brod - Neftegazinkor",
		null,
		null,
		null,
		null,
		null,
		177.17,
		191.48,
		41.48,
		7861.41,
		44.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.07,
		755.17,
		null,
		113.39,
		123.3,
		41.43,
		4174.92,
		44.69,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.07,
		755.17,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Neftegazinkor_Other Investors",
		"80_20",
		null,
		"Active",
		null,
		1.27,
		0.57,
		0.35,
		0,
		0.12,
		0.09,
		42.33333333,
		19,
		11.66666667,
		0,
		4,
		3,
		2.4,
	],
	[
		"REFCCTCHN-PFR",
		39.184284,
		-84.753837,
		"PLATTS - Refinery - United States - Cincinnati - Chevron",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBSHALB-PFR",
		40.604958,
		19.756971,
		"PLATTS - Refinery - Albania - Ballsh - Albpetrol Albanian State Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0.02,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Anika Enterprises_Refinery Associates of Texas_Albpetrol Albanian State Co_Mercuria",
		"37.5_37.5_15_10",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBSSIAN-PFR",
		4.5147,
		6.4822,
		"PLATTS - Refinery - Nigeria - Brass - IPMAN",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		308.2,
		337.89,
		41.41,
		15040.39,
		45.4,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"IPMAN",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBTNTAS-PFR",
		37.88108,
		41.13796,
		"PLATTS - Refinery - Turkey - Batman - Tupras",
		null,
		null,
		null,
		null,
		null,
		35.5,
		37.37,
		4.88,
		1793.24,
		5.18,
		17.68,
		null,
		2.63,
		958.65,
		null,
		0,
		null,
		0,
		0,
		null,
		17.68,
		null,
		2.63,
		958.65,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Koc Holding_Aygaz_Opet",
		"49_39.3_10.2_1.5",
		null,
		"Active",
		null,
		1.71,
		0,
		2.13,
		2.63,
		0,
		0.96,
		9.5,
		0,
		11.83333333,
		14.61111111,
		0,
		5.33333333,
		7.43,
	],
	[
		"REFCEPPAM-PFR",
		10.5369,
		107.0323,
		"PLATTS - Refinery - Vietnam - Cai Mep - Petro-Vietnam",
		null,
		null,
		null,
		null,
		null,
		25.2,
		27.78,
		2.88,
		1051.43,
		3.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.4,
		null,
		0.7,
		256.31,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5.4,
		null,
		0.7,
		256.31,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Vietnam",
		"100",
		null,
		"Active",
		null,
		0.64,
		4.34,
		0.05,
		0.65,
		0.4,
		0,
		10.66666667,
		72.33333333,
		0.83333333,
		10.83333333,
		6.66666667,
		0,
		6.07,
	],
	[
		"REFBVASIK-PFR",
		48.11949,
		17.180999,
		"PLATTS - Refinery - Slovakia - Bratislava - Slovnaft Odborovy Podnik",
		null,
		null,
		null,
		null,
		null,
		1389.25,
		1456.98,
		1056.69,
		20268.15,
		1104.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		112,
		null,
		15.45,
		5638.62,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		112,
		null,
		15.45,
		5638.62,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"MOL_OMV_Other Investors",
		"89.82_9.98_0.2",
		null,
		"Active",
		null,
		45.68,
		31.03,
		12.66,
		2.11,
		3.33,
		8.01,
		44.34951456,
		30.12621359,
		12.29126214,
		2.04854369,
		3.23300971,
		7.77669903,
		102.82,
	],
	[
		"REFCHCYOS-PFR",
		-18.8964,
		-65.1113,
		"PLATTS - Refinery - Bolivia - Chaco - YPF Bolivianos",
		16,
		17.18,
		1.88,
		687.06,
		2.02,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF Bolivianos",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBUNOMV-PFR",
		48.19386,
		12.84141,
		"PLATTS - Refinery - Germany - Burghausen - OMV",
		null,
		null,
		null,
		null,
		null,
		1076.04,
		1125.65,
		916.84,
		10745.37,
		957.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		70.18,
		null,
		9.17,
		3347.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		64.6,
		null,
		8.4,
		3066.25,
		null,
		0,
		null,
		0,
		0,
		null,
		5.57,
		null,
		0.77,
		281.44,
		null,
		null,
		null,
		null,
		null,
		null,
		"OMV",
		"100",
		null,
		"Active",
		null,
		28.45,
		7.91,
		23.11,
		4.36,
		2.37,
		11.86,
		37.66715212,
		10.47265987,
		30.59711373,
		5.77254071,
		3.13782603,
		15.70236992,
		78.05,
	],
	[
		"REFBWNATS-PFR",
		29.76934,
		-95.021256,
		"PLATTS - Refinery - United States - Baytown - Air Products",
		null,
		null,
		null,
		null,
		null,
		82,
		86.76,
		82,
		82,
		86.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBEDMGY-PFR",
		46.8853,
		-103.1996,
		"PLATTS - Refinery - United States - Belfield - Meridian Energy",
		null,
		null,
		null,
		null,
		null,
		103.75,
		108.7,
		13.57,
		4935.64,
		14.21,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Meridian Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCHEPMX-PFR",
		19.3292,
		-89.9439,
		"PLATTS - Refinery - Mexico - Campeche - PEMEX",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		736.9,
		803.57,
		110.93,
		38702.86,
		120.96,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBUTBSC-PFR",
		12.7136,
		101.1679,
		"PLATTS - Refinery - Thailand - Ban Map Ta Phut - Bangkok Synthetics Co.",
		null,
		null,
		null,
		null,
		null,
		1.16,
		1.25,
		0.14,
		50.05,
		0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bangkok Synthetics Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBEKDSM-PFR",
		50.961569,
		5.796589,
		"PLATTS - Refinery - Netherlands - Beek - DSM",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"DSM",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCAMPAP-PFR",
		-34.158439,
		-58.950693,
		"PLATTS - Refinery - Argentina - Campana - Pan American Energy Group - {Axion}",
		null,
		null,
		null,
		null,
		null,
		447.46,
		487.23,
		150.38,
		17877.45,
		162.41,
		0,
		null,
		0,
		0,
		null,
		55.5,
		null,
		8.24,
		3005.56,
		null,
		74,
		null,
		10.79,
		3933.94,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.85,
		null,
		0.24,
		87.81,
		null,
		0,
		null,
		0,
		0,
		null,
		16.65,
		null,
		2.3,
		840.56,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bridas Corp.",
		"100",
		null,
		"Active",
		null,
		29.04,
		18.54,
		3.91,
		3.96,
		7.56,
		9.44,
		36.3,
		23.175,
		4.8875,
		4.95,
		9.45,
		11.8,
		72.45,
	],
	[
		"REFCHNDGC-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Gelin Chemical",
		null,
		null,
		null,
		null,
		null,
		4,
		4.23,
		0.55,
		200,
		0.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gelin Chemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCANQUP-PFR",
		39.193,
		118.4505,
		"PLATTS - Refinery - China - Caofeidian - Qianhai Group",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		570,
		609.54,
		81.57,
		29770.92,
		87.25,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qianhai Group",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBERQGY-PFR",
		30.3143,
		-82.2847,
		"PLATTS - Refinery - United States - Baker - Quantum Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		34.02,
		35.69,
		9.87,
		1410.45,
		10.4,
		"Quantum Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCAOPTS-PFR",
		-23.867787,
		-46.434616,
		"PLATTS - Refinery - Brazil - Cubatao - Petrobras - {RPBC - Presidente Bernardes}",
		null,
		null,
		null,
		null,
		null,
		829.2,
		870.1,
		355.1,
		27778.9,
		372.01,
		97.84,
		null,
		14.54,
		5306.18,
		null,
		0,
		null,
		0,
		0,
		null,
		133.3,
		null,
		19.38,
		7073.25,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		6.36,
		null,
		0.83,
		301.73,
		null,
		29.02,
		null,
		4,
		1460.92,
		null,
		0.09,
		null,
		0.01,
		4.42,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		54.41,
		38.56,
		5.09,
		8.22,
		10.5,
		5.6,
		40.81770443,
		28.92723181,
		3.81845461,
		6.16654164,
		7.87696924,
		4.20105026,
		122.38,
	],
	[
		"REFCLECVR-PFR",
		37.04624,
		-95.6058,
		"PLATTS - Refinery - United States - Coffeyville - CVR Energy",
		null,
		null,
		null,
		null,
		null,
		444.97,
		467.58,
		111.38,
		19118.34,
		117.42,
		19.57,
		null,
		2.91,
		1061.45,
		null,
		0,
		null,
		0,
		0,
		null,
		114,
		null,
		15.19,
		5543.44,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		94.43,
		null,
		12.28,
		4481.98,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Icahn Enterprises_Other Investors",
		"80_20",
		null,
		"Active",
		null,
		49.24,
		68.2,
		0.39,
		5.55,
		-1.84,
		0.48,
		37.9060816,
		52.50192456,
		0.30023095,
		4.27251732,
		-1.41647421,
		0.36951501,
		122,
	],
	[
		"REFBFDWER-PFR",
		36.698364,
		-107.975803,
		"PLATTS - Refinery - United States - Bloomfield - Western Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Western Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCAUCOC-PFR",
		38.2106,
		116.8365,
		"PLATTS - Refinery - China - Cangzhou - CNOOC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		646.8,
		693.08,
		173.6,
		27806.65,
		184.88,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCLNSUR-PFR",
		43.500761,
		-79.609806,
		"PLATTS - Refinery - Canada - Clarkson - Suncor",
		null,
		null,
		null,
		null,
		null,
		16,
		16.92,
		2.26,
		826.02,
		2.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Canada",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBGLPRT-PFR",
		-6.371696,
		108.388069,
		"PLATTS - Refinery - Indonesia - Balongan - Pertamina",
		null,
		null,
		null,
		null,
		null,
		570.22,
		629.85,
		76.58,
		27909.4,
		84.53,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		82.8,
		null,
		11.44,
		4175.08,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.66,
		null,
		0.22,
		78.6,
		null,
		0,
		null,
		0,
		0,
		null,
		81.14,
		null,
		11.22,
		4096.48,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		31.17,
		34.42,
		4.39,
		7.96,
		11.49,
		0.08,
		34.63333333,
		38.24444444,
		4.87777778,
		8.84444444,
		12.76666667,
		0.08888889,
		89.51,
	],
	[
		"REFCBUEAR-PFR",
		29.3133,
		-95.2522,
		"PLATTS - Refinery - United States - Chocolate Bayou - Equistar",
		null,
		null,
		null,
		null,
		null,
		1.86,
		1.97,
		0.22,
		80.25,
		0.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Occidental",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCNEHER-PFR",
		41.12676,
		-104.7948,
		"PLATTS - Refinery - United States - Cheyenne - Holly-Frontier",
		6,
		6.35,
		0.7,
		256.44,
		0.74,
		29.11,
		30.79,
		7.93,
		1249.8,
		8.35,
		15.86,
		null,
		2.36,
		860.43,
		null,
		1.19,
		null,
		0.18,
		64.28,
		null,
		22.01,
		null,
		3.18,
		1161.04,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4.61,
		null,
		0.6,
		218.67,
		null,
		0,
		null,
		0,
		0,
		null,
		0.35,
		null,
		0.05,
		17.65,
		null,
		null,
		null,
		null,
		null,
		null,
		"Holly-Frontier",
		"100",
		null,
		"Active",
		null,
		13.8,
		18.14,
		0.24,
		0.56,
		0.27,
		0,
		37.21682848,
		48.92125135,
		0.64724919,
		1.51024811,
		0.72815534,
		0,
		33.01,
	],
	[
		"REFCANXPH-PFR",
		39.193,
		118.4505,
		"PLATTS - Refinery - China - Caofeidian - Xuyang Petrochemical",
		null,
		null,
		null,
		null,
		null,
		1151.6,
		1238.15,
		341.6,
		47299.94,
		364.13,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xuyang Petrochemical",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCNGJJP-PFR",
		34.3804,
		119.8069,
		"PLATTS - Refinery - China - Chenjiagang - Jiangsu Jurong Petrochemical",
		null,
		null,
		null,
		null,
		null,
		18,
		19.91,
		2.72,
		992.45,
		3.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jiangsu Jurong Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBIAHUM-PFR",
		38.064021,
		-122.134309,
		"PLATTS - Refinery - United States - Benicia - Huntway Petroleum",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		0,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCAPPRT-PFR",
		-7.701905,
		109.000203,
		"PLATTS - Refinery - Indonesia - Cilacap - Pertamina",
		null,
		null,
		null,
		null,
		null,
		1192.87,
		1302.63,
		188.13,
		57532.65,
		204.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		246.56,
		null,
		33.41,
		12194.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		80.13,
		null,
		10.42,
		3803.4,
		null,
		80.13,
		null,
		11.05,
		4034.23,
		null,
		86.3,
		null,
		11.94,
		4356.58,
		null,
		243.13,
		267.54,
		33.53,
		12193.99,
		36.88,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		90.11,
		83.13,
		34.53,
		27.56,
		13.26,
		7.96,
		33.37407407,
		30.78888889,
		12.78888889,
		10.20740741,
		4.91111111,
		2.94814815,
		256.55,
	],
	[
		"REFCCNEAP-PFR",
		-32.928376,
		-71.503172,
		"PLATTS - Refinery - Chile - Concon - ENAP - {Aconcagua}",
		301.87,
		317.15,
		81.08,
		12891.29,
		85.47,
		492.35,
		517.1,
		178.11,
		18370.88,
		186.93,
		38.98,
		null,
		5.79,
		2114.04,
		null,
		0,
		null,
		0,
		0,
		null,
		81.21,
		null,
		11.63,
		4245.87,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		42.23,
		null,
		5.84,
		2131.83,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENAP",
		"100",
		0,
		"Active",
		null,
		37.42,
		36.9,
		7.06,
		8.96,
		1.85,
		1.52,
		37.77508581,
		37.25015142,
		7.12699374,
		9.04502322,
		1.86755502,
		1.53442358,
		93.72,
	],
	[
		"REFCOYRST-PFR",
		46.2864,
		6.953681,
		"PLATTS - Refinery - Switzerland - Collombey - Raff. Du Sud-Ouest",
		169.81,
		178.43,
		41.6,
		7177.78,
		43.57,
		0.01,
		0,
		0.02,
		-0.02,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan Investment Authority",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCCOMIA-PFR",
		-38.938,
		-69.2294,
		"PLATTS - Refinery - Argentina - Cutral Co - Mas Energia",
		0,
		0,
		0,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mas Energia",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCAUSEC-PFR",
		38.338892,
		116.874337,
		"PLATTS - Refinery - China - Cangzhou - Sinopec",
		35,
		37.03,
		4.79,
		1750,
		5.07,
		273.36,
		295.81,
		49.81,
		13322,
		53.61,
		34.02,
		null,
		5.05,
		1844.9,
		null,
		0,
		null,
		0,
		0,
		null,
		51,
		null,
		7.4,
		2699.91,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		16.98,
		null,
		2.34,
		855.01,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		17.01,
		13.49,
		0.44,
		3.71,
		7.53,
		6.78,
		31.54088633,
		25.01390692,
		0.81587243,
		6.87928797,
		13.96254404,
		12.5718524,
		48.96,
	],
	[
		"REFBKUSAR-PFR",
		40.372334,
		49.91192,
		"PLATTS - Refinery - Azerbaijan - Baku - SOCAR",
		null,
		null,
		null,
		null,
		null,
		135,
		144.93,
		135,
		135,
		144.93,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		996.6,
		1091.8,
		213.83,
		45068,
		231.2,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCGESRC-PFR",
		32.9221,
		-111.507521,
		"PLATTS - Refinery - United States - Coolidge - Sunbelt Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Huntway Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCRGATS-PFR",
		38.355343,
		-82.594875,
		"PLATTS - Refinery - United States - Catlettsburg - Air Products",
		null,
		null,
		null,
		null,
		null,
		34,
		35.97,
		34,
		34,
		35.97,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBLECLS-PFR",
		25.914,
		-97.4891,
		"PLATTS - Refinery - United States - Brownsville - Centurion Terminals",
		50,
		52.14,
		5.88,
		2147.06,
		6.13,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Centurion Terminals",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCHAJPC-PFR",
		34.996526,
		136.852938,
		"PLATTS - Refinery - Japan - Chita - Japan Energy Corp.",
		null,
		null,
		null,
		null,
		null,
		0.09,
		0.09,
		0.03,
		4.52,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Japan Energy Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTIESO-PFR",
		27.813764,
		-97.438512,
		"PLATTS - Refinery - United States - Corpus Christi - El Paso",
		null,
		null,
		null,
		null,
		null,
		0.07,
		0.09,
		0.02,
		3.4,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCHGESR-PFR",
		22.266749,
		91.804635,
		"PLATTS - Refinery - Bangladesh - Chittagong - Eastern Refinery Ltd.",
		228.88,
		249.28,
		74.45,
		8910.55,
		80.37,
		67.43,
		73.8,
		10.29,
		3386.51,
		11.21,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		26,
		null,
		3.52,
		1284.01,
		null,
		60,
		64.41,
		8.22,
		3000,
		8.82,
		12.4,
		null,
		1.66,
		605.08,
		null,
		2,
		null,
		0.26,
		94.93,
		null,
		11.6,
		null,
		1.6,
		584,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bangladesh Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		6.83,
		2.5,
		5.84,
		5.06,
		0.42,
		1.25,
		28.45833333,
		10.41666667,
		24.33333333,
		21.08333333,
		1.75,
		5.20833333,
		21.91,
	],
	[
		"REFCTIVRO-PFR",
		27.80777,
		-97.44579,
		"PLATTS - Refinery - United States - Corpus Christi - Valero",
		null,
		null,
		null,
		null,
		null,
		1217.91,
		1281.5,
		329.46,
		51527.63,
		347.21,
		41.53,
		null,
		6.17,
		2252.22,
		null,
		0,
		null,
		0,
		0,
		null,
		241.06,
		null,
		32.35,
		11809.18,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		169.54,
		null,
		22.05,
		8047.18,
		null,
		29.99,
		null,
		4.14,
		1509.78,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		104.51,
		156.66,
		2.82,
		23.37,
		-12.93,
		7.46,
		44.3722668,
		66.5138199,
		1.19729971,
		9.92230289,
		-5.48974653,
		3.16732476,
		281.88,
	],
	[
		"REFBNDGCA-PFR",
		30.706911,
		-88.032193,
		"PLATTS - Refinery - United States - Blakeley Island - Gulf Coast Asphalt Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		31,
		32.91,
		4.52,
		1651.76,
		4.82,
		"Gulf Coast Asphalt Co.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCUYSAR-PFR",
		42.8222,
		75.2831,
		"PLATTS - Refinery - Kyrgyzstan - Chuy - SOCAR",
		90.06,
		98.41,
		12.03,
		4369.74,
		13.13,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBNTCPS-PFR",
		30.006187,
		-93.977433,
		"PLATTS - Refinery - United States - Beaumont - ConocoPhillips",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unocal",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCVTSHL-PFR",
		30.11256,
		-90.90384,
		"PLATTS - Refinery - United States - Convent - Shell",
		24.35,
		26.34,
		5.19,
		1403.35,
		5.58,
		-0.03,
		-0.02,
		0,
		-0.01,
		0.04,
		0.24,
		null,
		0.04,
		13.25,
		null,
		0,
		null,
		0,
		0,
		null,
		101.37,
		null,
		13.68,
		4991.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0.08,
		null,
		0.01,
		4.05,
		null,
		39.02,
		null,
		5.07,
		1852.08,
		null,
		62.02,
		null,
		8.55,
		3122.5,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		83.91,
		102.49,
		9.39,
		26.1,
		3.04,
		5.05,
		36.26188418,
		44.29127053,
		4.05790838,
		11.27917027,
		1.31374244,
		2.18236819,
		229.99,
	],
	[
		"REFBNTORS-PFR",
		29.987558,
		-93.940376,
		"PLATTS - Refinery - United States - Beaumont - Oiltanking Partners",
		95.08,
		99.45,
		11.67,
		4231.75,
		12.21,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oiltanking Partners",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCHONVT-PFR",
		10.0376,
		105.781,
		"PLATTS - Refinery - Vietnam - Can Tho - Nam Viet Oil",
		null,
		null,
		null,
		null,
		null,
		5,
		5.37,
		0.59,
		214.7,
		0.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nam Viet Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCWNCEX-PFR",
		-33.841061,
		18.530193,
		"PLATTS - Refinery - South Africa - Cape Town - Caltex",
		null,
		null,
		null,
		null,
		null,
		300.52,
		331.72,
		41.02,
		14935.24,
		45.24,
		0,
		null,
		0,
		0,
		null,
		1.2,
		null,
		0.18,
		64.99,
		null,
		12,
		null,
		1.64,
		597.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0.6,
		null,
		0.08,
		29.28,
		null,
		3.6,
		null,
		0.47,
		170.87,
		null,
		6.6,
		null,
		0.91,
		332.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron Corp_Texaco Inc.",
		"50_50",
		null,
		"Active",
		null,
		24.4,
		21.57,
		7.91,
		8.64,
		4.97,
		0,
		34.85714286,
		30.81428571,
		11.3,
		12.34285714,
		7.1,
		0,
		67.49,
	],
	[
		"REFBODBIL-PFR",
		50.5956,
		36.5873,
		"PLATTS - Refinery - Russia - Belgorod - Belogorie Oil",
		3.6,
		3.86,
		0.49,
		180,
		0.53,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Belogorie Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCHOVNG-PFR",
		10.02701,
		105.78598,
		"PLATTS - Refinery - Vietnam - Can Tho - Vien Dong",
		33.6,
		36.74,
		4.46,
		1627.65,
		4.87,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vien Dong",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBOHSKE-PFR",
		51.186761,
		12.363358,
		"PLATTS - Refinery - Germany - Boehlen - Saechsiche Olefinwerke",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Treuhandstelle",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCYDGOM-PFR",
		60.3412,
		112.5909,
		"PLATTS - Refinery - Russia - Chayanda - Gazprom",
		50.02,
		55.2,
		6.44,
		2336.98,
		7.08,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCHROAZ-PFR",
		43.3976,
		45.6985,
		"PLATTS - Refinery - Russia - Chechnya(Republic) - OJSC Grozneftegaz",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		346.2,
		380.15,
		46.44,
		16884.83,
		50.96,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Chechen Republic Govt",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFDADAAD-PFR",
		40.966342,
		72.981641,
		"PLATTS - Refinery - Kyrgyzstan - Dzhalal-Abad - Kyrgyzneft",
		null,
		null,
		null,
		null,
		null,
		10,
		10.74,
		1.36,
		500,
		1.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.5,
		null,
		0.2,
		75.52,
		null,
		12,
		13.48,
		1.66,
		599.62,
		1.84,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.5,
		null,
		0.2,
		75.52,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kyrgoil Corporation_Kyrgyzneft",
		"50_50",
		null,
		"Active",
		null,
		0.34,
		0,
		0.7,
		0.08,
		0,
		0.34,
		22.66666667,
		0,
		46.66666667,
		5.33333333,
		0,
		22.66666667,
		1.48,
	],
	[
		"REFBOPKBH-PFR",
		51.5216,
		6.9292,
		"PLATTS - Refinery - Germany - Bottrop - Kohleoel-Anlage Bottrop Gmbh",
		null,
		null,
		null,
		null,
		null,
		3.5,
		3.7,
		0.5,
		185.96,
		0.54,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ruhrkohle_Veba",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCKEATS-PFR",
		29.53877,
		-95.12317,
		"PLATTS - Refinery - United States - Clear Lake - Air Products",
		null,
		null,
		null,
		null,
		null,
		27,
		28.57,
		27,
		27,
		28.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBORWRB-PFR",
		35.697475,
		-101.363848,
		"PLATTS - Refinery - United States - Borger - WRB Refining",
		115.28,
		120.62,
		16.2,
		5814.46,
		16.98,
		667.3,
		703.18,
		174.63,
		28259.53,
		184.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		106.38,
		null,
		13.92,
		5082.64,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		94.94,
		null,
		12.34,
		4506.5,
		null,
		11.44,
		null,
		1.58,
		576.12,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co._Cenovus",
		"50_50",
		0,
		"Active",
		null,
		30.44,
		70.76,
		0.96,
		8.4,
		1,
		0,
		25.57983193,
		59.46218487,
		0.80672269,
		7.05882353,
		0.84033613,
		0,
		111.56,
	],
	[
		"REFDAESOI-PFR",
		35.1789,
		128.5063,
		"PLATTS - Refinery - South Korea - Daesan - S-Oil",
		1540.17,
		1630.11,
		314.02,
		71964.07,
		332.23,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Saudi Arabian Oil Co._S-Oil",
		"37_35_28",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCMOPMX-PFR",
		22.277384,
		-97.812181,
		"PLATTS - Refinery - Mexico - Ciudad Madero - PEMEX",
		null,
		null,
		null,
		null,
		null,
		780.7,
		855.21,
		190.91,
		33827.89,
		206.72,
		89.81,
		null,
		13.34,
		4870.8,
		null,
		0,
		null,
		0,
		0,
		null,
		89.81,
		null,
		13.34,
		4870.8,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		20.52,
		23.02,
		0.94,
		2.24,
		2.19,
		3.92,
		35.35492764,
		39.66230186,
		1.61957271,
		3.85940731,
		3.77325982,
		6.75396278,
		52.83,
	],
	[
		"REFDALYUP-PFR",
		38.9182,
		121.6283,
		"PLATTS - Refinery - China - Dalian - Yanchang Petroleum Group",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		618.08,
		667.13,
		84.12,
		30676.77,
		90.77,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shaanxi Provincial Government",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCN2CDL-PFR",
		13.0802,
		80.2838,
		"PLATTS - Refinery - India - Chennai (2) - Chennai Petroleum Corp. Ltd.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		895.48,
		984.13,
		122.18,
		44415.93,
		134.17,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp._Other Investors_NIOC",
		"51.9_32.7_15.4",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBROPTC-PFR",
		10.95,
		8.3333,
		"PLATTS - Refinery - Nigeria - Baro - PetroChina",
		144.08,
		158.34,
		19.86,
		7217.6,
		21.8,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCNDCES-PFR",
		4.9422,
		-52.3236,
		"PLATTS - Refinery - Guyana - Crab Island - Crab Island Refineries",
		180.1,
		197.3,
		23.7,
		8615.46,
		25.96,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Crab Island Refineries_Guyana Government",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBSKRLC-PFR",
		55.3568,
		78.3503,
		"PLATTS - Refinery - Russia - Barabinsk - Refinery Barabinskyi LLC",
		655.05,
		721.09,
		89.37,
		32488.79,
		98.28,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Refinery Barabinskyi LLC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDAMAUM-PFR",
		-6.844271,
		39.309279,
		"PLATTS - Refinery - Tanzania - Dar Es Salaam - Addax Petroleum",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Addax Petroleum_Tanzanian Govt.",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCNECOA-PFR",
		41.094938,
		-104.907659,
		"PLATTS - Refinery - United States - Cheyenne - Coastal Chemical",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"El Paso",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDASARL-PFR",
		43.02004,
		-105.2609,
		"PLATTS - Refinery - United States - Douglas - Slate",
		null,
		null,
		null,
		null,
		null,
		2,
		2.12,
		0.28,
		101.67,
		0.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Slate",
		"100",
		null,
		"Active",
		null,
		0.48,
		0.58,
		0.28,
		0.19,
		0,
		0,
		25.26315789,
		30.52631579,
		14.73684211,
		10,
		0,
		0,
		1.53,
	],
	[
		"REFCNICDL-PFR",
		13.159935,
		80.277655,
		"PLATTS - Refinery - India - Chennai - Chennai Petroleum Corp. Ltd. - {Manali}",
		null,
		null,
		null,
		null,
		null,
		827.82,
		901.51,
		302.66,
		31363.85,
		325.61,
		4.65,
		null,
		0.7,
		252.13,
		null,
		1.6,
		null,
		0.24,
		86.82,
		null,
		165.91,
		null,
		22.53,
		8223.3,
		null,
		null,
		null,
		null,
		null,
		null,
		30.94,
		null,
		4.14,
		1509.72,
		null,
		36.88,
		null,
		4.8,
		1750.01,
		null,
		90.25,
		null,
		12.45,
		4543.7,
		null,
		1.6,
		null,
		0.22,
		80.92,
		null,
		269.98,
		294.72,
		43.22,
		13215.33,
		47.01,
		"Indian Oil Corp._Other Investors_NIOC",
		"51.9_32.7_15.4",
		0,
		"Active",
		null,
		92.16,
		33.73,
		4.94,
		21.1,
		13.36,
		17.18,
		44.52173913,
		16.29468599,
		2.38647343,
		10.19323671,
		6.45410628,
		8.29951691,
		182.47,
	],
	[
		"REFDATPAM-PFR",
		15.3514,
		108.83117,
		"PLATTS - Refinery - Vietnam - Dung Quat - Nghi Son Refinery and Petrochemical LLC",
		null,
		null,
		null,
		null,
		null,
		490.25,
		540.08,
		102.5,
		22070.69,
		111.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		108,
		null,
		14.82,
		5411.52,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		13.5,
		null,
		1.75,
		640.77,
		null,
		0,
		null,
		0,
		0,
		null,
		94.5,
		null,
		13.07,
		4770.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrolimex_Other Investors",
		"95.93_4.07",
		null,
		"Active",
		null,
		40.03,
		60.04,
		3.54,
		6.38,
		10.71,
		0,
		33.35833333,
		50.03333333,
		2.95,
		5.31666667,
		8.925,
		0,
		120.7,
	],
	[
		"REFCNKFLJ-PFR",
		48.624743,
		-112.314177,
		"PLATTS - Refinery - United States - Cut Bank - Flying J",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Flying J",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDBETGV-PFR",
		38.5426,
		68.8152,
		"PLATTS - Refinery - Tajikistan - Dushanbe - Tajik Gov.",
		12.01,
		13.2,
		1.58,
		569.74,
		1.72,
		3.75,
		4.06,
		0.51,
		186.55,
		0.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tajik Gov.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCOUAGY-PFR",
		30.6671,
		117.486,
		"PLATTS - Refinery - China - Chizhou - Anhui Taihesen Energy",
		null,
		null,
		null,
		null,
		null,
		1,
		1.06,
		0.12,
		43.14,
		0.13,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Anhui Taihesen Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDERVRO-PFR",
		39.802188,
		-104.944347,
		"PLATTS - Refinery - United States - Denver - Valero",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		-0.01,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCPUPRT-PFR",
		-7.168494,
		111.581168,
		"PLATTS - Refinery - Indonesia - Cepu - Pertamina",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDHANOG-PFR",
		40.083075,
		124.383525,
		"PLATTS - Refinery - North Korea - Dongha - North Korean Government Co.",
		16.03,
		17.65,
		8.28,
		462.02,
		8.94,
		31,
		33.78,
		4.25,
		1550,
		4.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4.95,
		null,
		0.68,
		249.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4.95,
		null,
		0.68,
		249.21,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"North Korean Government Co.",
		"100",
		null,
		"Active",
		null,
		1.9,
		2.1,
		0.9,
		0.4,
		0,
		0,
		34.54545455,
		38.18181818,
		16.36363636,
		7.27272727,
		0,
		0,
		5.3,
	],
	[
		"REFCPUWAH-PFR",
		-7.1411,
		111.593,
		"PLATTS - Refinery - Indonesia - Cepu - Wahana International",
		null,
		null,
		null,
		null,
		null,
		6,
		6.44,
		0.82,
		300,
		0.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.76,
		null,
		0.38,
		139.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.76,
		null,
		0.38,
		139.34,
		null,
		null,
		null,
		null,
		null,
		null,
		"Wahana International",
		"100",
		null,
		"Active",
		null,
		0.5,
		0,
		1.7,
		0.4,
		0,
		0.4,
		16.66666667,
		0,
		56.66666667,
		13.33333333,
		0,
		13.33333333,
		3,
	],
	[
		"REFDIGHEN-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Hengrunde Petrochemical",
		null,
		null,
		null,
		null,
		null,
		89.5,
		97.34,
		12.43,
		4529.78,
		13.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hengrunde Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCQGPTC-PFR",
		29.5647,
		106.5479,
		"PLATTS - Refinery - China - Chongqing - PetroChina",
		603.67,
		650.64,
		127.67,
		27789.89,
		136.72,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGLIP-PFR",
		37.51720225,
		118.23873982,
		"PLATTS - Refinery - China - Dongying - Lijin Petrochemical - {Dongying Lihuayi Petrochemical Co.}",
		null,
		null,
		null,
		null,
		null,
		177.02,
		190.65,
		25.58,
		9185.22,
		27.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		328.12,
		354.62,
		46.44,
		16542.21,
		50.18,
		"Dongying Lihuayi Petrochemical Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCRNFCO-PFR",
		33.801706,
		-118.276832,
		"PLATTS - Refinery - United States - Carson - Fletcher Oil and Ref. Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		0.03,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hondo Oil and Gas",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGSID-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Shangneng Industrial Co.",
		null,
		null,
		null,
		null,
		null,
		149.58,
		161.71,
		32.07,
		7125.08,
		34.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shangneng Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCROPUM-PFR",
		30.0488,
		31.2437,
		"PLATTS - Refinery - Egypt - Cairo - PetroSilah Petroleum",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		10.9,
		1.36,
		500,
		1.5,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC_Pharos Energy",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFDIGSNH-PFR",
		37.41406747,
		118.36305086,
		"PLATTS - Refinery - China - Dongying - Shenchi Chemical",
		null,
		null,
		null,
		null,
		null,
		187.39,
		201.9,
		52.68,
		8272.24,
		56.27,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shenchi Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCRRPAS-PFR",
		7.6599,
		-72.3031,
		"PLATTS - Refinery - Venezuela - Cerro Negro - Petromonagas",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		422.77,
		466.27,
		61.7,
		21697.48,
		68.05,
		"PDVSA_TNK-BP",
		"83.33_16.67",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCTHMAS-PFR",
		37.921484,
		23.075015,
		"PLATTS - Refinery - Greece - Corinth - Motor Oil Hellas",
		null,
		null,
		null,
		null,
		null,
		1068.21,
		1118.98,
		583.31,
		28569.57,
		609.65,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		176.35,
		null,
		24.32,
		8878.29,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		176.35,
		null,
		24.32,
		8878.29,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroventure Holdings_Other Investors_Petroshares Ltd",
		"51_38.5_10.5",
		0,
		"Active",
		null,
		77.76,
		52.12,
		47.49,
		22.98,
		5.43,
		11.47,
		42.03470458,
		28.17449592,
		25.67165793,
		12.4222931,
		2.9352938,
		6.20033515,
		217.25,
	],
	[
		"REFDIGTAL-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Tianhong Chemical",
		null,
		null,
		null,
		null,
		null,
		316.3,
		340.02,
		45.06,
		15970.05,
		48.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Wanda Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTIADE-PFR",
		27.81573,
		-97.4794,
		"PLATTS - Refinery - United States - Corpus Christi - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		80,
		84.64,
		80,
		80,
		84.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGYIK-PFR",
		37.68411358,
		118.47496267,
		"PLATTS - Refinery - China - Dongying - Yikun Chemical",
		null,
		null,
		null,
		null,
		null,
		9.46,
		10,
		1.33,
		487.54,
		1.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yikun Chemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTIBRS-PFR",
		27.82959,
		-97.50046,
		"PLATTS - Refinery - United States - Corpus Christi - Buckeye Partners",
		null,
		null,
		null,
		null,
		null,
		50,
		52.14,
		5.89,
		2147.06,
		6.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		39.66,
		null,
		5.16,
		1882.76,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		39.66,
		null,
		5.16,
		1882.76,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Buckeye Partners_Trafigura",
		"80_20",
		null,
		"Active",
		null,
		11.69,
		17.99,
		1.8,
		6.3,
		0.9,
		1.8,
		27.66209181,
		42.56980596,
		4.2593469,
		14.90771415,
		2.12967345,
		4.2593469,
		40.46,
	],
	[
		"REFDILBPP-PFR",
		51.635163,
		6.701025,
		"PLATTS - Refinery - Germany - Dinslaken - The British Petroleum Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The British Petroleum Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTIBTB-PFR",
		27.816379,
		-97.494451,
		"PLATTS - Refinery - United States - Corpus Christi - BTB Refining",
		null,
		null,
		null,
		null,
		null,
		40.24,
		43.23,
		6.2,
		2261.55,
		6.68,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sargent Holdings_Trifinery",
		"75_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDINDLS-PFR",
		-12.5561,
		130.917764,
		"PLATTS - Refinery - Australia - Darwin - Darwin Clean Fuels",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		200.01,
		209.21,
		24.4,
		8902.95,
		25.53,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Darwin Clean Fuels",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCTNMUM-PFR",
		40.77415,
		-81.41484,
		"PLATTS - Refinery - United States - Canton - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		307.97,
		324.79,
		41.59,
		15131.7,
		43.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		99.78,
		null,
		13.03,
		4757.07,
		null,
		null,
		null,
		null,
		null,
		null,
		1.28,
		null,
		0.17,
		62.54,
		null,
		91.83,
		null,
		11.94,
		4358.54,
		null,
		3.81,
		null,
		0.52,
		191.59,
		null,
		2.86,
		null,
		0.4,
		144.4,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		22.29,
		68.13,
		0.88,
		10.19,
		-1.54,
		4.76,
		19.35399844,
		59.15603022,
		0.76408787,
		8.84779022,
		-1.33715377,
		4.13302075,
		104.71,
	],
	[
		"REFDKEAGS-PFR",
		48.125834,
		-98.904579,
		"PLATTS - Refinery - United States - Devils Lake - American Energy Holdings",
		20,
		20.86,
		2.74,
		1000,
		2.86,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"American Energy Holdings",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTOPDV-PFR",
		10.1124,
		-63.1034,
		"PLATTS - Refinery - Venezuela - Caripito - PDVSA",
		95,
		101.99,
		13.78,
		5030.08,
		14.79,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDKEEGY-PFR",
		48.147531,
		-98.910964,
		"PLATTS - Refinery - United States - Devils Lake - Eagles Ledge Energy",
		34.02,
		35.69,
		9.87,
		1410.45,
		10.4,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Eagles Ledge Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCTYCYS-PFR",
		43.183437,
		-84.852436,
		"PLATTS - Refinery - United States - Carson City - Crystal Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lakeside Refining Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDLSDNZ-PFR",
		55.8712,
		26.5159,
		"PLATTS - Refinery - Latvia - Daugavpils - Dinaz Group",
		495.91,
		540.34,
		162.9,
		19309.99,
		175.91,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dinaz Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDMIPRT-PFR",
		1.678458,
		101.472481,
		"PLATTS - Refinery - Indonesia - Dumai - Pertamina",
		null,
		null,
		null,
		null,
		null,
		336.92,
		364.07,
		48.32,
		17374.52,
		52.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		101.2,
		null,
		14,
		5108.99,
		null,
		134.08,
		146.61,
		17.87,
		6490.46,
		19.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		101.2,
		null,
		14,
		5108.99,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		64.92,
		23.85,
		0,
		10.49,
		5.41,
		7.77,
		57.45132743,
		21.10619469,
		0,
		9.28318584,
		4.78761062,
		6.87610619,
		112.45,
	],
	[
		"REFCUTPAP-PFR",
		-45.84665,
		-67.47166,
		"PLATTS - Refinery - Argentina - Chubut - Pan American Energy Group",
		328.72,
		358.67,
		82.5,
		14889.25,
		89.37,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pan American Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDNGCOC-PFR",
		19.05875279,
		108.638293,
		"PLATTS - Refinery - China - Dongfang - CNOOC",
		null,
		null,
		null,
		null,
		null,
		101.8,
		110.07,
		23.48,
		4567.36,
		25.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDAGPTC-PFR",
		39.074769,
		117.002153,
		"PLATTS - Refinery - China - Dagang - PetroChina",
		633.56,
		684.49,
		108.92,
		30508.85,
		117.16,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDNKCOG-PFR",
		51.044045,
		2.332366,
		"PLATTS - Refinery - France - Dunkirk - Colas Group",
		null,
		null,
		null,
		null,
		null,
		27.02,
		28.76,
		4.13,
		1509.41,
		4.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		4.23,
		0.56,
		203.34,
		0.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Colas Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDALDAN-PFR",
		38.9182,
		121.6283,
		"PLATTS - Refinery - China - Dalian - Dalian Jinyuan",
		null,
		null,
		null,
		null,
		null,
		167.7,
		181.17,
		37.24,
		7875.98,
		39.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dalian Jinyuan",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDOSTOT-PFR",
		47.31167,
		-2.065494,
		"PLATTS - Refinery - France - Donges - Total",
		null,
		null,
		null,
		null,
		null,
		619.36,
		650.62,
		84.89,
		30907.12,
		89.17,
		0,
		null,
		0,
		0,
		null,
		4.57,
		null,
		0.68,
		247.22,
		null,
		127.06,
		null,
		16.77,
		6120.21,
		null,
		75,
		79.35,
		32.13,
		2628.42,
		34,
		0,
		null,
		0,
		0,
		null,
		102.47,
		null,
		13.33,
		4863.85,
		null,
		12.01,
		null,
		1.66,
		604.81,
		null,
		8.01,
		null,
		1.11,
		404.32,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		68.49,
		37.63,
		20.38,
		12.6,
		5.26,
		12.54,
		43.1705011,
		23.71887803,
		12.84588717,
		7.94201072,
		3.31547431,
		7.90419162,
		156.91,
	],
	[
		"REFDALWPC-PFR",
		38.982126,
		121.887193,
		"PLATTS - Refinery - China - Dalian - West Pacific Petrochemical Corp.",
		null,
		null,
		null,
		null,
		null,
		663.83,
		717.94,
		133.57,
		30446.09,
		143.41,
		0,
		null,
		0,
		0,
		null,
		16.6,
		null,
		2.46,
		898.96,
		null,
		166,
		null,
		22.94,
		8372.66,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		16.6,
		null,
		2.16,
		787.91,
		null,
		132.8,
		null,
		18.31,
		6685.8,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinochem_China National Petroleum Corp._Total_Dalian Construction and Investment Co",
		"33.6_30_20_16.4",
		null,
		"Active",
		null,
		48.19,
		64.37,
		10.72,
		11.28,
		16.04,
		16.06,
		28.93599135,
		38.65137505,
		6.43689204,
		6.77314759,
		9.6313198,
		9.64332893,
		166.66,
	],
	[
		"REFDQGDYI-PFR",
		46.5969,
		125.1015,
		"PLATTS - Refinery - China - Daqing - Daqing Lianyi",
		null,
		null,
		null,
		null,
		null,
		40.7,
		43.78,
		6.31,
		2155.66,
		6.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Daqing Lianyi",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDAMTZG-PFR",
		-6.8763,
		39.298,
		"PLATTS - Refinery - Tanzania - Dar Es Salaam - Tanzanian Govt.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		584.6,
		641.67,
		136.32,
		25953.98,
		149.21,
		"Tanzanian Govt.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFDARSAE-PFR",
		14.740653,
		-17.348128,
		"PLATTS - Refinery - Senegal - Dakar - Societe Africaine De Raffinage",
		312.2,
		342.81,
		138.83,
		10558.67,
		151.63,
		46.02,
		50.33,
		6.29,
		2275.68,
		6.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.09,
		759.43,
		null,
		70.1,
		76.88,
		39.95,
		1807.31,
		43.61,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.09,
		759.43,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		-16.07,
		-17.64,
		-2.11,
		-775.69,
		-2.33,
		"Banque National Du Senegal_Saudi Binladin Group_Total",
		"46.4_33.6_20",
		null,
		"Active",
		null,
		5.11,
		3.71,
		4.5,
		1.31,
		0.18,
		0,
		34.06666667,
		24.73333333,
		30,
		8.73333333,
		1.2,
		0,
		14.82,
	],
	[
		"REFDRIRFD-PFR",
		46.36144,
		26.44431,
		"PLATTS - Refinery - Romania - Darmanesti - Rafinaria Darmanesti",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		0.01,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Imperial Oil_Unknown",
		"69.17_30.83",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDCHJSA-PFR",
		49.341352,
		23.481651,
		"PLATTS - Refinery - Ukraine - Drohobych - JSC Galichina - {Drogobych - Drohobycz}",
		190.42,
		207.28,
		26.66,
		9667.61,
		29.01,
		-0.01,
		0.01,
		0,
		0.06,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ukrainian State_Rommannor Investments Ltd_Weavernal Holdings Ltd_Deneiro Ventures Ltd_Dommennium Enterprices Ltd",
		"25_18.75_18.75_18.75_18.75",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDRKGES-PFR",
		29.756284,
		-95.08814,
		"PLATTS - Refinery - United States - Deer Park - Global Octanes",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mitsui_Daicel Chemical Industries",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDEEABN-PFR",
		56.464718,
		-2.947862,
		"PLATTS - Refinery - United Kingdom - Dundee - A.B. Nynas",
		null,
		null,
		null,
		null,
		null,
		0.02,
		0.02,
		-0.01,
		0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_Neste Oil",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDTIDNY-PFR",
		11.8146,
		42.8453,
		"PLATTS - Refinery - Djibouti - Djibouti - Djibouti Regional Petroleum Company",
		195.09,
		212.91,
		68.15,
		7374.23,
		73.57,
		130.06,
		141.96,
		45.44,
		4916.16,
		49.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Al Brooge Securities_Djibouti Regional Petroleum Company",
		"75_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDEIZTD-PFR",
		14.08650284,
		98.19095482,
		"PLATTS - Refinery - Myanmar - Dawei - Zhenrong Energy Co. Ltd",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		305.2,
		333.66,
		41.39,
		15040.9,
		45.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zhenrong Energy Co. Ltd_Other Investors",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEANBEX-PFR",
		41.086226,
		20.007747,
		"PLATTS - Refinery - Albania - Elbasan - BITEX",
		null,
		null,
		null,
		null,
		null,
		16.75,
		17.78,
		2.46,
		897.25,
		2.61,
		5,
		null,
		0.74,
		271.17,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.74,
		271.17,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BITEX",
		"100",
		null,
		"Active",
		null,
		1.4,
		0,
		1.8,
		0.1,
		0.1,
		0.6,
		28,
		0,
		36,
		2,
		2,
		12,
		4,
	],
	[
		"REFDENADE-PFR",
		51.079129,
		6.840805,
		"PLATTS - Refinery - Germany - Dormagen - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		23.5,
		24.86,
		23.5,
		23.5,
		24.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEETSAH-PFR",
		4.636,
		7.9575,
		"PLATTS - Refinery - Nigeria - Eket - Sahara Petroleum Exploration",
		null,
		null,
		null,
		null,
		null,
		12,
		13.07,
		1.64,
		600,
		1.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sahara Petroleum Exploration",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEEWQGY-PFR",
		47.866525,
		-104.034193,
		"PLATTS - Refinery - United States - East Fairview - Quantum Energy",
		34.02,
		35.69,
		9.87,
		1410.45,
		10.4,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Quantum Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEIDSUY-PFR",
		13.1834,
		30.2226,
		"PLATTS - Refinery - North Sudan - El Obeid - Sudan Petroleum Company - {Al-Khurais}",
		35,
		38.13,
		4.79,
		1750,
		5.22,
		10,
		10.9,
		1.37,
		500,
		1.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sudanese Government",
		"100",
		null,
		"Active",
		null,
		1.95,
		1.39,
		1.67,
		0,
		0,
		0.02,
		39,
		27.8,
		33.4,
		0,
		0,
		0.4,
		5.03,
	],
	[
		"REFEKSCRM-PFR",
		37.842806,
		-96.858359,
		"PLATTS - Refinery - United States - El Dorado (KS) - Coastal Refining and Marketing Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.02,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The Coastal Corporation",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGKNG-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Kelida Refining",
		-44,
		-46.55,
		-6.03,
		-2200,
		-6.38,
		44,
		46.55,
		6.03,
		2200,
		6.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kelida Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEKSHER-PFR",
		37.793333,
		-96.87333,
		"PLATTS - Refinery - United States - El Dorado (KS) - Holly-Frontier",
		null,
		null,
		null,
		null,
		null,
		616.19,
		649.34,
		173.73,
		25444.52,
		183.43,
		61.13,
		null,
		9.08,
		3315.5,
		null,
		0,
		null,
		0,
		0,
		null,
		106,
		null,
		14.92,
		5446.62,
		null,
		null,
		null,
		null,
		null,
		null,
		1.14,
		null,
		0.15,
		55.47,
		null,
		43.73,
		null,
		5.69,
		2075.65,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Holly-Frontier",
		"100",
		null,
		"Active",
		null,
		41.99,
		67.5,
		0.28,
		3.51,
		-3.29,
		0.28,
		37.40424016,
		60.12827365,
		0.24942099,
		3.12667023,
		-2.9306966,
		0.24942099,
		110.28,
	],
	[
		"REFEQGPEU-PFR",
		3.7771,
		8.7106,
		"PLATTS - Refinery - Equatorial Guinea - Punta Europa - Marathon Oil",
		null,
		null,
		null,
		null,
		null,
		5,
		5.45,
		0.68,
		250,
		0.75,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		10.9,
		1.37,
		500,
		1.49,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Oil",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFERTGVR-PFR",
		51.935087,
		4.167022,
		"PLATTS - Refinery - Netherlands - Europoort - Gunvor",
		-34.85,
		-36.36,
		-4.78,
		-1747.14,
		-4.99,
		102.6,
		107.87,
		12.65,
		4577.39,
		13.31,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		24,
		null,
		3.31,
		1208.28,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		24,
		null,
		3.31,
		1208.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gunvor",
		"100",
		null,
		"Active",
		null,
		19.19,
		9.78,
		17.37,
		13.69,
		2.31,
		1.64,
		25.93243243,
		13.21621622,
		23.47297297,
		18.5,
		3.12162162,
		2.21621622,
		63.97,
	],
	[
		"REFDIGYAT-PFR",
		38.0905312,
		118.88919382,
		"PLATTS - Refinery - China - Dongying - Yatong Petrochemical",
		null,
		null,
		null,
		null,
		null,
		357.33,
		385.17,
		51.64,
		18299.82,
		55.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yatong Petrochemical Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGYIL-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Yisheng oil",
		null,
		null,
		null,
		null,
		null,
		8.1,
		8.69,
		1.27,
		427.76,
		1.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yisheng oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDNECND-PFR",
		45.1759,
		20.206,
		"PLATTS - Refinery - Serbia - Danube - Comico Overseas N.V. Holland",
		287.25,
		313.37,
		46.58,
		13669.71,
		50.61,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Comico Overseas N.V. Holland",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDQMDRP-PFR",
		19.66538,
		57.71024,
		"PLATTS - Refinery - Oman - Duqm - Duqm Refinery & Petrochemical Ind.",
		null,
		null,
		null,
		null,
		null,
		881.76,
		964.22,
		278.84,
		35251.1,
		301.72,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum International_Oman Oil Co.",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFDTHIMP-PFR",
		44.641359,
		-63.53777,
		"PLATTS - Refinery - Canada - Dartmouth - Imperial Oil",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0.02,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Imperial Oil",
		"69.9_30.1",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDUNEEF-PFR",
		-29.94881,
		30.985689,
		"PLATTS - Refinery - South Africa - Durban - Enref - {ENGEN}",
		null,
		null,
		null,
		null,
		null,
		-0.05,
		-0.08,
		-0.07,
		-1.19,
		-0.04,
		0,
		null,
		0,
		0,
		null,
		3.5,
		null,
		0.52,
		189.54,
		null,
		35,
		null,
		4.77,
		1742.45,
		null,
		null,
		null,
		null,
		null,
		null,
		1.75,
		null,
		0.24,
		85.4,
		null,
		10.5,
		null,
		1.36,
		498.37,
		null,
		19.25,
		null,
		2.65,
		969.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petronas_Worldwide African Invst. Holdings",
		"80_20",
		null,
		"Active",
		null,
		25.39,
		25.39,
		6.84,
		8.96,
		-0.31,
		0,
		34.78082192,
		34.78082192,
		9.36986301,
		12.2739726,
		-0.42465753,
		0,
		66.25,
	],
	[
		"REFDVAPVA-PFR",
		48.811167,
		19.436789,
		"PLATTS - Refinery - Slovakia - Dubova - Petrochema Works Dubova",
		null,
		null,
		null,
		null,
		null,
		1.2,
		1.29,
		0.15,
		58.48,
		0.17,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Slovakian Government Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEDNALS-PFR",
		53.531891,
		-113.365049,
		"PLATTS - Refinery - Canada - Edmonton - Alberta Envirofuels",
		null,
		null,
		null,
		null,
		null,
		12.9,
		13.66,
		1.44,
		519.7,
		1.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron-Texaco Corp._Fortum",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEDNSUR-PFR",
		53.55225,
		-113.350348,
		"PLATTS - Refinery - Canada - Edmonton - Suncor",
		null,
		null,
		null,
		null,
		null,
		462.03,
		486.25,
		90.68,
		21252.73,
		95.6,
		9.38,
		null,
		1.39,
		508.85,
		null,
		0,
		null,
		0,
		0,
		null,
		116,
		null,
		15.91,
		5806.5,
		null,
		null,
		null,
		null,
		null,
		null,
		13.65,
		null,
		1.82,
		665.93,
		null,
		20.47,
		null,
		2.66,
		971.62,
		null,
		0,
		null,
		0,
		0,
		null,
		72.5,
		null,
		10.03,
		3660.1,
		null,
		null,
		null,
		null,
		null,
		null,
		"Suncor",
		"100",
		null,
		"Active",
		null,
		54.86,
		68.74,
		1.38,
		7.54,
		-3.14,
		8.46,
		40.33823529,
		50.54411765,
		1.01470588,
		5.54411765,
		-2.30882353,
		6.22058824,
		137.84,
	],
	[
		"REFEILKAR-PFR",
		36.19111,
		44.00917,
		"PLATTS - Refinery - Iraq - Erbil - Kar Group",
		null,
		null,
		null,
		null,
		null,
		362.82,
		397.31,
		47.24,
		17130.52,
		51.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		8.28,
		3020.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		8.28,
		3020.69,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KRG",
		"100",
		null,
		"Active",
		null,
		35.11,
		15.57,
		61.07,
		12.7,
		3.92,
		0.21,
		25.81617647,
		11.44852941,
		44.90441176,
		9.33823529,
		2.88235294,
		0.15441176,
		128.58,
	],
	[
		"REFBT2PAL-PFR",
		-6.0328,
		106.1637,
		"PLATTS - Refinery - Indonesia - Banten (2) - PT Chandra Asri Petrochemical",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		210.1,
		227.94,
		25.02,
		9100.4,
		27.16,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_PT Chandra Asri Petrochemical",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFELFHEL-PFR",
		38.040639,
		23.509637,
		"PLATTS - Refinery - Greece - Elefsina - Hellenic Petroleum",
		null,
		null,
		null,
		null,
		null,
		343.71,
		361.31,
		139.65,
		12310.73,
		147.44,
		15,
		null,
		2.23,
		813.52,
		null,
		0,
		null,
		0,
		0,
		null,
		100.99,
		null,
		13.97,
		5099.85,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		1.95,
		711.96,
		null,
		66.99,
		null,
		9.24,
		3372.43,
		null,
		4,
		null,
		0.55,
		201.94,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hellenic Petroleum",
		"100",
		null,
		"Active",
		null,
		59.94,
		21.6,
		2.54,
		11.95,
		5.16,
		8.37,
		61.16326531,
		22.04081633,
		2.59183673,
		12.19387755,
		5.26530612,
		8.54081633,
		109.56,
	],
	[
		"REFCAUXUP-PFR",
		38.2106,
		116.8365,
		"PLATTS - Refinery - China - Cangzhou - Xinhai Chemical Group",
		43.6,
		48.23,
		5.95,
		2134.14,
		6.58,
		195.7,
		208.73,
		28.57,
		10168.27,
		30.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		625.35,
		673.14,
		132.96,
		29110.39,
		142.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xinhai Chemical Group",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBUAUAZ-PFR",
		39.735464,
		64.490801,
		"PLATTS - Refinery - Uzbekistan - Bukhara - Uzbekneftegaz",
		23,
		25.84,
		2.67,
		972.31,
		2.99,
		136.64,
		150.99,
		18.12,
		6608.36,
		19.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		22.64,
		null,
		2.94,
		1074.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		22.64,
		null,
		2.94,
		1074.48,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Uzbekneftegaz",
		"100",
		null,
		"Active",
		null,
		6.33,
		14.2,
		0,
		1.34,
		0.32,
		0.05,
		27.95936396,
		62.72084806,
		0,
		5.91872792,
		1.41342756,
		0.22084806,
		22.25,
	],
	[
		"REFEREIND-PFR",
		13.2175,
		80.3216,
		"PLATTS - Refinery - India - Ennore - Indian Oil Corp.",
		897.97,
		985.94,
		128.39,
		45687.13,
		140.86,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCBASYK-PFR",
		35.61,
		140.1181,
		"PLATTS - Refinery - Japan - Chiba - Sankyo Yuka K.K.",
		null,
		null,
		null,
		null,
		null,
		1.8,
		1.9,
		0.25,
		92.93,
		0.27,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sankyo Yuka K.K.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBY2ATS-PFR",
		29.7355,
		-94.9774,
		"PLATTS - Refinery - United States - Baytown (2) - Air Products",
		null,
		null,
		null,
		null,
		null,
		125,
		132.25,
		125,
		125,
		132.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFERTLBR-PFR",
		51.96747,
		4.019489,
		"PLATTS - Refinery - Netherlands - Europoort - LyondellBasell Refining",
		null,
		null,
		null,
		null,
		null,
		12,
		12.7,
		1.42,
		517.73,
		1.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ARCO",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCDESHL-PFR",
		-33.829004,
		151.036282,
		"PLATTS - Refinery - Australia - Clyde - Shell",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.04,
		0.03,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCADROR-PFR",
		-22.203469,
		-63.665161,
		"PLATTS - Refinery - Argentina - Campo Duran - Refinor",
		4.2,
		4.51,
		0.57,
		210,
		0.62,
		54.01,
		58.76,
		7.27,
		2655.87,
		7.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.53,
		189.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.53,
		189.86,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF_Perez Companc_Pluspetrol_Astra S.A. Argentina_Repsol",
		"30_28_21_11_10",
		null,
		"Active",
		null,
		2.49,
		1.43,
		1.8,
		0.44,
		0.08,
		0.51,
		35.57142857,
		20.42857143,
		25.71428571,
		6.28571429,
		1.14285714,
		7.28571429,
		6.76,
	],
	[
		"REFCTIMLP-PFR",
		27.815994,
		-97.394785,
		"PLATTS - Refinery - United States - Corpus Christi - Martin Midstream Partners LP",
		100,
		104.28,
		11.76,
		4294.12,
		12.26,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Martin Midstream Partners LP",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCAIFNG-PFR",
		14.3585,
		100.5709,
		"PLATTS - Refinery - Thailand - Chang Mai - Fang",
		null,
		null,
		null,
		null,
		null,
		3.5,
		3.65,
		0.49,
		180.14,
		0.52,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.14,
		50.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.14,
		50.48,
		null,
		null,
		null,
		null,
		null,
		null,
		"Fang",
		"100",
		null,
		"Active",
		null,
		0.2,
		0,
		0.37,
		0.1,
		0,
		0.11,
		20,
		0,
		37,
		10,
		0,
		11,
		0.78,
	],
	[
		"REFCEWTES-PFR",
		29.763502,
		-95.102708,
		"PLATTS - Refinery - United States - Channelview - Targa Resources",
		null,
		null,
		null,
		null,
		null,
		91.04,
		95.25,
		11.13,
		4049.16,
		11.65,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Targa Resources",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCEYCAC-PFR",
		32.79821,
		-93.41181,
		"PLATTS - Refinery - United States - Cotton Valley - Calumet Lubricants Co.",
		null,
		null,
		null,
		null,
		null,
		19.5,
		20.43,
		4.85,
		861.07,
		5.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.28,
		null,
		1.09,
		396.18,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		7.19,
		null,
		0.94,
		341.32,
		null,
		1.09,
		null,
		0.15,
		54.85,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kerr-McGee",
		"100",
		null,
		"Active",
		null,
		2.64,
		0.44,
		0.53,
		0.22,
		-0.13,
		1.76,
		34.73684211,
		5.78947368,
		6.97368421,
		2.89473684,
		-1.71052632,
		23.15789474,
		5.46,
	],
	[
		"REFCGNEOL-PFR",
		10.316596,
		-75.502562,
		"PLATTS - Refinery - Colombia - Cartagena - Ecopetrol",
		null,
		null,
		null,
		null,
		null,
		936.11,
		1020.63,
		372.77,
		33377.73,
		399.95,
		42.18,
		null,
		6.27,
		2287.62,
		null,
		0,
		null,
		0,
		0,
		null,
		140.6,
		null,
		19.88,
		7256.27,
		null,
		40,
		42.94,
		5.48,
		2000,
		5.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		98.42,
		null,
		13.61,
		4968.64,
		null,
		127.73,
		140.69,
		38.9,
		5272.32,
		42.24,
		"Ecopetrol",
		"100",
		null,
		"Active",
		null,
		66.97,
		43.01,
		9.08,
		10.83,
		10.25,
		7.07,
		45.25,
		29.06081081,
		6.13513514,
		7.31756757,
		6.92567568,
		4.77702703,
		147.21,
	],
	[
		"REFCBAILL-PFR",
		35.486512,
		140.03498,
		"PLATTS - Refinery - Japan - Chiba - Idemitsu Showa Shell - {Idemitsu Kosan Company}",
		null,
		null,
		null,
		null,
		null,
		569.89,
		603.63,
		119.73,
		26587.26,
		126.76,
		0.11,
		null,
		0.02,
		6.22,
		null,
		2.38,
		null,
		0.35,
		128.89,
		null,
		128.98,
		null,
		17.49,
		6382.44,
		null,
		12,
		12.7,
		1.72,
		626.61,
		1.82,
		67,
		null,
		8.96,
		3269.39,
		null,
		6,
		null,
		0.78,
		284.63,
		null,
		50.49,
		null,
		6.96,
		2541.85,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company",
		"100",
		0,
		"Active",
		null,
		45.81,
		41.14,
		9.44,
		25.93,
		12.77,
		14.67,
		29.10604232,
		26.13889065,
		5.99783976,
		16.47499841,
		8.11360315,
		9.32079548,
		149.76,
	],
	[
		"REFCBAMTS-PFR",
		35.502854,
		140.039696,
		"PLATTS - Refinery - Japan - Chiba - Mitsui Petrochemical",
		null,
		null,
		null,
		null,
		null,
		0.18,
		0.19,
		0.02,
		7.77,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mitsui",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCHTSIL-PFR",
		42.3147,
		69.5883,
		"PLATTS - Refinery - Kazakhstan - Chimkent - Stratus Oil",
		13.21,
		14.45,
		1.77,
		638.94,
		1.92,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Stratus Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCNIOGC-PFR",
		13.0802,
		80.2838,
		"PLATTS - Refinery - India - Chennai - ONGC",
		889.21,
		976.09,
		126.98,
		45173.58,
		139.28,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ONGC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCERBBP-PFR",
		42.84324,
		-106.353115,
		"PLATTS - Refinery - United States - Casper - BP",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.03,
		0.01,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Amoco Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCOSCET-PFR",
		22.191103,
		-80.52041,
		"PLATTS - Refinery - Cuba - Cienfuegos - Cupet",
		407.8,
		444.92,
		186.81,
		12930.46,
		199.51,
		100.19,
		109.33,
		13.47,
		4915.76,
		14.67,
		1.6,
		null,
		0.24,
		86.78,
		null,
		0,
		null,
		0,
		0,
		null,
		8,
		null,
		1.12,
		408.98,
		null,
		123,
		132.94,
		18.23,
		6652.15,
		19.69,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.4,
		null,
		0.88,
		322.21,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cupet",
		"100",
		null,
		"Active",
		null,
		5.64,
		1.56,
		9.34,
		0.76,
		-0.25,
		0.08,
		31.33333333,
		8.66666667,
		51.88888889,
		4.22222222,
		-1.38888889,
		0.44444444,
		17.13,
	],
	[
		"REFCHTPAN-PFR",
		42.261259,
		69.652611,
		"PLATTS - Refinery - Kazakhstan - Chimkent - PetroKazakhstan - {Shymkent}",
		null,
		null,
		null,
		null,
		null,
		450.86,
		498.35,
		78.2,
		21211.07,
		85.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		78.16,
		null,
		10.16,
		3709.66,
		null,
		455.48,
		503.54,
		79.62,
		21723.34,
		87.48,
		0,
		null,
		0,
		0,
		null,
		78.16,
		null,
		10.16,
		3709.66,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._KazMunayGaz",
		"50_50",
		null,
		"Active",
		null,
		30.14,
		31.54,
		13.54,
		5.14,
		8.74,
		0,
		33.93379869,
		35.51002027,
		15.24431434,
		5.78698491,
		9.8401261,
		0,
		89.14,
	],
	[
		"REFCRAGST-PFR",
		-5.3265,
		-39.7156,
		"PLATTS - Refinery - Brazil - Ceara - Global Coast",
		10,
		10.42,
		1.36,
		500,
		1.42,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Global Coast",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCOAEBN-PFR",
		-17.453264,
		-66.124127,
		"PLATTS - Refinery - Bolivia - Cochabamba - Empresa Boliviana de Refinacion",
		null,
		null,
		null,
		null,
		null,
		103.35,
		112.74,
		14.15,
		5168.72,
		15.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		33.5,
		null,
		4.36,
		1590.05,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		33.5,
		null,
		4.36,
		1590.05,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF Bolivianos",
		"100",
		null,
		"Active",
		null,
		9.73,
		11.31,
		5.19,
		2.88,
		2.24,
		0,
		29.48484848,
		34.27272727,
		15.72727273,
		8.72727273,
		6.78787879,
		0,
		31.35,
	],
	[
		"REFCRGMUM-PFR",
		38.33834,
		-82.5909,
		"PLATTS - Refinery - United States - Catlettsburg - Marathon Petroleum",
		38.7,
		41.52,
		7.62,
		2162.5,
		8.16,
		877.64,
		924.07,
		120.09,
		43674,
		126.54,
		2.55,
		null,
		0.38,
		138.54,
		null,
		0,
		null,
		0,
		0,
		null,
		240.87,
		null,
		32.14,
		11732.28,
		null,
		null,
		null,
		null,
		null,
		null,
		30.34,
		null,
		4.06,
		1480.49,
		null,
		127.55,
		null,
		16.59,
		6054.26,
		null,
		6.96,
		null,
		0.96,
		350.55,
		null,
		73.46,
		null,
		10.16,
		3708.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		59.57,
		177.57,
		5.51,
		25.2,
		3.32,
		3.75,
		21.17969139,
		63.13375524,
		1.95904146,
		8.95968143,
		1.18040247,
		1.33328593,
		274.91,
	],
	[
		"REFCP2PRT-PFR",
		-7.736,
		109.0068,
		"PLATTS - Refinery - Indonesia - Cilacap (2) - Pertamina",
		610.38,
		662.41,
		173.62,
		25011.58,
		185.81,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCSNBBP-PFR",
		39.95602,
		0.00186681,
		"PLATTS - Refinery - Spain - Castellon - BP",
		null,
		null,
		null,
		null,
		null,
		609.59,
		641.56,
		266.4,
		19324.63,
		279.82,
		6.02,
		null,
		0.89,
		326.49,
		null,
		0,
		null,
		0,
		0,
		null,
		90.82,
		null,
		12.19,
		4449.31,
		null,
		null,
		null,
		null,
		null,
		null,
		5.16,
		null,
		0.69,
		251.79,
		null,
		48.69,
		null,
		6.33,
		2310.81,
		null,
		19.78,
		null,
		2.73,
		995.81,
		null,
		11.18,
		null,
		1.55,
		564.41,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		40.61,
		31.38,
		5.01,
		17.62,
		5.42,
		0.16,
		38.45279803,
		29.71309535,
		4.74386895,
		16.68402613,
		5.13208976,
		0.1515008,
		100.21,
	],
	[
		"REFCRENRP-PFR",
		11.7427,
		79.7503,
		"PLATTS - Refinery - India - Cuddalore - Nagarjuna Oil Corp",
		356.12,
		391.42,
		49.32,
		17946.83,
		54.14,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		467.88,
		513.43,
		99.58,
		21415.59,
		108.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tata_Nagarjuna Fertilizers_Trafigura_Cuddalore Port Development Company_Tamal Nadu Industrial Development",
		"30_27_24_10_5",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTICGO-PFR",
		27.80855,
		-97.42577,
		"PLATTS - Refinery - United States - Corpus Christi - Citgo",
		1,
		1.07,
		0.16,
		58.4,
		0.17,
		661.01,
		695.09,
		93.14,
		33114.5,
		97.94,
		55.33,
		null,
		8.22,
		3000.58,
		null,
		6.36,
		null,
		0.94,
		344.6,
		null,
		74.31,
		null,
		10.91,
		3981.17,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.82,
		null,
		1.08,
		393.9,
		null,
		4.8,
		null,
		0.66,
		242.09,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		0,
		"Active",
		null,
		21.63,
		36.27,
		0.43,
		6.66,
		0.73,
		1,
		27.32095491,
		45.81280788,
		0.54313503,
		8.41227738,
		0.92206644,
		1.26310471,
		66.71,
	],
	[
		"REFCRNATS-PFR",
		33.780251,
		-118.240787,
		"PLATTS - Refinery - United States - Carson - Air Products",
		null,
		null,
		null,
		null,
		null,
		170,
		179.86,
		170,
		170,
		179.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTICLC-PFR",
		27.826067,
		-97.438214,
		"PLATTS - Refinery - United States - Corpus Christi - CCI Corpus Christi LLC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		130.1,
		136.1,
		15.86,
		5752.66,
		16.58,
		"Castleton Commodities",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCTILBR-PFR",
		27.8112,
		-97.59381,
		"PLATTS - Refinery - United States - Corpus Christi - LyondellBasell Refining",
		null,
		null,
		null,
		null,
		null,
		11.63,
		12.31,
		1.37,
		501.77,
		1.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ARCO",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCRNMUM-PFR",
		33.821125,
		-118.243287,
		"PLATTS - Refinery - United States - Carson - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		1008.36,
		1062.24,
		231.6,
		45299.09,
		244.42,
		60.02,
		null,
		8.92,
		3255.05,
		null,
		8.16,
		null,
		1.21,
		441.97,
		null,
		268,
		null,
		37.56,
		13709.35,
		null,
		null,
		null,
		null,
		null,
		null,
		2.31,
		null,
		0.31,
		112.55,
		null,
		17.26,
		null,
		2.24,
		819.27,
		null,
		139.49,
		null,
		19.24,
		7022.7,
		null,
		40.76,
		null,
		5.64,
		2057.81,
		null,
		null,
		null,
		null,
		null,
		null,
		"Andeavor",
		"100",
		null,
		"Active",
		null,
		81.57,
		174.85,
		2.27,
		58.93,
		3.46,
		0.01,
		24.92589763,
		53.43009931,
		0.69365928,
		18.00763942,
		1.05729565,
		0.00305577,
		321.09,
	],
	[
		"REFCUKMRE-PFR",
		20.905583,
		94.824967,
		"PLATTS - Refinery - Myanmar - Chauk - Myanmar Petrochemical Enterpr.",
		null,
		null,
		null,
		null,
		null,
		7.8,
		8.26,
		1.09,
		400.27,
		1.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.07,
		null,
		0.29,
		104.5,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.07,
		null,
		0.29,
		104.5,
		null,
		null,
		null,
		null,
		null,
		null,
		"Myanmar Petrochemical Enterpr.",
		"100",
		null,
		"Active",
		null,
		0.59,
		0.54,
		0.89,
		0.31,
		0,
		0,
		25.65217391,
		23.47826087,
		38.69565217,
		13.47826087,
		0,
		0,
		2.34,
	],
	[
		"REFCSRATS-PFR",
		47.043156,
		7.037924,
		"PLATTS - Refinery - Switzerland - Cressier - Air Products",
		null,
		null,
		null,
		null,
		null,
		7,
		7.41,
		7,
		7,
		7.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDA2SAE-PFR",
		14.6934,
		-17.4479,
		"PLATTS - Refinery - Senegal - Dakar (2) - Societe Africaine De Raffinage",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		317.2,
		347.42,
		43.32,
		15736.35,
		47.45,
		"Societe Africaine De Raffinage",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFDAIDCO-PFR",
		25.075,
		55.1888,
		"PLATTS - Refinery - United Arab Emirates - Dubai - Dubai Oil Refining Co",
		377.2,
		414.94,
		51.48,
		18726.86,
		56.6,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENOC_Sonangol",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCTIFHR-PFR",
		27.83558,
		-97.52214,
		"PLATTS - Refinery - United States - Corpus Christi - Flint Hills Resources",
		null,
		null,
		null,
		null,
		null,
		992.7,
		1042.77,
		134.29,
		48631.1,
		141.07,
		2.27,
		null,
		0.34,
		123.03,
		null,
		0,
		null,
		0,
		0,
		null,
		220.6,
		null,
		28.74,
		10490.24,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		216.92,
		null,
		28.21,
		10296.01,
		null,
		1.41,
		null,
		0.2,
		71.2,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Koch Industries",
		"100",
		null,
		"Active",
		null,
		74.54,
		108.48,
		2.11,
		20.03,
		6.76,
		7.26,
		35.7660381,
		52.05124514,
		1.01242743,
		9.6108632,
		3.24360635,
		3.48351807,
		219.17,
	],
	[
		"REFCTIMRS-PFR",
		27.813057,
		-97.431801,
		"PLATTS - Refinery - United States - Corpus Christi - Magellan Midstream Partners",
		null,
		null,
		null,
		null,
		null,
		63.04,
		65.96,
		7.72,
		2804.3,
		8.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		63.04,
		65.96,
		7.72,
		2804.3,
		8.1,
		"Trafigura_Magellan Midstream Partners",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDALSAC-PFR",
		38.9182,
		121.6283,
		"PLATTS - Refinery - China - Dalian - SABIC",
		1277.88,
		1372.04,
		510.72,
		45942.96,
		543.1,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC_Dalian Shide Group",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCVOPTG-PFR",
		38.758617,
		-9.096156,
		"PLATTS - Refinery - Portugal - Cabo Ruivo - Petrogal",
		null,
		null,
		null,
		null,
		null,
		0.02,
		0.01,
		0.01,
		0,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrogal_Finpetro_Total",
		"75_13_12",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDERSUR-PFR",
		39.80507,
		-104.944,
		"PLATTS - Refinery - United States - Denver - Suncor - {Commerce City}",
		null,
		null,
		null,
		null,
		null,
		299.98,
		316.45,
		59.77,
		13744.32,
		63.12,
		22.27,
		null,
		3.31,
		1208.01,
		null,
		0,
		null,
		0,
		0,
		null,
		91.93,
		null,
		12.37,
		4514.1,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		69.65,
		null,
		9.06,
		3306.09,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Suncor",
		"100",
		null,
		"Active",
		null,
		27.13,
		49.54,
		0.52,
		7.23,
		5.72,
		0,
		26.80035563,
		48.93806184,
		0.51368171,
		7.14215154,
		5.65049886,
		0,
		90.14,
	],
	[
		"REFCVTATS-PFR",
		30.10864,
		-90.88574,
		"PLATTS - Refinery - United States - Convent - Air Products",
		null,
		null,
		null,
		null,
		null,
		110,
		116.38,
		110,
		110,
		116.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDGNDEN-PFR",
		23.0445,
		113.7466,
		"PLATTS - Refinery - China - Dongguan - Dongguan Liantai Modified Bitumen",
		null,
		null,
		null,
		null,
		null,
		22.5,
		23.8,
		3.28,
		1197.12,
		3.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dongguan Liantai Modified Bitumen",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCYNPUS-PFR",
		51.514228,
		0.511055,
		"PLATTS - Refinery - United Kingdom - Coryton - Petroplus",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.02,
		-2.64,
		-0.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroplus",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGDYH-PFR",
		37.42349012,
		118.35996006,
		"PLATTS - Refinery - China - Dongying - Dongying Haike Group",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Local Investors",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDANKAT-PFR",
		35.9538,
		44.9533,
		"PLATTS - Refinery - Iraq - Dukhan - KAT",
		null,
		null,
		null,
		null,
		null,
		18.5,
		19.86,
		2.53,
		925,
		2.72,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		59,
		64.42,
		7.66,
		2797.51,
		8.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KAT",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGKEX-PFR",
		37.5652894,
		118.541112,
		"PLATTS - Refinery - China - Dongying - Kenli Petrochemical Complex",
		null,
		null,
		null,
		null,
		null,
		260.52,
		282.05,
		49.48,
		12553.96,
		53.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kenli Petrochemical Complex",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDENERD-PFR",
		51.0942,
		6.8408,
		"PLATTS - Refinery - Germany - Dormagen - Erdoel",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Erdoel Chemie",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGSSG-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Shandong Sincier Chemical Group",
		298.2,
		321.26,
		40.6,
		14740.45,
		43.69,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shenchi Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDESUWN-PFR",
		41.3133,
		19.4462,
		"PLATTS - Refinery - Albania - Durres - Unknown",
		90.05,
		97.55,
		12.02,
		4369.73,
		13,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDMISKC-PFR",
		1.6632,
		101.447,
		"PLATTS - Refinery - Indonesia - Dumai - SK Corporation",
		null,
		null,
		null,
		null,
		null,
		11,
		12.35,
		1.56,
		567.89,
		1.75,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SK Corporation_Pertamina",
		"65_35",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDONMUM-PFR",
		46.85497,
		-102.9088,
		"PLATTS - Refinery - United States - Dickinson - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		14.5,
		15.34,
		2.02,
		737.14,
		2.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.05,
		null,
		0.79,
		287.13,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		6.05,
		null,
		0.79,
		287.13,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		5.85,
		7.24,
		6.37,
		1.49,
		0,
		0,
		29.01785714,
		35.91269841,
		31.59722222,
		7.39087302,
		0,
		0,
		20.95,
	],
	[
		"REFDOUHEP-PFR",
		37.18726196,
		116.8449278,
		"PLATTS - Refinery - China - Dezhou - Hengyuan Petrochemical",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hengyuan Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDHNDKA-PFR",
		37.521083,
		67.40916,
		"PLATTS - Refinery - Uzbekistan - Dharkurgan - Dzharkurganneftepererabotka",
		null,
		null,
		null,
		null,
		null,
		3.45,
		3.7,
		0.5,
		179.64,
		0.53,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.75,
		null,
		0.38,
		138.56,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.75,
		null,
		0.38,
		138.56,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dzharkurganneftepererabotka",
		"100",
		null,
		"Active",
		null,
		0.84,
		1.1,
		0.4,
		0.13,
		0,
		0.01,
		30.54545455,
		40,
		14.54545455,
		4.72727273,
		0,
		0.36363636,
		2.47,
	],
	[
		"REFHUAWEN-PFR",
		38.3667,
		117.3333,
		"PLATTS - Refinery - China - Huanghua - Weiya Special Bitumen",
		null,
		null,
		null,
		null,
		null,
		168.65,
		179.57,
		31.97,
		8519.72,
		33.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Weiya Special Bitumen",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDQGDPH-PFR",
		46.56157,
		124.82719,
		"PLATTS - Refinery - China - Daqing - Daqing Petrochemical Corp.",
		null,
		null,
		null,
		null,
		null,
		1022.99,
		1100.63,
		379.48,
		39319.7,
		404.06,
		35.1,
		null,
		5.22,
		1903.64,
		null,
		0,
		null,
		0,
		0,
		null,
		117,
		null,
		16.35,
		5968.38,
		null,
		null,
		null,
		null,
		null,
		null,
		40.95,
		null,
		5.47,
		1998.23,
		null,
		0,
		null,
		0,
		0,
		null,
		5.85,
		null,
		0.81,
		294.52,
		null,
		35.1,
		null,
		4.85,
		1771.99,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		0,
		"Active",
		null,
		58.21,
		31.78,
		0,
		8.12,
		10.69,
		12.58,
		47.89763844,
		26.14992183,
		0,
		6.68147782,
		8.79618201,
		10.35135358,
		121.38,
	],
	[
		"REFDIGHUL-PFR",
		37.89459526,
		118.41089186,
		"PLATTS - Refinery - China - Dongying - Hualian Petrochemical",
		100,
		105.8,
		13.7,
		5000,
		14.49,
		110.22,
		117.86,
		15.59,
		5606.08,
		16.67,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hualian Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDQGZHL-PFR",
		46.69410121,
		124.79817278,
		"PLATTS - Refinery - China - Daqing - Zhonglan Petrochemical",
		null,
		null,
		null,
		null,
		null,
		69,
		74.16,
		9.65,
		3519.71,
		10.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ChemChina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDQMODC-PFR",
		19.6204,
		57.6351,
		"PLATTS - Refinery - Oman - Duqm - QQ (Oman Oil + ORPIC)",
		1010.71,
		1099.31,
		381.89,
		36847.61,
		411.84,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oman Refineries and Petrochemicals",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGSWP-PFR",
		37.41144815,
		118.37936349,
		"PLATTS - Refinery - China - Dongying - Shandong Wantong Petrochemical",
		null,
		null,
		null,
		null,
		null,
		185.1,
		197.78,
		26.3,
		9248.18,
		28.09,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Wantong Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDTYPBF-PFR",
		39.58772,
		-75.633053,
		"PLATTS - Refinery - United States - Delaware City - PBF Energy Company LLC",
		65,
		68.77,
		9.17,
		3346.26,
		9.7,
		968.97,
		1017.18,
		406.37,
		32868.36,
		426.43,
		41.06,
		null,
		6.1,
		2226.67,
		null,
		1,
		null,
		0.15,
		54.3,
		null,
		105.48,
		null,
		14.62,
		5336.52,
		null,
		null,
		null,
		null,
		null,
		null,
		14.35,
		null,
		1.92,
		700.29,
		null,
		40.19,
		null,
		5.23,
		1907.48,
		null,
		5.16,
		null,
		0.71,
		259.99,
		null,
		3.72,
		null,
		0.51,
		187.79,
		null,
		null,
		null,
		null,
		null,
		null,
		"PBF Energy Company LLC",
		"100",
		null,
		"Active",
		null,
		54.36,
		83.03,
		1.94,
		14.47,
		3.23,
		1.29,
		36.13400691,
		55.19143845,
		1.28955065,
		9.61845254,
		2.14703536,
		0.85748471,
		158.32,
	],
	[
		"REFBENNST-PFR",
		50.8197,
		5.3115,
		"PLATTS - Refinery - Belgium - Berlingen - Neste Oil",
		null,
		null,
		null,
		null,
		null,
		1,
		1.06,
		0.14,
		51.63,
		0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Neste Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGZHE-PFR",
		37.12917858,
		118.42490288,
		"PLATTS - Refinery - China - Dongying - Zhenghe - {Dongying Zhenghe Group}",
		null,
		null,
		null,
		null,
		null,
		419.39,
		452.01,
		138.34,
		17370.72,
		147.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ChemChina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDUNSAP-PFR",
		-29.974709,
		30.964454,
		"PLATTS - Refinery - South Africa - Durban - SAPREF",
		null,
		null,
		null,
		null,
		null,
		512.39,
		564.32,
		84.66,
		24242.27,
		93.07,
		0,
		null,
		0,
		0,
		null,
		8,
		null,
		1.19,
		433.23,
		null,
		80,
		null,
		10.82,
		3948.16,
		null,
		null,
		null,
		null,
		null,
		null,
		4,
		null,
		0.54,
		195.19,
		null,
		36,
		null,
		4.69,
		1708.72,
		null,
		32,
		null,
		4.42,
		1611.04,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_Shell_Thebe",
		"50_37.5_12.5",
		0,
		"Active",
		null,
		46.71,
		38.32,
		17.82,
		16.93,
		3.44,
		0,
		34.09489051,
		27.97080292,
		13.00729927,
		12.35766423,
		2.51094891,
		0,
		123.2,
	],
	[
		"REFBGALIB-PFR",
		30.4073,
		19.5788,
		"PLATTS - Refinery - Libya - Brega - Libyan National Oil Company - {Sirte Oil Company}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		-0.02,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDITATS-PFR",
		42.28533,
		-83.15722,
		"PLATTS - Refinery - United States - Detroit - Air Products",
		null,
		null,
		null,
		null,
		null,
		58,
		61.36,
		58,
		58,
		61.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBILBBP-PFR",
		-27.40309,
		153.140552,
		"PLATTS - Refinery - Australia - Bulwer Island - BP",
		null,
		null,
		null,
		null,
		null,
		-0.01,
		0.01,
		0.01,
		0,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDKHMUY-PFR",
		46.5871,
		109.4811,
		"PLATTS - Refinery - Mongolia - Darkhan - Mongolsekiuy",
		4,
		4.29,
		0.55,
		200,
		0.59,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mongolsekiuy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBISTNY-PFR",
		35.21539,
		35.965609,
		"PLATTS - Refinery - Syria - Banias - The Banias Refining Company",
		null,
		null,
		null,
		null,
		null,
		379.24,
		414.97,
		75.37,
		17640.66,
		81.96,
		11,
		null,
		1.63,
		596.58,
		null,
		0,
		null,
		0,
		0,
		null,
		56,
		null,
		7.65,
		2791.11,
		null,
		null,
		null,
		null,
		null,
		null,
		44,
		null,
		5.88,
		2147.06,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		134.08,
		144.85,
		104.56,
		1735.61,
		111.7,
		"Syrian Govt.",
		"100",
		null,
		"Active",
		null,
		21.79,
		8.48,
		17.35,
		1.57,
		1.19,
		2.28,
		40.35185185,
		15.7037037,
		32.12962963,
		2.90740741,
		2.2037037,
		4.22222222,
		52.66,
	],
	[
		"REFDOIASC-PFR",
		27.385021,
		95.619865,
		"PLATTS - Refinery - India - Digboi - Assam Oil Co.",
		-0.05,
		-0.06,
		0.06,
		21.08,
		0.06,
		30.12,
		33.13,
		4.22,
		1481.7,
		4.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		13.83,
		null,
		1.8,
		656.65,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		13.83,
		null,
		1.8,
		656.65,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		4.63,
		1.94,
		3.04,
		1.37,
		0.77,
		0.74,
		33.55072464,
		14.05797101,
		22.02898551,
		9.92753623,
		5.57971014,
		5.36231884,
		12.48,
	],
	[
		"REFEB2ROL-PFR",
		37.569694,
		-0.922953,
		"PLATTS - Refinery - Spain - Escombreras (2) - Repsol",
		null,
		null,
		null,
		null,
		null,
		13.3,
		14.07,
		1.88,
		686.63,
		1.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SK Lubricants_Repsol",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBIUSNT-PFR",
		9.2323713,
		29.81682299,
		"PLATTS - Refinery - South Sudan - Bentiu - South Sudan Government",
		null,
		null,
		null,
		null,
		null,
		10,
		10.9,
		1.37,
		500,
		1.49,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		43.03,
		47.16,
		5.75,
		2085.14,
		6.3,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Safinat_Nilepet Corp.",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFDQGDRC-PFR",
		46.57051834,
		124.83944534,
		"PLATTS - Refinery - China - Daqing - Daqing Refining Co.",
		null,
		null,
		null,
		null,
		null,
		280.5,
		303.21,
		38.66,
		14108.55,
		41.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		117,
		null,
		15.99,
		5836.73,
		null,
		null,
		null,
		null,
		null,
		null,
		40.95,
		null,
		5.47,
		1998.23,
		null,
		0,
		null,
		0,
		0,
		null,
		5.85,
		null,
		0.81,
		294.52,
		null,
		70.2,
		null,
		9.71,
		3543.98,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		25.73,
		20.5,
		4.09,
		6.42,
		11.61,
		22.28,
		27.06996318,
		21.567596,
		4.30299842,
		6.75433982,
		12.21462388,
		23.44029458,
		90.64,
	],
	[
		"REFECUSEU-PFR",
		-2.2262,
		-80.8587,
		"PLATTS - Refinery - Ecuador - Santa Elena - Unknown",
		897.3,
		984.63,
		121.95,
		44396.31,
		133.74,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBKDAON-PFR",
		35.37968,
		-119.0724,
		"PLATTS - Refinery - United States - Bakersfield - Global Clean Energy Holding Inc (GCEH)",
		88.18,
		93.29,
		66.71,
		1350.2,
		70.57,
		15.01,
		15.91,
		2.12,
		762.53,
		2.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		120.8,
		126.59,
		37.66,
		4722.14,
		39.69,
		"Global Clean Energy Holding Inc (GCEH)",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDRATGV-PFR",
		38.0954,
		69.3321,
		"PLATTS - Refinery - Tajikistan - Danghara - Tajik Gov.",
		null,
		null,
		null,
		null,
		null,
		10,
		10.74,
		1.37,
		500,
		1.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		14,
		15.03,
		1.92,
		700,
		2.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dong Ying Heli Investment",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEDNIMP-PFR",
		53.545289,
		-113.39477,
		"PLATTS - Refinery - Canada - Edmonton - Imperial Oil",
		null,
		null,
		null,
		null,
		null,
		587.53,
		618.34,
		132.12,
		25963.99,
		138.76,
		9.78,
		null,
		1.46,
		530.41,
		null,
		0,
		null,
		0,
		0,
		null,
		155.5,
		null,
		21.2,
		7741.03,
		null,
		null,
		null,
		null,
		null,
		null,
		23.47,
		null,
		3.13,
		1145.35,
		null,
		35.21,
		null,
		4.58,
		1671.1,
		null,
		0,
		null,
		0,
		0,
		null,
		87.04,
		null,
		12.04,
		4394.18,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Imperial Oil",
		"69.9_30.1",
		null,
		"Active",
		null,
		47.36,
		78.53,
		1.92,
		8.8,
		-4.92,
		9.58,
		29.78616352,
		49.38993711,
		1.20754717,
		5.53459119,
		-3.09433962,
		6.02515723,
		141.27,
	],
	[
		"REFBKDSND-PFR",
		35.380473,
		-119.0932144,
		"PLATTS - Refinery - United States - Bakersfield - Sunland",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"World Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDRKSDP-PFR",
		29.72059,
		-95.12806,
		"PLATTS - Refinery - United States - Deer Park - PEMEX",
		-12,
		-12.52,
		-1.64,
		-600,
		-1.72,
		1223.82,
		1289.34,
		262.83,
		56384.57,
		277.46,
		200.44,
		null,
		29.78,
		10870.76,
		null,
		1.78,
		null,
		0.26,
		96.25,
		null,
		283,
		null,
		40.55,
		14801.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		80.79,
		null,
		10.5,
		3834.34,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_PEMEX",
		"50.01_50",
		null,
		"Active",
		null,
		89.27,
		120.37,
		2.64,
		27.67,
		10.06,
		4.54,
		30.67170589,
		41.35715513,
		0.90706064,
		9.50695757,
		3.45645078,
		1.55986944,
		254.55,
	],
	[
		"REFBKUAAG-PFR",
		40.379204,
		49.906757,
		"PLATTS - Refinery - Azerbaijan - Baku - Azerineftyag",
		0,
		0,
		0.21,
		74.71,
		0.23,
		0,
		-0.01,
		-0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEGAIRS-PFR",
		-26.668499,
		143.273268,
		"PLATTS - Refinery - Australia - Eromanga - Inland Oil Refiners",
		null,
		null,
		null,
		null,
		null,
		1.42,
		1.49,
		0.2,
		71.25,
		0.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Inland Resources",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFN2FSC-PFR",
		41.8693,
		123.9242,
		"PLATTS - Refinery - China - Fushun (2) - Fushun Petrochem Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDUSPTS-PFR",
		-22.719873,
		-43.26698,
		"PLATTS - Refinery - Brazil - Duque de Caxias - Petrobras - {REDUC}",
		null,
		null,
		null,
		null,
		null,
		599.34,
		629.49,
		94.6,
		30329.65,
		99.45,
		46.03,
		null,
		6.84,
		2496.47,
		null,
		0,
		null,
		0,
		0,
		null,
		182,
		null,
		25,
		9126.37,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		74.79,
		null,
		9.73,
		3549.96,
		null,
		61.18,
		null,
		8.44,
		3079.94,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		70.29,
		39.84,
		19.98,
		11.58,
		10.99,
		5.92,
		41.34705882,
		23.43529412,
		11.75294118,
		6.81176471,
		6.46470588,
		3.48235294,
		158.6,
	],
	[
		"REFBLAIOM-PFR",
		44.57582,
		8.946733,
		"PLATTS - Refinery - Italy - Busalla - Iplom",
		null,
		null,
		null,
		null,
		null,
		117.94,
		124.26,
		34.29,
		5076.43,
		36.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31,
		null,
		4.15,
		1515.85,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		15.57,
		null,
		2.02,
		738.93,
		null,
		15.43,
		null,
		2.13,
		776.91,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Finoil_Energy Management Group",
		"99.8_0.2",
		null,
		"Active",
		null,
		19.29,
		0.19,
		1.68,
		1.7,
		0.35,
		10.69,
		53.80753138,
		0.52998605,
		4.68619247,
		4.74198047,
		0.9762901,
		29.81868898,
		33.89,
	],
	[
		"REFEILRNY-PFR",
		36.1912,
		44.0095,
		"PLATTS - Refinery - Iraq - Erbil - Rezhwan Company",
		null,
		null,
		null,
		null,
		null,
		11,
		11.8,
		1.5,
		550,
		1.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.14,
		48.8,
		null,
		null,
		null,
		null,
		null,
		null,
		1,
		null,
		0.14,
		48.8,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rezhwan Company_Black Diamond",
		"50_50",
		null,
		"Active",
		null,
		0.2,
		0.1,
		0.52,
		0.08,
		0,
		0.08,
		20,
		10,
		52,
		8,
		0,
		8,
		0.98,
	],
	[
		"REFFOMVOC-PFR",
		40.692241,
		-80.262821,
		"PLATTS - Refinery - United States - Freedom - Valvoline Oil Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ashland Oil Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDZIXKP-PFR",
		44.3278,
		84.8844,
		"PLATTS - Refinery - China - Dushanzi - Xinjiang Kingmai Petrochemical",
		null,
		null,
		null,
		null,
		null,
		42.4,
		45.58,
		6.56,
		2250.93,
		7.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xinjiang Kingmai Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFRTBOR-PFR",
		26.51478,
		-78.75772,
		"PLATTS - Refinery - Bahamas - Freeport - Bahamas Oil Ref. Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron Corp_The Charter Company",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEAMERL-PFR",
		53.31295,
		-2.945366,
		"PLATTS - Refinery - United Kingdom - Eastham - Eastham Refining Ltd.",
		null,
		null,
		null,
		null,
		null,
		59.14,
		63.52,
		8.84,
		3219.92,
		9.51,
		11.64,
		null,
		1.72,
		630.76,
		null,
		0,
		null,
		0,
		0,
		null,
		11.64,
		null,
		1.72,
		630.76,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Fortum_PDVSA",
		"50_25_25",
		null,
		"Active",
		null,
		4.04,
		0.2,
		2.68,
		0,
		0.39,
		1.52,
		31.07692308,
		1.53846154,
		20.61538462,
		0,
		3,
		11.69230769,
		8.8,
	],
	[
		"REFFRTP66-PFR",
		28.9504,
		-95.35459,
		"PLATTS - Refinery - United States - Freeport - Phillips 66 Co.",
		63.05,
		65.94,
		7.73,
		2804.31,
		8.08,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEONWYG-PFR",
		41.26065,
		-110.8067,
		"PLATTS - Refinery - United States - Evanston - Wyoming Refining",
		null,
		null,
		null,
		null,
		null,
		3,
		3.13,
		0.41,
		150,
		0.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lair Petroleum",
		"100",
		null,
		"Active",
		null,
		0.3,
		0.1,
		0.6,
		0.09,
		0,
		0,
		20.13422819,
		6.7114094,
		40.26845638,
		6.04026846,
		0,
		0,
		1.1,
	],
	[
		"REFEARDLK-PFR",
		33.20122,
		-92.67345,
		"PLATTS - Refinery - United States - El Dorado (AR) - Delek Group",
		64,
		67.46,
		9.09,
		3205.73,
		9.6,
		230.5,
		242.75,
		31.73,
		11522.99,
		33.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		70.91,
		null,
		9.45,
		3450.07,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		41.56,
		null,
		5.4,
		1972.63,
		null,
		29.35,
		null,
		4.05,
		1477.43,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Delek Group",
		"100",
		null,
		"Active",
		null,
		19.11,
		27.18,
		0.17,
		1.48,
		-1.99,
		0,
		34.18604651,
		48.62254025,
		0.30411449,
		2.64758497,
		-3.55992844,
		0,
		45.95,
	],
	[
		"REFBMRHND-PFR",
		25.5819,
		71.6197,
		"PLATTS - Refinery - India - Barmer - Hindustan Petroleum - {Rajasthan}",
		null,
		null,
		null,
		null,
		null,
		716.1,
		786.69,
		166.36,
		32542.71,
		181.04,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		302.18,
		330.67,
		41.3,
		15013.32,
		45.17,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hindustan Petroleum_Rajasthan Government",
		"74_26",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFFUNFSC-PFR",
		41.834739,
		124.038894,
		"PLATTS - Refinery - China - Fushun - Fushun Petrochem Corp.",
		-8,
		-8.46,
		-1.1,
		-400,
		-1.16,
		954.03,
		1026.71,
		231.23,
		42985.21,
		247.12,
		97.8,
		null,
		14.53,
		5304.16,
		null,
		0,
		null,
		0,
		0,
		null,
		163,
		null,
		23.55,
		8595.72,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		65.2,
		null,
		9.02,
		3291.56,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		68.08,
		53.07,
		2.27,
		11.88,
		15.93,
		9.54,
		38.59410431,
		30.08503401,
		1.28684807,
		6.73469388,
		9.03061224,
		5.40816327,
		160.77,
	],
	[
		"REFEROPET-PFR",
		-8.216173,
		-78.97611,
		"PLATTS - Refinery - Peru - El Milagro - Petroperu",
		null,
		null,
		null,
		null,
		null,
		2.12,
		2.27,
		0.68,
		83.95,
		0.73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroperu",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBNEKOR-PFR",
		37.532076,
		-82.616328,
		"PLATTS - Refinery - United States - Betsy Layne - Kentucky Oil and Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kentucky Oil and Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFERTADE-PFR",
		51.88544,
		4.255566,
		"PLATTS - Refinery - Netherlands - Europoort - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		40,
		42.32,
		40,
		40,
		42.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFESDCHN-PFR",
		33.910317,
		-118.409839,
		"PLATTS - Refinery - United States - El Segundo - Chevron",
		null,
		null,
		null,
		null,
		null,
		1086.1,
		1142.9,
		272.91,
		47356.77,
		287.91,
		113.08,
		null,
		16.8,
		6132.98,
		null,
		0,
		null,
		0,
		0,
		null,
		191,
		null,
		27.48,
		10030.13,
		null,
		null,
		null,
		null,
		null,
		null,
		13.42,
		null,
		1.79,
		654.67,
		null,
		2.6,
		null,
		0.34,
		123.37,
		null,
		42.96,
		null,
		5.93,
		2162.82,
		null,
		18.94,
		null,
		2.62,
		956.29,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron",
		"100",
		null,
		"Active",
		null,
		52.63,
		106.74,
		8.93,
		52.2,
		-1.2,
		-0.01,
		21.83455028,
		44.28310654,
		3.70477929,
		21.65615665,
		-0.49784268,
		-0.00414869,
		219.29,
	],
	[
		"REFFZ2PTS-PFR",
		-3.7304512,
		-38.5217989,
		"PLATTS - Refinery - Brazil - Fortaleza (2) - Petrobras",
		1108.35,
		1165.05,
		358.45,
		44806.55,
		378.21,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBNOTAP-PFR",
		-9.1637,
		125.7238,
		"PLATTS - Refinery - Timor- Leste - Betano - Timor Gap",
		30,
		31.29,
		3.53,
		1288.23,
		3.68,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PTT_Timor Gap",
		"70_30",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBFDTAY-PFR",
		36.676353,
		-108.007329,
		"PLATTS - Refinery - United States - Bloomfield - Thriftway",
		null,
		null,
		null,
		null,
		null,
		-0.04,
		-0.04,
		-0.01,
		-1.71,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Thriftway",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGCNNIO-PFR",
		30.357,
		50.794,
		"PLATTS - Refinery - Iran - Gachsaran - National Iranian Oil Co.",
		458.23,
		503.72,
		62.62,
		22770.93,
		68.77,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBOOFAA-PFR",
		18.929707,
		-70.360268,
		"PLATTS - Refinery - Dominican Republic - Bonao - Falconbridge Dominicana C. por A.",
		null,
		null,
		null,
		null,
		null,
		222.78,
		236.35,
		203.52,
		1265.66,
		215.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.55,
		201.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.55,
		201.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Falconbridge Dominicana C. por A.",
		"100",
		null,
		"Active",
		null,
		3,
		0.3,
		1.99,
		2.08,
		0.1,
		2.3,
		30,
		3,
		19.9,
		20.8,
		1,
		23,
		9.77,
	],
	[
		"REFBGSP66-PFR",
		45.781422,
		-108.489955,
		"PLATTS - Refinery - United States - Billings - Phillips 66 Co.",
		31,
		32.33,
		4.39,
		1601.36,
		4.58,
		282.25,
		297.67,
		77.11,
		12153.17,
		81.43,
		42.39,
		null,
		6.3,
		2299.22,
		null,
		0,
		null,
		0,
		0,
		null,
		54.5,
		null,
		7.96,
		2903.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.72,
		null,
		0.22,
		81.85,
		null,
		8.89,
		null,
		1.23,
		447.59,
		null,
		1.49,
		null,
		0.21,
		75.24,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		21.85,
		30.8,
		0.62,
		1.69,
		-0.63,
		0,
		36.41059823,
		51.3247792,
		1.03316114,
		2.8161973,
		-1.04982503,
		0,
		54.33,
	],
	[
		"REFGEIPIR-PFR",
		30.19971,
		-91.01262,
		"PLATTS - Refinery - United States - Geismar - Praxair",
		null,
		null,
		null,
		null,
		null,
		70,
		74.06,
		70,
		70,
		74.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBRDARG-PFR",
		41.96464,
		-78.63507,
		"PLATTS - Refinery - United States - Bradford - American Refining Group",
		null,
		null,
		null,
		null,
		null,
		20.48,
		21.53,
		2.73,
		991.06,
		2.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		9.59,
		null,
		1.25,
		455.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		9.59,
		null,
		1.25,
		455.21,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Buckeye Pipeline Co.",
		"100",
		null,
		"Active",
		null,
		3.14,
		3.22,
		0,
		0,
		0.15,
		0,
		31.71717172,
		32.52525253,
		0,
		0,
		1.51515152,
		0,
		6.51,
	],
	[
		"REFBIAVRO-PFR",
		38.07402,
		-122.144,
		"PLATTS - Refinery - United States - Benicia - Valero",
		100,
		105.8,
		100,
		100,
		105.8,
		782.79,
		824.99,
		260.79,
		30437.22,
		274.83,
		29.12,
		null,
		4.33,
		1579.15,
		null,
		0,
		null,
		0,
		0,
		null,
		106,
		null,
		14.93,
		5450.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		72.83,
		null,
		10.05,
		3666.51,
		null,
		4.06,
		null,
		0.56,
		204.72,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		28.82,
		70.81,
		5.21,
		15.92,
		0.8,
		0,
		24.97833247,
		61.37112151,
		4.51551395,
		13.79788525,
		0.69336107,
		0,
		121.56,
	],
	[
		"REFGNECGY-PFR",
		-23.8432,
		151.2561,
		"PLATTS - Refinery - Australia - Gladstone - Casper Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		135.08,
		141.64,
		18.32,
		6658.64,
		19.2,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Casper Energy_Eagle Ford Oil and Gas",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBIDVRO-PFR",
		41.655548,
		-87.706327,
		"PLATTS - Refinery - United States - Blue Island - Valero",
		null,
		null,
		null,
		null,
		null,
		-0.06,
		-0.03,
		-0.02,
		-0.01,
		0.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Blackstone Group_Occidental_Unknown",
		"81_18_1",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGNTBSA-PFR",
		51.101086,
		3.725567,
		"PLATTS - Refinery - Belgium - Ghent - Belgian Shell S.A.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGOETOT-PFR",
		49.490808,
		0.233415,
		"PLATTS - Refinery - France - Gonfreville - Total",
		8,
		8.46,
		1.19,
		432.59,
		1.25,
		1106.89,
		1163.61,
		469.49,
		36538.48,
		492.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		101.32,
		15.43,
		8.05,
		12.52,
		7.82,
		19.95,
		62.00734394,
		9.44308446,
		4.92656059,
		7.6621787,
		4.78580171,
		12.20930233,
		165.1,
	],
	[
		"REFBKDKIL-PFR",
		35.2953483,
		-118.9192246,
		"PLATTS - Refinery - United States - Bakersfield - Kern Oil",
		null,
		null,
		null,
		null,
		null,
		42.35,
		44.45,
		5.64,
		2057.38,
		5.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10.31,
		null,
		1.42,
		518.94,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10.31,
		null,
		1.42,
		518.94,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kern Oil",
		"100",
		null,
		"Active",
		null,
		1.89,
		2.19,
		3.4,
		1.57,
		-0.13,
		0,
		15.30364372,
		17.73279352,
		27.53036437,
		12.71255061,
		-1.05263158,
		0,
		8.91,
	],
	[
		"REFGONEXM-PFR",
		49.47468,
		0.5511189,
		"PLATTS - Refinery - France - Gravenchon - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		0.08,
		0.11,
		0.02,
		4.05,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGREPTS-PFR",
		-5.1076,
		-36.3195,
		"PLATTS - Refinery - Brazil - Guamare - Petrobras - {RPCC - Potiguar Clara Camarao}",
		null,
		null,
		null,
		null,
		null,
		59.53,
		62.19,
		8.02,
		2915.21,
		8.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31.7,
		null,
		4.38,
		1600.35,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31.7,
		null,
		4.38,
		1600.35,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		10.82,
		3.73,
		14.13,
		1.99,
		0.39,
		0.1,
		34.13249211,
		11.76656151,
		44.57413249,
		6.27760252,
		1.23028391,
		0.31545741,
		31.14,
	],
	[
		"REFEASROL-PFR",
		37.569694,
		-0.922953,
		"PLATTS - Refinery - Spain - Escombreras - Repsol",
		null,
		null,
		null,
		null,
		null,
		755.68,
		794.62,
		215.99,
		32155.78,
		226.77,
		98.12,
		null,
		14.58,
		5321.61,
		null,
		0,
		null,
		0,
		0,
		null,
		200.92,
		null,
		28.13,
		10266.56,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		80.37,
		null,
		10.45,
		3814.53,
		null,
		13.08,
		null,
		1.8,
		658.66,
		null,
		9.34,
		null,
		1.29,
		471.77,
		null,
		null,
		null,
		null,
		null,
		null,
		"Repsol",
		"100",
		null,
		"Active",
		null,
		101.5,
		29.46,
		21.26,
		34.54,
		10.39,
		0,
		47.20930233,
		13.70232558,
		9.88837209,
		16.06511628,
		4.83255814,
		0,
		197.14,
	],
	[
		"REFBRMCAC-PFR",
		41.64064,
		-87.54264,
		"PLATTS - Refinery - United States - Burnham - Calumet Lubricants Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Calumet Lubricants Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBKDSBR-PFR",
		35.38727,
		-119.048221,
		"PLATTS - Refinery - United States - Bakersfield - Sabre Energy",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sabre Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFECHPP2-PFR",
		21.304911,
		-158.092353,
		"PLATTS - Refinery - United States - Ewa Beach - Par Petroleum - {Ewa Beach [East]}",
		null,
		null,
		null,
		null,
		null,
		274.92,
		288.79,
		70.11,
		11753.37,
		73.64,
		0,
		null,
		0,
		0,
		null,
		1.99,
		null,
		0.3,
		107.7,
		null,
		53.29,
		null,
		7.02,
		2560.74,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		45.31,
		null,
		5.89,
		2150.41,
		null,
		2,
		null,
		0.28,
		100.69,
		null,
		4,
		null,
		0.55,
		201.94,
		null,
		null,
		null,
		null,
		null,
		null,
		"Par Petroleum",
		"100",
		null,
		"Active",
		null,
		15.36,
		19.78,
		18.4,
		20.35,
		1.27,
		0,
		21.47050601,
		27.64886777,
		25.71987699,
		28.44562483,
		1.77523064,
		0,
		75.17,
	],
	[
		"REFGRGPEM-PFR",
		57.70841,
		11.827772,
		"PLATTS - Refinery - Sweden - Gothenburg - Preem",
		null,
		null,
		null,
		null,
		null,
		279.36,
		293.8,
		36.82,
		13402.56,
		38.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		101,
		null,
		13.13,
		4793.89,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		101,
		null,
		13.13,
		4793.89,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Corral Petroleum Holdings",
		"100",
		null,
		"Active",
		null,
		42.19,
		27.76,
		29.46,
		1.3,
		2.55,
		0,
		41.29392189,
		27.17040227,
		28.83429578,
		1.27238916,
		2.49584027,
		0,
		103.27,
	],
	[
		"REFBKDSJR-PFR",
		35.3978278,
		-119.0489613,
		"PLATTS - Refinery - United States - Bakersfield - San Joaquin Refining - {Oildale}",
		null,
		null,
		null,
		null,
		null,
		71.88,
		76.05,
		16.49,
		3471.81,
		17.44,
		0.02,
		null,
		0,
		0.99,
		null,
		0,
		null,
		0,
		0,
		null,
		8.28,
		null,
		1.14,
		416.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.26,
		null,
		1.14,
		415.99,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"San Joaquin Refining",
		"100",
		null,
		"Active",
		null,
		1.4,
		1.58,
		2.44,
		1.22,
		-0.26,
		0,
		14.11290323,
		15.92741935,
		24.59677419,
		12.2983871,
		-2.62096774,
		0,
		6.37,
	],
	[
		"REFBRYSPR-PFR",
		6.4387,
		2.9075,
		"PLATTS - Refinery - Nigeria - Badagry - South Atlantic Petrochemical",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		327.15,
		358.03,
		70.47,
		14744.22,
		75.8,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"South Atlantic Petrochemical",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFECHPPR-PFR",
		21.311435,
		-158.114201,
		"PLATTS - Refinery - United States - Ewa Beach - Par Petroleum - {Ewa Beach [West]}",
		null,
		null,
		null,
		null,
		null,
		134.19,
		140.83,
		19.94,
		6550.92,
		20.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		28.25,
		null,
		3.91,
		1425.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.28,
		100.69,
		null,
		26.25,
		null,
		3.63,
		1325.21,
		null,
		null,
		null,
		null,
		null,
		null,
		"Par Petroleum",
		"100",
		null,
		"Active",
		null,
		9.5,
		21.19,
		1.86,
		8.3,
		-2.35,
		0.09,
		25.33333333,
		56.50666667,
		4.96,
		22.13333333,
		-6.26666667,
		0.24,
		38.59,
	],
	[
		"REFBKUHRY-PFR",
		40.405993,
		49.922886,
		"PLATTS - Refinery - Azerbaijan - Baku - Heydar Aliev Refinery - {Novyy}",
		null,
		null,
		null,
		null,
		null,
		538.44,
		589.87,
		132.11,
		23852.19,
		143.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		108,
		null,
		14.04,
		5126.14,
		null,
		-435.81,
		-477.39,
		-61.77,
		-21921.05,
		-67.58,
		0,
		null,
		0,
		0,
		null,
		108,
		null,
		14.04,
		5126.14,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		48.79,
		29.15,
		5.55,
		14.38,
		5.06,
		7.1,
		41,
		24.49579832,
		4.66386555,
		12.08403361,
		4.25210084,
		5.96638655,
		110.04,
	],
	[
		"REFBTEPAL-PFR",
		-6.478,
		105.541,
		"PLATTS - Refinery - Indonesia - Banten - PT Chandra Asri Petrochemical",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		765.38,
		835.42,
		104.58,
		38031.14,
		113.97,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"PT Chandra Asri Petrochemical",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFEDNBNG-PFR",
		53.551688,
		-113.371437,
		"PLATTS - Refinery - Canada - Edmonton - Beaver Hills Processing",
		122.98,
		128.88,
		38.51,
		4218.95,
		40.54,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Corrillo Energy_Gibson Energy_Parkland Income Fund",
		"50_25_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBLDQGY-PFR",
		48.3131,
		-101.7371,
		"PLATTS - Refinery - United States - Berthold - Quantum Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		99.04,
		103.75,
		13.31,
		4841.36,
		13.93,
		"Quantum Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFBUSLUK-PFR",
		42.547258,
		27.339432,
		"PLATTS - Refinery - Bulgaria - Burgas - Lukoil - {Bourgas}",
		null,
		null,
		null,
		null,
		null,
		929.22,
		1004.21,
		465,
		28019.41,
		496.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		105,
		null,
		14.32,
		5225.71,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		21,
		null,
		2.73,
		996.75,
		null,
		84,
		null,
		11.59,
		4228.97,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		null,
		"Active",
		null,
		56.71,
		39.82,
		18.56,
		7.26,
		5.16,
		7.62,
		40.79856115,
		28.64748201,
		13.35251799,
		5.22302158,
		3.71223022,
		5.48201439,
		135.13,
	],
	[
		"REFEGNCPS-PFR",
		30.21985,
		-92.508618,
		"PLATTS - Refinery - United States - Egan - ConocoPhillips",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Du Pont",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCARPRS-PFR",
		25.2935,
		60.6469,
		"PLATTS - Refinery - Iran - Chabahar - Petrochina Pars",
		null,
		null,
		null,
		null,
		null,
		148.31,
		163.38,
		20.28,
		7382.88,
		22.33,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrochina Pars",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFBNGPRT-PFR",
		0.1237,
		117.4717,
		"PLATTS - Refinery - Indonesia - Bontang - Pertamina",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		750.6,
		817.26,
		102.61,
		37234.26,
		111.54,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Overseas Oil & Gas, LLC_Pertamina",
		"90_10",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFEQGCUK-PFR",
		1.0866,
		9.6943,
		"PLATTS - Refinery - Equatorial Guinea - Cogo - Ministry of Guinea",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		20,
		21.8,
		2.74,
		1000,
		2.98,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ministry of Guinea",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCAWGRM-PFR",
		30.76306,
		-88.05253,
		"PLATTS - Refinery - United States - Chickasaw - Gulf Atlantic R and M",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gulf Atlantic R and M",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFESDADE-PFR",
		33.914817,
		-118.417805,
		"PLATTS - Refinery - United States - El Segundo - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		85,
		89.93,
		85,
		85,
		89.93,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCBACOS-PFR",
		35.544424,
		140.07556,
		"PLATTS - Refinery - Japan - Chiba - Cosmo Oil",
		null,
		null,
		null,
		null,
		null,
		590.43,
		625.4,
		81.92,
		29654.61,
		86.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		126.35,
		null,
		17.1,
		6238.66,
		null,
		null,
		null,
		null,
		null,
		null,
		78.99,
		null,
		10.56,
		3854.42,
		null,
		0.11,
		null,
		0.01,
		5.43,
		null,
		47.25,
		null,
		6.52,
		2378.81,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mubadala Investment Company",
		"20.8",
		null,
		"Active",
		null,
		37.96,
		34.57,
		23.32,
		26.17,
		11.58,
		14.31,
		24.83968067,
		22.62138464,
		15.25978275,
		17.1247219,
		7.57754221,
		9.3639576,
		147.92,
	],
	[
		"REFCBOSOS-PFR",
		10.1667,
		-68.0833,
		"PLATTS - Refinery - Venezuela - Carabobo - Superoctanos",
		null,
		null,
		null,
		null,
		null,
		17,
		18.25,
		1.95,
		713.45,
		2.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Superoctanos",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCDASOG-PFR",
		-5.0564,
		12.3212,
		"PLATTS - Refinery - Angola - Cabinda - Sonangol",
		null,
		null,
		null,
		null,
		null,
		197.06,
		216.26,
		26.96,
		9836.06,
		29.66,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonangol_Gemcorp Capital",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCENSAR-PFR",
		37.0556,
		35.8712,
		"PLATTS - Refinery - Turkey - Ceyhan - SOCAR",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		873.74,
		916.02,
		214.64,
		38032.58,
		225.94,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR_Turcas",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCERLIT-PFR",
		42.859491,
		-106.242198,
		"PLATTS - Refinery - United States - Casper - Little America Refining Company",
		null,
		null,
		null,
		null,
		null,
		70.09,
		73.98,
		9.6,
		3493.45,
		10.12,
		0.49,
		null,
		0.07,
		26.54,
		null,
		0,
		null,
		0,
		0,
		null,
		18.03,
		null,
		2.35,
		858.96,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		17.54,
		null,
		2.28,
		832.42,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinclair",
		"100",
		null,
		"Active",
		null,
		7.79,
		9.27,
		0.13,
		0.2,
		1.63,
		0,
		39.24433249,
		46.70025189,
		0.65491184,
		1.00755668,
		8.2115869,
		0,
		19.02,
	],
	[
		"REFCEWLBR-PFR",
		29.832578,
		-95.119387,
		"PLATTS - Refinery - United States - Channelview - LyondellBasell Refining",
		null,
		null,
		null,
		null,
		null,
		37.96,
		40.16,
		4.49,
		1637.76,
		4.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Access Industries",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCGAPSA-PFR",
		-33.7567,
		25.6575,
		"PLATTS - Refinery - South Africa - Coega - PetroSA",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1104.9,
		1192.4,
		592.92,
		30292.86,
		628.4,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec_PetroSA",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCHGKPC-PFR",
		22.3308,
		91.8413,
		"PLATTS - Refinery - Bangladesh - Chittagong - Kuwait Petroleum Corp.",
		536.3,
		587.91,
		73.71,
		26791.28,
		80.72,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCILORC-PFR",
		34.896777,
		-98.19498,
		"PLATTS - Refinery - United States - Cyril - Oklahoma Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.02,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cayman Resources Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCNASTE-PFR",
		45.13011,
		25.737418,
		"PLATTS - Refinery - Romania - Campina - Steaua Romania S.A.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rafirom",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCNTCRC-PFR",
		30.42064,
		-92.1933,
		"PLATTS - Refinery - United States - Church Point - Canal Refining Co.",
		34,
		35.55,
		4.58,
		1671.56,
		4.79,
		0,
		0,
		0,
		0,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Blue Dolphin Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCOHPET-PFR",
		-12.253087,
		-76.921962,
		"PLATTS - Refinery - Peru - Conchan - Petroperu",
		null,
		null,
		null,
		null,
		null,
		23.59,
		25.33,
		3.38,
		1233.25,
		3.64,
		3,
		null,
		0.45,
		162.7,
		null,
		0,
		null,
		0,
		0,
		null,
		3,
		null,
		0.45,
		162.7,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroperu",
		"100",
		null,
		"Active",
		null,
		1.23,
		0.36,
		3.03,
		0.33,
		0,
		0,
		23.47328244,
		6.87022901,
		57.82442748,
		6.29770992,
		0,
		0,
		4.95,
	],
	[
		"REFCONPDV-PFR",
		11.631073,
		-70.22459,
		"PLATTS - Refinery - Venezuela - Cardon - PDVSA",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		-0.02,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCRMTAM-PFR",
		45.13628,
		9.993567,
		"PLATTS - Refinery - Italy - Cremona - Tamoil",
		97.89,
		103.3,
		58.53,
		2383.08,
		61.89,
		-0.01,
		0.02,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan Investment Authority",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCSRVSA-PFR",
		47.041342,
		7.036354,
		"PLATTS - Refinery - Switzerland - Cressier - Varo Holding SA",
		null,
		null,
		null,
		null,
		null,
		218.72,
		230.26,
		30.08,
		10959.18,
		31.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		56.6,
		null,
		7.36,
		2686.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		56.6,
		null,
		7.36,
		2686.48,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroplus",
		"100",
		null,
		"Active",
		null,
		28.77,
		15.31,
		4.24,
		0.6,
		3.51,
		0.56,
		53.27777778,
		28.35185185,
		7.85185185,
		1.11111111,
		6.5,
		1.03703704,
		52.99,
	],
	[
		"REFCTAPDV-PFR",
		7.6501,
		-66.2445,
		"PLATTS - Refinery - Venezuela - Cabruta - PDVSA",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		745,
		815.24,
		167.98,
		34369.52,
		182.46,
		"PDVSA_Sinopec",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFCTEPBF-PFR",
		29.93499,
		-89.97084,
		"PLATTS - Refinery - United States - Chalmette - PBF Energy Company LLC",
		18.52,
		19.59,
		2.61,
		953.43,
		2.76,
		638.49,
		671.19,
		90.28,
		32008.89,
		94.97,
		41.24,
		null,
		6.13,
		2236.78,
		null,
		0.47,
		null,
		0.07,
		25.48,
		null,
		121,
		null,
		16.71,
		6100.47,
		null,
		20,
		21.16,
		2.79,
		1016.71,
		2.95,
		0,
		null,
		0,
		0,
		null,
		53.28,
		null,
		6.93,
		2528.93,
		null,
		26.01,
		null,
		3.59,
		1309.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PBF Energy Company LLC",
		"100",
		null,
		"Active",
		null,
		38.38,
		85.38,
		2.17,
		16.44,
		1.64,
		2.35,
		25.95347579,
		57.73600216,
		1.467406,
		11.11712199,
		1.1090073,
		1.58912632,
		146.35,
	],
	[
		"REFCTIGAM-PFR",
		27.816379,
		-97.494451,
		"PLATTS - Refinery - United States - Corpus Christi - Gravity Midstream",
		130.1,
		136.14,
		16.03,
		5810.84,
		16.77,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gravity Midstream",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTISWR-PFR",
		27.804083,
		-97.425295,
		"PLATTS - Refinery - United States - Corpus Christi - Southwest Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Koch Industries",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCTRPOE-PFR",
		37.345207,
		-77.386887,
		"PLATTS - Refinery - United States - Chester - Primary Oil and Energy",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Primary Oil and Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCUAKPT-PFR",
		24.0756,
		120.5445,
		"PLATTS - Refinery - Taiwan - Changhua - Kuokang Petrochemical Tech. Corp.",
		924.3,
		980,
		129.26,
		46293.1,
		136.9,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chinese Petroleum Corp._Oriental Union Chemical Corp._Chang Chun Group_China Man-Made Fiber Corp._Fubon Financial Holding Vent. Cap.",
		"43_20_20_10_3",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCUTOCS-PFR",
		-43.7128,
		-68.7462,
		"PLATTS - Refinery - Argentina - Chubut - Oil Combustibles S.A.",
		158.1,
		172.62,
		21.73,
		7895.61,
		23.7,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oil Combustibles S.A.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCVACRL-PFR",
		33.759338,
		-87.169633,
		"PLATTS - Refinery - United States - Cordova - Coral Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Coral Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFCYAPMX-PFR",
		25.590443,
		-99.944063,
		"PLATTS - Refinery - Mexico - Cadereyta - PEMEX - {Refineria Ingeniero Hector R Lara Sosa}",
		27.2,
		30.49,
		5.36,
		1519.6,
		5.96,
		863.67,
		945.34,
		173.54,
		40344.71,
		188.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		102.71,
		null,
		14.11,
		5151.2,
		null,
		61.31,
		66.46,
		26.34,
		1858.95,
		28.36,
		12.67,
		null,
		1.69,
		618.12,
		null,
		0,
		null,
		0,
		0,
		null,
		90.04,
		null,
		12.42,
		4533.08,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		37.37,
		37.35,
		1.69,
		3.62,
		2.81,
		9.43,
		36.19721038,
		36.17783805,
		1.63696242,
		3.50639287,
		2.72181325,
		9.13405657,
		92.26,
	],
	[
		"REFDALDPT-PFR",
		38.984804,
		121.84451,
		"PLATTS - Refinery - China - Dalian - Dalian Petrochemical Co.",
		null,
		null,
		null,
		null,
		null,
		1664.97,
		1792.18,
		482.97,
		69334.4,
		515.16,
		0,
		null,
		0,
		0,
		null,
		26.9,
		null,
		3.99,
		1456.75,
		null,
		269,
		null,
		36.83,
		13441.75,
		null,
		null,
		null,
		null,
		null,
		null,
		67.25,
		null,
		8.99,
		3281.58,
		null,
		40.35,
		null,
		5.25,
		1915.18,
		null,
		13.45,
		null,
		1.86,
		677.14,
		null,
		121.05,
		null,
		16.74,
		6111.1,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		0,
		"Active",
		null,
		116.4,
		90.14,
		3.28,
		20.6,
		32.9,
		44.78,
		35.88162762,
		27.78668311,
		1.01109741,
		6.35018496,
		10.14180025,
		13.80394575,
		308.1,
	],
	[
		"REFDIGDAL-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Dongming Petrochemical",
		null,
		null,
		null,
		null,
		null,
		16.13,
		17.31,
		2.48,
		855.44,
		2.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dongming Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGHIN-PFR",
		38.05675433,
		118.87414881,
		"PLATTS - Refinery - China - Dongying - Haike Ruilin - {Ruilin Chemical Co.}",
		null,
		null,
		null,
		null,
		null,
		179.13,
		192.6,
		33.4,
		8942.59,
		35.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"HaiKe Chemical Group Ltd_Jindayuan Real Estate Company Ltd_Xindu Group Company Ltd",
		"65.7_31_3.3",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDIGLAL-PFR",
		37.4335,
		118.6689,
		"PLATTS - Refinery - China - Dongying - Lianhe Petrochemical",
		343.17,
		370.06,
		46.98,
		17085.7,
		50.63,
		280.65,
		302.91,
		38.43,
		13967.73,
		41.45,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lianhe Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDITMUM-PFR",
		42.28082,
		-83.15321,
		"PLATTS - Refinery - United States - Detroit - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		457.58,
		483.14,
		65.43,
		23514.08,
		69.13,
		92.01,
		null,
		13.67,
		4989.9,
		null,
		0,
		null,
		0,
		0,
		null,
		121.41,
		null,
		17.6,
		6422.85,
		null,
		null,
		null,
		null,
		null,
		null,
		16.93,
		null,
		2.26,
		826.28,
		null,
		7.55,
		null,
		0.98,
		358.24,
		null,
		0.54,
		null,
		0.07,
		27.36,
		null,
		4.38,
		null,
		0.61,
		221.08,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		38.37,
		66.46,
		1.7,
		9.47,
		5.42,
		0.33,
		27.76210115,
		48.08624557,
		1.2300123,
		6.85189205,
		3.92156863,
		0.23876709,
		121.76,
	],
	[
		"REFDK2MUY-PFR",
		49.48265127,
		105.92671474,
		"PLATTS - Refinery - Mongolia - Darkhan (2) - Mongolsekiuy",
		120.36,
		132.51,
		16.07,
		5858.11,
		17.7,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mongolsekiuy_Marubeni_Toyo",
		"34_33_33",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDLEYNG-PFR",
		33.762074,
		-84.729454,
		"PLATTS - Refinery - United States - Douglasville - Young Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Young Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFDQGPT3-PFR",
		46.5969,
		125.1015,
		"PLATTS - Refinery - China - Daqing - PetroChina",
		2,
		2.12,
		0.27,
		100,
		0.29,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGYEMUM-PFR",
		30.06501,
		-90.59736,
		"PLATTS - Refinery - United States - Garyville - Marathon Petroleum",
		121,
		128.36,
		78.6,
		2843.43,
		83.21,
		2249.93,
		2368,
		442.27,
		104495.78,
		466.33,
		24.89,
		null,
		3.7,
		1350.15,
		null,
		1.59,
		null,
		0.24,
		85.9,
		null,
		517,
		null,
		70.31,
		25664.63,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		161.96,
		null,
		21.06,
		7687.11,
		null,
		328.56,
		null,
		45.32,
		16541.47,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		197.58,
		262.16,
		3.93,
		59.71,
		15.48,
		0,
		36.84544234,
		48.88855736,
		0.7328808,
		11.13493958,
		2.88676712,
		0,
		538.87,
	],
	[
		"REFDUKMAG-PFR",
		36.8543,
		42.9925,
		"PLATTS - Refinery - Iraq - Dahouk - Make Oil AG",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		749.5,
		819.78,
		171.51,
		33294.31,
		186.07,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Make Oil AG",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGZUGEL-PFR",
		22.73114917,
		113.43737507,
		"PLATTS - Refinery - China - Guangzhou - Guangzhou Qimei Fuel",
		null,
		null,
		null,
		null,
		null,
		27,
		28.56,
		3.94,
		1438.22,
		4.17,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Guangzhou Qimei Fuel",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGZUGPC-PFR",
		22.748603,
		113.676844,
		"PLATTS - Refinery - China - Guangzhou - Guangzhou Tianyu Petrochem. Corp.",
		null,
		null,
		null,
		null,
		null,
		997.09,
		1076.83,
		257.41,
		44031.12,
		275.4,
		36.03,
		null,
		5.35,
		1953.92,
		null,
		36.03,
		null,
		5.35,
		1951.02,
		null,
		240.18,
		null,
		33.89,
		12369.22,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		168.13,
		null,
		23.19,
		8464.29,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		52.47,
		66.77,
		0.9,
		52.27,
		29.39,
		30.76,
		21.58815059,
		27.47171364,
		0.37029418,
		21.50586299,
		12.09216211,
		12.65583213,
		232.57,
	],
	[
		"REFDZIDPC-PFR",
		44.3565,
		84.87461,
		"PLATTS - Refinery - China - Dushanzi - Dushanzi Petrochem Corp.",
		null,
		null,
		null,
		null,
		null,
		568.68,
		611.65,
		129.17,
		24814.63,
		138.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		143.6,
		null,
		19.27,
		7032.69,
		null,
		253.37,
		272.45,
		34.84,
		12715.52,
		37.45,
		0,
		null,
		0,
		0,
		null,
		71.8,
		null,
		9.34,
		3407.93,
		null,
		0,
		null,
		0,
		0,
		null,
		71.8,
		null,
		9.93,
		3624.76,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		55.78,
		29,
		7.33,
		6.39,
		6.08,
		9.78,
		44.65972778,
		23.21857486,
		5.86869496,
		5.11609287,
		4.86789432,
		7.83026421,
		114.36,
	],
	[
		"REFHAISEC-PFR",
		19.76792,
		109.17011,
		"PLATTS - Refinery - China - Hainan - Sinopec",
		null,
		null,
		null,
		null,
		null,
		843.97,
		910.85,
		210.11,
		36152.88,
		224.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		181.14,
		null,
		24.78,
		9042.99,
		null,
		null,
		null,
		null,
		null,
		null,
		18.11,
		null,
		2.42,
		883.9,
		null,
		18.11,
		null,
		2.36,
		859.76,
		null,
		117.74,
		null,
		16.24,
		5927.63,
		null,
		27.17,
		null,
		3.76,
		1371.7,
		null,
		246.44,
		266.29,
		33.35,
		12117.26,
		36.04,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		54.02,
		60.31,
		14.6,
		12.53,
		20.21,
		21.24,
		29.1905328,
		32.58943045,
		7.88933319,
		6.77077705,
		10.92078245,
		11.47735869,
		182.91,
	],
	[
		"REFEDNATS-PFR",
		53.560052,
		-113.347827,
		"PLATTS - Refinery - Canada - Edmonton - Air Products",
		null,
		null,
		null,
		null,
		null,
		181,
		191.5,
		181,
		181,
		191.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFEDOTFS-PFR",
		6.6077,
		5.9723,
		"PLATTS - Refinery - Nigeria - Edo - TFS Financial Services",
		50,
		54.48,
		6.86,
		2500,
		7.46,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"TFS Financial Services_Financial Bridge",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHDEDEL-PFR",
		54.155366,
		9.073389,
		"PLATTS - Refinery - Germany - Heide - Deutsche Erdoel",
		null,
		null,
		null,
		null,
		null,
		274.97,
		289.58,
		92.09,
		10659.39,
		96.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71.15,
		null,
		9.25,
		3377.12,
		null,
		115,
		121.67,
		115,
		115,
		121.67,
		0,
		null,
		0,
		0,
		null,
		71.15,
		null,
		9.25,
		3377.12,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Klesch and Company",
		"100",
		null,
		"Active",
		null,
		42.17,
		10.39,
		4.68,
		4.87,
		3.5,
		8.24,
		55.06659702,
		13.5675111,
		6.1112562,
		6.35936276,
		4.57038391,
		10.75998955,
		73.84,
	],
	[
		"REFEENADL-PFR",
		53.355968,
		7.162633,
		"PLATTS - Refinery - Germany - Emden - Aectra Ltd.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Aectra Ltd.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHFAODL-PFR",
		32.793894,
		35.058168,
		"PLATTS - Refinery - Israel - Haifa - Oil Refineries Ltd.",
		null,
		null,
		null,
		null,
		null,
		669.4,
		703.67,
		187.04,
		28099.45,
		196.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		178.56,
		null,
		24.48,
		8938.13,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		17.85,
		null,
		2.32,
		847.52,
		null,
		160.7,
		null,
		22.17,
		8090.61,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ofer-Federman Group_Israel Petrochemical Enterprises_Other Investors",
		"46_35.4_18.6",
		null,
		"Active",
		null,
		60.28,
		52.09,
		26.35,
		30.5,
		23.06,
		12.83,
		27.36020334,
		23.64288308,
		11.95987654,
		13.84350036,
		10.46659405,
		5.82334786,
		205.11,
	],
	[
		"REFEGNHES-PFR",
		30.197108,
		-92.53634,
		"PLATTS - Refinery - United States - Egan - Hughes Resources",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"OGC Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHMAUNT-PFR",
		1.4637,
		31.1333,
		"PLATTS - Refinery - Uganda - Hoima - Albertine Graben Refinery Consortium",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		108,
		118.5,
		14.36,
		5246.96,
		15.8,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Albertine Graben Refinery Consortium_Uganda Government",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFEMNHLL-PFR",
		41.180604,
		-79.717351,
		"PLATTS - Refinery - United States - Emlenton - Honeywell",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"U.S. Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHMGBBP-PFR",
		53.533532,
		9.893298,
		"PLATTS - Refinery - Germany - Hamburg - BP",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFENTHON-PFR",
		42.677792,
		-96.696179,
		"PLATTS - Refinery - United States - Elk Point - Hyperion",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1936.65,
		2033.96,
		893.48,
		63073.14,
		938.48,
		"Hyperion",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHMSTHR-PFR",
		34.716834,
		36.63966,
		"PLATTS - Refinery - Syria - Homs - The Homs Refinery Co.",
		null,
		null,
		null,
		null,
		null,
		313,
		338.84,
		139.5,
		10193.85,
		149.23,
		13.8,
		null,
		2.05,
		748.44,
		null,
		0,
		null,
		0,
		0,
		null,
		24,
		null,
		3.41,
		1244.83,
		null,
		148.07,
		161.58,
		72.25,
		4506.68,
		77.91,
		9.2,
		null,
		1.23,
		448.93,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Syrian Govt.",
		"100",
		null,
		"Active",
		null,
		6.22,
		1.92,
		9.79,
		0.64,
		0.83,
		1.86,
		27.04347826,
		8.34782609,
		42.56521739,
		2.7826087,
		3.60869565,
		8.08695652,
		21.26,
	],
	[
		"REFEPOPDV-PFR",
		10.483085,
		-68.119996,
		"PLATTS - Refinery - Venezuela - El Palito - PDVSA - {RELP}",
		509.25,
		556.63,
		139.45,
		21689.15,
		151.04,
		421.82,
		462.82,
		64.02,
		20875.86,
		70.04,
		1.04,
		null,
		0.15,
		56.49,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.7,
		255.78,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.96,
		null,
		0.55,
		199.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHONPIR-PFR",
		29.718958,
		-95.111944,
		"PLATTS - Refinery - United States - Houston - Praxair",
		null,
		null,
		null,
		null,
		null,
		100,
		105.8,
		100,
		100,
		105.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFERNPES-PFR",
		-6.3287,
		108.0771,
		"PLATTS - Refinery - Indonesia - Eretan - PT Kreasindo Resources",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		378.08,
		410.26,
		51.76,
		18868.22,
		56.12,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"PT Kreasindo Resources_Nakhle Barani Pardis",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFERTKES-PFR",
		51.909808,
		4.217697,
		"PLATTS - Refinery - Netherlands - Europoort - Koch Industries",
		null,
		null,
		null,
		null,
		null,
		93,
		97.11,
		10.94,
		3993.13,
		11.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80,
		null,
		10.4,
		3797.14,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		80,
		null,
		10.4,
		3797.14,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Koch Industries",
		"100",
		null,
		"Active",
		null,
		7.03,
		16.14,
		2.03,
		9.02,
		0.51,
		36.31,
		9.90140845,
		22.73239437,
		2.85915493,
		12.70422535,
		0.71830986,
		51.14084507,
		71.05,
	],
	[
		"REFHUDEFF-PFR",
		31.792197,
		6.056817,
		"PLATTS - Refinery - Algeria - Hassi Messaoud - Enterprise National De Raff - {NAFTEC}",
		null,
		null,
		null,
		null,
		null,
		31.16,
		34.14,
		4.19,
		1522.76,
		4.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		18,
		null,
		2.34,
		854.36,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		18,
		null,
		2.34,
		854.36,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"S N Repal",
		"100",
		null,
		"Active",
		null,
		8.11,
		2.82,
		5.7,
		1.21,
		0.9,
		2.56,
		36.86363636,
		12.81818182,
		25.90909091,
		5.5,
		4.09090909,
		11.63636364,
		21.3,
	],
	[
		"REFERTNNY-PFR",
		51.94327,
		4.107049,
		"PLATTS - Refinery - Netherlands - Europoort - Netherlands Refining Company",
		278.35,
		293.47,
		169.4,
		7101.45,
		179.06,
		904.79,
		951.02,
		136.54,
		44294.26,
		143.56,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		279.3,
		null,
		37.01,
		13508.21,
		null,
		null,
		null,
		null,
		null,
		null,
		5,
		null,
		0.67,
		243.98,
		null,
		190,
		null,
		24.71,
		9018.21,
		null,
		70.3,
		null,
		9.7,
		3539.24,
		null,
		14,
		null,
		1.94,
		706.78,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		105.98,
		74.56,
		43.63,
		56.54,
		6.54,
		17.06,
		33.96794872,
		23.8974359,
		13.98397436,
		18.12179487,
		2.09615385,
		5.46794872,
		304.31,
	],
	[
		"REFHUTYOM-PFR",
		16.1553,
		47.1672,
		"PLATTS - Refinery - Yemen - Hadramout - Yemen Oil and Minerals Corp.",
		201.6,
		221.46,
		26.18,
		9555.87,
		28.74,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yemen Oil and Minerals Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHVACSA-PFR",
		37.181593,
		-6.900586,
		"PLATTS - Refinery - Spain - Huelva - Cepsa",
		null,
		null,
		null,
		null,
		null,
		708.74,
		744.22,
		240.44,
		27496.07,
		251.85,
		9.84,
		null,
		1.46,
		533.79,
		null,
		0,
		null,
		0,
		0,
		null,
		138.53,
		null,
		18.55,
		6771.06,
		null,
		null,
		null,
		null,
		null,
		null,
		6.56,
		null,
		0.88,
		320.18,
		null,
		81.11,
		null,
		10.55,
		3850.22,
		null,
		24.6,
		null,
		3.39,
		1238.75,
		null,
		16.4,
		null,
		2.27,
		828.12,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mubadala Investment Company",
		"95.89",
		null,
		"Active",
		null,
		77.62,
		25.93,
		15.75,
		27.72,
		6.37,
		4.92,
		45.95618709,
		15.35227946,
		9.3250444,
		16.41207815,
		3.7714624,
		2.91296625,
		158.31,
	],
	[
		"REFHZUHCO-PFR",
		23.1061,
		114.4141,
		"PLATTS - Refinery - China - Huizhou - Huizhou Zhongchuang Chemical Co",
		null,
		null,
		null,
		null,
		null,
		1.6,
		1.69,
		0.19,
		69.03,
		0.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Huizhou Zhongchuang Chemical Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFINIUYO-PFR",
		34.192834,
		132.231689,
		"PLATTS - Refinery - Japan - Iwakuni - Union Sekiyu Kogyo",
		null,
		null,
		null,
		null,
		null,
		1.8,
		1.9,
		0.25,
		92.93,
		0.27,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Union Sekiyu Kogyo",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFIONSKG-PFR",
		37.510121,
		126.658561,
		"PLATTS - Refinery - South Korea - Inchon - SK Energy - {SK Incheon Petrochem}",
		250.14,
		266.12,
		122.7,
		8336.36,
		130.04,
		690.73,
		728.86,
		90.61,
		33023.63,
		95.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		213,
		null,
		28.14,
		10271.79,
		null,
		null,
		null,
		null,
		null,
		null,
		121.49,
		null,
		16.24,
		5928.81,
		null,
		91.49,
		null,
		11.9,
		4342.98,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SK Holdings_Other Investors",
		"91_9",
		null,
		"Active",
		null,
		71.75,
		32.29,
		25.38,
		56.18,
		5.35,
		67.4,
		26.94835681,
		12.12769953,
		9.53239437,
		21.10046948,
		2.00938967,
		25.31455399,
		258.34,
	],
	[
		"REFJAGJEN-PFR",
		22.60369323,
		113.14203948,
		"PLATTS - Refinery - China - Jiangmeng - Jiangmen Xinpeng Modified Bitumen",
		null,
		null,
		null,
		null,
		null,
		12,
		12.7,
		1.74,
		637.34,
		1.85,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jiangmen Xinpeng Modified Bitumen",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJINABC-PFR",
		31.9093,
		120.263,
		"PLATTS - Refinery - China - Jiangyin - Alpha Bitumen Co.",
		null,
		null,
		null,
		null,
		null,
		60,
		63.48,
		8.75,
		3193.25,
		9.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alpha Bitumen Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJLIDUS-PFR",
		25.018857,
		55.076382,
		"PLATTS - Refinery - United Arab Emirates - Jebel Ali - Dugas",
		null,
		null,
		null,
		null,
		null,
		15,
		16.1,
		1.77,
		647.16,
		1.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dugas",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJLITO2-PFR",
		25.000052,
		55.058883,
		"PLATTS - Refinery - United Arab Emirates - Jebel Ali - Total",
		null,
		null,
		null,
		null,
		null,
		2,
		2.25,
		0.28,
		103.25,
		0.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJLITOT-PFR",
		25.0288,
		55.1238,
		"PLATTS - Refinery - United Arab Emirates - Jebel Ali - Total",
		null,
		null,
		null,
		null,
		null,
		19,
		20.4,
		2.76,
		1006.02,
		2.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJNGZMP-PFR",
		30.7474,
		120.7511,
		"PLATTS - Refinery - China - Jiaxing - Zhejiang Meifu Petrochemical",
		null,
		null,
		null,
		null,
		null,
		34.38,
		37.57,
		12.15,
		1338.87,
		13.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zhejiang Meifu Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJNNJNC-PFR",
		36.6507,
		117.114,
		"PLATTS - Refinery - China - Jinan - Jinan Petrochemical Corp.",
		null,
		null,
		null,
		null,
		null,
		557.93,
		600.93,
		112.41,
		26218.68,
		120.4,
		48.5,
		null,
		7.21,
		2630.39,
		null,
		0,
		null,
		0,
		0,
		null,
		97,
		null,
		13.91,
		5078.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		48.5,
		null,
		6.71,
		2448.48,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		33.84,
		25.54,
		3.08,
		6.36,
		13.4,
		11.6,
		32.50408222,
		24.53174527,
		2.95840937,
		6.10892325,
		12.87100182,
		11.14206128,
		93.82,
	],
	[
		"REFJNRNGY-PFR",
		22.4732,
		70.0552,
		"PLATTS - Refinery - India - Jamnagar - Nayara Energy - {Vadinar, Essar Oil}",
		null,
		null,
		null,
		null,
		null,
		5060.74,
		5475.71,
		2799.63,
		137016.94,
		2993.79,
		28.7,
		null,
		4.26,
		1556,
		null,
		0,
		null,
		0,
		0,
		null,
		358.16,
		null,
		48.59,
		17732.17,
		null,
		null,
		null,
		null,
		null,
		null,
		127.72,
		null,
		17.09,
		6232.15,
		null,
		74.04,
		null,
		9.64,
		3514.18,
		null,
		127.72,
		null,
		17.61,
		6429.87,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Trafigura_United Capital Partners_Other Investors",
		"49.13_24.57_24.57_1.73",
		null,
		"Active",
		null,
		237.16,
		98.62,
		2.76,
		34.26,
		23.28,
		15.95,
		57.49751497,
		23.90961767,
		0.66913957,
		8.30605862,
		5.64404684,
		3.8669479,
		412.01,
	],
	[
		"REFJORPTN-PFR",
		1.34369,
		104.17371,
		"PLATTS - Refinery - Malaysia - Johor - Petronas - {Pengerang - RAPID}",
		null,
		null,
		null,
		null,
		null,
		1014.44,
		1081.38,
		200.62,
		47582.94,
		213.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45,
		null,
		6.18,
		2253.08,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.06,
		755.18,
		null,
		30,
		null,
		4.14,
		1514.52,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petronas_Saudi Aramco",
		"50_50",
		null,
		"Active",
		null,
		11.06,
		13.5,
		3.14,
		4.68,
		1.8,
		6.76,
		24.57777778,
		30,
		6.97777778,
		10.4,
		4,
		15.02222222,
		40.96,
	],
	[
		"REFJZNARM-PFR",
		16.87889,
		42.54747,
		"PLATTS - Refinery - Saudi Arabia - Jizan - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		5476.8,
		5844.23,
		4472.11,
		63185.9,
		4742.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKADUWN-PFR",
		54.7101,
		20.5106,
		"PLATTS - Refinery - Russia - Kaliningrad - Unknown",
		970.35,
		1057.01,
		327.84,
		37273.03,
		353.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKANTLT-PFR",
		4.1928,
		103.1195,
		"PLATTS - Refinery - Malaysia - Kemaman - Tipco Asphalt",
		null,
		null,
		null,
		null,
		null,
		70,
		73.23,
		10.29,
		3754.4,
		10.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tipco Asphalt",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKBKWSR-PFR",
		48.501737,
		135.051715,
		"PLATTS - Refinery - Russia - Khabarovsk - West Siberian Resources",
		20,
		21.47,
		2.74,
		1000,
		2.94,
		296.5,
		323.92,
		62.89,
		13829.1,
		68.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94.57,
		null,
		12.66,
		4622.79,
		null,
		313.9,
		344.1,
		65.27,
		14396.52,
		71.02,
		0,
		null,
		0,
		0,
		null,
		48,
		null,
		6.24,
		2278.29,
		null,
		46.57,
		null,
		6.42,
		2344.5,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alliance Co._Other Investors",
		"95.79_4.21",
		null,
		"Active",
		null,
		37.35,
		16.43,
		22.43,
		5.98,
		2.11,
		6.13,
		37.88800974,
		16.66666667,
		22.75309393,
		6.06613918,
		2.14039359,
		6.21829986,
		90.44,
	],
	[
		"REFKBOEGP-PFR",
		24.4762,
		32.9495,
		"PLATTS - Refinery - Egypt - Kom Ombo - EGPC",
		2,
		2.18,
		0.27,
		100,
		0.3,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKEHNIO-PFR",
		34.352549,
		47.104126,
		"PLATTS - Refinery - Iran - Kermanshah - National Iranian Oil Co.",
		74.06,
		81.23,
		10.44,
		3790.46,
		11.45,
		34.75,
		37.77,
		4.61,
		1680.91,
		5.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		19.45,
		null,
		2.68,
		979.24,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		19.45,
		null,
		2.68,
		979.24,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		5.12,
		0.49,
		9.61,
		0.62,
		0.22,
		3.2,
		25.6,
		2.45,
		48.05,
		3.1,
		1.1,
		16,
		19.27,
	],
	[
		"REFKIAKTD-PFR",
		54.0536,
		-128.6541,
		"PLATTS - Refinery - Canada - Kitimat - Kitimat Clean Ltd",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		2060.8,
		2165.48,
		826.32,
		75637.42,
		870.6,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kitimat Clean Ltd",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKINTOA-PFR",
		35.513338,
		139.744035,
		"PLATTS - Refinery - Japan - Keihin - Toa Oil Company",
		null,
		null,
		null,
		null,
		null,
		1260.53,
		1334.14,
		976.72,
		17845.95,
		1033.48,
		0.04,
		null,
		0,
		2.24,
		null,
		0.86,
		null,
		0.12,
		46.31,
		null,
		46.27,
		null,
		6.27,
		2290.06,
		null,
		null,
		null,
		null,
		null,
		null,
		23.28,
		null,
		3.11,
		1135.97,
		null,
		2.33,
		null,
		0.3,
		110.6,
		null,
		18.14,
		null,
		2.5,
		913.24,
		null,
		1.62,
		null,
		0.22,
		81.72,
		null,
		null,
		null,
		null,
		null,
		null,
		"Showa Shell_Other Investors",
		"50.1_49.9",
		null,
		"Active",
		null,
		15.43,
		21.04,
		0.48,
		9.74,
		7.68,
		1.85,
		27.35815603,
		37.30496454,
		0.85106383,
		17.26950355,
		13.61702128,
		3.28014184,
		56.23,
	],
	[
		"REFKKWSHW-PFR",
		35.505724,
		139.720772,
		"PLATTS - Refinery - Japan - Kawasaki - Showa Oil Company",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		0,
		0.06,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFAHFRC-PFR",
		25.193995,
		56.354657,
		"PLATTS - Refinery - United Arab Emirates - Fujairah - Fujairah Refining Company",
		240,
		257.65,
		32.5,
		11858.82,
		34.87,
		100,
		107.36,
		13.99,
		5102.73,
		15.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.07,
		755.18,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.07,
		755.18,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vitol_Fujairah Govt.",
		"90_10",
		null,
		"Active",
		null,
		4.04,
		2.8,
		9.19,
		2.19,
		0.6,
		0.5,
		20.2,
		14,
		45.95,
		10.95,
		3,
		2.5,
		19.31,
	],
	[
		"REFFANFAL-PFR",
		22.87920988,
		112.91823609,
		"PLATTS - Refinery - China - Foshan - Foshan Ruifeng Petrochemical",
		null,
		null,
		null,
		null,
		null,
		26,
		27.64,
		3.78,
		1378.89,
		4.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Foshan Ruifeng Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFANFSY-PFR",
		23.0248,
		113.1146,
		"PLATTS - Refinery - China - Foshan - Foshan Sanshui Yihao Asph.",
		null,
		null,
		null,
		null,
		null,
		26,
		27.64,
		3.78,
		1378.89,
		4.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Foshan Sanshui Yihao Asph.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFAYMUM-PFR",
		41.032459,
		-83.669529,
		"PLATTS - Refinery - United States - Findlay - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ashland Oil Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFINTOT-PFR",
		45.67471,
		4.845357,
		"PLATTS - Refinery - France - Feyzin - Total",
		null,
		null,
		null,
		null,
		null,
		308.76,
		324.95,
		43.11,
		15703.3,
		45.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		58.12,
		null,
		7.61,
		2779.46,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		51.17,
		null,
		6.65,
		2428.51,
		null,
		0,
		null,
		0,
		0,
		null,
		6.95,
		null,
		0.96,
		350.95,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		38.42,
		24.91,
		3.46,
		6.05,
		2.1,
		8.28,
		45.9569378,
		29.79665072,
		4.13875598,
		7.23684211,
		2.51196172,
		9.90430622,
		83.21,
	],
	[
		"REFFLEP66-PFR",
		48.82775,
		-122.6986,
		"PLATTS - Refinery - United States - Ferndale - Phillips 66 Co.",
		31.12,
		33.24,
		5.8,
		1711.12,
		6.19,
		276,
		289.8,
		37.28,
		13590.56,
		39.13,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		73.87,
		null,
		9.93,
		3625.13,
		null,
		null,
		null,
		null,
		null,
		null,
		0.83,
		null,
		0.11,
		40.73,
		null,
		33.3,
		null,
		4.33,
		1580.79,
		null,
		15.22,
		null,
		2.1,
		766.02,
		null,
		24.51,
		null,
		3.39,
		1237.59,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		8.83,
		49.43,
		16.39,
		14.1,
		-4.76,
		0,
		9.97627387,
		55.84679697,
		18.51768162,
		15.93040334,
		-5.3779234,
		0,
		83.99,
	],
	[
		"REFFNAUAZ-PFR",
		40.442016,
		71.82594,
		"PLATTS - Refinery - Uzbekistan - Fergana - Uzbekneftegaz",
		null,
		null,
		null,
		null,
		null,
		409.34,
		447.5,
		134.89,
		16164.26,
		145.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		38.53,
		null,
		5.31,
		1939.89,
		null,
		10.04,
		11.28,
		1.64,
		584.04,
		1.85,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		38.53,
		null,
		5.31,
		1939.89,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sanoat Energetika Guruhi",
		"100",
		null,
		"Active",
		null,
		12.67,
		13.46,
		4.47,
		2.36,
		0.95,
		0,
		32.88346743,
		34.9338178,
		11.6013496,
		6.12509733,
		2.46561121,
		0,
		33.92,
	],
	[
		"REFFRTHGY-PFR",
		28.954767,
		-95.330916,
		"PLATTS - Refinery - United States - Freeport - Hunton Energy",
		1276.28,
		1340.66,
		367.94,
		53757.69,
		388.02,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hunton Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFRTOES-PFR",
		26.5357,
		-78.6954,
		"PLATTS - Refinery - Bahamas - Freeport - Oban Energies",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		70.05,
		76.19,
		9.26,
		3361.42,
		10.05,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oban Energies",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFFZAPTS-PFR",
		-3.716573,
		-38.469307,
		"PLATTS - Refinery - Brazil - Fortaleza - Petrobras - {LUBNOR - Lubricantes e Derivados do Nordeste}",
		null,
		null,
		null,
		null,
		null,
		30.52,
		32.37,
		12.97,
		1095.34,
		13.73,
		5.05,
		null,
		0.75,
		273.66,
		null,
		0,
		null,
		0,
		0,
		null,
		7.1,
		null,
		1.03,
		377.08,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.05,
		null,
		0.28,
		103.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		2.26,
		0.62,
		1.42,
		0.49,
		-0.1,
		0,
		31.83098592,
		8.73239437,
		20,
		6.90140845,
		-1.4084507,
		0,
		4.7,
	],
	[
		"REFGERENE-PFR",
		38.984838,
		-110.100357,
		"PLATTS - Refinery - United States - Green River - EcoDomaine",
		15,
		15.64,
		2.05,
		750,
		2.14,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Emery Refinery",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGL2NIO-PFR",
		37.1984436,
		55.070672,
		"PLATTS - Refinery - Iran - Golestan (2) - National Iranian Oil Co.",
		1321.1,
		1444.73,
		469.1,
		50917.19,
		507.24,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGLAAPS-PFR",
		37.054624,
		14.274287,
		"PLATTS - Refinery - Italy - Gela - Agip Petroli S.P.A.",
		45,
		47.61,
		45,
		45,
		47.61,
		138.44,
		145.49,
		114.1,
		1557.68,
		119.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGOUPTC-PFR",
		27,
		107,
		"PLATTS - Refinery - China - Guizhou - PetroChina",
		298.05,
		321.41,
		40.61,
		14800.49,
		43.76,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFLEBBP-PFR",
		48.88485,
		-122.7364,
		"PLATTS - Refinery - United States - Ferndale - BP - {Cherry Point}",
		null,
		null,
		null,
		null,
		null,
		815.67,
		859.47,
		231.08,
		34052.63,
		244.04,
		3.99,
		null,
		0.59,
		216.63,
		null,
		6.95,
		null,
		1.03,
		376.39,
		null,
		184.47,
		null,
		24.77,
		9042.07,
		null,
		null,
		null,
		null,
		null,
		null,
		0.31,
		null,
		0.04,
		15.27,
		null,
		101.04,
		null,
		13.14,
		4795.81,
		null,
		38.49,
		null,
		5.31,
		1937.86,
		null,
		33.68,
		null,
		4.66,
		1700.11,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		55.55,
		100.56,
		5.21,
		40.73,
		12.42,
		0,
		25.13347208,
		45.49814496,
		2.35725274,
		18.42819654,
		5.61940096,
		0,
		214.48,
	],
	[
		"REFFTALUM-PFR",
		39.177591,
		-108.781048,
		"PLATTS - Refinery - United States - Fruita - Landmark Petroleum",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0.03,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Landmark Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHAYTRI-PFR",
		36.4137,
		36.2307,
		"PLATTS - Refinery - Turkey - Hatay - Turkiye Petrolleri",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		27,
		28.49,
		3.76,
		1371.61,
		3.99,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Turkiye Petrolleri",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFFWAJPC-PFR",
		39.872005,
		139.847124,
		"PLATTS - Refinery - Japan - Funakawa - Japan Energy Corp.",
		null,
		null,
		null,
		null,
		null,
		-0.01,
		0,
		-0.02,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kyodo Oil Co_Nippon Mining",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHCHCNG-PFR",
		51.94262,
		1.240382,
		"PLATTS - Refinery - United Kingdom - Harwich - Carless Refining and Marketing",
		null,
		null,
		null,
		null,
		null,
		15,
		15.64,
		1.76,
		644.12,
		1.84,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.49,
		null,
		0.97,
		355.56,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		7.49,
		null,
		0.97,
		355.56,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Carless Refining and Marketing",
		"100",
		null,
		"Active",
		null,
		2.05,
		0.1,
		0,
		0.63,
		0.39,
		5.7,
		22.52747253,
		1.0989011,
		0,
		6.92307692,
		4.28571429,
		62.63736264,
		8.88,
	],
	[
		"REFFWYEXM-PFR",
		50.83221,
		-1.357176,
		"PLATTS - Refinery - United Kingdom - Fawley - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		1226.06,
		1288.42,
		421.18,
		46623.49,
		441.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		182.23,
		null,
		24.35,
		8887.24,
		null,
		null,
		null,
		null,
		null,
		null,
		10.03,
		null,
		1.34,
		489.38,
		null,
		95.31,
		null,
		12.39,
		4523.76,
		null,
		54.32,
		null,
		7.49,
		2734.91,
		null,
		22.57,
		null,
		3.12,
		1139.18,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		90.63,
		76.42,
		10.88,
		34.59,
		19.81,
		1.46,
		38.24050633,
		32.24472574,
		4.5907173,
		14.59493671,
		8.35864979,
		0.61603376,
		233.79,
	],
	[
		"REFHD2ICO-PFR",
		34.1353,
		42.3778,
		"PLATTS - Refinery - Iraq - Haditha (2) - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		122,
		131.96,
		17.28,
		6308.7,
		18.69,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGANNIO-PFR",
		37.1984436,
		55.070672,
		"PLATTS - Refinery - Iran - Golestan - National Iranian Oil Co.",
		20,
		21.48,
		2.74,
		1000,
		2.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHDOILL-PFR",
		42.634966,
		141.653366,
		"PLATTS - Refinery - Japan - Hokkaido - Idemitsu Showa Shell - {Idemitsu Kosan Company}",
		null,
		null,
		null,
		null,
		null,
		361.7,
		382.77,
		50.12,
		18158.33,
		53.05,
		0.09,
		null,
		0.01,
		4.92,
		null,
		1.88,
		null,
		0.28,
		101.88,
		null,
		101.83,
		null,
		13.81,
		5039.74,
		null,
		null,
		null,
		null,
		null,
		null,
		52,
		null,
		6.95,
		2537.43,
		null,
		4.95,
		null,
		0.64,
		234.93,
		null,
		39.91,
		null,
		5.5,
		2009.13,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company",
		"100",
		null,
		"Active",
		null,
		47.77,
		31.02,
		5,
		21.44,
		9.05,
		12.22,
		38.39106325,
		24.92967934,
		4.01832356,
		17.23057141,
		7.27316564,
		9.82078277,
		126.49,
	],
	[
		"REFGCEPTY-PFR",
		49.676692,
		21.175097,
		"PLATTS - Refinery - Poland - Gorlice - P.P. Rafineria Nafty - {Gilmar}",
		11.39,
		12.12,
		1.6,
		584.96,
		1.71,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hudson Oil Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHEIHUA-PFR",
		38.73312897,
		116.13544066,
		"PLATTS - Refinery - China - Huabei - Huabei Petrochemical",
		null,
		null,
		null,
		null,
		null,
		823.76,
		887.01,
		243.01,
		33986.5,
		259.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		147,
		null,
		20.33,
		7421.16,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		147,
		null,
		20.33,
		7421.16,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		34.96,
		34.55,
		19.46,
		6.16,
		7.89,
		20.49,
		28.04653028,
		27.71760931,
		15.6117128,
		4.94183714,
		6.32972323,
		16.43802647,
		123.5,
	],
	[
		"REFGEIATS-PFR",
		30.20949,
		-90.99182,
		"PLATTS - Refinery - United States - Geismar - Air Products",
		null,
		null,
		null,
		null,
		null,
		35,
		37.03,
		35,
		35,
		37.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHENYEN-PFR",
		22.6638,
		112.8001,
		"PLATTS - Refinery - China - Heshan - Yingchang Bitumen",
		null,
		null,
		null,
		null,
		null,
		31,
		32.8,
		4.5,
		1643.36,
		4.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yingchang Bitumen",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGENSAC-PFR",
		50.95937,
		5.791769,
		"PLATTS - Refinery - Netherlands - Geleen - SABIC",
		null,
		null,
		null,
		null,
		null,
		3.24,
		3.43,
		0.38,
		139.79,
		0.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGERGLC-PFR",
		38.970385,
		-110.29685,
		"PLATTS - Refinery - United States - Green River - Green River Refinery LLC",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		12.51,
		1.64,
		600,
		1.71,
		"Green River Refinery LLC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGIASCH-PFR",
		32.5876,
		3.7191,
		"PLATTS - Refinery - Algeria - Ghardaia - Sonatrach",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		297.2,
		325.73,
		78.91,
		12346.16,
		86.24,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGINGTY-PFR",
		51.2837,
		37.5347,
		"PLATTS - Refinery - Russia - Gubkin - Gubkin City",
		68.04,
		74.42,
		9.07,
		3295.79,
		9.91,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gubkin City",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGNGOMV-PFR",
		48.7665,
		11.5334,
		"PLATTS - Refinery - Germany - Grossmehring - OMV",
		null,
		null,
		null,
		null,
		null,
		1,
		1.14,
		0.16,
		58.4,
		0.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"OMV",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGPJECE-PFR",
		49.473041,
		0.544068,
		"PLATTS - Refinery - France - Gravenchon (Port Jerome) - Esso France",
		null,
		null,
		null,
		null,
		null,
		647.57,
		680.64,
		88.58,
		32252.57,
		93.11,
		4.22,
		null,
		0.63,
		228.45,
		null,
		0.85,
		null,
		0.12,
		45.63,
		null,
		190.4,
		null,
		25.11,
		9167.01,
		null,
		null,
		null,
		null,
		null,
		null,
		16.85,
		null,
		2.26,
		822.18,
		null,
		143.21,
		null,
		18.63,
		6797.76,
		null,
		21.07,
		null,
		2.91,
		1060.34,
		null,
		4.22,
		null,
		0.59,
		212.65,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Other Investors",
		"81.55_18.45",
		null,
		"Active",
		null,
		75.38,
		58.42,
		32.41,
		16.01,
		4.16,
		19.2,
		33.3539823,
		25.84955752,
		14.34070796,
		7.0840708,
		1.84070796,
		8.49557522,
		205.56,
	],
	[
		"REFGRGSOY-PFR",
		57.701318,
		11.878461,
		"PLATTS - Refinery - Sweden - Gothenburg - St1 Oy",
		null,
		null,
		null,
		null,
		null,
		224.04,
		235.99,
		30.76,
		11221.57,
		32.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80,
		null,
		10.43,
		3806.2,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		77,
		null,
		10.01,
		3654.75,
		null,
		0,
		null,
		0,
		0,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"St1 Oy",
		"100",
		null,
		"Active",
		null,
		26.41,
		22.1,
		17.68,
		2.06,
		2.7,
		1.66,
		37.72857143,
		31.57142857,
		25.25714286,
		2.94285714,
		3.85714286,
		2.37142857,
		72.6,
	],
	[
		"REFGTIIND-PFR",
		26.186508,
		91.687872,
		"PLATTS - Refinery - India - Guwahati - Indian Oil Corp.",
		null,
		null,
		null,
		null,
		null,
		78.53,
		86.59,
		17.88,
		3494.72,
		19.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		14.79,
		null,
		1.92,
		702.01,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		14.79,
		null,
		1.92,
		702.01,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		0,
		"Active",
		null,
		7.6,
		5.41,
		0,
		1.9,
		1.89,
		0.82,
		41.62102957,
		29.62760131,
		0,
		10.40525739,
		10.35049288,
		4.49069003,
		17.61,
	],
	[
		"REFGUPMUM-PFR",
		35.48792,
		-108.4255,
		"PLATTS - Refinery - United States - Gallup - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		-0.03,
		-0.03,
		0.01,
		-1.43,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		9.86,
		12.41,
		0.36,
		0,
		-0.48,
		0,
		44.81818182,
		56.40909091,
		1.63636364,
		0,
		-2.18181818,
		0,
		22.14,
	],
	[
		"REFKKYVIL-PFR",
		55.008502,
		82.238233,
		"PLATTS - Refinery - Russia - Kochenevsky - VPK-Oil",
		null,
		null,
		null,
		null,
		null,
		22.02,
		24.16,
		3.07,
		1105.59,
		3.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.62,
		null,
		1.19,
		433.48,
		null,
		59.01,
		64.53,
		7.8,
		2851.32,
		8.54,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.62,
		null,
		1.19,
		433.48,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"VPK-Oil_Shanghai Hoto Engineering_China Machinery Industry Constr Grp",
		"85_7.5_7.5",
		null,
		"Active",
		null,
		3.07,
		0,
		3.97,
		0,
		0,
		1.73,
		33.69923161,
		0,
		43.57848518,
		0,
		0,
		18.99012075,
		8.77,
	],
	[
		"REFKMIMFT-PFR",
		63.9881,
		54.3326,
		"PLATTS - Refinery - Russia - Komi - Mosneft",
		29,
		31.43,
		6.57,
		1306.32,
		7.09,
		45.03,
		48.79,
		9.66,
		2059.02,
		10.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.06,
		null,
		0.42,
		153.83,
		null,
		29,
		31.43,
		6.57,
		1306.32,
		7.09,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.06,
		null,
		0.42,
		153.83,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mosneft",
		"100",
		null,
		"Active",
		null,
		0.87,
		0,
		1.31,
		0,
		0,
		0.61,
		26.93498452,
		0,
		40.55727554,
		0,
		0,
		18.88544892,
		2.8,
	],
	[
		"REFKMKRFT-PFR",
		50.59697,
		137.14251,
		"PLATTS - Refinery - Russia - Komsomolsk - Rosneft",
		17.77,
		19.92,
		3.49,
		993.57,
		3.88,
		778.25,
		847.14,
		345.24,
		25873.53,
		371.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		106.98,
		null,
		14.33,
		5231.64,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		53.49,
		null,
		6.95,
		2538.78,
		null,
		53.49,
		null,
		7.38,
		2692.86,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Unknown_Other Investors",
		"79_10.6_10.4",
		null,
		"Active",
		null,
		49.24,
		15,
		40.67,
		9.26,
		6.77,
		9.42,
		33.96096283,
		10.34554107,
		28.05021036,
		6.38664735,
		4.66928754,
		6.49699979,
		130.37,
	],
	[
		"REFGZANIL-PFR",
		14.1816,
		24.694,
		"PLATTS - Refinery - South Sudan - Gemeza - Noor Oil",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		597.3,
		656.11,
		81.49,
		29634.7,
		89.52,
		"Noor Oil",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHEZCOC-PFR",
		38.46597873,
		117.60827711,
		"PLATTS - Refinery - China - Huanghua (Zhongjie) - CNOOC",
		null,
		null,
		null,
		null,
		null,
		510.18,
		547.56,
		166.77,
		19922.74,
		177.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGZUGJB-PFR",
		23.1302,
		113.2593,
		"PLATTS - Refinery - China - Guangzhou - Guangzhou Jiasheng Bitumen Co.",
		null,
		null,
		null,
		null,
		null,
		17,
		17.98,
		2.49,
		906.02,
		2.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Guangzhou Jiasheng Bitumen Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKNAUWN-PFR",
		12.5631,
		7.6207,
		"PLATTS - Refinery - Nigeria - Katsina - Unknown",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		60,
		65.38,
		8.22,
		3000,
		8.96,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NNPC_Niger Government",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHGOINY-PFR",
		34.77979,
		134.694156,
		"PLATTS - Refinery - Japan - Hyogo - Idemitsu Kosan Company",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHAIHEM-PFR",
		19.2,
		109.6,
		"PLATTS - Refinery - China - Hainan - Hainan Handi Yangguang Petrochem",
		null,
		null,
		null,
		null,
		null,
		136.12,
		148.27,
		20.05,
		7315.13,
		21.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hainan Handi Yangguang Petrochem",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKOASPE-PFR",
		22.5727,
		88.3639,
		"PLATTS - Refinery - India - Kolkata - Spice Energy",
		426.59,
		472.36,
		56.53,
		20386.15,
		62.51,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Spice Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHONKAN-PFR",
		29.733366,
		-95.219048,
		"PLATTS - Refinery - United States - Houston - Kinder Morgan",
		null,
		null,
		null,
		null,
		null,
		140.12,
		146.72,
		17.34,
		6285.36,
		18.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		79.33,
		null,
		10.32,
		3765.52,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		79.33,
		null,
		10.32,
		3765.52,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kinder Morgan",
		"100",
		null,
		"Active",
		null,
		22.83,
		36.35,
		3.39,
		11.83,
		2.53,
		4.22,
		27.00816278,
		43.00248433,
		4.01041051,
		13.99503135,
		2.99302023,
		4.99231042,
		81.15,
	],
	[
		"REFHHAICO-PFR",
		34.070045,
		42.360759,
		"PLATTS - Refinery - Iraq - Haditha - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		16,
		17.18,
		2.19,
		800,
		2.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.38,
		503.45,
		null,
		54,
		57.97,
		7.39,
		2700,
		7.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.38,
		503.45,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		1.79,
		0.81,
		5.23,
		0.98,
		0.08,
		0.54,
		17.9,
		8.1,
		52.3,
		9.8,
		0.8,
		5.4,
		9.44,
	],
	[
		"REFKSRKFT-PFR",
		44.997494,
		38.966017,
		"PLATTS - Refinery - Russia - Krasnodar - Krasnodareconeft",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		51,
		null,
		7.04,
		2567.59,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		51,
		null,
		7.04,
		2567.59,
		null,
		0,
		null,
		0,
		0,
		null,
		284.24,
		309.31,
		125.74,
		9409.65,
		135.54,
		"Adamas_Other Investors",
		"75_25",
		null,
		"Active",
		null,
		15.83,
		3.87,
		17.76,
		3.29,
		0.97,
		3.77,
		29.93004349,
		7.31707317,
		33.57912649,
		6.22045755,
		1.83399508,
		7.12800151,
		45.49,
	],
	[
		"REFHINPTC-PFR",
		45.755982,
		126.737886,
		"PLATTS - Refinery - China - Harbin - PetroChina",
		-30,
		-31.74,
		-4.11,
		-1500,
		-4.35,
		275.9,
		297.56,
		36.9,
		13456.81,
		39.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71,
		null,
		9.64,
		3517.03,
		null,
		null,
		null,
		null,
		null,
		null,
		14.2,
		null,
		1.9,
		692.91,
		null,
		14.2,
		null,
		1.85,
		673.99,
		null,
		3.55,
		null,
		0.49,
		178.72,
		null,
		39.05,
		null,
		5.4,
		1971.4,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		21.62,
		19.99,
		1.56,
		4.57,
		9.53,
		8.07,
		31.85971117,
		29.45770704,
		2.29885057,
		6.73445329,
		14.04361922,
		11.89213086,
		65.33,
	],
	[
		"REFHONLBR-PFR",
		29.71171,
		-95.23579,
		"PLATTS - Refinery - United States - Houston - LyondellBasell Refining",
		null,
		null,
		null,
		null,
		null,
		1059.97,
		1115.9,
		152.88,
		53667.62,
		160.91,
		183.62,
		null,
		27.28,
		9958.73,
		null,
		0,
		null,
		0,
		0,
		null,
		228.88,
		null,
		33.17,
		12106.92,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		45.26,
		null,
		5.89,
		2148.19,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Access Industries",
		"100",
		null,
		"Active",
		null,
		67.52,
		104.19,
		5.52,
		27.46,
		11.87,
		17.41,
		25.46291059,
		39.29177509,
		2.08168345,
		10.35562092,
		4.47637365,
		6.56559943,
		233.97,
	],
	[
		"REFHMGHAG-PFR",
		53.512774,
		9.957575,
		"PLATTS - Refinery - Germany - Hamburg - H and R Wasag",
		null,
		null,
		null,
		null,
		null,
		23.33,
		24.46,
		4.22,
		1218.84,
		4.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mobil_BP-Amoco Corporation",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHONVRO-PFR",
		29.72003,
		-95.25381,
		"PLATTS - Refinery - United States - Houston - Valero",
		null,
		null,
		null,
		null,
		null,
		472.63,
		496.63,
		94.41,
		22033.84,
		98.94,
		22.27,
		null,
		3.31,
		1207.9,
		null,
		0,
		null,
		0,
		0,
		null,
		186.97,
		null,
		24.73,
		9024.97,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		164.69,
		null,
		21.42,
		7817.07,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		69.92,
		96.18,
		1.73,
		15.57,
		-4.78,
		2.02,
		40.5168917,
		55.73390508,
		1.00249174,
		9.02242568,
		-2.76989048,
		1.17053949,
		180.64,
	],
	[
		"REFKUKKRG-PFR",
		35.4703,
		44.3957,
		"PLATTS - Refinery - Iraq - Kirkuk - KRG",
		null,
		null,
		null,
		null,
		null,
		53,
		56.91,
		7.26,
		2650,
		7.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.52,
		2013.79,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.52,
		2013.79,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KRG",
		"100",
		null,
		"Active",
		null,
		8.22,
		3.79,
		23.71,
		4.27,
		0.51,
		3.06,
		18.26666667,
		8.42222222,
		52.68888889,
		9.48888889,
		1.13333333,
		6.8,
		43.55,
	],
	[
		"REFHOTPTC-PFR",
		40.80471,
		111.76117,
		"PLATTS - Refinery - China - Hohhot - PetroChina",
		null,
		null,
		null,
		null,
		null,
		352.8,
		381.13,
		48.55,
		17685.51,
		52.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		82.24,
		null,
		11.37,
		4151.59,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		82.24,
		null,
		11.37,
		4151.59,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		26.09,
		26.92,
		8.66,
		5.27,
		5.96,
		11.87,
		30.59333959,
		31.56660413,
		10.15478424,
		6.17964353,
		6.98874296,
		13.91885553,
		84.77,
	],
	[
		"REFKVISAR-PFR",
		42.2727,
		41.6657,
		"PLATTS - Refinery - Georgia - Kulevi - SOCAR",
		426.9,
		466.84,
		89.5,
		19420.74,
		97.2,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Georgia State Company_SOCAR",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHNGHAP-PFR",
		20.8589,
		106.675,
		"PLATTS - Refinery - Vietnam - Hai Phong - Hapaco",
		304.16,
		334.4,
		41.5,
		15090.42,
		45.56,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hapaco_Evagor",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKVOCRY-PFR",
		55.61187,
		86.145176,
		"PLATTS - Refinery - Russia - Kemerovo - Chernigov Refinery",
		null,
		null,
		null,
		null,
		null,
		11.2,
		12.14,
		2.62,
		520.98,
		2.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4.72,
		null,
		0.65,
		237.39,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4.72,
		null,
		0.65,
		237.39,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sibirskiy Business Union",
		"100",
		null,
		"Active",
		null,
		1.01,
		0.98,
		1.74,
		0,
		0,
		0,
		20.24048096,
		19.63927856,
		34.86973948,
		0,
		0,
		0,
		3.72,
	],
	[
		"REFHRARES-PFR",
		21.0956,
		72.6466,
		"PLATTS - Refinery - India - Hazira - Reliance Industries",
		null,
		null,
		null,
		null,
		null,
		3.3,
		3.54,
		0.39,
		142.38,
		0.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Reliance Industries",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHNHFPC-PFR",
		18.2879,
		105.7843,
		"PLATTS - Refinery - Vietnam - Ha Tinh - Formosa Petrochemical Co.",
		891.45,
		979.59,
		121.6,
		44219.53,
		133.49,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Formosa Petrochemical Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLANNIO-PFR",
		26.799535,
		53.349962,
		"PLATTS - Refinery - Iran - Lavan - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		74.04,
		80.68,
		9.73,
		3540.87,
		10.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.52,
		2013.79,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.52,
		2013.79,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		10.62,
		6.57,
		19.63,
		1.18,
		0.62,
		0.24,
		26.55,
		16.425,
		49.075,
		2.95,
		1.55,
		0.6,
		38.86,
	],
	[
		"REFHONBBP-PFR",
		29.7589,
		-95.3677,
		"PLATTS - Refinery - United States - Houston - BP",
		65.05,
		68.06,
		8.98,
		3258.36,
		9.39,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_Other Investors",
		"80_20",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHSEIRC-PFR",
		29.834228,
		-94.347015,
		"PLATTS - Refinery - United States - Hamshire - Independent Refining Co.",
		40,
		41.72,
		5.48,
		2000,
		5.72,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jefferson Refinery, LLC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLAPTNT-PFR",
		38.8131,
		63.0513,
		"PLATTS - Refinery - Turkmenistan - Lebap - Turkmenistan Government",
		null,
		null,
		null,
		null,
		null,
		4,
		4.3,
		0.48,
		171.76,
		0.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.96,
		null,
		0.26,
		92.7,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.96,
		null,
		0.26,
		92.7,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Turkmenistan Government",
		"50_50",
		null,
		"Active",
		null,
		0.2,
		0,
		0.1,
		0.3,
		0.1,
		1.36,
		10.20408163,
		0,
		5.10204082,
		15.30612245,
		5.10204082,
		69.3877551,
		2.06,
	],
	[
		"REFLASMNT-PFR",
		4.8597,
		115.4083,
		"PLATTS - Refinery - Malaysia - Lawas - Malaysian Government",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		507.3,
		536.66,
		70.88,
		25761.81,
		74.96,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Malaysian Government",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHRDVRO-PFR",
		36.319839,
		-119.653005,
		"PLATTS - Refinery - United States - Hanford - Valero",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ultramar",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLAZYOS-PFR",
		-16.4955,
		-68.1336,
		"PLATTS - Refinery - Bolivia - La Paz - YPF Bolivianos",
		10,
		10.74,
		1.37,
		500,
		1.47,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF Bolivianos",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHUAXQP-PFR",
		38.43573908,
		117.31084439,
		"PLATTS - Refinery - China - Huanghua - Xinquan Petrochemical",
		null,
		null,
		null,
		null,
		null,
		59.82,
		64.45,
		13.61,
		2849.41,
		14.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xinquan Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHTEAIS-PFR",
		41.822296,
		140.699806,
		"PLATTS - Refinery - Japan - Hakodate - Asia Oil",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mitsubishi_Unknown_Mitsui",
		"48.7_41.3_10",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLBESRF-PFR",
		4.013472,
		9.127315,
		"PLATTS - Refinery - Cameroon - Limbe - Soc. Nationale De Raffinage - {SONARA}",
		null,
		null,
		null,
		null,
		null,
		233.78,
		255.78,
		83.71,
		8653.14,
		90.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cameroon Govt._Total_Other Investors",
		"74_18_8",
		0,
		"Active",
		null,
		4.17,
		2.54,
		1.48,
		1.99,
		0.26,
		0,
		37.90909091,
		23.09090909,
		13.45454545,
		18.09090909,
		2.36363636,
		0,
		10.43,
	],
	[
		"REFHUDBBA-PFR",
		31.6957,
		6.0604,
		"PLATTS - Refinery - Algeria - Hassi Messaoud - Bir Seba",
		20,
		21.8,
		2.74,
		1000,
		2.98,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Vietnam_PTT Exp. and Prod. Algeria_Sonatrach",
		"40_35_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLCACYP-PFR",
		34.940478,
		33.641138,
		"PLATTS - Refinery - Cyprus - Larnaca - Cyprus Pet. Ref. Ltd.",
		null,
		null,
		null,
		null,
		null,
		-0.06,
		0.02,
		-0.01,
		0.01,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cyprian Govt._ExxonMobil_Petrolina",
		"65_20_15",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHZESHP-PFR",
		35.35815542,
		115.12756401,
		"PLATTS - Refinery - China - Heze - Shandong Dongming Petrochemical Grp",
		null,
		null,
		null,
		null,
		null,
		458.26,
		496.11,
		81.69,
		22995.06,
		88.13,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Local Investors_China National Petroleum Corp.",
		"60_40",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHZUCNC-PFR",
		22.69987,
		114.56062,
		"PLATTS - Refinery - China - Huizhou - CNOOC Huizhou Petrochemical",
		1054.22,
		1133.4,
		181.72,
		50590.98,
		194.69,
		2061.05,
		2218.63,
		608.65,
		86102.59,
		649.15,
		0,
		null,
		0,
		0,
		null,
		409.52,
		null,
		60.76,
		22177.21,
		null,
		409.52,
		null,
		60.76,
		22177.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		146.83,
		50.41,
		7.52,
		22.54,
		34,
		65.31,
		40.65173454,
		13.95664332,
		2.0820067,
		6.24048285,
		9.41332817,
		18.08189596,
		326.61,
	],
	[
		"REFLCSSOL-PFR",
		30.251172,
		-93.277928,
		"PLATTS - Refinery - United States - Lake Charles - Sasol",
		null,
		null,
		null,
		null,
		null,
		10,
		10.58,
		1.41,
		516.27,
		1.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sasol",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHZEYHI-PFR",
		35.21754115,
		115.56417569,
		"PLATTS - Refinery - China - Heze - Yuhuang Shengshi - {Shandong Yuhuang Petrochem}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Yuhuang Petrochem",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFIAMP66-PFR",
		53.63428,
		-0.2492952,
		"PLATTS - Refinery - United Kingdom - Immingham - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		2147.21,
		2250.04,
		1329,
		49553.48,
		1387.73,
		5.26,
		null,
		0.78,
		285.37,
		null,
		1.75,
		null,
		0.26,
		94.98,
		null,
		150.86,
		null,
		20.12,
		7342.85,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		98.24,
		null,
		12.77,
		4662.76,
		null,
		17.54,
		null,
		2.42,
		883.01,
		null,
		28.06,
		null,
		3.88,
		1416.72,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		85.42,
		67.03,
		3.1,
		16.04,
		6.81,
		3.33,
		46.67759563,
		36.6284153,
		1.69398907,
		8.76502732,
		3.72131148,
		1.81967213,
		181.73,
	],
	[
		"REFLDORUM-PFR",
		27.52,
		-99.4954,
		"PLATTS - Refinery - United States - Laredo - Raven Petroleum, LLC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		90.55,
		94.68,
		11.88,
		4320.46,
		12.42,
		"Raven Petroleum, LLC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFIANNIO-PFR",
		32.781336,
		51.50631,
		"PLATTS - Refinery - Iran - Isfahan - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		1703.14,
		1871.21,
		512.41,
		70188.85,
		555.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		285,
		null,
		39.31,
		14348.27,
		null,
		36.6,
		41.03,
		7.2,
		2045.6,
		8.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		285,
		null,
		39.31,
		14348.27,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		95.96,
		83.27,
		56.87,
		19.2,
		16.95,
		5.58,
		32.52881356,
		28.22711864,
		19.2779661,
		6.50847458,
		5.74576271,
		1.89152542,
		277.83,
	],
	[
		"REFLEAMFR-PFR",
		51.289227,
		11.994492,
		"PLATTS - Refinery - Germany - Leuna - Mittel Deutsche Erdoel Raff.",
		null,
		null,
		null,
		null,
		null,
		853.94,
		896.35,
		258.23,
		35068.71,
		270.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		197.86,
		null,
		26.79,
		9779,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		63.22,
		null,
		8.22,
		3000.84,
		null,
		134.63,
		null,
		18.57,
		6778.16,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		78.18,
		56.66,
		17.19,
		10.62,
		4.29,
		17.05,
		41.6360441,
		30.17521436,
		9.15481706,
		5.65585557,
		2.28471002,
		9.08025776,
		184,
	],
	[
		"REFIASEFF-PFR",
		28.0387,
		9.5762,
		"PLATTS - Refinery - Algeria - In Amenas - Enterprise National De Raff - {NAFTEC}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFIIRTAS-PFR",
		38.802417,
		26.940088,
		"PLATTS - Refinery - Turkey - Izmir - Tupras",
		8,
		8.35,
		8,
		8,
		8.35,
		851.84,
		894.63,
		297.44,
		31560.52,
		312.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		196.4,
		null,
		26.28,
		9594.12,
		null,
		null,
		null,
		null,
		null,
		null,
		65.62,
		null,
		8.77,
		3202.64,
		null,
		67.14,
		null,
		8.72,
		3186.56,
		null,
		53.64,
		null,
		7.4,
		2700.99,
		null,
		9.98,
		null,
		1.38,
		503.94,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Koc Holding_Aygaz_Opet",
		"48.5_39.8_10.2_1.5",
		null,
		"Active",
		null,
		54.55,
		43.04,
		20.66,
		36.34,
		8.23,
		3.95,
		27.275,
		21.52,
		10.33,
		18.17,
		4.115,
		1.975,
		166.76,
	],
	[
		"REFIIIKSK-PFR",
		56.0681,
		89.0326,
		"PLATTS - Refinery - Russia - Itatskii - Kuznetsk",
		null,
		null,
		null,
		null,
		null,
		12,
		12.88,
		1.64,
		600,
		1.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.51,
		null,
		0.9,
		327.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.51,
		null,
		0.9,
		327.6,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuznetsk",
		"100",
		null,
		"Active",
		null,
		2.09,
		0,
		2.99,
		0,
		0,
		1.57,
		30.33381713,
		0,
		43.39622642,
		0,
		0,
		22.78664731,
		6.65,
	],
	[
		"REFIOSPET-PFR",
		-3.724799,
		-73.24365,
		"PLATTS - Refinery - Peru - Iquitos - Petroperu",
		9,
		9.77,
		1.32,
		478.26,
		1.41,
		16.34,
		17.67,
		4.37,
		668.38,
		4.68,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6,
		null,
		0.83,
		302.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6,
		null,
		0.83,
		302.9,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroperu",
		"100",
		null,
		"Active",
		null,
		2.9,
		1.25,
		3.71,
		0.56,
		0,
		0,
		34.11764706,
		14.70588235,
		43.64705882,
		6.58823529,
		0,
		0,
		8.42,
	],
	[
		"REFIMONNP-PFR",
		5.5859,
		7.067,
		"PLATTS - Refinery - Nigeria - Imo - NNPC",
		458,
		500.85,
		62.14,
		22678.22,
		67.97,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NNPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJENJGP-PFR",
		30.97807,
		112.185704,
		"PLATTS - Refinery - China - Jingmen - Jingmen Gen.Petrochem Works",
		null,
		null,
		null,
		null,
		null,
		521.71,
		566.83,
		100.68,
		25067.23,
		108.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		75.11,
		null,
		10.39,
		3791.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		75.11,
		null,
		10.39,
		3791.69,
		null,
		244.58,
		261.86,
		33.61,
		12202.35,
		35.94,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		26.74,
		24.03,
		-0.01,
		5.4,
		8.11,
		9.7,
		33.11455108,
		29.75851393,
		-0.0123839,
		6.6873065,
		10.04334365,
		12.0123839,
		73.97,
	],
	[
		"REFJKHJUM-PFR",
		40.1332,
		67.8234,
		"PLATTS - Refinery - Uzbekistan - Jizzakh - Jizzakh Petroleum - {Djizak}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		298.65,
		328.24,
		40.59,
		14759.17,
		44.53,
		"National Holding Co. Uzbekneftgaz_Gazprom",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFIWASYK-PFR",
		35.677015,
		139.888719,
		"PLATTS - Refinery - Japan - Ichikawa - Sankyo Yuka K.K.",
		null,
		null,
		null,
		null,
		null,
		5.03,
		5.32,
		0.75,
		271.23,
		0.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sankyo Yuka K.K.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJLNLDE-PFR",
		42.9995,
		125.9816,
		"PLATTS - Refinery - China - Jilin - Linde",
		null,
		null,
		null,
		null,
		null,
		21,
		22.22,
		21,
		21,
		22.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Linde",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJNRRES-PFR",
		22.39928,
		69.86137,
		"PLATTS - Refinery - India - Jamnagar - Reliance Industries",
		null,
		null,
		null,
		null,
		null,
		2781.14,
		3010.13,
		1225.16,
		93432.67,
		1305.97,
		164.86,
		null,
		24.5,
		8941.08,
		null,
		4.49,
		null,
		0.67,
		243.31,
		null,
		697.85,
		null,
		96.61,
		35262.85,
		null,
		null,
		null,
		null,
		null,
		null,
		80.28,
		null,
		10.73,
		3917.34,
		null,
		140.68,
		null,
		18.29,
		6677.29,
		null,
		303.05,
		null,
		41.8,
		15256.99,
		null,
		4.49,
		null,
		0.62,
		226.82,
		null,
		null,
		null,
		null,
		null,
		null,
		"Reliance Industries",
		"100",
		null,
		"Active",
		null,
		267.4,
		116.99,
		26.14,
		57.75,
		44.88,
		104.92,
		39.86047344,
		17.4393298,
		3.89660724,
		8.6086101,
		6.69011985,
		15.64009302,
		618.08,
	],
	[
		"REFKACPDR-PFR",
		24.846393,
		67.126166,
		"PLATTS - Refinery - Pakistan - Karachi - Pakistan Refinery Ltd.",
		null,
		null,
		null,
		null,
		null,
		154.14,
		169.14,
		27.01,
		7296.84,
		29.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		29.1,
		null,
		3.9,
		1419.85,
		null,
		91.05,
		99.57,
		12.12,
		4405.87,
		13.25,
		29.1,
		null,
		3.9,
		1419.85,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Shell_Pakistan State Oil Co._Chevron",
		"40_30_18_12",
		null,
		"Active",
		null,
		11.52,
		4.37,
		5.7,
		2.76,
		0.9,
		3.44,
		36.42111919,
		13.81599747,
		18.02086627,
		8.72589314,
		2.84539994,
		10.87575087,
		28.69,
	],
	[
		"REFJDMAUK-PFR",
		30.2181,
		36.493,
		"PLATTS - Refinery - Jordan - Ma'an - Unknown",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		150,
		161.03,
		20.55,
		7500,
		22.06,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKARBTD-PFR",
		10.664,
		-14.5853,
		"PLATTS - Refinery - Guinea - Kamsar - Brahms Oil Refineries Ltd",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		12,
		13.07,
		1.64,
		600,
		1.79,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Brahms Oil Refineries Ltd",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFJETEXM-PFR",
		41.41513,
		-88.18359,
		"PLATTS - Refinery - United States - Joliet - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		838.47,
		882.02,
		117.37,
		41381.92,
		123.53,
		147.05,
		null,
		21.85,
		7975.21,
		null,
		0,
		null,
		0,
		0,
		null,
		225,
		null,
		32.43,
		11836.94,
		null,
		null,
		null,
		null,
		null,
		null,
		29.94,
		null,
		4,
		1460.75,
		null,
		7.36,
		null,
		0.96,
		349.16,
		null,
		5.66,
		null,
		0.78,
		285.18,
		null,
		34.99,
		null,
		4.84,
		1766.65,
		null,
		838.51,
		882.07,
		117.37,
		41382.79,
		123.53,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		44.32,
		107.24,
		2.98,
		15.84,
		-0.65,
		1.48,
		23.29811281,
		56.37386322,
		1.56652473,
		8.32676234,
		-0.34169164,
		0.77800557,
		171.2,
	],
	[
		"REFKATSUM-PFR",
		33.5967,
		71.44,
		"PLATTS - Refinery - Pakistan - Kohat - Sharjah Consortium",
		40,
		42.95,
		5.48,
		2000,
		5.88,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sharjah Consortium",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJG2REP-PFR",
		22.336853,
		69.855561,
		"PLATTS - Refinery - India - Jamnagar (2) - Reliance Petroleum",
		null,
		null,
		null,
		null,
		null,
		3035.87,
		3319.41,
		974.84,
		121088.13,
		1046.65,
		136.34,
		null,
		20.26,
		7394.54,
		null,
		3.72,
		null,
		0.55,
		201.23,
		null,
		577.15,
		null,
		79.9,
		29163.43,
		null,
		1269.3,
		1389.33,
		185.07,
		63799.7,
		202.36,
		66.39,
		null,
		8.88,
		3239.76,
		null,
		116.35,
		null,
		15.13,
		5522.32,
		null,
		250.63,
		null,
		34.57,
		12617.99,
		null,
		3.72,
		null,
		0.51,
		187.59,
		null,
		null,
		null,
		null,
		null,
		null,
		"Reliance Petroleum",
		"100",
		null,
		"Active",
		null,
		391.05,
		215.63,
		5.33,
		47.02,
		18.24,
		22.35,
		52.30318594,
		28.84064949,
		0.71289089,
		6.28895487,
		2.43961159,
		2.9893267,
		699.63,
	],
	[
		"REFKDAKYZ-PFR",
		44.8575,
		65.4933,
		"PLATTS - Refinery - Kazakhstan - Kyzylorda - Kyzylorda Region Gov.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		10.74,
		1.37,
		500,
		1.47,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kyzylorda Region Gov.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKHISGZ-PFR",
		59.483622,
		32.070804,
		"PLATTS - Refinery - Russia - Kirishi - Surgutneftegaz",
		50,
		53.68,
		6.85,
		2500,
		7.35,
		1291.07,
		1410.83,
		325,
		56387.38,
		352.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		355,
		null,
		48.67,
		17765.83,
		null,
		44.94,
		50.37,
		8.82,
		2513.14,
		9.81,
		0,
		null,
		0,
		0,
		null,
		37,
		null,
		4.81,
		1756.18,
		null,
		318,
		null,
		43.86,
		16009.65,
		null,
		0,
		null,
		0,
		0,
		null,
		152,
		170.71,
		20.26,
		7396.84,
		22.76,
		"Surgutneftegaz",
		"100",
		0,
		"Active",
		null,
		117.68,
		58.67,
		101.8,
		24.25,
		9.61,
		23.98,
		32.38572254,
		16.146077,
		28.01552137,
		6.67363844,
		2.64468723,
		6.59933401,
		335.99,
	],
	[
		"REFJLGJRP-PFR",
		32.16459914,
		118.92006347,
		"PLATTS - Refinery - China - Jinling - Jinling Petrochemical Corp",
		-70,
		-74.06,
		-9.59,
		-3500,
		-10.14,
		1311.85,
		1418.05,
		182.42,
		65817.45,
		197.12,
		75.03,
		null,
		11.15,
		4069.17,
		null,
		108.37,
		null,
		16.08,
		5868.96,
		null,
		333.46,
		null,
		47.93,
		17492.75,
		null,
		11,
		11.64,
		1.66,
		606.5,
		1.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		150.06,
		null,
		20.7,
		7554.62,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		105.02,
		73.72,
		0.87,
		52.85,
		38.1,
		34.03,
		31.38860661,
		22.03359436,
		0.2600275,
		15.79592325,
		11.38741108,
		10.17096061,
		304.6,
	],
	[
		"REFKKITEI-PFR",
		37.193926,
		138.262389,
		"PLATTS - Refinery - Japan - Kubiki - Teiseki Topping",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Teiseki Topping",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJLIJNY-PFR",
		25.007612,
		55.059295,
		"PLATTS - Refinery - United Arab Emirates - Jebel Ali - Jebel Ali Refinery Company",
		null,
		null,
		null,
		null,
		null,
		580.51,
		641.53,
		75.97,
		24659.43,
		83.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.2,
		1898.57,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.2,
		1898.57,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENOC",
		"100",
		null,
		"Active",
		null,
		12.15,
		11.06,
		2.5,
		5.56,
		4.02,
		11.75,
		24.3,
		22.12,
		5,
		11.12,
		8.04,
		23.5,
		47.04,
	],
	[
		"REFKLETAS-PFR",
		39.743415,
		33.463183,
		"PLATTS - Refinery - Turkey - Kirikkale - Tupras",
		null,
		null,
		null,
		null,
		null,
		329.07,
		345.55,
		82.7,
		14175.4,
		87.13,
		43.22,
		null,
		6.42,
		2343.37,
		null,
		0,
		null,
		0,
		0,
		null,
		83.46,
		null,
		11.8,
		4308.04,
		null,
		null,
		null,
		null,
		null,
		null,
		40.26,
		null,
		5.38,
		1964.65,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Koc Holding_Aygaz_Opet",
		"48.5_39.8_10.2_1.5",
		null,
		"Active",
		null,
		22.36,
		14.97,
		14.21,
		15.08,
		2.52,
		0,
		26.30897753,
		17.61383692,
		16.71961407,
		17.74326391,
		2.96505471,
		0,
		69.12,
	],
	[
		"REFJLNXID-PFR",
		44.43384573,
		125.13775186,
		"PLATTS - Refinery - China - Jilin - Xinda Group",
		385.55,
		416.87,
		76.69,
		18326.77,
		82.37,
		20,
		21.16,
		2.74,
		1000,
		2.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xinda Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKOMTGV-PFR",
		40.2961,
		70.4345,
		"PLATTS - Refinery - Tajikistan - Konibodom - Tajik Gov.",
		4,
		4.29,
		0.55,
		200,
		0.59,
		2,
		2.15,
		0.27,
		100,
		0.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tajik Gov.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJLOPTY-PFR",
		49.725754,
		21.458185,
		"PLATTS - Refinery - Poland - Jaslo - P.P. Rafineria Nafty",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Polish State Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJNNJRY-PFR",
		36.737661,
		117.177232,
		"PLATTS - Refinery - China - Jinan - Jinan Provincial Oil Refinery",
		null,
		null,
		null,
		null,
		null,
		9.09,
		9.72,
		1.39,
		475.29,
		1.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Blue Star",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKOOLRC-PFR",
		42.260219,
		-85.543777,
		"PLATTS - Refinery - United States - Kalamazoo - Lakeside Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lakeside Refining Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKOVNSS-PFR",
		58.6035,
		49.6639,
		"PLATTS - Refinery - Russia - Kirov - NPZ Severnyi Kuzbass",
		null,
		null,
		null,
		null,
		null,
		68.04,
		74.42,
		9.07,
		3295.79,
		9.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.48,
		null,
		0.76,
		275.85,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.48,
		null,
		0.76,
		275.85,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kem-Oil Group",
		"100",
		null,
		"Active",
		null,
		1.17,
		1.14,
		2.02,
		0,
		0,
		0,
		20.17241379,
		19.65517241,
		34.82758621,
		0,
		0,
		0,
		4.33,
	],
	[
		"REFKRGEOR-PFR",
		55.65528,
		11.09926,
		"PLATTS - Refinery - Denmark - Kalundborg - Equinor",
		null,
		null,
		null,
		null,
		null,
		369.05,
		386.94,
		195.82,
		10315.88,
		204.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		88,
		null,
		11.49,
		4194.42,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		82,
		null,
		10.66,
		3892.07,
		null,
		4,
		null,
		0.55,
		201.38,
		null,
		2,
		null,
		0.28,
		100.97,
		null,
		null,
		null,
		null,
		null,
		null,
		"Statoil",
		"100",
		null,
		"Active",
		null,
		39.39,
		33.42,
		18.57,
		1.65,
		1.03,
		0,
		41.46315789,
		35.17894737,
		19.54736842,
		1.73684211,
		1.08421053,
		0,
		94.06,
	],
	[
		"REFJSESOR-PFR",
		9.281,
		-70.5122,
		"PLATTS - Refinery - Venezuela - Jose - Sincor",
		null,
		null,
		null,
		null,
		null,
		166,
		178.2,
		166,
		166,
		178.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_Total_StatoilHydro",
		"60_30.33_9.67",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKRIPTC-PFR",
		37.5097412,
		69.54239434,
		"PLATTS - Refinery - Afghanistan - Kashkari - PetroChina",
		51.03,
		55.83,
		6.76,
		2455.43,
		7.38,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJUGHNG-PFR",
		1.242534,
		103.681063,
		"PLATTS - Refinery - Singapore - Jurong - Hin Leong Trading",
		1576,
		1664.18,
		519.02,
		61675.55,
		548.56,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hin Leong Trading",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKSKSAZ-PFR",
		51.347669,
		37.047572,
		"PLATTS - Refinery - Russia - Kursk - Soyuzneftegaz",
		null,
		null,
		null,
		null,
		null,
		3,
		3.22,
		0.41,
		150,
		0.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Soyuzneftegaz",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJUNPIO-PFR",
		9.7422,
		-63.191,
		"PLATTS - Refinery - Venezuela - Junin - Petrobicentenario",
		454.92,
		496.4,
		159.28,
		18122.57,
		172.12,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_ENI",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKTAZDA-PFR",
		42.7952,
		73.89005,
		"PLATTS - Refinery - Kyrgyzstan - Karabalta - Zhongda",
		null,
		null,
		null,
		null,
		null,
		31.02,
		33.99,
		4.14,
		1505.38,
		4.54,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		null,
		1.66,
		604.14,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		null,
		1.66,
		604.14,
		null,
		0,
		null,
		0,
		0,
		null,
		58.03,
		63.49,
		7.73,
		2808.54,
		8.45,
		"Zhongda",
		"100",
		null,
		"Active",
		null,
		2.8,
		0,
		5.6,
		0.6,
		0,
		2.8,
		23.33333333,
		0,
		46.66666667,
		5,
		0,
		23.33333333,
		11.8,
	],
	[
		"REFJYGPTC-PFR",
		23.5431,
		116.3497,
		"PLATTS - Refinery - China - Jieyang - PetroChina",
		null,
		null,
		null,
		null,
		null,
		1446.45,
		1559.1,
		382.24,
		63571.47,
		408.49,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		15,
		16.59,
		2.05,
		748.97,
		2.27,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1316.6,
		1413.57,
		355.09,
		55784.91,
		378.43,
		"China National Petroleum Corp._PDVSA",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKUITAT-PFR",
		54.3901,
		45.6215,
		"PLATTS - Refinery - Russia - Kichui - Tatneftegaz - {Elkhovsk, Yelkhosky}",
		null,
		null,
		null,
		null,
		null,
		16.3,
		17.68,
		2.24,
		817.94,
		2.43,
		4.06,
		null,
		0.6,
		219.93,
		null,
		0,
		null,
		0,
		0,
		null,
		4.06,
		null,
		0.6,
		219.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tatneftegaz",
		"100",
		null,
		"Active",
		null,
		0.78,
		0.08,
		1.79,
		0.26,
		0.1,
		0.2,
		18.18181818,
		1.86480186,
		41.72494172,
		6.06060606,
		2.33100233,
		4.66200466,
		3.21,
	],
	[
		"REFKACEPS-PFR",
		24.8668,
		67.0311,
		"PLATTS - Refinery - Pakistan - Karachi - Enar Petrotech Services Ltd.",
		null,
		null,
		null,
		null,
		null,
		6.6,
		7.08,
		0.91,
		330,
		0.97,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.97,
		null,
		0.78,
		283.3,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5.97,
		null,
		0.78,
		283.3,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Enar Petrotech Services Ltd.",
		"100",
		null,
		"Active",
		null,
		1.91,
		0,
		1.73,
		0.58,
		0.11,
		1.52,
		29.42989214,
		0,
		26.65639445,
		8.93682589,
		1.69491525,
		23.42064715,
		5.85,
	],
	[
		"REFKUKICO-PFR",
		35.528411,
		44.334753,
		"PLATTS - Refinery - Iraq - Kirkuk - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		447.15,
		483.11,
		250.99,
		11477.82,
		267.13,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKAHPTN-PFR",
		5.9683,
		100.666,
		"PLATTS - Refinery - Malaysia - Kedah - Petronas",
		695.8,
		733.74,
		218.68,
		28200.35,
		230.45,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petronas",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLAYPON-PFR",
		14.531151,
		120.599516,
		"PLATTS - Refinery - Philippines - Limay - Petron - {Bataan}",
		null,
		null,
		null,
		null,
		null,
		900.2,
		953.76,
		328.1,
		33366.76,
		345.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		66.87,
		null,
		9.18,
		3351.08,
		null,
		237.59,
		252,
		31.02,
		11278.85,
		32.86,
		10,
		null,
		1.34,
		487.97,
		null,
		0,
		null,
		0,
		0,
		null,
		56.87,
		null,
		7.84,
		2863.11,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"San Miguel Corporation_Ashmore Group_Other Investors",
		"68_23_9",
		0,
		"Active",
		null,
		43.49,
		26.97,
		0.34,
		9.58,
		9.52,
		7.52,
		44.37755102,
		27.52040816,
		0.34693878,
		9.7755102,
		9.71428571,
		7.67346939,
		97.43,
	],
	[
		"REFKBICRP-PFR",
		2.8656,
		9.892,
		"PLATTS - Refinery - Cameroon - Kribi - Cedecorp",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		535.3,
		587.23,
		72.07,
		26199.13,
		79.06,
		"Cedecorp",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLCYBBP-PFR",
		51.640981,
		-3.872582,
		"PLATTS - Refinery - United Kingdom - Llandarcy - BP",
		null,
		null,
		null,
		null,
		null,
		6.5,
		7.41,
		1.04,
		379.59,
		1.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mobil_BP-Amoco Corporation",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKCIKRL-PFR",
		9.9313,
		76.2674,
		"PLATTS - Refinery - India - Kochi - Kochi Refineries Ltd. - {Cochin}",
		null,
		null,
		null,
		null,
		null,
		1680.64,
		1827.16,
		729.34,
		56671.32,
		778.81,
		3,
		null,
		0.45,
		162.99,
		null,
		16.69,
		null,
		2.47,
		904.16,
		null,
		267.13,
		null,
		36.28,
		13241.6,
		null,
		236.28,
		258.84,
		34.52,
		12132.58,
		37.78,
		19.37,
		null,
		2.59,
		945.06,
		null,
		88.49,
		null,
		11.51,
		4200.04,
		null,
		122.89,
		null,
		16.95,
		6186.47,
		null,
		16.69,
		null,
		2.31,
		842.88,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bharat Petroleum_Other Investors",
		"55_45",
		null,
		"Active",
		null,
		132.07,
		63.51,
		8.69,
		33.48,
		32.66,
		30.45,
		39.76694469,
		19.12318208,
		2.61660293,
		10.08099726,
		9.83409111,
		9.16864894,
		300.84,
	],
	[
		"REFETOPTS-PFR",
		-19.5688,
		-40.1722,
		"PLATTS - Refinery - Brazil - Espirito Santo - Petrobras",
		15,
		15.64,
		2.05,
		750,
		2.14,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKIHPTN-PFR",
		4.567342,
		103.453701,
		"PLATTS - Refinery - Malaysia - Kertih - Petronas",
		null,
		null,
		null,
		null,
		null,
		141.38,
		148,
		17.58,
		6415.99,
		18.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		109,
		null,
		14.17,
		5173.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		109,
		null,
		14.17,
		5173.6,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petronas",
		"100",
		null,
		"Active",
		null,
		36.07,
		22.39,
		12.48,
		16.31,
		2.04,
		19.02,
		32.64253394,
		20.26244344,
		11.29411765,
		14.760181,
		1.84615385,
		17.21266968,
		108.31,
	],
	[
		"REFFAHBPG-PFR",
		25.1212,
		56.334,
		"PLATTS - Refinery - United Arab Emirates - Fujairah - Brooge Petroleum and Gas Investment Co.",
		null,
		null,
		null,
		null,
		null,
		25,
		26.84,
		3.42,
		1250,
		3.68,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		485.43,
		529.84,
		178.6,
		18004,
		192.94,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Brooge Petroleum and Gas Investment Co.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKITPTJ-PFR",
		17.974858,
		-76.817221,
		"PLATTS - Refinery - Jamaica - Kingston - Petrojam",
		108.56,
		118.02,
		42.14,
		4182.34,
		45.18,
		66.68,
		72.97,
		8.9,
		3243.95,
		9.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		23,
		null,
		3.17,
		1157.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		23,
		null,
		3.17,
		1157.93,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrojam_PDVSA",
		"51_49",
		null,
		"Active",
		null,
		3.2,
		3.14,
		10.8,
		1.6,
		0.4,
		0,
		16,
		15.7,
		54,
		8,
		2,
		0,
		19.14,
	],
	[
		"REFKKWMHI-PFR",
		35.500901,
		139.725399,
		"PLATTS - Refinery - Japan - Kawasaki - Mitsubishi",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		-0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon Mitsubishi",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKLAHIL-PFR",
		0.3177,
		32.5814,
		"PLATTS - Refinery - Uganda - Kampala - Heritage Oil",
		78.05,
		85.46,
		10.45,
		3795.8,
		11.44,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Heritage Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKLIBRA-PFR",
		22.3255,
		91.8528,
		"PLATTS - Refinery - Bangladesh - Karnaphuli - Bashundhara",
		160.9,
		176.37,
		22.53,
		7899.37,
		24.65,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bashundhara",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKLKKRT-PFR",
		61.007735,
		68.98785,
		"PLATTS - Refinery - Russia - Krasnoleninsk - Kransoleninskneft",
		null,
		null,
		null,
		null,
		null,
		6,
		6.44,
		0.82,
		300,
		0.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.96,
		null,
		0.4,
		148.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.96,
		null,
		0.4,
		148.6,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tyumen Oil",
		"100",
		null,
		"Active",
		null,
		0.84,
		0,
		1.26,
		0,
		0,
		0.6,
		26.92307692,
		0,
		40.38461538,
		0,
		0,
		19.23076923,
		2.7,
	],
	[
		"REFKLLCEX-PFR",
		-34.018426,
		151.21484,
		"PLATTS - Refinery - Australia - Kurnell - Caltex",
		null,
		null,
		null,
		null,
		null,
		-1.02,
		-1.11,
		-0.11,
		-43.31,
		-0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron_Other Investors",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKLPKLT-PFR",
		42.4586,
		59.6059,
		"PLATTS - Refinery - Uzbekistan - Karakalpak - KarBalt-Rutoil",
		null,
		null,
		null,
		null,
		null,
		1.4,
		1.5,
		0.19,
		70,
		0.21,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.38,
		null,
		0.19,
		69.28,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.38,
		null,
		0.19,
		69.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KarBalt-Rutoil",
		"100",
		null,
		"Active",
		null,
		0.42,
		0.55,
		0.4,
		0.13,
		0,
		0,
		30.43478261,
		39.85507246,
		28.98550725,
		9.42028986,
		0,
		0,
		1.5,
	],
	[
		"REFKMAJNO-PFR",
		35.910371,
		140.690773,
		"PLATTS - Refinery - Japan - Kashima - ENEOS",
		null,
		null,
		null,
		null,
		null,
		93.61,
		98.44,
		11.23,
		4098.76,
		11.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		35,
		null,
		4.55,
		1661.25,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		35,
		null,
		4.55,
		1661.25,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"JX Nippon Oil and Energy_Mitsubishi",
		"80_20",
		null,
		"Active",
		null,
		6.75,
		14.03,
		0,
		7.35,
		2,
		11.74,
		16.07142857,
		33.4047619,
		0,
		17.5,
		4.76190476,
		27.95238095,
		41.88,
	],
	[
		"REFKNOQUE-PFR",
		54.8899,
		61.408,
		"PLATTS - Refinery - Russia - Korkino - Quality Energy",
		528.6,
		577.88,
		121.73,
		23550.77,
		132.02,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Quality Energy_Chelyabinsk Oblast",
		"75_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKORTPP-PFR",
		41.70249699,
		86.21460859,
		"PLATTS - Refinery - China - Korla - Tarim Petroleum and Petrochem. Co.",
		null,
		null,
		null,
		null,
		null,
		35,
		37.75,
		4.89,
		1783.26,
		5.27,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tarim Petroleum and Petrochem. Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKPYUOL-PFR",
		50.2564,
		14.32806,
		"PLATTS - Refinery - Czech Republic - Kralupy - Unipetrol - {Ceska Rafinerska}",
		null,
		null,
		null,
		null,
		null,
		315.81,
		335.17,
		139.59,
		9945.7,
		147.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		46.66,
		null,
		6.18,
		2255.37,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		32.66,
		null,
		4.25,
		1550.35,
		null,
		12.11,
		null,
		1.67,
		609.62,
		null,
		1.89,
		null,
		0.26,
		95.41,
		null,
		null,
		null,
		null,
		null,
		null,
		"PKN Orlen_ENI_Unipetrol",
		"42.4_32.6_25",
		null,
		"Active",
		null,
		23.58,
		23.96,
		0.91,
		1.71,
		6.52,
		1.2,
		39.3,
		39.93333333,
		1.51666667,
		2.85,
		10.86666667,
		2,
		57.87,
	],
	[
		"REFKVEVPP-PFR",
		59.387939,
		27.239398,
		"PLATTS - Refinery - Estonia - Kohtla-Jarve - Viru Keemia Grupp",
		null,
		null,
		null,
		null,
		null,
		17.01,
		18.45,
		5.82,
		666.92,
		6.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Viru Keemia Grupp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKWAKRY-PFR",
		34.5,
		72,
		"PLATTS - Refinery - Pakistan - Khyber-Pakhtunkhwa - Khyber Refinery - {Kohat}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		70.04,
		76.7,
		9.26,
		3366.94,
		10.14,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Khyber Refinery",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKYIIND-PFR",
		22.374249,
		73.119479,
		"PLATTS - Refinery - India - Koyali - Indian Oil Corp. - {Vadodara, Gujarat}",
		null,
		null,
		null,
		null,
		null,
		1355.71,
		1488.15,
		333.03,
		59194.63,
		361.86,
		49.37,
		null,
		7.34,
		2677.7,
		null,
		2.62,
		null,
		0.39,
		141.97,
		null,
		249.05,
		null,
		34.1,
		12446.72,
		null,
		null,
		null,
		null,
		null,
		null,
		6.12,
		null,
		0.82,
		298.49,
		null,
		98.74,
		null,
		12.84,
		4686.85,
		null,
		89.57,
		null,
		12.35,
		4509.36,
		null,
		2.62,
		null,
		0.36,
		132.35,
		null,
		265.15,
		290.34,
		36.95,
		13431.88,
		40.44,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		114.41,
		50.41,
		9.24,
		26.36,
		21.15,
		15.58,
		45.20347689,
		19.91702884,
		3.65073094,
		10.41485579,
		8.35638088,
		6.1556697,
		237.15,
	],
	[
		"REFKYMKAZ-PFR",
		62.357424,
		74.797324,
		"PLATTS - Refinery - Russia - Kogalym - Kogalymneftegaz",
		null,
		null,
		null,
		null,
		null,
		17.2,
		18.8,
		2.29,
		836.78,
		2.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.7,
		null,
		0.48,
		175.78,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		3.7,
		null,
		0.48,
		175.78,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		null,
		"Active",
		null,
		1.09,
		0.48,
		1.11,
		0.19,
		0.11,
		0.11,
		27.80612245,
		12.24489796,
		28.31632653,
		4.84693878,
		2.80612245,
		2.80612245,
		3.1,
	],
	[
		"REFLA2P66-PFR",
		33.80313,
		-118.2421,
		"PLATTS - Refinery - United States - Los Angeles (2) - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		0.08,
		0.1,
		0.04,
		3.72,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unocal",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLCHAON-PFR",
		33.873892,
		-118.161989,
		"PLATTS - Refinery - United States - Long Beach - Alon - {Paramount}",
		20,
		20.85,
		2.73,
		1000,
		2.85,
		0,
		-0.01,
		0,
		-0.01,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alon",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLCSCIN-PFR",
		30.186704,
		-93.339747,
		"PLATTS - Refinery - United States - Lake Charles - Cit-Con Oil Corporation",
		null,
		null,
		null,
		null,
		null,
		0.02,
		0.01,
		-0.03,
		0.04,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLDECNA-PFR",
		43.39476,
		5.10066,
		"PLATTS - Refinery - France - La Mede - Cie De Raff. Et Distrib.Total Fina",
		null,
		null,
		null,
		null,
		null,
		18,
		18.95,
		9.41,
		516.35,
		9.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLDNP66-PFR",
		40.635879,
		-74.223528,
		"PLATTS - Refinery - United States - Linden - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		1051.96,
		1105.62,
		355.97,
		40064.38,
		373.39,
		7.74,
		null,
		1.15,
		419.66,
		null,
		0,
		null,
		0,
		0,
		null,
		178.47,
		null,
		23.69,
		8645.03,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		130.5,
		null,
		16.97,
		6194.24,
		null,
		0,
		null,
		0,
		0,
		null,
		40.23,
		null,
		5.56,
		2031.13,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		0,
		"Active",
		null,
		82.3,
		156.55,
		4.17,
		20.91,
		8.84,
		3.85,
		33.25252525,
		63.25252525,
		1.68484848,
		8.44848485,
		3.57171717,
		1.55555556,
		276.62,
	],
	[
		"REFLEALAG-PFR",
		51.312015,
		12.006374,
		"PLATTS - Refinery - Germany - Leuna - Leuna Werke A.G.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		-0.04,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Elf_Thyssen Handelsunion",
		"66.66_33.34",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLEKVFT-PFR",
		60.7145,
		114.9172,
		"PLATTS - Refinery - Russia - Lensk - VNIIneft",
		10,
		10.74,
		1.37,
		500,
		1.47,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"VNIIneft",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFESOCHN-PFR",
		31.766877,
		-106.395787,
		"PLATTS - Refinery - United States - El Paso - Chevron",
		null,
		null,
		null,
		null,
		null,
		0.06,
		0.07,
		0.01,
		2.17,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Western Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFESOMUM-PFR",
		31.770061,
		-106.405366,
		"PLATTS - Refinery - United States - El Paso - Marathon Petroleum",
		47.15,
		49.3,
		6.33,
		2257.55,
		6.63,
		358.91,
		377.54,
		57.65,
		17012.23,
		60.67,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		120.83,
		null,
		15.83,
		5777.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		106.3,
		null,
		13.82,
		5045.42,
		null,
		14.54,
		null,
		2,
		731.78,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Andeavor",
		"100",
		null,
		"Active",
		null,
		37.9,
		75.86,
		2.89,
		8.06,
		0.29,
		0.72,
		28.04084049,
		56.1260728,
		2.13820657,
		5.96330275,
		0.21456052,
		0.53270198,
		125.72,
	],
	[
		"REFEVACNP-PFR",
		-7.6977,
		112.4914,
		"PLATTS - Refinery - Indonesia - East Java - China National Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		896.49,
		977.65,
		123.06,
		44378.43,
		133.98,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Iraq National Oil Co",
		"85_15",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFFANFLP-PFR",
		23.01276401,
		112.83934933,
		"PLATTS - Refinery - China - Foshan - Foshan Longchi Petrochemical",
		null,
		null,
		null,
		null,
		null,
		25,
		26.59,
		3.57,
		1301.82,
		3.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Guangdong Zhenrong",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFANSFB-PFR",
		23.12716304,
		112.80575705,
		"PLATTS - Refinery - China - Foshan - Sanshui Futeng Bitumen",
		null,
		null,
		null,
		null,
		null,
		32.12,
		34.13,
		4.8,
		1707.02,
		5.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sanshui Futeng Bitumen",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFANSHR-PFR",
		23.01074923,
		112.83834033,
		"PLATTS - Refinery - China - Foshan - Sanshui Haishengda Road Mat.",
		null,
		null,
		null,
		null,
		null,
		20,
		21.16,
		2.9,
		1057.89,
		3.07,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sanshui Haishengda Road Mat.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFCESES-PFR",
		14.608082,
		-61.03183,
		"PLATTS - Refinery - Martinique Island - Fort-De-France - SA de la Raffinerie des Antilles",
		null,
		null,
		null,
		null,
		null,
		33.52,
		36.82,
		4.31,
		1594.95,
		4.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.34,
		489.04,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		5,
		null,
		0.69,
		251.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total_Rubis SCA_ExxonMobil_Chevron",
		"50_24_14.5_11.5",
		null,
		"Active",
		null,
		2.34,
		2.07,
		4.4,
		0.53,
		0.34,
		0,
		23.4,
		20.7,
		44,
		5.3,
		3.4,
		0,
		9.66,
	],
	[
		"REFFEYHLL-PFR",
		41.85977,
		-78.44519,
		"PLATTS - Refinery - United States - Farmers Valley - Honeywell",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"U.S. Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFONMRC-PFR",
		30.8919,
		-102.8837,
		"PLATTS - Refinery - United States - Fort Stockton - MMEX Resources Corp.",
		null,
		null,
		null,
		null,
		null,
		10,
		10.43,
		1.37,
		500,
		1.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		168.1,
		175.78,
		22.25,
		8084.01,
		23.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"MMEX Resources Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFFOSNNP-PFR",
		5.286,
		5.8467,
		"PLATTS - Refinery - Nigeria - Forcados - NNPC - {Western Forcados}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		230.1,
		251.82,
		27.82,
		10117.69,
		30.47,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_NNPC",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFFRDIMR-PFR",
		36.972273,
		-112.525359,
		"PLATTS - Refinery - United States - Fredonia - Intermountain Ref.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Arizona Fuels Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFRTADE-PFR",
		28.98713,
		-95.33751,
		"PLATTS - Refinery - United States - Freeport - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		41.2,
		43.59,
		41.2,
		41.2,
		43.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFWNSLP-PFR",
		8.477919,
		-13.190988,
		"PLATTS - Refinery - Sierra Leone - Freetown - Sierra Leone Petroleum Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		10.9,
		1.37,
		500,
		1.49,
		"Sierra Leone Govt._NNPC_Precious Minerals and Marketng Co.",
		"50_39.8_10.2",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGDKGSA-PFR",
		54.346243,
		18.738431,
		"PLATTS - Refinery - Poland - Gdansk - Grupa Lotos SA",
		250,
		260.72,
		250,
		250,
		260.72,
		957.49,
		1014.31,
		355.23,
		36203.93,
		375.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		180.69,
		null,
		24.56,
		8966.92,
		null,
		30,
		32.2,
		4.37,
		1596.15,
		4.7,
		10,
		null,
		1.34,
		487.97,
		null,
		40,
		null,
		5.2,
		1898.57,
		null,
		123.69,
		null,
		17.07,
		6226.99,
		null,
		6.99,
		null,
		0.97,
		353.39,
		null,
		null,
		null,
		null,
		null,
		null,
		"Polish State Company_Saudi Aramco_Other Investors_ING OFE",
		"53.2_30_11.78_5.02",
		null,
		"Active",
		null,
		110.11,
		41.86,
		10.15,
		15,
		9.2,
		9.24,
		52.43333333,
		19.93333333,
		4.83333333,
		7.14285714,
		4.38095238,
		4.4,
		195.56,
	],
	[
		"REFGERPLC-PFR",
		41.5291,
		-109.4665,
		"PLATTS - Refinery - United States - Green River - P and M Petroleum Management LLC",
		44.03,
		46.05,
		5.84,
		2122.16,
		6.11,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"P and M Petroleum Management LLC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGL3NIO-PFR",
		37.1984436,
		55.070672,
		"PLATTS - Refinery - Iran - Golestan (3) - National Iranian Oil Co.",
		1193.3,
		1301.1,
		449.49,
		44560.53,
		485.31,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGLEWUM-PFR",
		33.6601,
		-86.8128,
		"PLATTS - Refinery - United States - Gardendale - Worldwide Energy Consortium, Inc.",
		13,
		13.6,
		1.79,
		651.66,
		1.87,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Worldwide Energy Consortium, Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFESMPEC-PFR",
		0.933176,
		-79.692882,
		"PLATTS - Refinery - Ecuador - Esmeraldas - Petroecuador",
		null,
		null,
		null,
		null,
		null,
		324.46,
		355.97,
		44.25,
		16091.78,
		48.5,
		40,
		null,
		5.94,
		2169.39,
		null,
		0,
		null,
		0,
		0,
		null,
		80,
		null,
		11.46,
		4183.18,
		null,
		370.25,
		408.01,
		53.71,
		18676.55,
		59.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40,
		null,
		5.52,
		2013.79,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroecuador",
		"100",
		null,
		"Active",
		null,
		20.79,
		21,
		33.2,
		4.41,
		4.24,
		0,
		23.9626556,
		24.20470263,
		38.26648225,
		5.08298755,
		4.88704472,
		0,
		83.64,
	],
	[
		"REFGLSMOT-PFR",
		47.52348,
		-111.2942,
		"PLATTS - Refinery - United States - Great Falls - Montana Refining Co.",
		-98.86,
		-104.47,
		-19.08,
		-4736.32,
		-20.18,
		116.86,
		123.51,
		21.63,
		5651.35,
		22.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		22.11,
		null,
		3.05,
		1112.89,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		22.11,
		null,
		3.05,
		1112.89,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Calumet Lubricants Co.",
		"100",
		null,
		"Active",
		null,
		5.67,
		9.28,
		1.26,
		2.32,
		0.25,
		0,
		23.29498767,
		38.12654067,
		5.17666393,
		9.53163517,
		1.02711586,
		0,
		18.78,
	],
	[
		"REFGQOGPY-PFR",
		31.437927,
		121.429869,
		"PLATTS - Refinery - China - Gaoqiao - Gaoqiao Petrochemical Company",
		null,
		null,
		null,
		null,
		null,
		829.69,
		894.26,
		175.48,
		38530.97,
		187.96,
		0,
		null,
		0,
		0,
		null,
		103.82,
		null,
		15.4,
		5622.5,
		null,
		207.65,
		null,
		29.51,
		10769.89,
		null,
		-767.69,
		-826,
		-166.95,
		-35412.69,
		-178.54,
		0,
		null,
		0,
		0,
		null,
		31.15,
		null,
		4.05,
		1478.37,
		null,
		0,
		null,
		0,
		0,
		null,
		72.68,
		null,
		10.05,
		3669.01,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		65.54,
		48.25,
		0.99,
		35.07,
		25.33,
		20.21,
		31.11617528,
		22.90746807,
		0.47001852,
		16.65004985,
		12.02582728,
		9.59502445,
		195.39,
	],
	[
		"REFETUKNY-PFR",
		5.3436,
		-0.6227,
		"PLATTS - Refinery - Ghana - Effutu - Kalahari Investment Company",
		996.6,
		1091.98,
		134.58,
		48900.8,
		147.46,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kalahari Investment Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFAHCAS-PFR",
		25.180021,
		56.344588,
		"PLATTS - Refinery - United Arab Emirates - Fujairah - Cylingas",
		null,
		null,
		null,
		null,
		null,
		7.5,
		8.05,
		1.03,
		375,
		1.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFANFSH-PFR",
		23.01256391,
		112.84271425,
		"PLATTS - Refinery - China - Foshan - Foshan Gaofu Oil",
		null,
		null,
		null,
		null,
		null,
		80,
		85.07,
		11.55,
		4215.08,
		12.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFFNEGLD-PFR",
		41.07016,
		-85.08484,
		"PLATTS - Refinery - United States - Fort Wayne - Gladieux Refinery",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gladieux Refinery",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGRFDLL-PFR",
		50.859546,
		6.98437,
		"PLATTS - Refinery - Germany - Godorf - Deutsche Shell - {Rheinland (Godorf + Wesseling)}",
		null,
		null,
		null,
		null,
		null,
		1776.66,
		1864.5,
		1007.01,
		45230.7,
		1054.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		273.88,
		null,
		36.62,
		13366.1,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		147.63,
		null,
		19.2,
		7007.22,
		null,
		105.99,
		null,
		14.62,
		5335.82,
		null,
		20.26,
		null,
		2.8,
		1023.05,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		157.45,
		49.46,
		18.97,
		15.93,
		11.68,
		22.55,
		56.00611817,
		17.59328425,
		6.74776794,
		5.66641767,
		4.15466154,
		8.02120016,
		276.04,
	],
	[
		"REFFRAASD-PFR",
		55.59194,
		9.75028,
		"PLATTS - Refinery - Denmark - Fredericia - A/S Dansk Shell",
		null,
		null,
		null,
		null,
		null,
		496.97,
		520.5,
		371.5,
		7455.64,
		388.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		55,
		null,
		7.15,
		2610.53,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		55,
		null,
		7.15,
		2610.53,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		34.36,
		14.44,
		4.6,
		0.97,
		2.29,
		0,
		59.09872721,
		24.83660131,
		7.9119367,
		1.66838665,
		3.93876849,
		0,
		56.66,
	],
	[
		"REFGTHIJV-PFR",
		56.01786,
		-3.689432,
		"PLATTS - Refinery - United Kingdom - Grangemouth - INEOS Petrochina JV",
		null,
		null,
		null,
		null,
		null,
		548.38,
		575.38,
		229.09,
		18353.73,
		239.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94.96,
		null,
		12.58,
		4592.8,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		66.42,
		null,
		8.64,
		3153.04,
		null,
		5.4,
		null,
		0.74,
		271.78,
		null,
		23.14,
		null,
		3.2,
		1167.98,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._INEOS",
		"50_50",
		null,
		"Active",
		null,
		51.9,
		36.4,
		11.6,
		18.14,
		7.34,
		4.72,
		39.61832061,
		27.78625954,
		8.85496183,
		13.84732824,
		5.60305344,
		3.60305344,
		130.12,
	],
	[
		"REFFRIALB-PFR",
		40.708528,
		19.549707,
		"PLATTS - Refinery - Albania - Fieri - Albpetrol Albanian State Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Anika Enterprises_Refinery Associates of Texas_Albpetrol Albanian State Co_Mercuria",
		"37.5_37.5_15_10",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGTSTOT-PFR",
		48.58666,
		2.948005,
		"PLATTS - Refinery - France - Grandpuits - Total",
		null,
		null,
		null,
		null,
		null,
		7.2,
		7.63,
		0.93,
		341.53,
		0.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		56.25,
		null,
		7.42,
		2706.84,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		43.42,
		null,
		5.65,
		2060.79,
		null,
		11.25,
		null,
		1.55,
		566.34,
		null,
		1.58,
		null,
		0.22,
		79.71,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		31.8,
		23.49,
		3.76,
		5.15,
		1.84,
		5.39,
		44.63157895,
		32.96842105,
		5.27719298,
		7.22807018,
		2.58245614,
		7.56491228,
		71.42,
	],
	[
		"REFLELCHS-PFR",
		45.658411,
		-108.767687,
		"PLATTS - Refinery - United States - Laurel - CHS",
		null,
		null,
		null,
		null,
		null,
		280.71,
		297.25,
		81.16,
		11792.11,
		85.93,
		38.5,
		null,
		5.72,
		2088,
		null,
		0,
		null,
		0,
		0,
		null,
		49.69,
		null,
		7.25,
		2646.77,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.62,
		null,
		0.21,
		77.07,
		null,
		8.93,
		null,
		1.23,
		449.77,
		null,
		0.63,
		null,
		0.09,
		31.93,
		null,
		null,
		null,
		null,
		null,
		null,
		"CHS",
		"100",
		null,
		"Active",
		null,
		17.79,
		21.76,
		0.29,
		0.97,
		0.48,
		0,
		32.51096491,
		39.76608187,
		0.52997076,
		1.77266082,
		0.87719298,
		0,
		41.29,
	],
	[
		"REFFTHARI-PFR",
		32.797348,
		-97.314253,
		"PLATTS - Refinery - United States - Fort Worth - Amber Refining Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"E-Z Serve Refining Inc",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGUDPTC-PFR",
		36.38692955,
		94.952908,
		"PLATTS - Refinery - China - Golmud - PetroChina",
		null,
		null,
		null,
		null,
		null,
		105.42,
		113.34,
		20.67,
		4809.25,
		22.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLENARC-PFR",
		12.750742,
		44.882198,
		"PLATTS - Refinery - Yemen - Little Aden - Aden Refinery Co.",
		448.4,
		502.58,
		60.28,
		21853.45,
		67.55,
		232.49,
		250.08,
		70.43,
		9332.36,
		75.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yemen Oil and Minerals Corp.",
		"100",
		null,
		"Active",
		null,
		2.79,
		1.68,
		4.27,
		1.4,
		0.28,
		2.34,
		19.92857143,
		12,
		30.5,
		10,
		2,
		16.71428571,
		12.75,
	],
	[
		"REFGAODKJ-PFR",
		37.0487,
		118.413,
		"PLATTS - Refinery - China - Guangrao - Dongying Keli Jituan",
		null,
		null,
		null,
		null,
		null,
		57.1,
		60.99,
		33.84,
		1397.87,
		35.89,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dongying Keli Jituan",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGYUJAL-PFR",
		35.00702779,
		119.22612781,
		"PLATTS - Refinery - China - Ganyu - Jiangsu Xinhai Petrochemical",
		259.16,
		278.06,
		36.02,
		13087.18,
		38.66,
		235.46,
		253.28,
		40.44,
		11312.18,
		43.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lianyungang Wanhai Petrochemical_Dongming Zhongyou Fuel Petrochem",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGARVED-PFR",
		25.148,
		62.3255,
		"PLATTS - Refinery - Pakistan - Gwadar - Volant Industry Limited",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		599.92,
		659.46,
		81.79,
		29744.59,
		89.86,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Volant Industry Limited",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGEGVGY-PFR",
		-38.078537,
		144.381591,
		"PLATTS - Refinery - Australia - Geelong - Viva Energy",
		null,
		null,
		null,
		null,
		null,
		429.95,
		452.85,
		57.94,
		20913.35,
		61.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		105,
		null,
		13.72,
		5008.17,
		null,
		null,
		null,
		null,
		null,
		null,
		7,
		null,
		0.94,
		341.58,
		null,
		93,
		null,
		12.09,
		4414.17,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.69,
		252.42,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vitol",
		"100",
		null,
		"Active",
		null,
		38.85,
		54.9,
		2.7,
		19,
		2.86,
		0.7,
		33.7826087,
		47.73913043,
		2.34782609,
		16.52173913,
		2.48695652,
		0.60869565,
		119.02,
	],
	[
		"REFLISVRO-PFR",
		46.759483,
		-71.193046,
		"PLATTS - Refinery - Canada - Levis - Valero",
		45,
		48.85,
		6.84,
		2495.82,
		7.44,
		718.55,
		757.66,
		95.94,
		34952.14,
		101.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		163,
		null,
		21.2,
		7736.67,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		163,
		null,
		21.2,
		7736.67,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		66.82,
		84.39,
		13.82,
		12.67,
		10.17,
		5.44,
		34.98429319,
		44.18324607,
		7.23560209,
		6.63350785,
		5.32460733,
		2.84816754,
		193.31,
	],
	[
		"REFGLNBEN-PFR",
		51.604406,
		7.023986,
		"PLATTS - Refinery - Germany - Gelsenkirchen - BP Gelsenkirchen",
		null,
		null,
		null,
		null,
		null,
		1088.4,
		1146.66,
		329.32,
		44296.06,
		347.74,
		12.94,
		null,
		1.92,
		702.03,
		null,
		0,
		null,
		0,
		0,
		null,
		197.86,
		null,
		26.88,
		9812.1,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		69.34,
		null,
		9.02,
		3291.36,
		null,
		112.8,
		null,
		15.56,
		5678.69,
		null,
		2.77,
		null,
		0.38,
		140.03,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_PDVSA",
		"50_50",
		null,
		"Active",
		null,
		118.17,
		36.59,
		-0.01,
		12.44,
		16.09,
		33.46,
		55.21962617,
		17.09813084,
		-0.0046729,
		5.81308411,
		7.51869159,
		15.63551402,
		216.73,
	],
	[
		"REFLLDPID-PFR",
		-2.225487,
		-80.899343,
		"PLATTS - Refinery - Ecuador - La Libertad - Petroindustrial - {Cautivo}",
		null,
		null,
		null,
		null,
		null,
		8,
		8.59,
		1.1,
		400,
		1.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.97,
		352.41,
		null,
		-8,
		-8.59,
		-1.1,
		-400,
		-1.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.97,
		352.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroecuador",
		"100",
		null,
		"Active",
		null,
		1.91,
		2.3,
		2.5,
		0.4,
		0.22,
		0,
		27.28571429,
		32.85714286,
		35.71428571,
		5.71428571,
		3.14285714,
		0,
		7.33,
	],
	[
		"REFLNYSEC-PFR",
		34.6093,
		119.1695,
		"PLATTS - Refinery - China - Lianyungang - Sinopec",
		2133.42,
		2292.2,
		462.31,
		95600.01,
		493.78,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec_Lianyungang Port Group",
		"70_30",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHAOJXC-PFR",
		40.833998,
		121.045045,
		"PLATTS - Refinery - China - Huludao - Jinxi Petrochem. Corp.",
		292.2,
		314.03,
		83.16,
		12445.75,
		88.67,
		510.08,
		550.77,
		107.36,
		23634.94,
		115.13,
		25.8,
		null,
		3.83,
		1399.26,
		null,
		0,
		null,
		0,
		0,
		null,
		86,
		null,
		11.9,
		4343.48,
		null,
		null,
		null,
		null,
		null,
		null,
		55.9,
		null,
		7.47,
		2727.74,
		null,
		0,
		null,
		0,
		0,
		null,
		4.3,
		null,
		0.59,
		216.48,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		43.23,
		28.5,
		1.73,
		7.36,
		11.16,
		12.78,
		37.01515541,
		24.40277421,
		1.48129121,
		6.30190941,
		9.55561264,
		10.9427177,
		104.77,
	],
	[
		"REFGQOSIG-PFR",
		31.3438,
		121.5712,
		"PLATTS - Refinery - China - Gaoqiao - SCIPIG",
		null,
		null,
		null,
		null,
		null,
		17,
		17.98,
		17,
		17,
		17.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide_Praxair",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHARVUM-PFR",
		-17.8318,
		31.0457,
		"PLATTS - Refinery - Zimbabwe - Harare - Venessia Petroleum",
		244.24,
		272.62,
		32.57,
		11799.83,
		36.36,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Venessia Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLOSDUP-PFR",
		6.44201116,
		3.35543606,
		"PLATTS - Refinery - Nigeria - Lagos - Dangote Group",
		null,
		null,
		null,
		null,
		null,
		2118.3,
		2325.03,
		508.08,
		91798.84,
		555.97,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		730.5,
		800.62,
		138.3,
		33921.09,
		151.35,
		"Dangote Group_NNPC",
		"80_20",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFGRGABN-PFR",
		57.69971,
		11.84972,
		"PLATTS - Refinery - Sweden - Gothenburg - A.B. Nynas",
		null,
		null,
		null,
		null,
		null,
		34.5,
		36.82,
		5.1,
		1863.17,
		5.46,
		1,
		null,
		0.14,
		54.24,
		null,
		0,
		null,
		0,
		0,
		null,
		9,
		null,
		1.26,
		457.56,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.56,
		201.38,
		null,
		4,
		null,
		0.56,
		201.94,
		null,
		null,
		null,
		null,
		null,
		null,
		"Axel Johnson",
		"100",
		null,
		"Active",
		null,
		1.56,
		0,
		2.64,
		0.26,
		0.08,
		1.18,
		17.33333333,
		0,
		29.33333333,
		2.88888889,
		0.88888889,
		13.11111111,
		5.7,
	],
	[
		"REFHATANY-PFR",
		34.3508,
		62.2164,
		"PLATTS - Refinery - Afghanistan - Herat - Ansar Company",
		10,
		10.74,
		1.37,
		500,
		1.47,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ansar Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLOSODO-PFR",
		6.4551,
		3.3942,
		"PLATTS - Refinery - Nigeria - Lagos - Oando",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1063.54,
		1168.34,
		142.91,
		51965.29,
		157.05,
		"Oando",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHAXVRO-PFR",
		44.620104,
		-63.499057,
		"PLATTS - Refinery - Canada - Halifax - Valero",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ultramar",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLOUCOC-PFR",
		28.5298,
		105.5383,
		"PLATTS - Refinery - China - Luzhou - CNOOC",
		null,
		null,
		null,
		null,
		null,
		32.63,
		35.06,
		4.82,
		1743.53,
		5.13,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC_Sichuan Road and Bridge Holding_Chengdu Road and Bridge",
		"88_7_5",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHMGHIE-PFR",
		53.47704,
		9.952047,
		"PLATTS - Refinery - Germany - Hamburg - Holborn Europa Raffinerie",
		null,
		null,
		null,
		null,
		null,
		218.46,
		229.56,
		29.01,
		10562.31,
		30.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		92.59,
		null,
		12.18,
		4446.77,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		74.58,
		null,
		9.7,
		3539.86,
		null,
		18.01,
		null,
		2.48,
		906.91,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oilinvest_El Paso",
		"66.7_33.3",
		null,
		"Active",
		null,
		33.59,
		24.42,
		23.72,
		6.29,
		6.99,
		8.93,
		32.67509728,
		23.75486381,
		23.07392996,
		6.11867704,
		6.79961089,
		8.68677043,
		103.93,
	],
	[
		"REFHRGABN-PFR",
		53.485253,
		9.968936,
		"PLATTS - Refinery - Germany - Harburg - A.B. Nynas",
		-9.29,
		-10.32,
		-1.43,
		-520.19,
		-1.58,
		96.06,
		101.02,
		25.66,
		4279.82,
		27.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		26.32,
		null,
		3.43,
		1251.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		25.48,
		null,
		3.31,
		1209.38,
		null,
		0,
		null,
		0,
		0,
		null,
		0.84,
		null,
		0.12,
		42.22,
		null,
		null,
		null,
		null,
		null,
		null,
		"A.B. Nynas",
		"100",
		null,
		"Active",
		null,
		12.26,
		0,
		2.75,
		0,
		0.21,
		7.69,
		38.95773753,
		0,
		8.73848109,
		0,
		0.66730219,
		24.43597077,
		22.91,
	],
	[
		"REFLRFABH-PFR",
		51.325741,
		12.012376,
		"PLATTS - Refinery - Germany - Luetzkendorf - Addinol Mineraloel Gmbh",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.01,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Innovative Umwelttechnik",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLTAYPF-PFR",
		-34.875667,
		-57.923824,
		"PLATTS - Refinery - Argentina - La Plata - YPF",
		null,
		null,
		null,
		null,
		null,
		564.66,
		619.98,
		78.01,
		28029.79,
		85.62,
		0,
		null,
		0,
		0,
		null,
		30.82,
		null,
		4.57,
		1669.34,
		null,
		134.09,
		null,
		18.86,
		6882.64,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		103.27,
		null,
		14.28,
		5213.3,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF_Petersen Energia",
		"85.1_14.9",
		null,
		"Active",
		null,
		47,
		37.93,
		29.46,
		9.94,
		10.81,
		18.57,
		29.19254658,
		23.55900621,
		18.29813665,
		6.17391304,
		6.71428571,
		11.53416149,
		153.7,
	],
	[
		"REFLNAADE-PFR",
		43.346652,
		-8.457711,
		"PLATTS - Refinery - Spain - La Coruna - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		25,
		26.45,
		25,
		25,
		26.45,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLIBMCG-PFR",
		6.328,
		-10.7978,
		"PLATTS - Refinery - Liberia - Monrovia - Conex Group JV Ltd.",
		null,
		null,
		null,
		null,
		null,
		10,
		10.9,
		1.37,
		500,
		1.49,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Conex Group JV Ltd.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHUDSCH-PFR",
		31.6957,
		6.0604,
		"PLATTS - Refinery - Algeria - Hassi Messaoud - Sonatrach - {Haoud El Hamra}",
		null,
		null,
		null,
		null,
		null,
		267.1,
		292.6,
		35.6,
		12954.03,
		39,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLUGSAD-PFR",
		4.476623,
		114.003009,
		"PLATTS - Refinery - Malaysia - Lutong - Sarawak Shell Berhad",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLNTUWN-PFR",
		18.0357,
		-77.9429,
		"PLATTS - Refinery - Jamaica - Luana Point - Unknown",
		1641.16,
		1802.9,
		249.32,
		80187.82,
		273.1,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLL2PID-PFR",
		-2.22143503,
		-80.90220024,
		"PLATTS - Refinery - Ecuador - La Libertad (2) - Petroindustrial",
		null,
		null,
		null,
		null,
		null,
		35,
		37.57,
		4.79,
		1750,
		5.15,
		25,
		null,
		3.71,
		1355.87,
		null,
		0,
		null,
		0,
		0,
		null,
		25,
		null,
		3.71,
		1355.87,
		null,
		-35,
		-37.58,
		-4.8,
		-1750,
		-5.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroecuador",
		"100",
		null,
		"Active",
		null,
		4.71,
		5.96,
		17.24,
		1.73,
		0.1,
		0,
		15.61671088,
		19.76127321,
		57.16180371,
		5.73607427,
		0.33156499,
		0,
		29.74,
	],
	[
		"REFLZNPTT-PFR",
		12.7503,
		122.7312,
		"PLATTS - Refinery - Philippines - Luzon - PTT",
		398.5,
		421.99,
		55.77,
		20354.53,
		59.07,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PTT",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHUZNIO-PFR",
		27.068,
		56.4642,
		"PLATTS - Refinery - Iran - Hormuz - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		869.17,
		954.47,
		121.56,
		43577.87,
		133.35,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLLUATS-PFR",
		29.92652,
		-90.35069,
		"PLATTS - Refinery - United States - Luling - Air Products",
		null,
		null,
		null,
		null,
		null,
		100,
		105.8,
		100,
		100,
		105.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMADEOR-PFR",
		60.8124,
		5.034742,
		"PLATTS - Refinery - Norway - Mongstad - Equinor",
		null,
		null,
		null,
		null,
		null,
		1122.91,
		1175.05,
		738.17,
		22425.5,
		770.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		166,
		null,
		22.58,
		8241.44,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		46,
		null,
		5.98,
		2183.35,
		null,
		0,
		null,
		0,
		0,
		null,
		120,
		null,
		16.6,
		6058.09,
		null,
		105,
		109.95,
		15.49,
		5651.82,
		16.21,
		"Equinor",
		"100",
		null,
		"Active",
		null,
		91.9,
		48.04,
		9.07,
		10.99,
		12.27,
		11.38,
		49.40860215,
		25.82795699,
		4.87634409,
		5.90860215,
		6.59677419,
		6.11827957,
		183.65,
	],
	[
		"REFLMABOC-PFR",
		40.72001,
		-84.11465,
		"PLATTS - Refinery - United States - Lima - BOC",
		null,
		null,
		null,
		null,
		null,
		20,
		21.16,
		20,
		20,
		21.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMAEECE-PFR",
		43.44469,
		4.925394,
		"PLATTS - Refinery - France - Marseille - Esso France - {Fos-sur-Mer}",
		null,
		null,
		null,
		null,
		null,
		397.48,
		418.18,
		53.39,
		19445.47,
		56.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		102.22,
		null,
		13.7,
		4999.15,
		null,
		null,
		null,
		null,
		null,
		null,
		14.73,
		null,
		1.97,
		718.63,
		null,
		43.31,
		null,
		5.63,
		2055.89,
		null,
		41.58,
		null,
		5.74,
		2093.44,
		null,
		2.6,
		null,
		0.36,
		131.2,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Other Investors",
		"81.55_18.45",
		null,
		"Active",
		null,
		36.98,
		25.63,
		23.42,
		8.79,
		10.23,
		10.9,
		31.33898305,
		21.72033898,
		19.84745763,
		7.44915254,
		8.66949153,
		9.23728814,
		115.95,
	],
	[
		"REFIDTGVR-PFR",
		48.78886,
		11.47303,
		"PLATTS - Refinery - Germany - Ingolstadt - Gunvor",
		null,
		null,
		null,
		null,
		null,
		331.56,
		348.75,
		69.9,
		14822.88,
		73.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		89.98,
		null,
		12.07,
		4405.8,
		null,
		null,
		null,
		null,
		null,
		null,
		20,
		null,
		2.67,
		975.94,
		null,
		32.93,
		null,
		4.28,
		1563.02,
		null,
		24.7,
		null,
		3.41,
		1243.41,
		null,
		12.35,
		null,
		1.71,
		623.43,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		33.12,
		31.62,
		21.82,
		5.98,
		10.53,
		5.96,
		31.54285714,
		30.11428571,
		20.78095238,
		5.6952381,
		10.02857143,
		5.67619048,
		109.02,
	],
	[
		"REFLVSADE-PFR",
		36.1673,
		-115.1485,
		"PLATTS - Refinery - United States - Las Vegas - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		30,
		31.74,
		30,
		30,
		31.74,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLMAHUS-PFR",
		40.717268,
		-84.127174,
		"PLATTS - Refinery - United States - Lima - Cenovus",
		null,
		null,
		null,
		null,
		null,
		820.37,
		865.53,
		305.44,
		29079.04,
		322.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		136,
		null,
		17.74,
		6474.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		129.72,
		null,
		16.87,
		6156.99,
		null,
		0,
		null,
		0,
		0,
		null,
		6.28,
		null,
		0.87,
		317.12,
		null,
		null,
		null,
		null,
		null,
		null,
		"Husky Oil",
		"100",
		null,
		"Active",
		null,
		41.73,
		71.78,
		0.86,
		11.67,
		12.51,
		0.86,
		30.59384164,
		52.62463343,
		0.63049853,
		8.55571848,
		9.17155425,
		0.63049853,
		139.41,
	],
	[
		"REFMAHTAM-PFR",
		32.8545,
		12.2391,
		"PLATTS - Refinery - Libya - Mellitah - Tamoil",
		594.4,
		651.43,
		194.23,
		23066.78,
		212.16,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tamoil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFIISMUM-PFR",
		39.78216,
		-86.22664,
		"PLATTS - Refinery - United States - Indianapolis - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLWVIRG-PFR",
		38.714439,
		-87.68005,
		"PLATTS - Refinery - United States - Lawrenceville - Indian Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Castle Energy Corp._Unknown",
		"98_2",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLNOAGP-PFR",
		43.58448,
		10.33822,
		"PLATTS - Refinery - Italy - Livorno - Agip Plas S.P.A",
		null,
		null,
		null,
		null,
		null,
		212.15,
		222.47,
		29.19,
		10593.04,
		30.62,
		4.93,
		null,
		0.73,
		267.3,
		null,
		0,
		null,
		0,
		0,
		null,
		69,
		null,
		9.27,
		3384.33,
		null,
		-195.15,
		-204.51,
		-26.69,
		-9675.65,
		-27.96,
		6.57,
		null,
		0.88,
		320.66,
		null,
		34.5,
		null,
		4.49,
		1637.52,
		null,
		16.43,
		null,
		2.27,
		827.09,
		null,
		6.57,
		null,
		0.91,
		331.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		24.12,
		15.56,
		17.59,
		4.09,
		1.65,
		3.93,
		28.71428571,
		18.52380952,
		20.94047619,
		4.86904762,
		1.96428571,
		4.67857143,
		66.94,
	],
	[
		"REFJAHARM-PFR",
		21.447835,
		39.186709,
		"PLATTS - Refinery - Saudi Arabia - Jeddah - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.03,
		-0.02,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMALODC-PFR",
		23.625342,
		58.513277,
		"PLATTS - Refinery - Oman - Mina Al Fahal - QQ (Oman Oil + ORPIC)",
		null,
		null,
		null,
		null,
		null,
		232.76,
		253.04,
		72.23,
		8861.65,
		77.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71,
		null,
		9.49,
		3463.24,
		null,
		null,
		null,
		null,
		null,
		null,
		70,
		null,
		9.36,
		3415.78,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oman Refineries and Petrochemicals",
		"100",
		null,
		"Active",
		null,
		6.29,
		21.51,
		33.74,
		7.5,
		5.7,
		0,
		7.8625,
		26.8875,
		42.175,
		9.375,
		7.125,
		0,
		74.73,
	],
	[
		"REFMAIETA-PFR",
		56.311,
		22.3485,
		"PLATTS - Refinery - Lithuania - Mazeikiai - Ecolita",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI_Lithuanian State Company",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJAHLEF-PFR",
		21.443858,
		39.183747,
		"PLATTS - Refinery - Saudi Arabia - Jeddah - LUBEREF - {Saudi Aramco Lubricating Oil Refining Company}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco_Jadwa Industrial Investment",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMAIOVA-PFR",
		56.0602,
		21.10592,
		"PLATTS - Refinery - Lithuania - Mazeikiai - ORLEN Lietuva",
		null,
		null,
		null,
		null,
		null,
		1084.51,
		1185.7,
		353.93,
		42839.83,
		382.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		166,
		null,
		22.63,
		8259.3,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		34,
		null,
		4.42,
		1613.78,
		null,
		132,
		null,
		18.21,
		6645.52,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PKN Orlen_Lithuanian State Company_Other Investors",
		"84.4_10_5.6",
		null,
		"Active",
		null,
		64.37,
		64.37,
		27.53,
		19.28,
		11.4,
		0.19,
		34.05820106,
		34.05820106,
		14.56613757,
		10.2010582,
		6.03174603,
		0.1005291,
		187.14,
	],
	[
		"REFJLEVOR-PFR",
		36.666386,
		-83.158017,
		"PLATTS - Refinery - United States - Jonesville - Virginia Oil and Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Virginia Oil and Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMAMERD-PFR",
		49.524525,
		8.444911,
		"PLATTS - Refinery - Germany - Mannheim - Erdoel",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Badische Anilin and Soda Fabrik",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLSNACO-PFR",
		32.794048,
		-92.809785,
		"PLATTS - Refinery - United States - Lisbon - Arcadia Ref. and Marketing Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Arcadia Ref. and Marketing Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJORKPT-PFR",
		2.0119,
		103.4466,
		"PLATTS - Refinery - Malaysia - Johor - Kuokang Petrochemical Tech. Corp.",
		924.26,
		980.14,
		129.1,
		46293.1,
		136.84,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuokang Petrochemical Tech. Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLTEETT-PFR",
		29.681421,
		-95.013949,
		"PLATTS - Refinery - United States - La Porte - EOTT",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Enron",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJOUJZC-PFR",
		41.051632,
		120.982512,
		"PLATTS - Refinery - China - Jinzhou - Jinzhou Petrochem Corp.",
		null,
		null,
		null,
		null,
		null,
		528.03,
		571.09,
		108.01,
		24590.49,
		116,
		34.5,
		null,
		5.13,
		1871.1,
		null,
		0,
		null,
		0,
		0,
		null,
		115,
		null,
		15.81,
		5771.07,
		null,
		null,
		null,
		null,
		null,
		null,
		34.5,
		null,
		4.61,
		1683.49,
		null,
		34.5,
		null,
		4.49,
		1637.52,
		null,
		11.5,
		null,
		1.59,
		578.97,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		38.53,
		29.95,
		0.4,
		6.8,
		10.23,
		12.62,
		38.7314033,
		30.10655408,
		0.40209087,
		6.83554483,
		10.28347407,
		12.68596703,
		98.53,
	],
	[
		"REFLESMUM-PFR",
		33.794672,
		-118.234392,
		"PLATTS - Refinery - United States - Los Angeles - Marathon Petroleum",
		86.12,
		91.36,
		13.42,
		4488.82,
		14.24,
		550.7,
		580,
		223.89,
		19149.25,
		235.73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJOUTLS-PFR",
		41.4944,
		121.6153,
		"PLATTS - Refinery - China - Jinzhou - Tianhe Chemicals",
		null,
		null,
		null,
		null,
		null,
		12,
		12.79,
		1.65,
		603.25,
		1.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tianhe Chemicals",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLESVRO-PFR",
		33.778419,
		-118.234016,
		"PLATTS - Refinery - United States - Los Angeles - Valero",
		null,
		null,
		null,
		null,
		null,
		471.26,
		496.57,
		108.54,
		20666.35,
		114.53,
		18.59,
		null,
		2.76,
		1007.99,
		null,
		0,
		null,
		0,
		0,
		null,
		51.15,
		null,
		7.25,
		2647.78,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		29.79,
		null,
		4.11,
		1499.63,
		null,
		2.78,
		null,
		0.38,
		140.16,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		12.72,
		51.53,
		3.39,
		5.92,
		0.85,
		0,
		20.75718016,
		84.08942559,
		5.53198433,
		9.66057441,
		1.38707572,
		0,
		74.4,
	],
	[
		"REFLYGLRE-PFR",
		41.213549,
		123.215143,
		"PLATTS - Refinery - China - Liaoyang - Liaoyang Petro Oil and Chem Fibre",
		20,
		21.16,
		2.74,
		1000,
		2.9,
		714.4,
		771.12,
		166.78,
		32194.39,
		178.6,
		70.4,
		null,
		10.46,
		3818.13,
		null,
		0,
		null,
		0,
		0,
		null,
		176,
		null,
		24.65,
		8998.31,
		null,
		null,
		null,
		null,
		null,
		null,
		88,
		null,
		11.76,
		4294.12,
		null,
		0,
		null,
		0,
		0,
		null,
		17.6,
		null,
		2.43,
		886.07,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		0,
		"Active",
		null,
		68.25,
		48.99,
		8.81,
		6.59,
		14.88,
		17.8,
		41.20630321,
		29.577975,
		5.31908471,
		3.97874781,
		8.98387973,
		10.74684538,
		165.32,
	],
	[
		"REFLETCGO-PFR",
		41.64569,
		-88.05287,
		"PLATTS - Refinery - United States - Lemont - Citgo",
		null,
		null,
		null,
		null,
		null,
		553.29,
		582.57,
		78.09,
		27575.11,
		82.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		153.86,
		null,
		21.22,
		7746.28,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		153.86,
		null,
		21.22,
		7746.28,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		42.11,
		88.37,
		5.06,
		14.82,
		-2.42,
		3.3,
		24.89800745,
		52.24974871,
		2.99178147,
		8.76249039,
		-1.43085201,
		1.95116183,
		151.23,
	],
	[
		"REFJUGFCS-PFR",
		1.2596,
		103.6705,
		"PLATTS - Refinery - Singapore - Jurong - Formosa Plastics",
		890.25,
		943.97,
		205.93,
		40300.52,
		218.13,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Formosa Plastics",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLEWLOG-PFR",
		32.439025,
		-94.688006,
		"PLATTS - Refinery - United States - Longview - Longview Refining",
		51,
		53.49,
		6.72,
		2450.19,
		7.04,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Longview Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKABICO-PFR",
		32.6156,
		44.0348,
		"PLATTS - Refinery - Iraq - Karbala - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		883.3,
		951.35,
		518.26,
		21615.61,
		551.33,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKACIED-PFR",
		24.7858,
		67.38009,
		"PLATTS - Refinery - Pakistan - Karachi - Indus Refinery Limited",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		202.54,
		220.54,
		27.93,
		10181.06,
		30.38,
		"Indus Refinery Limited",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKAYXPC-PFR",
		43.862908,
		87.374737,
		"PLATTS - Refinery - China - Karamay - Xianjiang Petrochem Corp.",
		1228.26,
		1330.41,
		169.65,
		60908.23,
		183.73,
		351.52,
		378.58,
		61.86,
		17333.13,
		66.4,
		0,
		null,
		0,
		0,
		null,
		16.95,
		null,
		2.51,
		917.87,
		null,
		84.75,
		null,
		11.58,
		4225.36,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		38.14,
		null,
		4.96,
		1810.08,
		null,
		0,
		null,
		0,
		0,
		null,
		29.66,
		null,
		4.1,
		1497.41,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		23.95,
		17,
		3.18,
		5.25,
		6.94,
		6.6,
		30.84352865,
		21.89311011,
		4.09529942,
		6.76110753,
		8.93754024,
		8.49967804,
		62.92,
	],
	[
		"REFKERPWA-PFR",
		34.95262,
		72.33111,
		"PLATTS - Refinery - Pakistan - Khyber-Pakhtunkhwa - Pakistan State Oil Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		68.04,
		74.42,
		9.07,
		3295.79,
		9.91,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pakistan State Oil Co.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKGSDLK-PFR",
		30.52634,
		-91.74814,
		"PLATTS - Refinery - United States - Krotz Springs - Delek Group",
		null,
		null,
		null,
		null,
		null,
		235.49,
		247.61,
		31.5,
		11493.76,
		33.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		50.21,
		null,
		6.53,
		2383.34,
		null,
		20,
		21.16,
		2.77,
		1011.08,
		2.93,
		0,
		null,
		0,
		0,
		null,
		50.21,
		null,
		6.53,
		2383.34,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Delek Group",
		"100",
		null,
		"Active",
		null,
		20.02,
		30.46,
		0.86,
		7.03,
		5.78,
		1.15,
		31.37931034,
		47.74294671,
		1.34796238,
		11.01880878,
		9.05956113,
		1.80250784,
		65.29,
	],
	[
		"REFGYEATS-PFR",
		30.069313,
		-90.576343,
		"PLATTS - Refinery - United States - Garyville - Air Products",
		null,
		null,
		null,
		null,
		null,
		145,
		153.4,
		145,
		145,
		153.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKHEEXM-PFR",
		49.0512,
		8.348408,
		"PLATTS - Refinery - Germany - Karlsruhe - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		0.13,
		0.12,
		0.05,
		4.82,
		0.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rheinisch-Westf.Elektr.-Werk_Du Pont_PDVSA_Veba",
		"42_25_16.5_16.5",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFGZUGNG-PFR",
		22.65044516,
		113.56356343,
		"PLATTS - Refinery - China - Guangzhou - Guangzhou Panyu Huahong",
		null,
		null,
		null,
		null,
		null,
		29,
		30.68,
		4.23,
		1543.36,
		4.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Guangzhou Panyu Huahong",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKIKICO-PFR",
		36.5053,
		42.5545,
		"PLATTS - Refinery - Iraq - Kisik - Iraq National Oil Co - {Kasik}",
		null,
		null,
		null,
		null,
		null,
		20,
		21.49,
		2.74,
		1000,
		2.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.97,
		352.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.97,
		352.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		1.44,
		0.73,
		4.15,
		0.71,
		0.14,
		0.56,
		18,
		9.125,
		51.875,
		8.875,
		1.75,
		7,
		7.72,
	],
	[
		"REFHANKON-PFR",
		37.2221,
		67.4249,
		"PLATTS - Refinery - Afghanistan - Hairatan - Kingston",
		10,
		10.74,
		1.37,
		500,
		1.47,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kingston",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHAVCET-PFR",
		23.13651,
		-82.32186,
		"PLATTS - Refinery - Cuba - Havana - Cupet",
		null,
		null,
		null,
		null,
		null,
		198.85,
		215.37,
		27.57,
		10060.92,
		29.85,
		2.4,
		null,
		0.36,
		130.16,
		null,
		0,
		null,
		0,
		0,
		null,
		6,
		null,
		0.85,
		311.4,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.6,
		null,
		0.5,
		181.24,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cupet",
		"100",
		null,
		"Active",
		null,
		3.41,
		3.61,
		6.25,
		0.65,
		0.88,
		0.53,
		21.3125,
		22.5625,
		39.0625,
		4.0625,
		5.5,
		3.3125,
		15.34,
	],
	[
		"REFHESPCO-PFR",
		38.021636,
		-122.281879,
		"PLATTS - Refinery - United States - Hercules - Pacific Refining Co",
		null,
		null,
		null,
		null,
		null,
		0.05,
		0.02,
		0,
		0.02,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China Natl Chem.Im./Exprt Corp_The Coastal Corporation",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKKAHND-PFR",
		16.9437,
		82.2351,
		"PLATTS - Refinery - India - Kakinada - Hindustan Petroleum",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		915.45,
		1006.56,
		124.94,
		45430.38,
		137.25,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Government_Other Investors",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHIAIND-PFR",
		22.049799,
		88.107945,
		"PLATTS - Refinery - India - Haldia - Indian Oil Corp.",
		null,
		null,
		null,
		null,
		null,
		528.5,
		580.53,
		130.14,
		23102.07,
		141.49,
		3.22,
		null,
		0.48,
		174.53,
		null,
		0,
		null,
		0,
		0,
		null,
		125.66,
		null,
		17.1,
		6242.68,
		null,
		null,
		null,
		null,
		null,
		null,
		6.44,
		null,
		0.86,
		314.06,
		null,
		29.88,
		null,
		3.89,
		1418.32,
		null,
		86.12,
		null,
		11.88,
		4335.77,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		64.86,
		13.27,
		4.84,
		14.44,
		9.63,
		24.57,
		46.32857143,
		9.47857143,
		3.45714286,
		10.31428571,
		6.87857143,
		17.55,
		131.61,
	],
	[
		"REFKKHEGP-PFR",
		31.3815,
		30.8514,
		"PLATTS - Refinery - Egypt - Kafr El-Sheikh - EGPC",
		1390.65,
		1530.48,
		497.18,
		53383.39,
		543.84,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFHLTWAR-PFR",
		33.24836,
		-87.48958,
		"PLATTS - Refinery - United States - Holt - Warrior Asphalt Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Warrior Asphalt Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKKWJNO-PFR",
		35.522432,
		139.774746,
		"PLATTS - Refinery - Japan - Kawasaki - ENEOS",
		null,
		null,
		null,
		null,
		null,
		1131.25,
		1195.56,
		247.79,
		50630.16,
		261.28,
		0.15,
		null,
		0.02,
		8.08,
		null,
		3.09,
		null,
		0.46,
		167.52,
		null,
		167.29,
		null,
		22.67,
		8276.21,
		null,
		null,
		null,
		null,
		null,
		null,
		87,
		null,
		11.63,
		4245.32,
		null,
		8.43,
		null,
		1.1,
		400.08,
		null,
		65.62,
		null,
		9.05,
		3303.74,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		null,
		"Active",
		null,
		68.26,
		60.32,
		17.19,
		34.52,
		0.87,
		21.21,
		33.39040258,
		29.50643252,
		8.40874627,
		16.88597564,
		0.42557355,
		10.37518955,
		202.37,
	],
	[
		"REFHNAREO-PFR",
		18.40171,
		-70.029,
		"PLATTS - Refinery - Dominican Republic - Haina - Refineria Dominicana de Petroleo - {Santo Domingo}",
		null,
		null,
		null,
		null,
		null,
		54.56,
		59.7,
		7.08,
		2575.56,
		7.76,
		6.4,
		null,
		0.95,
		347.1,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.27,
		830.41,
		null,
		108.41,
		118.12,
		45.35,
		3801.17,
		48.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		9.6,
		null,
		1.33,
		483.31,
		null,
		0,
		null,
		0,
		0,
		null,
		187.37,
		204.25,
		65.8,
		7314.96,
		71.06,
		"Dominican Republic Govt._PDVSA",
		"51_49",
		null,
		"Active",
		null,
		5.06,
		1.98,
		5.81,
		3.88,
		0.37,
		2.33,
		25.3,
		9.9,
		29.05,
		19.4,
		1.85,
		11.65,
		19.41,
	],
	[
		"REFKLRSIE-PFR",
		49.237551,
		6.883692,
		"PLATTS - Refinery - Germany - Klarenthal - Saarland Raffinerie",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saarbergwerke_Elf_Total_Chimique Charbonnages",
		"50_20_20_10",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKMETLO-PFR",
		53.64333,
		-0.2514839,
		"PLATTS - Refinery - United Kingdom - Killingholme - Prax Group",
		null,
		null,
		null,
		null,
		null,
		497.93,
		524.14,
		116.45,
		22405.06,
		122.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		137.88,
		null,
		18.28,
		6672.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		94.17,
		null,
		12.25,
		4469.5,
		null,
		24.28,
		null,
		3.35,
		1222.6,
		null,
		19.43,
		null,
		2.69,
		980.79,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		57.26,
		49,
		4.39,
		21.88,
		8.09,
		4.2,
		37.9205298,
		32.45033113,
		2.90728477,
		14.49006623,
		5.35761589,
		2.78145695,
		144.82,
	],
	[
		"REFKNTPAO-PFR",
		24.9284,
		66.712,
		"PLATTS - Refinery - Pakistan - Khalifa Point - Parco - {Karachi}",
		null,
		null,
		null,
		null,
		null,
		607.33,
		664.11,
		84.04,
		30549.94,
		91.8,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pakistan Refinery Ltd._Mubadala Investment Company",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFHUAXNY-PFR",
		38.3667,
		117.3333,
		"PLATTS - Refinery - China - Huanghua - Xinyi Chemical",
		50.75,
		54.18,
		7.57,
		2601.97,
		8.09,
		52.25,
		56.33,
		7.95,
		2736.03,
		8.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinochem_Xinyi Chemical",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKS2JNO-PFR",
		35.910371,
		140.690773,
		"PLATTS - Refinery - Japan - Kashima (2) - ENEOS",
		42.85,
		45.31,
		7.63,
		2293.45,
		8.08,
		1321.8,
		1386.17,
		909.46,
		25018.25,
		949.89,
		0.11,
		null,
		0.02,
		5.89,
		null,
		2.25,
		null,
		0.33,
		121.94,
		null,
		122.26,
		null,
		16.57,
		6049.57,
		null,
		null,
		null,
		null,
		null,
		null,
		63,
		null,
		8.42,
		3074.2,
		null,
		6.14,
		null,
		0.8,
		291.23,
		null,
		47.77,
		null,
		6.59,
		2404.87,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		null,
		"Active",
		null,
		43.64,
		35.26,
		14.18,
		25.64,
		10,
		14.23,
		29.35952637,
		23.72174381,
		9.53982777,
		17.24973089,
		6.72766416,
		9.57346609,
		142.95,
	],
	[
		"REFHUNJIA-PFR",
		33.4078,
		119.1209,
		"PLATTS - Refinery - China - Huaian - Jiangsu Farun Chemical",
		null,
		null,
		null,
		null,
		null,
		62.42,
		67.32,
		22.78,
		2516.44,
		24.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jiangsu Farun Chemical_Zhangjiagang Jinfeng Glass Co Ltd",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKSUNON-PFR",
		33.980947,
		131.888438,
		"PLATTS - Refinery - Japan - Kudamatsu - Nippon",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon_Chevron Corp_Texaco Inc.",
		"50_25_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFIDTBAY-PFR",
		48.76461,
		11.59504,
		"PLATTS - Refinery - Germany - Ingolstadt - Bayern Oil",
		null,
		null,
		null,
		null,
		null,
		836.88,
		882.09,
		252.98,
		33725.68,
		267.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		134.51,
		null,
		17.8,
		6497.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		95.24,
		null,
		12.39,
		4521.11,
		null,
		39.24,
		null,
		5.42,
		1976.1,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"OMV_BP_ENI_PDVSA",
		"45_22.5_20_12.5",
		null,
		"Active",
		null,
		79.89,
		50.12,
		0.71,
		9.69,
		12.93,
		10.21,
		51.80933852,
		32.50324254,
		0.46044099,
		6.28404669,
		8.38521401,
		6.62127108,
		163.59,
	],
	[
		"REFKUGUTA-PFR",
		49.160269,
		33.463529,
		"PLATTS - Refinery - Ukraine - Kremenchug - Ukrtatnafta",
		140,
		156.74,
		19.97,
		7288.79,
		22.36,
		-130.02,
		-146.04,
		-18.6,
		-6788.75,
		-20.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30.23,
		null,
		3.98,
		1453.6,
		null,
		null,
		null,
		null,
		null,
		null,
		14.23,
		null,
		1.9,
		694.53,
		null,
		16,
		null,
		2.08,
		759.07,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Korsan_Ukrainian State_Viloris Ltd_Other Investors",
		"47_43_8.6_1.4",
		null,
		"Active",
		null,
		7.75,
		7.32,
		4.26,
		0.66,
		1.21,
		0,
		33.50626891,
		31.64721141,
		18.41763943,
		2.85343709,
		5.23130134,
		0,
		21.19,
	],
	[
		"REFIDTRVI-PFR",
		48.75095,
		11.480936,
		"PLATTS - Refinery - Germany - Ingolstadt - RVI",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.04,
		-0.48,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI_The British Petroleum Co",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKUNKAL-PFR",
		44.5513,
		85.0136,
		"PLATTS - Refinery - China - Kuitun - Kuishan Baotao Petrochemical",
		null,
		null,
		null,
		null,
		null,
		316.3,
		340.02,
		45.06,
		15970.05,
		48.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuishan Baotao Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFIITTAS-PFR",
		40.753268,
		29.764599,
		"PLATTS - Refinery - Turkey - Izmit - Tupras",
		null,
		null,
		null,
		null,
		null,
		1279.66,
		1345.71,
		471.43,
		47300.06,
		495.08,
		35.36,
		null,
		5.26,
		1917.31,
		null,
		0,
		null,
		0,
		0,
		null,
		187.56,
		null,
		26.13,
		9537.24,
		null,
		null,
		null,
		null,
		null,
		null,
		5.9,
		null,
		0.78,
		287.51,
		null,
		11.79,
		null,
		1.53,
		559.32,
		null,
		134.53,
		null,
		18.56,
		6773.1,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Koc Holding_Aygaz_Opet",
		"48.5_39.8_10.2_1.5",
		null,
		"Active",
		null,
		78,
		48.11,
		1.69,
		39.95,
		16.3,
		2.08,
		40.83769634,
		25.18848168,
		0.88481675,
		20.91623037,
		8.53403141,
		1.08900524,
		186.14,
	],
	[
		"REFKWNBBP-PFR",
		-32.22664,
		115.761821,
		"PLATTS - Refinery - Australia - Kwinana - BP",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.02,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		125,
		null,
		16.34,
		5964.12,
		null,
		null,
		null,
		null,
		null,
		null,
		12,
		null,
		1.6,
		585.56,
		null,
		108,
		null,
		14.04,
		5126.14,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.69,
		252.42,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		47.79,
		66.09,
		5.24,
		19.07,
		5.66,
		0,
		32.95862069,
		45.57931034,
		3.6137931,
		13.15172414,
		3.90344828,
		0,
		143.86,
	],
	[
		"REFJANFNC-PFR",
		36.9666,
		65.956,
		"PLATTS - Refinery - Afghanistan - Jawzjan - FMC Technologies Inc",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		100.06,
		109.42,
		13.32,
		4836.06,
		14.54,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown_FMC Technologies Inc",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLAVIJV-PFR",
		43.38394,
		5.005217,
		"PLATTS - Refinery - France - Lavera - INEOS Petrochina JV",
		null,
		null,
		null,
		null,
		null,
		533.79,
		563.08,
		74.05,
		26948.97,
		78.16,
		2.58,
		null,
		0.38,
		139.66,
		null,
		0,
		null,
		0,
		0,
		null,
		132.62,
		null,
		18,
		6566.86,
		null,
		null,
		null,
		null,
		null,
		null,
		5.8,
		null,
		0.78,
		282.74,
		null,
		38.62,
		null,
		5.02,
		1833.4,
		null,
		83.04,
		null,
		11.46,
		4181.06,
		null,
		2.58,
		null,
		0.36,
		130,
		null,
		null,
		null,
		null,
		null,
		null,
		"INEOS",
		"100",
		null,
		"Active",
		null,
		92.46,
		40.48,
		13.76,
		16.28,
		12.22,
		19.92,
		44.88349515,
		19.65048544,
		6.67961165,
		7.90291262,
		5.93203883,
		9.66990291,
		195.14,
	],
	[
		"REFJETATS-PFR",
		41.41026,
		-88.19202,
		"PLATTS - Refinery - United States - Joliet - Air Products",
		null,
		null,
		null,
		null,
		null,
		18,
		19.04,
		18,
		18,
		19.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLBNHRC-PFR",
		31.02664,
		-89.44852,
		"PLATTS - Refinery - United States - Lumberton - Hunt Refining Consolidated",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hunt Refining Consolidated",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJJGJKS-PFR",
		29.73893,
		116.066216,
		"PLATTS - Refinery - China - Jiujiang - Jiujiang Gen. Petrochem Works",
		null,
		null,
		null,
		null,
		null,
		908.6,
		976.64,
		300.82,
		35098.49,
		320.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		140.96,
		null,
		19.35,
		7062.64,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		14.1,
		null,
		1.83,
		669.03,
		null,
		77.53,
		null,
		10.69,
		3903,
		null,
		49.33,
		null,
		6.82,
		2490.6,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		57.84,
		37.24,
		7.12,
		10.8,
		19.45,
		16.43,
		36.8149704,
		23.70313793,
		4.53185666,
		6.8741646,
		12.37986124,
		10.45764114,
		148.87,
	],
	[
		"REFLCKWUM-PFR",
		33.5635,
		-101.8793,
		"PLATTS - Refinery - United States - Lubbock - Worldwide Energy Consortium, Inc.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		10.43,
		1.37,
		500,
		1.43,
		"Worldwide Energy Consortium, Inc.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFJJIJGY-PFR",
		25.156,
		99.253,
		"PLATTS - Refinery - China - Jinji - Jinji Technology",
		null,
		null,
		null,
		null,
		null,
		40.9,
		43.46,
		5.78,
		2112.97,
		6.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jinji Technology",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLEIWUE-PFR",
		23.3916,
		109.234,
		"PLATTS - Refinery - China - Lubei - Wudi Xinyue",
		424.15,
		455.32,
		58.03,
		21053.91,
		62.28,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Wudi Xinyue",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLESP66-PFR",
		33.775194,
		-118.284791,
		"PLATTS - Refinery - United States - Los Angeles - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		575.63,
		606.79,
		81.11,
		28553.75,
		85.51,
		48.88,
		null,
		7.26,
		2650.85,
		null,
		0,
		null,
		0,
		0,
		null,
		114,
		null,
		16.24,
		5926.38,
		null,
		null,
		null,
		null,
		null,
		null,
		2.11,
		null,
		0.28,
		102.88,
		null,
		0,
		null,
		0,
		0,
		null,
		61.54,
		null,
		8.49,
		3098.05,
		null,
		1.48,
		null,
		0.2,
		74.61,
		null,
		null,
		null,
		null,
		null,
		null,
		"ConocoPhillips",
		"100",
		null,
		"Active",
		null,
		26.08,
		71.49,
		0.96,
		26.12,
		-0.27,
		0,
		20.86900856,
		57.20572938,
		0.76818436,
		20.90101624,
		-0.21605185,
		0,
		124.39,
	],
	[
		"REFJUGJON-PFR",
		1.263032,
		103.668098,
		"PLATTS - Refinery - Singapore - Jurong - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		273.1,
		290.12,
		33.44,
		12168.68,
		35.54,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		20,
		null,
		2.6,
		949.28,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		20,
		null,
		2.6,
		949.28,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jurong Aromatics Corporation",
		"100",
		null,
		"Active",
		null,
		2,
		0,
		0,
		2,
		1.9,
		14,
		10,
		0,
		0,
		10,
		9.5,
		70,
		19.9,
	],
	[
		"REFLILPEM-PFR",
		58.345987,
		11.423498,
		"PLATTS - Refinery - Sweden - Lysekil - Preem",
		215.4,
		228.96,
		95.98,
		7621.64,
		101.71,
		35.82,
		37.55,
		6.27,
		2267.76,
		6.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		144,
		null,
		18.95,
		6916.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		116,
		null,
		15.08,
		5505.85,
		null,
		18,
		null,
		2.48,
		906.21,
		null,
		10,
		null,
		1.38,
		504.84,
		null,
		null,
		null,
		null,
		null,
		null,
		"Corral Petroleum Holdings",
		"100",
		null,
		"Active",
		null,
		69.04,
		54.56,
		19.24,
		0.2,
		5.59,
		0.55,
		46.02666667,
		36.37333333,
		12.82666667,
		0.13333333,
		3.72666667,
		0.36666667,
		149.19,
	],
	[
		"REFJUGMBL-PFR",
		1.309006,
		103.687404,
		"PLATTS - Refinery - Singapore - Jurong - Mobil",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mobil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLINLIJ-PFR",
		37.4964,
		118.242,
		"PLATTS - Refinery - China - Lijin - Lijin Juxin Oil Processing Company",
		255.3,
		276.36,
		143.25,
		6676.68,
		152.43,
		0,
		0,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lijin Juxin Oil Processing Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLKNLKC-PFR",
		40.97037,
		-85.84459,
		"PLATTS - Refinery - United States - Laketon - Laketon Refining Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		0.01,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Asphalt Materials",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFJZEPTY-PFR",
		49.712344,
		21.660639,
		"PLATTS - Refinery - Poland - Jedlicze - P.P. Rafineria Nafty",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"P.P. Rafineria Nafty",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLLEBTE-PFR",
		38.024424,
		-85.918033,
		"PLATTS - Refinery - United States - Louisville - B-T Energy Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"B-T Energy Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKAANNP-PFR",
		10.411588,
		7.490649,
		"PLATTS - Refinery - Nigeria - Kaduna - NNPC",
		null,
		null,
		null,
		null,
		null,
		251.41,
		277.41,
		34.35,
		12523.05,
		37.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NNPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLMALDE-PFR",
		40.72064,
		-84.11444,
		"PLATTS - Refinery - United States - Lima - Linde",
		null,
		null,
		null,
		null,
		null,
		60,
		63.47,
		60,
		60,
		63.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Linde",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKACNDR-PFR",
		24.802523,
		67.117331,
		"PLATTS - Refinery - Pakistan - Karachi - National Refinery Ltd.",
		null,
		null,
		null,
		null,
		null,
		296.93,
		323.4,
		136.07,
		9599.41,
		146.72,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		40.48,
		null,
		5.43,
		1981.11,
		null,
		176.03,
		192.19,
		110.04,
		3755.69,
		118.54,
		29.28,
		null,
		3.91,
		1428.77,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		7.2,
		null,
		0.99,
		362.48,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"State Petr. Ref. and Petrochem. Corp",
		"100",
		null,
		"Active",
		null,
		17.02,
		3.46,
		5.76,
		5.55,
		1.11,
		6.5,
		38.68181818,
		7.86363636,
		13.09090909,
		12.61363636,
		2.52272727,
		14.77272727,
		39.39,
	],
	[
		"REFLMSSGY-PFR",
		33.13188,
		-89.04944,
		"PLATTS - Refinery - United States - Louisville (MS) - SNC Energy",
		335.9,
		352.67,
		76.93,
		15005.51,
		81.02,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SNC Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKAIWPR-PFR",
		34.147133,
		135.203148,
		"PLATTS - Refinery - Japan - Kainan - Wakayama Petroleum Refining",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0,
		0.05,
		0.53,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon Mitsubishi_Fuji Kosan Company_Nihon Kojun_Unknown",
		"50_25_13_12",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLMUKDL-PFR",
		-2.2675,
		40.9011,
		"PLATTS - Refinery - Kenya - Lamu - Kenya Petroleum Refineries Ltd.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		345.8,
		380.25,
		49.12,
		17274.87,
		54.04,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kenya Petroleum Refineries Ltd.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKAKUUM-PFR",
		33.4802,
		71.8749,
		"PLATTS - Refinery - Pakistan - Karak - United Petroleum",
		176.1,
		192.82,
		23.28,
		8461.56,
		25.44,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"UAE Xclera Resources",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLNGLRY-PFR",
		36.4442,
		115.9642,
		"PLATTS - Refinery - China - Liaocheng - Liaocheng Refinery",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Liaocheng Refinery",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLOGLYC-PFR",
		34.700528,
		112.519562,
		"PLATTS - Refinery - China - Luoyang - Luoyang Petrochem. Corp.",
		50,
		52.9,
		6.85,
		2500,
		7.25,
		879.64,
		952.21,
		205.23,
		40848.59,
		220.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		126,
		null,
		17.4,
		6350.47,
		null,
		410.06,
		445.68,
		57.03,
		20709.34,
		61.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		75.6,
		null,
		10.43,
		3806.07,
		null,
		50.4,
		null,
		6.97,
		2544.4,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		0,
		"Active",
		null,
		47.69,
		29.39,
		0,
		9.13,
		9.51,
		12.76,
		43.35454545,
		26.71818182,
		0,
		8.3,
		8.64545455,
		11.6,
		108.48,
	],
	[
		"REFLTEADE-PFR",
		29.64863,
		-95.05563,
		"PLATTS - Refinery - United States - La Porte - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		128.5,
		135.95,
		128.5,
		128.5,
		135.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKGINNP-PFR",
		7.795,
		6.6869,
		"PLATTS - Refinery - Nigeria - Kogi - NNPC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		175.1,
		191.85,
		23.71,
		8617.86,
		25.97,
		"IPMAN",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLTEATS-PFR",
		29.70112,
		-95.07016,
		"PLATTS - Refinery - United States - La Porte - Air Products",
		null,
		null,
		null,
		null,
		null,
		52,
		55.02,
		52,
		52,
		55.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKH2NIO-PFR",
		34.3239,
		47.0736,
		"PLATTS - Refinery - Iran - Kermanshah (2) - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		478.3,
		521.29,
		151.89,
		18931.65,
		164.07,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLVANVA-PFR",
		46.53833,
		16.45359,
		"PLATTS - Refinery - Slovenia - Lendava - Nafte Lendava",
		null,
		null,
		null,
		null,
		null,
		13.5,
		14.49,
		1.85,
		675,
		1.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nafte Lendava",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKHEMIN-PFR",
		49.05714,
		8.32665,
		"PLATTS - Refinery - Germany - Karlsruhe - Mineraloelraffinerie Oberrhein",
		null,
		null,
		null,
		null,
		null,
		1053.93,
		1108.8,
		223.05,
		48158.94,
		233.97,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		266.08,
		null,
		35.41,
		12920.71,
		null,
		5,
		5.29,
		0.69,
		254.17,
		0.74,
		0,
		null,
		0,
		0,
		null,
		165.8,
		null,
		21.55,
		7869.67,
		null,
		83.57,
		null,
		11.53,
		4207.25,
		null,
		16.71,
		null,
		2.31,
		843.78,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_ExxonMobil_Rosneft_Phillips 66 Co.",
		"32.25_25_24_18.75",
		null,
		"Active",
		null,
		112.84,
		94.83,
		14.21,
		15.93,
		10.03,
		23.41,
		41.69376293,
		35.03916642,
		5.25051729,
		5.88604789,
		3.70603015,
		8.64986698,
		271.25,
	],
	[
		"REFLYILNT-PFR",
		35.1441,
		110.6093,
		"PLATTS - Refinery - China - Linyi - Linyi Petroleum Chemical Plant",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Linyi Petroleum Chemical Plant",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKHRNIO-PFR",
		35.2474,
		58.4732,
		"PLATTS - Refinery - Iran - Khoramshahr - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		22.01,
		24.18,
		2.91,
		1055.8,
		3.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLZULZC-PFR",
		36.0621,
		103.8319,
		"PLATTS - Refinery - China - Lanzhou - Lanzhou Petrochemical Corp.",
		77.29,
		81.77,
		10.97,
		4004.66,
		11.61,
		667.48,
		720.83,
		130.71,
		31881.75,
		140.32,
		45.92,
		null,
		6.82,
		2490.73,
		null,
		0,
		null,
		0,
		0,
		null,
		183.7,
		null,
		25.86,
		9439.78,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45.92,
		null,
		6.33,
		2312.09,
		null,
		91.85,
		null,
		12.7,
		4636.96,
		null,
		562.56,
		603.17,
		177.8,
		22284.43,
		189.21,
		"China National Petroleum Corp.",
		"100",
		0,
		"Active",
		null,
		53.45,
		47.15,
		7.6,
		12.47,
		14.54,
		19,
		28.86069114,
		25.45896328,
		4.10367171,
		6.73326134,
		7.85097192,
		10.25917927,
		154.21,
	],
	[
		"REFMAAPTS-PFR",
		-23.641121,
		-46.475644,
		"PLATTS - Refinery - Brazil - Maua - Petrobras - {RECAP - Capuava}",
		null,
		null,
		null,
		null,
		null,
		101.11,
		106.16,
		13.88,
		5045.16,
		14.55,
		21.97,
		null,
		3.26,
		1191.44,
		null,
		0,
		null,
		0,
		0,
		null,
		49.7,
		null,
		7.02,
		2562.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		8.77,
		null,
		1.14,
		416.16,
		null,
		18.96,
		null,
		2.62,
		954.74,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		13.03,
		13.42,
		15.41,
		3.02,
		3.09,
		1.97,
		26.21730382,
		27.00201207,
		31.00603622,
		6.07645875,
		6.21730382,
		3.9637827,
		49.94,
	],
	[
		"REFKLTPRT-PFR",
		1.4297,
		114.7406,
		"PLATTS - Refinery - Indonesia - Kalimantan - Pertamina",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		886.45,
		976.13,
		121.8,
		44296.09,
		134.07,
		"Kuwait Petroleum Corp._SK Corporation_Pertamina",
		"35_35_30",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMAELBR-PFR",
		43.42425,
		4.847395,
		"PLATTS - Refinery - France - Marseille - LyondellBasell Refining",
		null,
		null,
		null,
		null,
		null,
		13,
		13.75,
		1.54,
		560.88,
		1.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lyondell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKNGCPC-PFR",
		22.709888,
		120.315716,
		"PLATTS - Refinery - Taiwan - Kaohsiung - CPC Corporation",
		6,
		6.44,
		0.89,
		324.44,
		0.95,
		0,
		-0.05,
		0,
		-0.03,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CPC Corporation",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKONJKA-PFR",
		46.674934,
		32.568652,
		"PLATTS - Refinery - Ukraine - Kherson - JSC Khersonnefte-Perperabotka",
		225.44,
		246.29,
		31.83,
		11455.82,
		34.75,
		0,
		0,
		0,
		0.13,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kontinium Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKONUTE-PFR",
		46.6413,
		32.6258,
		"PLATTS - Refinery - Ukraine - Kherson - Ukrainian State",
		284.16,
		311.96,
		39.06,
		14196.54,
		42.8,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Ukrainian State",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKR2SGZ-PFR",
		59.4503,
		32.0106,
		"PLATTS - Refinery - Russia - Kirishi (2) - Surgutneftegaz - {Kirishinefteorgsinztez - Kinef}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		651.27,
		711.37,
		126.62,
		30822.34,
		137.54,
		"Surgutneftegaz",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKRKKOD-PFR",
		51.2186,
		51.374,
		"PLATTS - Refinery - Kazakhstan - Karachaganak - Kondensat",
		null,
		null,
		null,
		null,
		null,
		47.52,
		52.23,
		5.77,
		2103.43,
		6.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.78,
		null,
		0.75,
		274.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5.78,
		null,
		0.75,
		274.38,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kondensat",
		"100",
		null,
		"Active",
		null,
		0.61,
		1.39,
		0.23,
		1.18,
		0.05,
		3.02,
		9.28462709,
		21.15677321,
		3.50076104,
		17.96042618,
		0.76103501,
		45.96651446,
		6.48,
	],
	[
		"REFKUKAAM-PFR",
		35.4703,
		44.3957,
		"PLATTS - Refinery - Iraq - Kirkuk - Al Bahram",
		184.1,
		200.22,
		78.68,
		6116.28,
		84.8,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Al Bahram",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFKUMSNA-PFR",
		16.128123,
		32.688842,
		"PLATTS - Refinery - North Sudan - Khartoum - Sudan Petroleum and PetroChina",
		799.16,
		878.36,
		241.92,
		32982.54,
		264.68,
		337.74,
		372.52,
		48.08,
		17200.02,
		53.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		70,
		null,
		9.68,
		3533.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		70,
		null,
		9.68,
		3533.88,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Sudanese Government",
		"50_50",
		null,
		"Active",
		null,
		30.5,
		23.92,
		2.44,
		3.44,
		6.32,
		0,
		43.57142857,
		34.17142857,
		3.48571429,
		4.91428571,
		9.02857143,
		0,
		66.62,
	],
	[
		"REFKUTICO-PFR",
		32.501,
		45.8296,
		"PLATTS - Refinery - Iraq - Kut - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		279.15,
		306.08,
		38.36,
		13943.96,
		42.03,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFKZ2KYZ-PFR",
		45.6234,
		63.2519,
		"PLATTS - Refinery - Kazakhstan - Kyzylorda (2) - Kyzylorda Region Gov.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		2,
		2.15,
		0.27,
		100,
		0.29,
		"Kyzylorda Region Gov.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLACDYP-PFR",
		17.9641,
		102.6134,
		"PLATTS - Refinery - Laos - Vientiane - Laos-China Dongyan Petrochemical Co",
		null,
		null,
		null,
		null,
		null,
		45.03,
		49.61,
		6.31,
		2284.36,
		6.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YunnanProvincial Oversea Investment_Laos State Fuel Company_Yunnan Dongyan Industry_Laos-China Dongyan Petrochemical Co",
		"59_20_16_5",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLCSCGO-PFR",
		30.179219,
		-93.328841,
		"PLATTS - Refinery - United States - Lake Charles - Citgo",
		null,
		null,
		null,
		null,
		null,
		1485.52,
		1562.88,
		259.07,
		70732.72,
		272.93,
		50.3,
		null,
		7.47,
		2728.02,
		null,
		0.55,
		null,
		0.08,
		29.65,
		null,
		252.82,
		null,
		34.99,
		12769.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		56.26,
		null,
		7.32,
		2670.12,
		null,
		102.51,
		null,
		14.14,
		5160.7,
		null,
		43.21,
		null,
		5.98,
		2181.41,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		130,
		179.64,
		3.62,
		46.22,
		19.41,
		1.65,
		33.78729598,
		46.68884499,
		0.94084624,
		12.01268323,
		5.04470319,
		0.42883876,
		380.54,
	],
	[
		"REFLCSCLU-PFR",
		30.13415,
		-93.31882,
		"PLATTS - Refinery - United States - Lake Charles - Calcasieu Refining Co.",
		30,
		31.29,
		4.11,
		1500,
		4.29,
		158.5,
		165.35,
		21.95,
		8018.45,
		22.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		65,
		null,
		8.81,
		3214.16,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		20.22,
		null,
		2.63,
		959.83,
		null,
		44.78,
		null,
		6.18,
		2254.33,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"TransWorld Oil",
		"100",
		0,
		"Active",
		null,
		29.71,
		0.02,
		42.1,
		13.16,
		1.29,
		15.53,
		23.44909234,
		0.01578532,
		33.22809787,
		10.38674033,
		1.01815312,
		12.25730071,
		101.82,
	],
	[
		"REFLCSPEY-PFR",
		30.28781,
		-93.14609,
		"PLATTS - Refinery - United States - Lake Charles - Pelican Refining Company",
		null,
		null,
		null,
		null,
		null,
		23.2,
		25.06,
		3.59,
		1307.88,
		3.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nucoastal",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLDASOG-PFR",
		-8.83606,
		13.463,
		"PLATTS - Refinery - Angola - Luanda - Sonangol - {Sonarel}",
		null,
		null,
		null,
		null,
		null,
		147.14,
		161.06,
		19.93,
		7280.85,
		21.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		47.48,
		null,
		6.57,
		2396.99,
		null,
		41.09,
		45.16,
		5.73,
		2056.2,
		6.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		47.48,
		null,
		6.57,
		2396.99,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonangol_Angolan Govt._Other Investors",
		"60.5_33.3_6.2",
		null,
		"Active",
		null,
		13.3,
		0.27,
		18.86,
		8.88,
		1.19,
		7.41,
		25.6509161,
		0.52073288,
		36.37415622,
		17.12632594,
		2.29508197,
		14.29122469,
		49.9,
	],
	[
		"REFLERHUS-PFR",
		53.289459,
		-110.023106,
		"PLATTS - Refinery - Canada - Lloydminster - Husky Oil",
		null,
		null,
		null,
		null,
		null,
		52.16,
		55.57,
		7.64,
		2785.29,
		8.15,
		23,
		null,
		3.42,
		1247.4,
		null,
		0,
		null,
		0,
		0,
		null,
		23,
		null,
		3.42,
		1247.4,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Husky Oil",
		"100",
		null,
		"Active",
		null,
		3.79,
		0,
		7.95,
		0,
		0.17,
		3.08,
		14.57692308,
		0,
		30.57692308,
		0,
		0.65384615,
		11.84615385,
		14.99,
	],
	[
		"REFLETLDE-PFR",
		41.642232,
		-88.056105,
		"PLATTS - Refinery - United States - Lemont - Linde",
		null,
		null,
		null,
		null,
		null,
		60,
		63.48,
		60,
		60,
		63.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Linde",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLIGERD-PFR",
		52.56247,
		7.304277,
		"PLATTS - Refinery - Germany - Lingen - Erdoel",
		null,
		null,
		null,
		null,
		null,
		436.14,
		460.56,
		170.32,
		15335.76,
		180.09,
		14.1,
		null,
		2.09,
		764.67,
		null,
		0,
		null,
		0,
		0,
		null,
		84.8,
		null,
		11.65,
		4253.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		25.38,
		null,
		3.3,
		1204.57,
		null,
		22.76,
		null,
		3.14,
		1145.84,
		null,
		22.56,
		null,
		3.12,
		1138.85,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		38.5,
		14.47,
		22.43,
		5.13,
		4.67,
		3.77,
		42.67819532,
		16.04035029,
		24.86420574,
		5.68673096,
		5.17680967,
		4.17913757,
		88.97,
	],
	[
		"REFLIOPEC-PFR",
		0.1266,
		-76.7576,
		"PLATTS - Refinery - Ecuador - Lago Agrio - Petroecuador",
		null,
		null,
		null,
		null,
		null,
		1,
		1.07,
		0.14,
		50,
		0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroecuador_Texaco Inc.",
		"62.5_37.5",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLLAYPF-PFR",
		-11.919154,
		-77.130456,
		"PLATTS - Refinery - Peru - La Pampilla - Repsol",
		null,
		null,
		null,
		null,
		null,
		543.04,
		588,
		243.75,
		18306.93,
		259.97,
		29,
		null,
		4.31,
		1572.8,
		null,
		0,
		null,
		0,
		0,
		null,
		58,
		null,
		8.31,
		3036.84,
		null,
		89.78,
		97.36,
		12.55,
		4541.85,
		13.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		29,
		null,
		4.01,
		1464.04,
		null,
		null,
		null,
		null,
		null,
		null,
		"Repsol_Petroperu_Other Investors_Peru Privatization Fund",
		"51_25_14_10",
		null,
		"Active",
		null,
		33.51,
		20.2,
		22.26,
		5.72,
		3.27,
		0,
		38.54382333,
		23.23441454,
		25.60386473,
		6.57925006,
		3.76121463,
		0,
		84.92,
	],
	[
		"REFLNAROL-PFR",
		43.353122,
		-8.446339,
		"PLATTS - Refinery - Spain - La Coruna - Repsol",
		null,
		null,
		null,
		null,
		null,
		394.6,
		414.77,
		91.35,
		17810.82,
		95.75,
		18.54,
		null,
		2.76,
		1005.6,
		null,
		0,
		null,
		0,
		0,
		null,
		55.05,
		null,
		7.6,
		2775.75,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		23.76,
		null,
		3.09,
		1127.58,
		null,
		6.95,
		null,
		0.96,
		350.05,
		null,
		5.79,
		null,
		0.8,
		292.52,
		null,
		null,
		null,
		null,
		null,
		null,
		"Repsol",
		"100",
		0,
		"Active",
		null,
		34.43,
		16.41,
		9.26,
		15.48,
		8.54,
		3.97,
		36.24210526,
		17.27368421,
		9.74736842,
		16.29473684,
		8.98947368,
		4.17894737,
		88.09,
	],
	[
		"REFLOGSEC-PFR",
		34.6557,
		112.421,
		"PLATTS - Refinery - China - Luoyang - Sinopec",
		4,
		4.23,
		0.55,
		200,
		0.58,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFLONNJV-PFR",
		10.9601,
		108.3277,
		"PLATTS - Refinery - Vietnam - Long Son - Nippon and SK Energy JV",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		594.3,
		653.06,
		81.07,
		29483.02,
		89.01,
		"Petro-Vietnam_Siam Cement_Qatar Petroleum_Thai Plastics and Chem",
		"29_28_25_18",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLOVUOL-PFR",
		50.55723,
		13.61069,
		"PLATTS - Refinery - Czech Republic - Litvinov - Unipetrol - {Ceska Rafinerska}",
		null,
		null,
		null,
		null,
		null,
		424.07,
		448.8,
		154.75,
		15914.74,
		163.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		76.21,
		null,
		10.32,
		3765.55,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		24.89,
		null,
		3.24,
		1181.22,
		null,
		49.8,
		null,
		6.87,
		2507.37,
		null,
		1.52,
		null,
		0.21,
		76.96,
		null,
		null,
		null,
		null,
		null,
		null,
		"PKN Orlen",
		"100",
		null,
		"Active",
		null,
		48.97,
		17.75,
		5.05,
		1.97,
		4.41,
		16.83,
		49.96938776,
		18.1122449,
		5.15306122,
		2.01020408,
		4.5,
		17.17346939,
		94.98,
	],
	[
		"REFLSKDCT-PFR",
		52.6042,
		39.5937,
		"PLATTS - Refinery - Russia - Lipetsk - Dobrovsky District",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		453.25,
		501.6,
		61.83,
		22478.71,
		68.42,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dobrovsky District",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLTOSOG-PFR",
		-12.33961,
		13.58601,
		"PLATTS - Refinery - Angola - Lobito - Sonangol",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		517.3,
		566.55,
		70.03,
		25450.86,
		76.7,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonangol",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFLYNCEX-PFR",
		-27.416665,
		153.157616,
		"PLATTS - Refinery - Australia - Lytton - Caltex",
		null,
		null,
		null,
		null,
		null,
		263.46,
		276.4,
		34.91,
		12725.07,
		36.61,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		70,
		null,
		9.18,
		3349.94,
		null,
		null,
		null,
		null,
		null,
		null,
		7,
		null,
		0.94,
		341.58,
		null,
		57,
		null,
		7.41,
		2705.46,
		null,
		0,
		null,
		0,
		0,
		null,
		6,
		null,
		0.83,
		302.9,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron_Other Investors",
		"50_50",
		null,
		"Active",
		null,
		43.98,
		47.67,
		2.92,
		20.43,
		4.59,
		1.03,
		36.65,
		39.725,
		2.43333333,
		17.025,
		3.825,
		0.85833333,
		120.62,
	],
	[
		"REFMABKNP-PFR",
		29.003914,
		48.153387,
		"PLATTS - Refinery - Kuwait - Mina Abdulla - Kuwait National Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		2028.96,
		2215,
		801.33,
		74565.97,
		864.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		256,
		null,
		35.31,
		12888.27,
		null,
		30,
		32.21,
		4.11,
		1500,
		4.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		256,
		null,
		35.31,
		12888.27,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		96.67,
		0,
		26.28,
		53.98,
		1.07,
		78.19,
		36.61742424,
		0,
		9.95454545,
		20.4469697,
		0.40530303,
		29.61742424,
		256.19,
	],
	[
		"REFMAOFPC-PFR",
		23.799902,
		120.199459,
		"PLATTS - Refinery - Taiwan - Mailiao - Formosa Petrochemical Co.",
		90,
		95.08,
		12.39,
		4522.16,
		13.09,
		1689.62,
		1791.17,
		488.84,
		71957.22,
		517.72,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		424.06,
		null,
		57.98,
		21162.79,
		null,
		null,
		null,
		null,
		null,
		null,
		53.33,
		null,
		7.13,
		2602.53,
		null,
		36.06,
		null,
		4.69,
		1711.5,
		null,
		334.67,
		null,
		46.16,
		16848.76,
		null,
		0,
		null,
		0,
		0,
		null,
		484.92,
		512.89,
		114.94,
		23051.4,
		121.58,
		"Formosa Plastics",
		"100",
		null,
		"Active",
		null,
		182.01,
		131.5,
		42.96,
		49.67,
		-2.23,
		109.87,
		35.00192308,
		25.28846154,
		8.26153846,
		9.55192308,
		-0.42884615,
		21.12884615,
		513.78,
	],
	[
		"REFMASCET-PFR",
		23.0469,
		-81.5786,
		"PLATTS - Refinery - Cuba - Matanzas - Cupet",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		630.48,
		691.43,
		137.92,
		29414.56,
		150.09,
		"Cupet_PDVSA",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMATMEN-PFR",
		33.848543,
		132.709418,
		"PLATTS - Refinery - Japan - Matsuyama - Maruzen",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Maruzen_Unocal",
		"67.1_32.9",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMAUCIC-PFR",
		43.6923,
		51.3047,
		"PLATTS - Refinery - Kazakhstan - Mangistau - CITIC",
		null,
		null,
		null,
		null,
		null,
		53.02,
		57.95,
		7.21,
		2625.33,
		7.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CITIC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMBIGOL-PFR",
		1.5773,
		9.7832,
		"PLATTS - Refinery - Equatorial Guinea - Mbini - GE Petrol",
		123.56,
		135.81,
		16.65,
		6053.03,
		18.31,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"GE Petrol",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMDAZRO-PFR",
		-5.968688,
		12.420322,
		"PLATTS - Refinery - Democratic Rep. of the Congo - Moanda - Zairo-Italian Society Refinery",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.01,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zairo-Italian Society Refinery",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMEOAAP-PFR",
		-34.875825,
		-56.2299,
		"PLATTS - Refinery - Uruguay - Montevideo - ANCAP",
		42.63,
		46.46,
		7.1,
		2362.04,
		7.74,
		197.82,
		217.47,
		27.25,
		9931.35,
		29.97,
		3.9,
		null,
		0.58,
		211.52,
		null,
		0,
		null,
		0,
		0,
		null,
		39,
		null,
		5.37,
		1961.77,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5.85,
		null,
		0.76,
		277.67,
		null,
		29.25,
		null,
		4.03,
		1472.59,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ANCAP",
		"100",
		null,
		"Active",
		null,
		13.08,
		12.87,
		5.59,
		2.23,
		3.15,
		0,
		31.90243902,
		31.3902439,
		13.63414634,
		5.43902439,
		7.68292683,
		0,
		36.92,
	],
	[
		"REFMHAIND-PFR",
		27.37846,
		77.686623,
		"PLATTS - Refinery - India - Mathura - Indian Oil Corp. - {Uttar Pradesh}",
		65.35,
		71.64,
		11.29,
		3627.97,
		12.35,
		685.48,
		748.59,
		221.3,
		26785.97,
		239.23,
		5.45,
		null,
		0.81,
		295.4,
		null,
		11.91,
		null,
		1.77,
		645.22,
		null,
		170.21,
		null,
		23.14,
		8447.12,
		null,
		null,
		null,
		null,
		null,
		null,
		15.15,
		null,
		2.03,
		739.19,
		null,
		57.87,
		null,
		7.53,
		2746.77,
		null,
		67.91,
		null,
		9.37,
		3419.04,
		null,
		11.91,
		null,
		1.65,
		601.49,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		76.48,
		41.28,
		12.03,
		19.31,
		12.48,
		4.86,
		40.90714591,
		22.07958922,
		6.43453145,
		10.32841249,
		6.67522465,
		2.59948652,
		166.44,
	],
	[
		"REFMHKSUN-PFR",
		39.812307,
		-75.426854,
		"PLATTS - Refinery - United States - Marcus Hook - Sunoco",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sunoco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMILRNE-PFR",
		45.4668,
		9.1905,
		"PLATTS - Refinery - Italy - Milan - Rondine",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rondine",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMINANI-PFR",
		36.821687,
		34.700953,
		"PLATTS - Refinery - Turkey - Mersin - Anadolu Tasfiyehanesi",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		0,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_Shell_Marmara Refining Co",
		"68_27_5",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMISVRO-PFR",
		35.08548,
		-90.08274,
		"PLATTS - Refinery - United States - Memphis - Valero",
		null,
		null,
		null,
		null,
		null,
		556.13,
		584.66,
		99.72,
		25457.07,
		105.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		109,
		null,
		14.91,
		5441.18,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		20.39,
		null,
		2.65,
		967.91,
		null,
		0,
		null,
		0,
		0,
		null,
		88.61,
		null,
		12.26,
		4473.27,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		39.58,
		85.2,
		4.39,
		12.01,
		0.9,
		1.61,
		27.42896743,
		59.04365904,
		3.04227304,
		8.32293832,
		0.62370062,
		1.11573112,
		143.69,
	],
	[
		"COPAK 2",
		24.9284,
		66.712,
		"PLATTS - Refinery - Pakistan - Mouza Kund - Cinergyco PK Limited - {Karachi, ORC I}",
		null,
		null,
		null,
		null,
		null,
		60.6,
		66.01,
		12.22,
		2641.4,
		13.17,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45,
		null,
		6.17,
		2251.58,
		null,
		null,
		null,
		null,
		null,
		null,
		9,
		null,
		1.2,
		439.17,
		null,
		0,
		null,
		0,
		0,
		null,
		36,
		null,
		4.97,
		1812.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Byco Petroleum",
		"100",
		null,
		"Active",
		null,
		16.91,
		6.48,
		17.41,
		0.88,
		1.7,
		3.07,
		34.51020408,
		13.2244898,
		35.53061224,
		1.79591837,
		3.46938776,
		6.26530612,
		46.44,
	],
	[
		"REFMMOABN-PFR",
		55.634058,
		13.023599,
		"PLATTS - Refinery - Sweden - Malmo - A.B. Nynas",
		null,
		null,
		null,
		null,
		null,
		0.02,
		-0.02,
		-0.01,
		0.02,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Axel Johnson_PDVSA",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMMUGTD-PFR",
		30.203225,
		-92.595023,
		"PLATTS - Refinery - United States - Mermentau - Gold Line Refining Ltd",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Discovery Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMNACTV-PFR",
		33.3244,
		44.4557,
		"PLATTS - Refinery - Iraq - Muthanna - Cityview Corp",
		30,
		32.21,
		4.11,
		1500,
		4.41,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cityview Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMODCNY-PFR",
		27.196204,
		30.991163,
		"PLATTS - Refinery - Egypt - Mostorod - Cairo Oil Refining Company - {Mostorod}",
		495.04,
		544.61,
		280.85,
		12954.18,
		306.8,
		245.27,
		268.8,
		32.49,
		11843.89,
		35.57,
		42.24,
		null,
		6.27,
		2290.88,
		null,
		0,
		null,
		0,
		0,
		null,
		128,
		null,
		18.11,
		6608.45,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		85.76,
		null,
		11.82,
		4317.58,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qalaa Holdings_EGPC",
		"85_15",
		null,
		"Active",
		null,
		23.4,
		23.55,
		46.87,
		10.38,
		2.07,
		2.94,
		21.18413905,
		21.31993482,
		42.43164947,
		9.39706681,
		1.87398153,
		2.66159696,
		109.22,
	],
	[
		"REFMODEY2-PFR",
		30.13463,
		31.29968,
		"PLATTS - Refinery - Egypt - Mostorod - Egypt Refining Company - {Mostorod}",
		84.01,
		91.53,
		11.5,
		4200,
		12.54,
		264.64,
		290.27,
		124.48,
		8728.15,
		135.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Qatar Petroleum_EGPC_Qalaa Holdings",
		"30.7_28.32_27.84_13.14",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMODEYP-PFR",
		30.1423,
		31.2992,
		"PLATTS - Refinery - Egypt - Mostorod - Egypt Refining Company",
		403.26,
		443.12,
		216.98,
		11396.22,
		236.93,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Qatar Petroleum_EGPC_Citadel Capital",
		"36.6_27.9_23.8_11.7",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOHSIR-PFR",
		33.686784,
		-7.426437,
		"PLATTS - Refinery - Morocco - Mohammedia - SAMIR",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SAMIR",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOKMOC-PFR",
		41.805451,
		-87.811953,
		"PLATTS - Refinery - United States - McCook - Motor Oils Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Motor Oils Refining Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMRGDAG-PFR",
		52.385335,
		9.845963,
		"PLATTS - Refinery - Germany - Misburg - Deurag-Nerag",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		0.02,
		-0.02,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Exxon Corp._Shell",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMRLEIK-PFR",
		51.682769,
		7.100678,
		"PLATTS - Refinery - Germany - Marl - Evonik",
		null,
		null,
		null,
		null,
		null,
		9,
		9.52,
		1.06,
		388.29,
		1.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Evonik",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMRYCLK-PFR",
		30.05554,
		-90.64882,
		"PLATTS - Refinery - United States - Mount Airy - Clark",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Apex Oil Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMTITUM-PFR",
		47.978298,
		-101.933186,
		"PLATTS - Refinery - United States - Makoti - Thunder Butte Petroleum",
		48.53,
		50.86,
		13.52,
		2012.55,
		14.25,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Three Affiliated Tribes",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFODOCED-PFR",
		7.021,
		5.0567,
		"PLATTS - Refinery - Nigeria - Ondo - Covenant Ground Refinery Limited",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		276.12,
		302.34,
		36.42,
		13240.08,
		39.9,
		"Covenant Ground Refinery Limited_Ondo State Government",
		"95_5",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFOEMTNT-PFR",
		38.0641,
		53.8441,
		"PLATTS - Refinery - Turkmenistan - Okarem - Turkmenistan Government",
		595.8,
		654.75,
		81.29,
		29559.64,
		89.25,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Turkmenistan Government",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOIEGAR-PFR",
		35.41852,
		-119.01,
		"PLATTS - Refinery - United States - Oildale - Golden Bear",
		null,
		null,
		null,
		null,
		null,
		18.12,
		19.27,
		2.72,
		990.25,
		2.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Witco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMAYMRE-PFR",
		21.9588,
		96.0891,
		"PLATTS - Refinery - Myanmar - Mandalay - Myanmar Petrochemical Enterpr.",
		45,
		47.61,
		6.16,
		2250,
		6.53,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Myanmar Petrochemical Enterpr.",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFOIGUAZ-PFR",
		40.428675,
		71.512753,
		"PLATTS - Refinery - Uzbekistan - Oltiarig - Uzbekneftegaz - {Altyarik}",
		null,
		null,
		null,
		null,
		null,
		75.86,
		81.58,
		10.53,
		3842.03,
		11.33,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		9.7,
		null,
		1.34,
		488.44,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		9.7,
		null,
		1.34,
		488.44,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Uzbekneftegaz",
		"100",
		null,
		"Active",
		null,
		4.04,
		4.09,
		0.84,
		0.62,
		0.11,
		0.02,
		41.64948454,
		42.16494845,
		8.65979381,
		6.39175258,
		1.13402062,
		0.20618557,
		9.72,
	],
	[
		"REFMCKCNA-PFR",
		51.020199,
		2.260024,
		"PLATTS - Refinery - France - Mardyck - Cie De Raff. Et Distrib.Total Fina",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0.01,
		-0.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOKAJNO-PFR",
		34.532194,
		135.414126,
		"PLATTS - Refinery - Japan - Osaka - ENEOS",
		null,
		null,
		null,
		null,
		null,
		0.05,
		0,
		-0.01,
		0.03,
		0.06,
		1.92,
		null,
		0.29,
		103.95,
		null,
		2.06,
		null,
		0.31,
		111.88,
		null,
		81.73,
		null,
		11.18,
		4081.6,
		null,
		null,
		null,
		null,
		null,
		null,
		32,
		null,
		4.28,
		1561.49,
		null,
		0,
		null,
		0,
		0,
		null,
		37.45,
		null,
		5.16,
		1885.51,
		null,
		8.29,
		null,
		1.15,
		418.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"51",
		null,
		"Active",
		null,
		18.7,
		31.92,
		19.2,
		16.63,
		-0.47,
		9.73,
		18.77133106,
		32.04175868,
		19.27323831,
		16.69343505,
		-0.47179281,
		9.76711504,
		95.69,
	],
	[
		"REFMDNMUM-PFR",
		46.85225,
		-100.88,
		"PLATTS - Refinery - United States - Mandan - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		164.91,
		173.45,
		21.81,
		7957.62,
		22.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		68.36,
		null,
		8.91,
		3252.75,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		65.58,
		null,
		8.53,
		3112.61,
		null,
		2.78,
		null,
		0.38,
		140.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tesoro",
		"100",
		null,
		"Active",
		null,
		22.92,
		49.85,
		0.65,
		4.49,
		-1.47,
		0.02,
		31.00649351,
		67.43777056,
		0.879329,
		6.0741342,
		-1.98863636,
		0.02705628,
		76.46,
	],
	[
		"REFOLEVNS-PFR",
		30.29173,
		-94.97804,
		"PLATTS - Refinery - United States - Oakdale - Virtual Engineering Operations",
		40,
		41.72,
		5.48,
		2000,
		5.72,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Virtual Engineering Operations",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMEANOR-PFR",
		44.959656,
		18.313065,
		"PLATTS - Refinery - Bosnia-Herzegovina - Modrica - Neftegazinkor",
		0.6,
		0.63,
		0.08,
		30,
		0.09,
		10.28,
		11.12,
		1.51,
		553.22,
		1.65,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Neftegazinkor_Bosnia Herzegovina State Co.",
		"75.6_24.4",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOLOEXM-PFR",
		59.316867,
		10.515178,
		"PLATTS - Refinery - Norway - Oslo - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94,
		null,
		12.42,
		4533,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		70,
		null,
		9.1,
		3322.5,
		null,
		8,
		null,
		1.1,
		402.76,
		null,
		16,
		null,
		2.21,
		807.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		50.68,
		23.69,
		17.31,
		6.37,
		3.86,
		1.65,
		47.32909974,
		22.12364587,
		16.16548375,
		5.94882331,
		3.60478147,
		1.540904,
		103.56,
	],
	[
		"REFMEUATS-PFR",
		29.855495,
		-94.91179,
		"PLATTS - Refinery - United States - Mont Belvieu - Air Products",
		null,
		null,
		null,
		null,
		null,
		29,
		30.68,
		29,
		29,
		30.68,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOMSASP-PFR",
		24.3446,
		56.7425,
		"PLATTS - Refinery - Oman - Sohar - Sohar Asphalt",
		null,
		null,
		null,
		null,
		null,
		17,
		18.25,
		2.72,
		992.8,
		2.92,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sohar Asphalt",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMEZATS-PFR",
		38.027901,
		-122.065147,
		"PLATTS - Refinery - United States - Martinez - Air Products",
		null,
		null,
		null,
		null,
		null,
		35,
		37.03,
		35,
		35,
		37.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOOSZCO-PFR",
		39.6081,
		109.7764,
		"PLATTS - Refinery - China - Ordos - Zhong Tian He Chuang Co",
		null,
		null,
		null,
		null,
		null,
		0.2,
		0.21,
		0.02,
		8.63,
		0.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zhong Tian He Chuang Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMB2BHR-PFR",
		18.9388,
		72.8353,
		"PLATTS - Refinery - India - Mumbai (2) - Bharat Petroleum",
		938.45,
		1032.28,
		130.8,
		46849.53,
		143.73,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bharat Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMEZMUM-PFR",
		38.024494,
		-122.063914,
		"PLATTS - Refinery - United States - Martinez - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		54.48,
		58.43,
		7.73,
		2800.36,
		8.25,
		26.65,
		null,
		3.96,
		1445.44,
		null,
		3.16,
		null,
		0.47,
		171.12,
		null,
		39.3,
		null,
		5.71,
		2085.35,
		null,
		null,
		null,
		null,
		null,
		null,
		2.39,
		null,
		0.32,
		116.79,
		null,
		2.03,
		null,
		0.26,
		96.38,
		null,
		0.84,
		null,
		0.12,
		42.5,
		null,
		4.22,
		null,
		0.58,
		213.13,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		36.79,
		88.27,
		1.75,
		19.09,
		-3.98,
		0,
		25.02550847,
		60.04353445,
		1.19039521,
		12.98551119,
		-2.70729882,
		0,
		141.92,
	],
	[
		"REFORKFST-PFR",
		51.259485,
		58.526656,
		"PLATTS - Refinery - Russia - Orsk - ForteInvest",
		-91,
		-96.7,
		-13.92,
		-5086.03,
		-14.82,
		636.75,
		698.35,
		156.49,
		27962.47,
		169.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		90.88,
		null,
		12.03,
		4390.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		64,
		null,
		8.32,
		3037.71,
		null,
		26.88,
		null,
		3.71,
		1353.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SAFMAR Group",
		"90",
		null,
		"Active",
		null,
		31.01,
		18.29,
		23.73,
		8.19,
		3.79,
		5.2,
		32.70062217,
		19.28714542,
		25.02372667,
		8.63650743,
		3.99662554,
		5.48349678,
		90.21,
	],
	[
		"REFOSAEON-PFR",
		31.819892,
		-102.335873,
		"PLATTS - Refinery - United States - Odessa - Equilon",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Texaco Inc.",
		"56_44",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMCADAZ-PFR",
		42.983,
		47.5049,
		"PLATTS - Refinery - Russia - Makhachkala - Dagneftegaz",
		null,
		null,
		null,
		null,
		null,
		4,
		4.29,
		0.55,
		200,
		0.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.83,
		null,
		0.39,
		142.44,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.83,
		null,
		0.39,
		142.44,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dagneftegaz",
		"100",
		null,
		"Active",
		null,
		0.91,
		0,
		1.33,
		0,
		0,
		0.68,
		30.43478261,
		0,
		44.48160535,
		0,
		0,
		22.74247492,
		2.92,
	],
	[
		"REFMIMDLL-PFR",
		51.10339,
		6.887237,
		"PLATTS - Refinery - Germany - Monheim - Deutsche Shell",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMDIPNE-PFR",
		13.5012,
		7.1025,
		"PLATTS - Refinery - Niger - Maradi - Petro One",
		1333.45,
		1464.88,
		222.54,
		63227.21,
		244.14,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro One",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMJNNXL-PFR",
		38.42072667,
		106.11948224,
		"PLATTS - Refinery - China - Majiatan - Ningxia Petrochemical",
		null,
		null,
		null,
		null,
		null,
		303.14,
		329.06,
		41.67,
		15170.2,
		45.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		76.91,
		null,
		10.64,
		3882.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		76.91,
		null,
		10.64,
		3882.93,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		26.68,
		28.33,
		9,
		5.4,
		8.53,
		12.72,
		29.34447866,
		31.15926089,
		9.89881214,
		5.93928729,
		9.38187418,
		13.99032116,
		90.65,
	],
	[
		"REFMAWMLT-PFR",
		50.389013,
		-105.5196,
		"PLATTS - Refinery - Canada - Moose Jaw - Moose Jaw Asphalt",
		null,
		null,
		null,
		null,
		null,
		40.12,
		42.75,
		5.83,
		2129.15,
		6.23,
		10,
		null,
		1.49,
		542.35,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.49,
		542.35,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Moose Jaw Asphalt",
		"100",
		null,
		"Active",
		null,
		0.94,
		0,
		3.99,
		0.16,
		0.08,
		1.5,
		7.23076923,
		0,
		30.69230769,
		1.23076923,
		0.61538462,
		11.53846154,
		6.67,
	],
	[
		"REFPBYIIL-PFR",
		-9.455667,
		147.114798,
		"PLATTS - Refinery - Papua New Guinea - Port Moresby - Interoil",
		75.05,
		80.03,
		17.93,
		2886.33,
		19.18,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Interoil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMEUAT2-PFR",
		29.857145,
		-94.913471,
		"PLATTS - Refinery - United States - Mont Belvieu - Air Products",
		null,
		null,
		null,
		null,
		null,
		40,
		42.32,
		40,
		40,
		42.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"COPAK 1",
		24.9284,
		66.712,
		"PLATTS - Refinery - Pakistan - Mouza Kund (2) - Cinergyco PK Limited - {ORC II}",
		null,
		null,
		null,
		null,
		null,
		390.23,
		431.29,
		52.5,
		19079.23,
		57.97,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		537.71,
		589.08,
		147.77,
		22601.18,
		160.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cinergyco PK Limited",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPCMPUS-PFR",
		49.37797,
		1.017973,
		"PLATTS - Refinery - France - Petit Couronne - Petroplus",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		0.04,
		0.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroplus",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMBESLU-PFR",
		30.79035,
		-88.05646,
		"PLATTS - Refinery - United States - Mobile - Vertex Energy Inc.",
		null,
		null,
		null,
		null,
		null,
		222.59,
		233.91,
		39.05,
		10395.69,
		41.09,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30.22,
		null,
		3.93,
		1434.49,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		30.22,
		null,
		3.93,
		1434.49,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vertex Energy Inc.",
		"100",
		null,
		"Active",
		null,
		10.19,
		7.71,
		9.92,
		4.17,
		1.62,
		0,
		26.53645833,
		20.078125,
		25.83333333,
		10.859375,
		4.21875,
		0,
		33.6,
	],
	[
		"REFMBOPDV-PFR",
		10.509101,
		-71.640162,
		"PLATTS - Refinery - Venezuela - Maracaibo - PDVSA - {Bajo Grande}",
		null,
		null,
		null,
		null,
		null,
		30.79,
		33.05,
		4.5,
		1643.5,
		4.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMEUESE-PFR",
		29.855495,
		-94.91179,
		"PLATTS - Refinery - United States - Mont Belvieu - Enterprise",
		null,
		null,
		null,
		null,
		null,
		15.68,
		16.61,
		1.65,
		592.16,
		1.72,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Enterprise",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMNGGOC-PFR",
		4.3348,
		100.6343,
		"PLATTS - Refinery - Malaysia - Manjung - Gulf Oil Corp.",
		419.23,
		444.09,
		58.05,
		21104.7,
		61.46,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gulf Oil Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMDASFR-PFR",
		-5.96922,
		12.422747,
		"PLATTS - Refinery - Democratic Rep. of the Congo - Moanda - Soc. Congo-Italienne De Raff.",
		91.47,
		100.09,
		12.08,
		4385.23,
		13.22,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Congo Govt.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMDOPET-PFR",
		-17.0293,
		-72.0155,
		"PLATTS - Refinery - Peru - Mollendo - Petroperu",
		153.75,
		169.14,
		22.48,
		7820.85,
		24.67,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroperu",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPDYPDA-PFR",
		49.279589,
		-122.883932,
		"PLATTS - Refinery - Canada - Port Moody - Petro-Canada",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0.02,
		-0.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Canada",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMFUJNO-PFR",
		34.203041,
		132.24193,
		"PLATTS - Refinery - Japan - Marifu - ENEOS",
		null,
		null,
		null,
		null,
		null,
		532.82,
		561.31,
		188.02,
		20344.65,
		196.92,
		2,
		null,
		0.3,
		108.47,
		null,
		2.16,
		null,
		0.32,
		116.75,
		null,
		85.98,
		null,
		11.76,
		4293.64,
		null,
		null,
		null,
		null,
		null,
		null,
		34,
		null,
		4.55,
		1659.09,
		null,
		0,
		null,
		0,
		0,
		null,
		36.08,
		null,
		4.98,
		1816.22,
		null,
		11.75,
		null,
		1.62,
		593.11,
		null,
		null,
		null,
		null,
		null,
		null,
		"JXTG Nippon Oil & Energy",
		"100",
		null,
		"Active",
		null,
		32.31,
		24.78,
		3.9,
		18.83,
		9.71,
		11.67,
		30.66337667,
		23.51713011,
		3.70124324,
		17.87036158,
		9.21514663,
		11.07525861,
		101.19,
	],
	[
		"REFMOGMAR-PFR",
		21.824153,
		110.844833,
		"PLATTS - Refinery - China - Maoming - Maoming Refining and Chemical Corp.",
		1275.4,
		1371.58,
		351.82,
		54591.79,
		375.26,
		1910.65,
		2053.41,
		640.21,
		75178.99,
		681.78,
		95.99,
		null,
		14.26,
		5206.09,
		null,
		0,
		null,
		0,
		0,
		null,
		383.97,
		null,
		53.98,
		19704.17,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		287.98,
		null,
		39.72,
		14498.07,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		119.52,
		95.7,
		2.04,
		65.82,
		29.37,
		55.7,
		30.23602924,
		24.21007362,
		0.5160768,
		16.65106631,
		7.42998811,
		14.09092059,
		368.14,
	],
	[
		"REFMEPUWN-PFR",
		-3.6943,
		128.1826,
		"PLATTS - Refinery - Indonesia - Maluku (Province) - Unknown",
		20,
		21.47,
		2.74,
		1000,
		2.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMENMED-PFR",
		51.738355,
		-5.063158,
		"PLATTS - Refinery - United Kingdom - Milford Haven - Murco Petroleum Limited",
		null,
		null,
		null,
		null,
		null,
		5.99,
		6.37,
		0.67,
		243.31,
		0.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Murphy Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMIBYMH-PFR",
		15.420418,
		45.338677,
		"PLATTS - Refinery - Yemen - Marib - Yemen Hunt Oil",
		47.5,
		52.28,
		6.42,
		2325.02,
		7.05,
		12.5,
		13.55,
		1.66,
		607.23,
		1.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hunt Refining Consolidated_Other Investors",
		"75.5_24.5",
		null,
		"Active",
		null,
		0.4,
		0.2,
		0.09,
		0.1,
		0.09,
		0.1,
		40.4040404,
		20.2020202,
		9.09090909,
		10.1010101,
		9.09090909,
		10.1010101,
		0.99,
	],
	[
		"REFPENSLS-PFR",
		13.2127,
		109.0834,
		"PLATTS - Refinery - Vietnam - Phu Yen - SP Chemicals",
		10,
		10.74,
		1.37,
		500,
		1.47,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SP Chemicals",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMEZSSA-PFR",
		38.019613,
		-122.116748,
		"PLATTS - Refinery - United States - Martinez - PBF Energy Company LLC",
		-21.59,
		-23.18,
		-3.45,
		-1260.86,
		-3.71,
		843.14,
		888.39,
		291.73,
		32747.05,
		306.8,
		38.12,
		null,
		5.66,
		2067.4,
		null,
		0,
		null,
		0,
		0,
		null,
		99,
		null,
		14.05,
		5129.04,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.33,
		null,
		0.17,
		63.14,
		null,
		56.3,
		null,
		7.77,
		2834.32,
		null,
		3.25,
		null,
		0.45,
		164.18,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		26.69,
		57.96,
		0.8,
		23.24,
		-2.71,
		0,
		24.30119275,
		52.77246654,
		0.72839843,
		21.15997451,
		-2.46744969,
		0,
		105.97,
	],
	[
		"REFMOLKCI-PFR",
		45.634052,
		-73.521803,
		"PLATTS - Refinery - Canada - Montreal - Kemtec Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.01,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lavalin",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMGEMEZ-PFR",
		12.8698,
		74.843,
		"PLATTS - Refinery - India - Mangalore - Mangalore SEZ",
		764,
		837.17,
		110.26,
		38782.71,
		120.72,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ONGC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMJNPTC-PFR",
		38.479469,
		106.06125,
		"PLATTS - Refinery - China - Majiatan - PetroChina",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPESOAL-PFR",
		8.2726,
		-82.8604,
		"PLATTS - Refinery - Panama - Puerto Armuelles - Occidental",
		1341.98,
		1411.66,
		282.56,
		61824.32,
		297.82,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Occidental_Qatar Petroleum",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMI2JNO-PFR",
		34.492562,
		133.753454,
		"PLATTS - Refinery - Japan - Mizushima (2) - ENEOS - {Mizushima 'B'}",
		-90,
		-95.22,
		-12.33,
		-4500,
		-13.04,
		752.2,
		796.37,
		105.83,
		38120.3,
		112.07,
		5.34,
		null,
		0.79,
		289.43,
		null,
		5.75,
		null,
		0.85,
		311.53,
		null,
		228.55,
		null,
		31.18,
		11379.01,
		null,
		null,
		null,
		null,
		null,
		null,
		93.28,
		null,
		12.47,
		4551.86,
		null,
		10,
		null,
		1.3,
		474.64,
		null,
		90.83,
		null,
		12.53,
		4572.97,
		null,
		23.35,
		null,
		3.23,
		1178.59,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		null,
		"Active",
		null,
		80.74,
		52.72,
		34.63,
		48.71,
		7.04,
		38.73,
		28.95359679,
		18.905544,
		12.41841784,
		17.46754644,
		2.5245643,
		13.88868967,
		262.56,
	],
	[
		"REFMOLSUR-PFR",
		45.641806,
		-73.52173,
		"PLATTS - Refinery - Canada - Montreal - Suncor",
		25.11,
		26.96,
		4.11,
		1460.11,
		4.41,
		460.64,
		487.12,
		108.98,
		20496.71,
		115.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		131,
		null,
		17.44,
		6366.54,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		81.75,
		null,
		10.63,
		3880.29,
		null,
		0,
		null,
		0,
		0,
		null,
		49.25,
		null,
		6.81,
		2486.25,
		null,
		null,
		null,
		null,
		null,
		null,
		"Suncor",
		"100",
		null,
		"Active",
		null,
		50.79,
		46.61,
		1.32,
		8.65,
		2.9,
		8.57,
		38.18796992,
		35.04511278,
		0.9924812,
		6.5037594,
		2.18045113,
		6.44360902,
		118.84,
	],
	[
		"REFMGEMMP-PFR",
		12.9869,
		74.847388,
		"PLATTS - Refinery - India - Mangalore - Mangalore Refinery And Petrochem.",
		14,
		15.03,
		1.91,
		700,
		2.06,
		1112.75,
		1216.83,
		347,
		44884.46,
		373.57,
		5.88,
		null,
		0.88,
		319,
		null,
		8.31,
		null,
		1.23,
		449.68,
		null,
		228.35,
		null,
		31.2,
		11386.89,
		null,
		497.38,
		543.84,
		102.11,
		23374.94,
		110.95,
		24.22,
		null,
		3.24,
		1181.8,
		null,
		44.29,
		null,
		5.76,
		2102.01,
		null,
		137.36,
		null,
		18.95,
		6915.19,
		null,
		8.31,
		null,
		1.15,
		419.21,
		null,
		null,
		null,
		null,
		null,
		null,
		"ONGC_Other Investors_Indian Government",
		"72_19_9",
		null,
		"Active",
		null,
		158.3,
		28.15,
		0.98,
		31.69,
		26.6,
		43.57,
		52.94314381,
		9.41471572,
		0.3277592,
		10.59866221,
		8.89632107,
		14.57190635,
		289.27,
	],
	[
		"REFMLGQIN-PFR",
		31.77026,
		116.616628,
		"PLATTS - Refinery - China - Maling - Qingyang Petrochemical",
		160.99,
		174.24,
		21.72,
		7906.36,
		23.53,
		179.89,
		194.47,
		24.18,
		8804.95,
		26.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		63.12,
		null,
		8.47,
		3091.43,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		31.56,
		null,
		4.1,
		1498.06,
		null,
		0,
		null,
		0,
		0,
		null,
		31.56,
		null,
		4.37,
		1593.37,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		18.12,
		17.74,
		0.45,
		3.77,
		8.68,
		7.95,
		31.90702588,
		31.237894,
		0.79239303,
		6.63849269,
		15.28438105,
		13.99894348,
		56.7,
	],
	[
		"REFMONNRA-PFR",
		38.34873,
		-97.67226,
		"PLATTS - Refinery - United States - McPherson - NCRA",
		null,
		null,
		null,
		null,
		null,
		487.73,
		513.8,
		161.46,
		18508.09,
		170.49,
		43.05,
		null,
		6.4,
		2334.89,
		null,
		0,
		null,
		0,
		0,
		null,
		95.44,
		null,
		13.21,
		4821.53,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		52.39,
		null,
		6.81,
		2486.64,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CHS",
		"100",
		null,
		"Active",
		null,
		42.45,
		54.98,
		0.29,
		3.95,
		2.19,
		0.6,
		40.62200957,
		52.61244019,
		0.27751196,
		3.77990431,
		2.09569378,
		0.57416268,
		104.46,
	],
	[
		"REFMLEMNC-PFR",
		31.128,
		-92.0662,
		"PLATTS - Refinery - United States - Marksville - Magna International Develop. Inc",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		697.2,
		731.99,
		205.43,
		28680.27,
		216.6,
		"Magna International Develop. Inc",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMIALNY-PFR",
		6.332724,
		-10.727885,
		"PLATTS - Refinery - Liberia - Monrovia - Liberia Petroleum Company",
		21,
		23.05,
		2.8,
		1020.66,
		3.06,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Liberia Petroleum Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMMAJNO-PFR",
		34.506903,
		133.728139,
		"PLATTS - Refinery - Japan - Mizushima - ENEOS - {Mizushima 'A'}",
		30,
		31.74,
		4.29,
		1566.52,
		4.54,
		707.92,
		749.05,
		96.5,
		35070.96,
		102.12,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOSGLP-PFR",
		41.20494,
		-8.706322,
		"PLATTS - Refinery - Portugal - Matosinhos - GALP",
		null,
		null,
		null,
		null,
		null,
		82.07,
		85.55,
		82.05,
		83.14,
		85.49,
		7.36,
		null,
		1.1,
		399.5,
		null,
		1.85,
		null,
		0.27,
		99.73,
		null,
		74.73,
		null,
		10.08,
		3678.25,
		null,
		null,
		null,
		null,
		null,
		null,
		4.59,
		null,
		0.61,
		224.66,
		null,
		39.73,
		null,
		5.17,
		1886.26,
		null,
		7.36,
		null,
		1.01,
		370.84,
		null,
		13.8,
		null,
		1.9,
		697.26,
		null,
		null,
		null,
		null,
		null,
		null,
		"Grupo Amorim_Portugese Government_ENI_Other Investors",
		"38.3_30_21.6_10.1",
		null,
		"Active",
		null,
		23.84,
		10.97,
		24.41,
		8.25,
		1.6,
		5.93,
		29.3740759,
		13.5165106,
		30.07639231,
		10.16510596,
		1.97141449,
		7.30655495,
		75.04,
	],
	[
		"REFMNDSGR-PFR",
		-0.8102,
		12.7311,
		"PLATTS - Refinery - Gabon - Mandji Island - Soc. Gabonaise De Raffinage",
		159.1,
		174.28,
		47.68,
		6443.4,
		52.08,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gabon Government_SK Corporation",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPHTOEL-PFR",
		4.7677,
		7.0189,
		"PLATTS - Refinery - Nigeria - Port Harcourt - OMEL",
		454.24,
		497.54,
		62.28,
		22650.5,
		68.26,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ONGC_Mittal Energy",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMIETAN-PFR",
		35.010133,
		136.672767,
		"PLATTS - Refinery - Japan - Mie - Taniguchi Sekiyu K.K.",
		null,
		null,
		null,
		null,
		null,
		2.8,
		2.97,
		0.42,
		150.98,
		0.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Taniguchi Sekiyu K.K.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOLSCL-PFR",
		45.625157,
		-73.529692,
		"PLATTS - Refinery - Canada - Montreal - Shell Canada Ltd.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.02,
		-0.02,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Other Investors",
		"78_22",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOWRFT-PFR",
		55.70869,
		37.56517,
		"PLATTS - Refinery - Russia - Moscow - Rosneft",
		725.75,
		797.24,
		99.2,
		36075.74,
		108.85,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMNLADI-PFR",
		29.058386,
		48.132182,
		"PLATTS - Refinery - Kuwait - Mina Al-Ahmadi - Kuwait National Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		1386.03,
		1515.38,
		444.36,
		55750.49,
		480.84,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		363,
		null,
		50.07,
		18275.17,
		null,
		30,
		32.21,
		4.11,
		1500,
		4.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		363,
		null,
		50.07,
		18275.17,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		63.36,
		55.72,
		116.94,
		79.97,
		0.92,
		65.51,
		16.16326531,
		14.21428571,
		29.83163265,
		20.4005102,
		0.23469388,
		16.71173469,
		382.42,
	],
	[
		"REFPIAPNS-PFR",
		39.911338,
		-75.200358,
		"PLATTS - Refinery - United States - Philadelphia - Philadelphia Energy Solutions",
		95,
		100.5,
		82.27,
		907.83,
		87.04,
		0.03,
		-0.01,
		-0.01,
		-0.05,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Credit Suisse Asset Management and Bardin Hill_Sunoco_Carlyle Group",
		"75_12.5_12.5",
		null,
		"Active",
		null,
		23.54,
		48.96,
		11.67,
		7.98,
		-3.51,
		0,
		26.16427698,
		54.41813938,
		12.97099033,
		8.86962321,
		-3.90130043,
		0,
		88.64,
	],
	[
		"REFMIFSAR-PFR",
		36.7113,
		67.1088,
		"PLATTS - Refinery - Afghanistan - Mazari-Sharif - SOCAR",
		null,
		null,
		null,
		null,
		null,
		1,
		1.07,
		0.14,
		50,
		0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		2.15,
		0.27,
		100,
		0.29,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOWTSA-PFR",
		55.7504,
		37.6175,
		"PLATTS - Refinery - Russia - Moscow - Trassa",
		240.12,
		263.98,
		32.78,
		11918.3,
		36.01,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Trassa",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMORMYA-PFR",
		35.7913,
		-5.8249,
		"PLATTS - Refinery - Morocco - Unknown - MYA Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		345.16,
		381.34,
		46.56,
		16932.08,
		51.44,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"MYA Energy_VEB Bank",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMOAMNS-PFR",
		20.656,
		-74.943,
		"PLATTS - Refinery - Cuba - Moa - Moa Nickel S.A.",
		null,
		null,
		null,
		null,
		null,
		2,
		2.15,
		2,
		2,
		2.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Moa Nickel S.A.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPJNLPC-PFR",
		41.195405,
		121.991005,
		"PLATTS - Refinery - China - Panjin - Liaohe Petrochem Corp.",
		null,
		null,
		null,
		null,
		null,
		464.13,
		499.03,
		98.9,
		21989.5,
		105.78,
		48.5,
		null,
		7.21,
		2630.39,
		null,
		0,
		null,
		0,
		0,
		null,
		97,
		null,
		13.9,
		5072.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		48.5,
		null,
		6.69,
		2441.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		25.48,
		18.82,
		0.18,
		6.39,
		11.5,
		10.02,
		26.75065617,
		19.75853018,
		0.18897638,
		6.70866142,
		12.07349081,
		10.51968504,
		72.39,
	],
	[
		"REFMKAPT2-PFR",
		2.258642,
		102.13786,
		"PLATTS - Refinery - Malaysia - Melaka - Petronas - {Tangga Batu - Melaka 1}",
		1,
		1.07,
		0.14,
		51.63,
		0.15,
		317.42,
		335.63,
		104.78,
		11381.46,
		110.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		110,
		null,
		14.3,
		5221.07,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		110,
		null,
		14.3,
		5221.07,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petronas",
		"100",
		null,
		"Active",
		null,
		35.35,
		20.08,
		15.02,
		14.57,
		3.2,
		3.33,
		35.70707071,
		20.28282828,
		15.17171717,
		14.71717172,
		3.23232323,
		3.36363636,
		91.56,
	],
	[
		"REFMPEPTS-PFR",
		-12.702194,
		-38.57677,
		"PLATTS - Refinery - Brazil - Mataripe - Mubadala Investment Company - {RLAM - Landulpho Alves}",
		null,
		null,
		null,
		null,
		null,
		939.48,
		983.69,
		389.46,
		33286.51,
		407.35,
		110.61,
		null,
		16.44,
		5998.95,
		null,
		0,
		null,
		0,
		0,
		null,
		226,
		null,
		31.79,
		11602.92,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		71.48,
		null,
		9.3,
		3392.93,
		null,
		39.32,
		null,
		5.42,
		1979.66,
		null,
		4.58,
		null,
		0.63,
		231.38,
		null,
		175.92,
		184.73,
		30.55,
		7536.59,
		32.17,
		"Mubadala Investment Company",
		"100",
		null,
		"Active",
		null,
		76.99,
		58.86,
		54.61,
		11.6,
		17.19,
		5.65,
		34.06637168,
		26.04424779,
		24.16371681,
		5.13274336,
		7.60619469,
		2.5,
		224.9,
	],
	[
		"REFPJNPNJ-PFR",
		41.16526082,
		122.15496912,
		"PLATTS - Refinery - China - Panjin - Panjin North Bitumen Fuel",
		20,
		21.16,
		2.74,
		1000,
		2.9,
		157,
		166.49,
		22.04,
		8047.85,
		23.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Norinco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMKAPTN-PFR",
		2.269077,
		102.133425,
		"PLATTS - Refinery - Malaysia - Melaka - Petronas - {Tangga Batu - Melaka 2}",
		null,
		null,
		null,
		null,
		null,
		676.07,
		716.69,
		190.27,
		28780.83,
		201.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		115,
		null,
		14.95,
		5458.39,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		115,
		null,
		14.95,
		5458.39,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petronas",
		"100",
		null,
		"Active",
		null,
		65.19,
		23.5,
		-0.04,
		17.91,
		8.87,
		7.93,
		53.65432099,
		19.34156379,
		-0.03292181,
		14.74074074,
		7.30041152,
		6.52674897,
		123.35,
	],
	[
		"REFMSAKDL-PFR",
		-4.01725,
		39.619412,
		"PLATTS - Refinery - Kenya - Mombasa - Kenya Petroleum Refineries Ltd.",
		359.25,
		395.61,
		60.5,
		17623.26,
		66.58,
		-0.03,
		0.02,
		-0.01,
		-0.01,
		0.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kenyan Govt.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOWLUK-PFR",
		55.7504,
		37.6175,
		"PLATTS - Refinery - Russia - Moscow - Lukoil",
		938.85,
		1025.9,
		250.11,
		40018.73,
		270.85,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil_ConocoPhillips",
		"80_20",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMS2QRY-PFR",
		36.3443,
		43.1968,
		"PLATTS - Refinery - Iraq - Mosul (2) - Qayara Refinery",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		100,
		107.35,
		13.7,
		5000,
		14.71,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMLASON-PFR",
		14.5907,
		120.981,
		"PLATTS - Refinery - Philippines - Manila - San Miguel Corporation",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		689.37,
		730.22,
		95.06,
		34553.81,
		100.63,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_San Miguel Corporation",
		"66.67_33.33",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMOWMBV-PFR",
		55.649457,
		37.807575,
		"PLATTS - Refinery - Russia - Moscow - Moscow NPZ Holdings BV",
		null,
		null,
		null,
		null,
		null,
		1161.31,
		1273.53,
		377.21,
		46245.14,
		408.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		205,
		null,
		28.27,
		10320.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		205,
		null,
		28.27,
		10320.69,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazpromneft_Sibir Energy_Tatneftegaz",
		"96_3_1",
		null,
		"Active",
		null,
		57.75,
		51.86,
		54.37,
		10.78,
		-0.39,
		7.35,
		27.44119743,
		24.64243288,
		25.83511523,
		5.12235685,
		-0.18531718,
		3.49251604,
		181.72,
	],
	[
		"REFPLACHN-PFR",
		30.34279,
		-88.48633,
		"PLATTS - Refinery - United States - Pascagoula - Chevron",
		null,
		null,
		null,
		null,
		null,
		1618.14,
		1703.31,
		479.9,
		68691.4,
		506.3,
		135.8,
		null,
		20.18,
		7364.85,
		null,
		2.85,
		null,
		0.42,
		154.07,
		null,
		281.79,
		null,
		40.09,
		14632.95,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		32.5,
		null,
		4.23,
		1542.43,
		null,
		105.68,
		null,
		14.58,
		5320.26,
		null,
		4.98,
		null,
		0.69,
		251.34,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron",
		"100",
		null,
		"Active",
		null,
		109.4,
		117.96,
		3.86,
		68.63,
		15.48,
		3.18,
		30.55524522,
		32.94603955,
		1.07809183,
		19.16824936,
		4.32353927,
		0.88816892,
		318.51,
	],
	[
		"REFMNIJSP-PFR",
		41.5632,
		45.9705,
		"PLATTS - Refinery - Georgia - Mirzaani - Jindal Steel and Power Ltd.",
		40,
		42.94,
		5.48,
		2000,
		5.88,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jindal Steel and Power Ltd.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMRAIND-PFR",
		18.9068,
		75.6742,
		"PLATTS - Refinery - India - Maharashtra - Indian Oil Corp. - {Ratnagiri, West Coast Refinery}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		4656.61,
		5090.64,
		1457.57,
		186013.84,
		1571.95,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"ADNOC_Indian Oil Corp._Saudi Aramco_Bharat Petroleum_Hindustan Petroleum",
		"25_25_25_12.5_12.5",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPLLPPC-PFR",
		13.776989,
		121.025034,
		"PLATTS - Refinery - Philippines - Pililla - Philippine Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		25.58,
		26.83,
		3.82,
		1402.4,
		4.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Other Investors_Insular Life Assurance Co.",
		"73.91_13.23_12.86",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOTOEOL-PFR",
		0.675954,
		-76.877753,
		"PLATTS - Refinery - Colombia - Orito - Ecopetrol",
		null,
		null,
		null,
		null,
		null,
		3,
		3.22,
		0.41,
		150,
		0.44,
		1,
		null,
		0.15,
		54.23,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.15,
		54.23,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ecopetrol",
		"100",
		null,
		"Active",
		null,
		0.1,
		0,
		0.7,
		0.1,
		0,
		0.1,
		10,
		0,
		70,
		10,
		0,
		10,
		1,
	],
	[
		"REFMOHSNR-PFR",
		33.682273,
		-7.425149,
		"PLATTS - Refinery - Morocco - Mohammedia - S A Maroc. De L'ind. Du Raffin.",
		null,
		null,
		null,
		null,
		null,
		-0.02,
		0,
		0,
		-0.02,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		438.5,
		480.2,
		165.88,
		15406.07,
		179.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Corral Petroleum Holdings_Other Investors_B.M.R.P.M.",
		"60.9_32.3_6.8",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPANPRT-PFR",
		5.223631,
		97.082552,
		"PLATTS - Refinery - Indonesia - Pangkalan Brandan - Pertamina",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMOTQGY-PFR",
		48.2325,
		-101.2963,
		"PLATTS - Refinery - United States - Minot - Quantum Energy",
		34.02,
		35.69,
		9.87,
		1410.45,
		10.4,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Quantum Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPARZUP-PFR",
		5.0057,
		115.1051,
		"PLATTS - Refinery - Brunei - Pulau Muara Besar - Zhejiang Hengyi Group",
		null,
		null,
		null,
		null,
		null,
		758.4,
		816.67,
		275.68,
		27311.42,
		296.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		96,
		null,
		12.76,
		4657.68,
		null,
		402.5,
		431.27,
		56.53,
		20629.32,
		60.63,
		24,
		null,
		3.21,
		1171.13,
		null,
		48,
		null,
		6.24,
		2278.28,
		null,
		24,
		null,
		3.31,
		1208.27,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zhejiang Hengyi Group_Damai Holdings",
		"70_30",
		null,
		"Active",
		null,
		6.96,
		12.01,
		0,
		5.06,
		1.6,
		4.8,
		21.75,
		37.53125,
		0,
		15.8125,
		5,
		15,
		30.43,
	],
	[
		"REFMOWGFT-PFR",
		55.65182,
		37.806422,
		"PLATTS - Refinery - Russia - Moscow - Gazpromneft",
		517.32,
		563.52,
		174.48,
		19888.67,
		188.36,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazpromneft",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPERPIL-PFR",
		56.2325,
		-117.3207,
		"PLATTS - Refinery - Canada - Peace River - Peace River Oil",
		944.97,
		993.97,
		329.81,
		37031.38,
		348.17,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Peace River Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMSIPRT-PFR",
		3.955,
		126.6632,
		"PLATTS - Refinery - Indonesia - Musi - Pertamina - {Plaju - Sungai Gerong}",
		null,
		null,
		null,
		null,
		null,
		385.44,
		419.18,
		79.34,
		17957.82,
		85.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94.76,
		null,
		13.11,
		4783.87,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		94.76,
		null,
		13.11,
		4783.87,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		37.91,
		27.35,
		16.1,
		10.73,
		-2.26,
		7.21,
		36.1047619,
		26.04761905,
		15.33333333,
		10.21904762,
		-2.15238095,
		6.86666667,
		97.05,
	],
	[
		"REFPIMNAL-PFR",
		24.8498086,
		67.3037334,
		"PLATTS - Refinery - Pakistan - Port Qasim - Noor Financial",
		489.31,
		535.34,
		67.6,
		24562.14,
		73.91,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Noor Financial",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPIPIND-PFR",
		20.256,
		86.65123,
		"PLATTS - Refinery - India - Paradip - Indian Oil Corp.",
		null,
		null,
		null,
		null,
		null,
		1509.71,
		1648.65,
		534.46,
		57372.72,
		572.49,
		5.63,
		null,
		0.84,
		305.59,
		null,
		0,
		null,
		0,
		0,
		null,
		257.02,
		null,
		35.31,
		12888.71,
		null,
		694.18,
		762.09,
		142.54,
		32521.19,
		155.31,
		28.57,
		null,
		3.82,
		1394.05,
		null,
		9.89,
		null,
		1.29,
		469.2,
		null,
		212.93,
		null,
		29.37,
		10719.87,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		143.9,
		88.57,
		11.66,
		32.37,
		17.3,
		8.3,
		44.92803397,
		27.65306441,
		3.64045084,
		10.10646602,
		5.40135502,
		2.59140154,
		302.1,
	],
	[
		"REFMTAPEC-PFR",
		-0.95002,
		-80.7162,
		"PLATTS - Refinery - Ecuador - Manta - Petroecuador - {Manabi}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1131.15,
		1243.18,
		162.9,
		57593.78,
		178.91,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroecuador_PDVSA",
		"80_20",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPNRCGE-PFR",
		-4.73361,
		11.84839,
		"PLATTS - Refinery - Congo - Pointe Noire - Congolaise De Raffinage",
		null,
		null,
		null,
		null,
		null,
		183.65,
		201.69,
		25.13,
		9142.93,
		27.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.21,
		807.75,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.21,
		807.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hydro-Congo",
		"100",
		null,
		"Active",
		null,
		5.65,
		2.12,
		5.74,
		0.97,
		0.18,
		0.18,
		37.66666667,
		14.13333333,
		38.26666667,
		6.46666667,
		1.2,
		1.2,
		14.82,
	],
	[
		"REFPISAHC-PFR",
		31.18903,
		-89.39799,
		"PLATTS - Refinery - United States - Purvis - Amerada-Hess Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Amerada-Hess Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMRNKRG-PFR",
		35.426,
		45.5886,
		"PLATTS - Refinery - Iraq - Miran - KRG",
		20,
		21.48,
		2.74,
		1000,
		2.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KRG_Heritage Oil",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMUIHND-PFR",
		19.017941,
		72.903211,
		"PLATTS - Refinery - India - Mumbai - Hindustan Petroleum - {Bombay}",
		20,
		21.47,
		3.2,
		1168,
		3.43,
		605.45,
		660.56,
		178.71,
		25300.99,
		192.51,
		3.02,
		null,
		0.45,
		163.85,
		null,
		0,
		null,
		0,
		0,
		null,
		152.78,
		null,
		20.86,
		7615.61,
		null,
		null,
		null,
		null,
		null,
		null,
		10.27,
		null,
		1.37,
		501.24,
		null,
		25.04,
		null,
		3.26,
		1188.14,
		null,
		114.45,
		null,
		15.79,
		5762.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Government_Other Investors",
		"51_49",
		null,
		"Active",
		null,
		50.98,
		38.81,
		15.23,
		16.65,
		15.55,
		12.31,
		31.50608739,
		23.98492059,
		9.41227365,
		10.28984612,
		9.61003646,
		7.60768803,
		149.55,
	],
	[
		"REFPNSHMC-PFR",
		29.9702,
		-93.94129,
		"PLATTS - Refinery - United States - Port Neches - Huntsman Corp.",
		null,
		null,
		null,
		null,
		null,
		23.23,
		24.59,
		2.74,
		1002.25,
		2.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Texaco Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMSKSTZ-PFR",
		68.9707,
		33.075,
		"PLATTS - Refinery - Russia - Murmansk - Sintez Petroleum",
		348.97,
		381.6,
		72.42,
		16176.69,
		78.68,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sintez Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMULQRY-PFR",
		35.789601,
		43.282712,
		"PLATTS - Refinery - Iraq - Mosul - Qayara Refinery",
		null,
		null,
		null,
		null,
		null,
		20,
		21.47,
		2.74,
		1000,
		2.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		null,
		1.66,
		604.14,
		null,
		70,
		75.15,
		9.59,
		3500,
		10.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		null,
		1.66,
		604.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		3.21,
		0,
		4.69,
		0.75,
		0.24,
		1.84,
		22.92857143,
		0,
		33.5,
		5.35714286,
		1.71428571,
		13.14285714,
		10.72,
	],
	[
		"REFPONADE-PFR",
		49.47562,
		0.310758,
		"PLATTS - Refinery - France - Port Jerome-Gravenchon - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		50.8,
		53.74,
		50.8,
		50.8,
		53.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMTNPMX-PFR",
		17.981633,
		-94.530826,
		"PLATTS - Refinery - Mexico - Minatitlan - PEMEX - {Refineria Lazaro Cardenas}",
		null,
		null,
		null,
		null,
		null,
		897.85,
		985.36,
		166.67,
		42115.24,
		181.75,
		62.1,
		null,
		9.23,
		3367.85,
		null,
		0,
		null,
		0,
		0,
		null,
		78.47,
		null,
		11.49,
		4192.09,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		16.37,
		null,
		2.26,
		824.25,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		28.28,
		31.36,
		19.72,
		3.92,
		-0.23,
		0,
		30.87336245,
		34.23580786,
		21.52838428,
		4.27947598,
		-0.2510917,
		0,
		83.06,
	],
	[
		"REFPKEPEB-PFR",
		51.68276,
		-5.028477,
		"PLATTS - Refinery - United Kingdom - Pembroke - Pembroke Refining",
		null,
		null,
		null,
		null,
		null,
		770.19,
		808.65,
		149.18,
		35093.54,
		156.39,
		6,
		null,
		0.89,
		325.41,
		null,
		0,
		null,
		0,
		0,
		null,
		142.22,
		null,
		18.81,
		6866.58,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		111.22,
		null,
		14.46,
		5279.07,
		null,
		0,
		null,
		0,
		0,
		null,
		25,
		null,
		3.46,
		1262.1,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		75.55,
		81.56,
		6.08,
		17.99,
		-3.28,
		4.36,
		42.44382022,
		45.82022472,
		3.41573034,
		10.10674157,
		-1.84269663,
		2.4494382,
		182.25,
	],
	[
		"REFMUNJNO-PFR",
		42.364369,
		140.947234,
		"PLATTS - Refinery - Japan - Muroran - ENEOS",
		25,
		26.45,
		3.58,
		1305.44,
		3.78,
		434.78,
		458.53,
		101.86,
		18814.33,
		106.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"JX Nippon Oil and Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMUAPUY-PFR",
		12.145712,
		-86.319383,
		"PLATTS - Refinery - Nicaragua - Managua - Puma Energy - {MANREF}",
		null,
		null,
		null,
		null,
		null,
		40.2,
		44.05,
		5.32,
		1946.37,
		5.84,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.06,
		755.17,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		2.06,
		755.17,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		3.41,
		2.16,
		4.41,
		0.9,
		0.51,
		0.1,
		28.41666667,
		18,
		36.75,
		7.5,
		4.25,
		0.83333333,
		11.49,
	],
	[
		"REFPOVSYE-PFR",
		57.8174,
		28.3344,
		"PLATTS - Refinery - Russia - Pskov - Severnoye Suyaniye",
		11.2,
		12.26,
		1.47,
		539.44,
		1.61,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Severnoye Suyaniye",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMUDIND-PFR",
		22.746,
		69.7,
		"PLATTS - Refinery - India - Mundra - Indian Oil Corp.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1922.88,
		2116.4,
		262.96,
		95652.96,
		289.2,
		"Indian Oil Corp._Adani Group",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFOIAAIO-PFR",
		42.3476,
		44.0979,
		"PLATTS - Refinery - Georgia - Ossetia - Alania Oil",
		3,
		3.22,
		0.42,
		150,
		0.44,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alania Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPLIRPE-PFR",
		9.991843,
		-83.092927,
		"PLATTS - Refinery - Costa Rica - Puerto Limon - Recope",
		376.44,
		413.33,
		53.63,
		18866.67,
		58.81,
		0,
		-0.01,
		-0.01,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Recope",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMUIBHR-PFR",
		19.0205,
		72.89394,
		"PLATTS - Refinery - India - Mumbai - Bharat Petroleum - {Bombay}",
		null,
		null,
		null,
		null,
		null,
		683.97,
		747.64,
		138.63,
		31443.52,
		150.57,
		3.34,
		null,
		0.5,
		181.18,
		null,
		0,
		null,
		0,
		0,
		null,
		264.62,
		null,
		35.39,
		12918.78,
		null,
		137.25,
		149.82,
		23.09,
		7608.81,
		25.2,
		74.38,
		null,
		9.94,
		3629.26,
		null,
		104.62,
		null,
		13.61,
		4965.59,
		null,
		82.28,
		null,
		11.35,
		4142.75,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bharat Petroleum_Other Investors",
		"66.2_33.8",
		null,
		"Active",
		null,
		121.61,
		28.74,
		12.54,
		31.1,
		22.54,
		53.4,
		41.07752069,
		9.70781963,
		4.23577098,
		10.50498227,
		7.61357879,
		18.03749367,
		269.91,
	],
	[
		"REFPREPIN-PFR",
		10.3229,
		-61.4453,
		"PLATTS - Refinery - Trinidad and Tobago - Pointe-A-Pierre - Petrotrin - {Guaracara Refining Co Ltd}",
		26.1,
		28,
		5.1,
		1461.1,
		5.45,
		0,
		0.01,
		0.03,
		-0.03,
		0.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		670.75,
		705.84,
		118.26,
		32174.33,
		124.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrotrin",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOOVCRO-PFR",
		58.5363,
		48.8851,
		"PLATTS - Refinery - Russia - Orlov - Cepro",
		200.19,
		218.85,
		42.96,
		9059.67,
		46.62,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cepro",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMULKAR-PFR",
		36.3437,
		43.0997,
		"PLATTS - Refinery - Iraq - Mosul - Kar Group",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		565.1,
		608.82,
		336.37,
		13359.81,
		357.32,
		"Kar Group",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPLNPLA-PFR",
		43.436613,
		24.565289,
		"PLATTS - Refinery - Bulgaria - Pleven - Plama",
		34.93,
		37.51,
		8.37,
		1596.65,
		9,
		0,
		0,
		-0.02,
		0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Highway Logistic Centre_Overgas",
		"65_35",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFMURPRU-PFR",
		5.0263,
		115.0702,
		"PLATTS - Refinery - Brunei - Muara - PetroBru",
		1606,
		1721.23,
		526.52,
		62605.98,
		564.75,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"TRC Energy_PetroBru",
		"74_26",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFMUSPTS-PFR",
		-3.147635,
		-59.953983,
		"PLATTS - Refinery - Brazil - Manaus - Petrobras - {REMAN - Isaac Sabba}",
		null,
		null,
		null,
		null,
		null,
		105.91,
		111.11,
		23.06,
		4726.77,
		24.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31.6,
		null,
		4.16,
		1516.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		25.66,
		null,
		3.34,
		1218,
		null,
		5.94,
		null,
		0.82,
		298.97,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		12.92,
		6.57,
		6.43,
		1.99,
		1.85,
		0.76,
		40.88607595,
		20.79113924,
		20.34810127,
		6.29746835,
		5.85443038,
		2.40506329,
		30.52,
	],
	[
		"REFPNEATS-PFR",
		30.493791,
		-91.187797,
		"PLATTS - Refinery - United States - Plaquemine - Air Products",
		null,
		null,
		null,
		null,
		null,
		30,
		31.74,
		30,
		30,
		31.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFORINNP-PFR",
		5.4897,
		7.0342,
		"PLATTS - Refinery - Nigeria - Owerri - NNPC - {Imo}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		200.1,
		218.13,
		23.66,
		8601.07,
		25.8,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_NNPC",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFOSAUKT-PFR",
		46.512835,
		30.684855,
		"PLATTS - Refinery - Ukraine - Odessa - Ukrtransnefteprodukt",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0.04,
		-0.03,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		107.5,
		117.57,
		15.02,
		5481.65,
		16.42,
		"Ukrainian State",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOSAUTE-PFR",
		46.4873,
		30.7393,
		"PLATTS - Refinery - Ukraine - Odessa - Ukrainian State",
		650.4,
		710.6,
		187.76,
		26527.62,
		203.16,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company_Ukrainian State",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPNOADE-PFR",
		38.666437,
		-4.049356,
		"PLATTS - Refinery - Spain - Puertollano - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		50.8,
		53.74,
		50.8,
		50.8,
		53.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOSKGFT-PFR",
		55.077247,
		73.241416,
		"PLATTS - Refinery - Russia - Omsk - Gazpromneft",
		24.09,
		25.87,
		2.83,
		1034.88,
		3.04,
		1543.5,
		1690.51,
		347.09,
		70329.45,
		377.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		411,
		null,
		54.43,
		19867.87,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		286,
		null,
		37.19,
		13574.77,
		null,
		125,
		null,
		17.24,
		6293.11,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom_Other Investors",
		"95_5",
		null,
		"Active",
		null,
		164.01,
		117.2,
		51.73,
		29.23,
		12.95,
		23.97,
		38.91841868,
		27.81073513,
		12.27516492,
		6.93607328,
		3.07294386,
		5.6879123,
		399.09,
	],
	[
		"REFOSETOH-PFR",
		34.058179,
		136.204984,
		"PLATTS - Refinery - Japan - Owase - Toho Oil",
		null,
		null,
		null,
		null,
		null,
		0.02,
		0,
		0,
		-0.02,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon_Chubu Electric_Idemitsu Kosan Company",
		"33.34_33.33_33.33",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPOMSHL-PFR",
		1.232481,
		103.766927,
		"PLATTS - Refinery - Singapore - Pulau Bukom - Shell",
		null,
		null,
		null,
		null,
		null,
		79.5,
		83.3,
		9.56,
		3485.6,
		10.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		50,
		null,
		6.5,
		2373.22,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		50,
		null,
		6.5,
		2373.22,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell Eastern Petroleum_Petrochemical Corp of Singapore",
		"50_50",
		null,
		"Active",
		null,
		7.12,
		0,
		0.88,
		11.92,
		-0.74,
		29.72,
		14.24,
		0,
		1.76,
		23.84,
		-1.48,
		59.44,
		48.9,
	],
	[
		"REFOUNALC-PFR",
		6.9789,
		3.4389,
		"PLATTS - Refinery - Nigeria - Ogun - Anthonio Oil Plc",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		65.42,
		72.28,
		8.51,
		3102.34,
		9.4,
		"Anthonio Oil Plc",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPPAMON-PFR",
		-8.39229,
		-74.533012,
		"PLATTS - Refinery - Peru - Pucallpa - Maple Gas Corporation",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Maple Gas Corporation_Petroperu",
		"60_40",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOTIRTI-PFR",
		46.25558,
		26.8157,
		"PLATTS - Refinery - Romania - Onesti - Rafo Onesti",
		null,
		null,
		null,
		null,
		null,
		0.26,
		0.33,
		0.06,
		13.66,
		0.07,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrochemical Holding GmbH_Other Investors",
		"96.51_3.49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPAAPTS-PFR",
		-22.727556,
		-47.128362,
		"PLATTS - Refinery - Brazil - Paulinia - Petrobras - {REPLAN}",
		null,
		null,
		null,
		null,
		null,
		1015.63,
		1066.55,
		166.82,
		49590.67,
		175.44,
		181.87,
		null,
		27.02,
		9863.85,
		null,
		0,
		null,
		0,
		0,
		null,
		310,
		null,
		44.33,
		16181.75,
		null,
		90.67,
		95.63,
		56.51,
		2183.01,
		59.74,
		0,
		null,
		0,
		0,
		null,
		46.16,
		null,
		6,
		2191,
		null,
		79.46,
		null,
		10.96,
		4000.24,
		null,
		2.51,
		null,
		0.35,
		126.66,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		143.99,
		73.05,
		18.93,
		18.51,
		25.09,
		10.2,
		47.8372093,
		24.26910299,
		6.28903654,
		6.14950166,
		8.33554817,
		3.38870432,
		289.77,
	],
	[
		"REFPRAHSS-PFR",
		40.564368,
		-74.248643,
		"PLATTS - Refinery - United States - Port Reading - Hess",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hess",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPALPNG-PFR",
		30.47616,
		-91.20775,
		"PLATTS - Refinery - United States - Port Allen - Placid Refining",
		null,
		null,
		null,
		null,
		null,
		208.83,
		219.5,
		28.27,
		10257.37,
		29.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		85.41,
		null,
		11.56,
		4218.09,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		28.38,
		null,
		3.69,
		1347.25,
		null,
		57.02,
		null,
		7.87,
		2870.84,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Placid Refining",
		"100",
		null,
		"Active",
		null,
		24.06,
		32.29,
		4.3,
		7.26,
		2.08,
		1.77,
		34.17613636,
		45.86647727,
		6.10795455,
		10.3125,
		2.95454545,
		2.51420455,
		71.76,
	],
	[
		"REFPACSLL-PFR",
		45.226513,
		-0.752033,
		"PLATTS - Refinery - France - Pauillac - Societe Des Petroles Shell",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPROAXS-PFR",
		39.84115,
		-75.2274,
		"PLATTS - Refinery - United States - Paulsboro - Axeon Specialty Products",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0.02,
		-0.02,
		0.55,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lindsay Goldberg LLC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPAUSNO-PFR",
		1.28164,
		103.713085,
		"PLATTS - Refinery - Singapore - Pulau Merlimau - Singapore Refining Co - {Jurong Island}",
		null,
		null,
		null,
		null,
		null,
		927.8,
		983.65,
		232.19,
		40546.3,
		245.1,
		0,
		null,
		0,
		0,
		null,
		6.54,
		null,
		0.98,
		354.32,
		null,
		231.9,
		null,
		31.16,
		11376.66,
		null,
		null,
		null,
		null,
		null,
		null,
		91.96,
		null,
		12.3,
		4487.72,
		null,
		63.32,
		null,
		8.24,
		3005.68,
		null,
		61.9,
		null,
		8.54,
		3116.7,
		null,
		8.16,
		null,
		1.12,
		412.24,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron_China National Petroleum Corp.",
		"50_50",
		null,
		"Active",
		null,
		54.56,
		61.58,
		14.12,
		54.9,
		1.18,
		13.22,
		25.84801971,
		29.17377298,
		6.68940686,
		26.00909608,
		0.55902975,
		6.26302824,
		199.58,
	],
	[
		"REFPAKSHD-PFR",
		4.7917,
		100.9276,
		"PLATTS - Refinery - Malaysia - Perak - SVL Oil and Gas Sdn Bhd",
		664.4,
		703.1,
		155.53,
		29326.51,
		164.54,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SVL Engineering Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPCKPEN-PFR",
		52.58879,
		19.67772,
		"PLATTS - Refinery - Poland - Plock - PKN Orlen",
		null,
		null,
		null,
		null,
		null,
		1316.37,
		1386.93,
		523.23,
		47084.49,
		548.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		329.91,
		null,
		45.19,
		16493.9,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		null,
		1.34,
		487.97,
		null,
		35,
		null,
		4.55,
		1661.25,
		null,
		276.91,
		null,
		38.19,
		13940.81,
		null,
		8,
		null,
		1.11,
		403.87,
		null,
		null,
		null,
		null,
		null,
		null,
		"PKN Orlen",
		"100",
		0,
		"Active",
		null,
		141.77,
		64.43,
		42.05,
		16.73,
		13.23,
		35.39,
		42.44610778,
		19.29041916,
		12.58982036,
		5.00898204,
		3.96107784,
		10.59580838,
		313.59,
	],
	[
		"REFPCEPKS-PFR",
		50.02965,
		15.74489,
		"PLATTS - Refinery - Czech Republic - Pardubice - Paramo Refinery Works",
		null,
		null,
		null,
		null,
		null,
		-0.02,
		-0.01,
		-0.01,
		-0.99,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PKN Orlen",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPCNCAC-PFR",
		32.59226,
		-93.51344,
		"PLATTS - Refinery - United States - Princeton - Calumet Lubricants Co.",
		null,
		null,
		null,
		null,
		null,
		42.46,
		44.79,
		13.88,
		1781.94,
		14.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.19,
		null,
		0.97,
		352.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		3.16,
		null,
		0.41,
		149.97,
		null,
		4.03,
		null,
		0.56,
		202.96,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Calumet Lubricants Co.",
		"100",
		null,
		"Active",
		null,
		1.79,
		0.38,
		0,
		0.24,
		-0.22,
		1.44,
		27.12121212,
		5.75757576,
		0,
		3.63636364,
		-3.33333333,
		21.81818182,
		3.63,
	],
	[
		"REFPDBBBP-PFR",
		70.25414,
		-148.350951,
		"PLATTS - Refinery - United States - Prudhoe Bay - BP",
		null,
		null,
		null,
		null,
		null,
		10.18,
		10.62,
		1.38,
		509,
		1.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.01,
		null,
		1.11,
		403.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.01,
		null,
		1.11,
		403.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips Petroleum",
		"100",
		null,
		"Active",
		null,
		2.61,
		0,
		0,
		0.08,
		0,
		0,
		27.1875,
		0,
		0,
		0.83333333,
		0,
		0,
		2.69,
	],
	[
		"REFPDNPON-PFR",
		2.5152,
		101.8996,
		"PLATTS - Refinery - Malaysia - Port Dickson - Petron",
		null,
		null,
		null,
		null,
		null,
		184.57,
		195.3,
		24.01,
		8785.89,
		25.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		55,
		null,
		7.15,
		2610.54,
		null,
		267.15,
		283.2,
		36.28,
		13191.71,
		38.45,
		0,
		null,
		0,
		0,
		null,
		55,
		null,
		7.15,
		2610.54,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petron_Other Investors",
		"65_35",
		null,
		"Active",
		null,
		20.62,
		6.11,
		12.45,
		8.09,
		1.47,
		2.6,
		37.49090909,
		11.10909091,
		22.63636364,
		14.70909091,
		2.67272727,
		4.72727273,
		51.32,
	],
	[
		"REFPDNHEP-PFR",
		2.533181,
		101.812483,
		"PLATTS - Refinery - Malaysia - Port Dickson - Hengyuan Petrochemical",
		-18,
		-18.77,
		-2.47,
		-900,
		-2.57,
		413.28,
		438.93,
		125.57,
		16562.4,
		133.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		108.95,
		null,
		14.78,
		5396.02,
		null,
		null,
		null,
		null,
		null,
		null,
		1,
		null,
		0.14,
		48.8,
		null,
		32.7,
		null,
		4.25,
		1552.08,
		null,
		27.25,
		null,
		3.76,
		1371.9,
		null,
		48,
		null,
		6.64,
		2423.24,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hengyuan Petrochemical_Other Investors",
		"51_49",
		null,
		"Active",
		null,
		27.3,
		15.73,
		26.96,
		15.76,
		7.14,
		8.6,
		25.51401869,
		14.70093458,
		25.19626168,
		14.72897196,
		6.6728972,
		8.03738318,
		101.48,
	],
	[
		"REFPHTNCE-PFR",
		4.7677,
		7.0189,
		"PLATTS - Refinery - Nigeria - Port Harcourt - National Standard Finance, LLC",
		45.02,
		49.43,
		6.18,
		2246.25,
		6.79,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"National Standard Finance, LLC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPEWRGY-PFR",
		46.1381676,
		-122.93816,
		"PLATTS - Refinery - United States - Port Longview - Riverside Energy",
		14,
		14.82,
		1.97,
		720.85,
		2.09,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Riverside Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPIASUN-PFR",
		39.911338,
		-75.200358,
		"PLATTS - Refinery - United States - Philadelphia - Sunoco",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		-0.02,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sunoco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPGEHUS-PFR",
		53.927822,
		-122.69921,
		"PLATTS - Refinery - Canada - Prince George - Tidewater Midstream & Infrastructure Ltd.",
		null,
		null,
		null,
		null,
		null,
		43.57,
		45.95,
		9.3,
		1940.81,
		9.84,
		1.81,
		null,
		0.27,
		98.02,
		null,
		0,
		null,
		0,
		0,
		null,
		6.33,
		null,
		0.86,
		312.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4.52,
		null,
		0.59,
		214.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tidewater Midstream & Infrastructure Ltd.",
		"100",
		null,
		"Active",
		null,
		1.95,
		3.09,
		0.13,
		0.42,
		0.47,
		0.31,
		27.85714286,
		44.14285714,
		1.85714286,
		6,
		6.71428571,
		4.42857143,
		6.37,
	],
	[
		"REFPILSGR-PFR",
		-0.688855,
		8.767619,
		"PLATTS - Refinery - Gabon - Port Gentil - Soc. Gabonaise De Raffinage",
		null,
		null,
		null,
		null,
		null,
		42.18,
		46.65,
		5.81,
		2092,
		6.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15.01,
		null,
		2.06,
		755.17,
		null,
		4.61,
		5.15,
		0.65,
		230.1,
		0.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15.01,
		null,
		2.06,
		755.17,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Gabon Government_Petrogabon_Portofino Assets Corp._ENI",
		"44_25_14.25_14.25_2.5",
		0,
		"Active",
		null,
		3.04,
		1.24,
		4.05,
		1.18,
		0.36,
		0.06,
		30.43043043,
		12.41241241,
		40.54054054,
		11.81181181,
		3.6036036,
		0.6006006,
		9.9,
	],
	[
		"REFPH2NNP-PFR",
		4.760004,
		7.105497,
		"PLATTS - Refinery - Nigeria - Port Harcourt (2) - NNPC - {Port Harcourt II}",
		null,
		null,
		null,
		null,
		null,
		412.33,
		448.44,
		103.4,
		17353.22,
		110.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NNPC",
		"100",
		null,
		"Active",
		null,
		0.57,
		0.72,
		0.33,
		0.2,
		0.04,
		0,
		28.5,
		36,
		16.5,
		10,
		2,
		0,
		1.87,
	],
	[
		"REFPLOADE-PFR",
		37.13486,
		15.206767,
		"PLATTS - Refinery - Italy - Priolo Gargallo - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		25,
		26.45,
		25,
		25,
		26.45,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPHTNNP-PFR",
		4.834671,
		7.099892,
		"PLATTS - Refinery - Nigeria - Port Harcourt - NNPC - {Port Harcourt I - Alese}",
		null,
		null,
		null,
		null,
		null,
		72,
		78.85,
		9.64,
		3514.68,
		10.53,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NNPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPNAPDV-PFR",
		11.737705,
		-70.196131,
		"PLATTS - Refinery - Venezuela - Paraguana - PDVSA - {Amuay - Cardon}",
		null,
		null,
		null,
		null,
		null,
		2755.13,
		3011.23,
		520.54,
		132954.12,
		566.19,
		26.36,
		null,
		3.92,
		1429.87,
		null,
		0,
		null,
		0,
		0,
		null,
		76,
		null,
		10.68,
		3899.96,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.3,
		474.64,
		null,
		39.64,
		null,
		5.47,
		1995.45,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		0,
		"Active",
		null,
		45.53,
		33.7,
		38.19,
		9.27,
		3.02,
		0.93,
		31.4,
		23.24137931,
		26.33793103,
		6.39310345,
		2.08275862,
		0.64137931,
		130.64,
	],
	[
		"REFPNOROL-PFR",
		38.671132,
		-4.051375,
		"PLATTS - Refinery - Spain - Puertollano - Repsol",
		null,
		null,
		null,
		null,
		null,
		494.74,
		520.71,
		99.33,
		23115.39,
		104.22,
		29.04,
		null,
		4.31,
		1574.89,
		null,
		0,
		null,
		0,
		0,
		null,
		77.06,
		null,
		10.71,
		3909.82,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		28.86,
		null,
		3.75,
		1369.82,
		null,
		17.42,
		null,
		2.4,
		877.16,
		null,
		1.74,
		null,
		0.24,
		87.96,
		null,
		null,
		null,
		null,
		null,
		null,
		"Repsol",
		"100",
		null,
		"Active",
		null,
		70.33,
		27,
		2.59,
		22.41,
		6.03,
		5.97,
		53.00324064,
		20.34817997,
		1.951918,
		16.88898937,
		4.54442686,
		4.49920868,
		134.33,
	],
	[
		"REFPITIND-PFR",
		29.473082,
		76.878308,
		"PLATTS - Refinery - India - Panipat - Indian Oil Corp.",
		null,
		null,
		null,
		null,
		null,
		1788.35,
		1953.73,
		577.2,
		71632.58,
		624.26,
		46.79,
		null,
		6.95,
		2537.71,
		null,
		15.36,
		null,
		2.28,
		831.91,
		null,
		276.51,
		null,
		38.38,
		14010.17,
		null,
		null,
		null,
		null,
		null,
		null,
		12.62,
		null,
		1.69,
		615.89,
		null,
		46.5,
		null,
		6.05,
		2207.12,
		null,
		139.88,
		null,
		19.29,
		7042.01,
		null,
		15.36,
		null,
		2.12,
		775.53,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		149.1,
		28.58,
		6.82,
		28.24,
		22.46,
		37.43,
		51.13168724,
		9.80109739,
		2.3388203,
		9.68449931,
		7.70233196,
		12.83607682,
		272.64,
	],
	[
		"REFPNTAON-PFR",
		33.897652,
		-118.146295,
		"PLATTS - Refinery - United States - Paramount - Alon",
		39.5,
		41.82,
		5.29,
		1929.82,
		5.6,
		-0.01,
		-0.04,
		-0.02,
		-0.02,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alon",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPOUSCP-PFR",
		30.9928,
		103.9557,
		"PLATTS - Refinery - China - Pengzhou - Sichuan Petrochemical",
		null,
		null,
		null,
		null,
		null,
		705.23,
		759.54,
		175.54,
		31168.16,
		187.6,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		207.29,
		null,
		27.81,
		10152.35,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		103.65,
		null,
		13.48,
		4919.67,
		null,
		0,
		null,
		0,
		0,
		null,
		103.65,
		null,
		14.33,
		5232.68,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Chengdu Petrochemical",
		"75_25",
		0,
		"Active",
		null,
		59.56,
		52.65,
		16.05,
		11.88,
		16.41,
		21.11,
		33.61173815,
		29.71218962,
		9.05756208,
		6.70428894,
		9.26072235,
		11.91309255,
		177.68,
	],
	[
		"REFPJUPRT-PFR",
		-2.998575,
		104.833372,
		"PLATTS - Refinery - Indonesia - Plaju - Pertamina",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPLOISS-PFR",
		37.177517,
		15.189864,
		"PLATTS - Refinery - Italy - Priolo Gargallo - ISAB S.r.l.",
		null,
		null,
		null,
		null,
		null,
		2263.54,
		2371.37,
		1397.07,
		51787.09,
		1461.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		142,
		null,
		19.19,
		7004.43,
		null,
		null,
		null,
		null,
		null,
		null,
		11.33,
		null,
		1.51,
		552.7,
		null,
		44.31,
		null,
		5.76,
		2102.97,
		null,
		81.84,
		null,
		11.29,
		4120.04,
		null,
		4.53,
		null,
		0.63,
		228.73,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		null,
		"Active",
		null,
		101.53,
		67.27,
		9.44,
		9.84,
		8.22,
		8.26,
		53.99095985,
		35.77240096,
		5.0199415,
		5.23265089,
		4.37117788,
		4.39244882,
		204.55,
	],
	[
		"REFPRGFES-PFR",
		39.773453,
		-99.331711,
		"PLATTS - Refinery - United States - Phillipsburg - Farmland Industries",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Farmland Industries",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPNGHLI-PFR",
		35.7631,
		115.0234,
		"PLATTS - Refinery - China - Puyang - Henan Fengli",
		null,
		null,
		null,
		null,
		null,
		192.8,
		208.3,
		40.97,
		9201.65,
		43.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Henan Fengli",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPRMLUK-PFR",
		57.911074,
		56.151717,
		"PLATTS - Refinery - Russia - Perm - Lukoil",
		null,
		null,
		null,
		null,
		null,
		1152.45,
		1255.88,
		424.76,
		43252.85,
		455.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		243,
		null,
		32.93,
		12017.75,
		null,
		6.9,
		7.75,
		0.98,
		356.22,
		1.1,
		0,
		null,
		0,
		0,
		null,
		75,
		null,
		9.75,
		3559.82,
		null,
		168,
		null,
		23.17,
		8457.93,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		null,
		"Active",
		null,
		108.54,
		54.79,
		17.74,
		18.44,
		12.13,
		19.78,
		43.24992031,
		21.83216449,
		7.06885559,
		7.34778451,
		4.83343959,
		7.88173414,
		231.43,
	],
	[
		"REFPOOLDE-PFR",
		60.31176,
		25.50854,
		"PLATTS - Refinery - Finland - Porvoo - Linde",
		null,
		null,
		null,
		null,
		null,
		80,
		84.64,
		80,
		80,
		84.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Linde",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPOYCHN-PFR",
		40.53491,
		-74.25893,
		"PLATTS - Refinery - United States - Perth Amboy - Chevron",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSESING-PFR",
		30.07804,
		-90.913154,
		"PLATTS - Refinery - United States - Saint James - Inca Refining",
		100,
		104.29,
		13.7,
		5000,
		14.29,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Inca Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSEZEYP-PFR",
		29.9745,
		32.5371,
		"PLATTS - Refinery - Egypt - Suez - Egypt Refining Company",
		651.91,
		715.86,
		173.76,
		27430.68,
		190.18,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Arab Refining Co._EGPC",
		"75.8_24.2",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSGOCET-PFR",
		20.005806,
		-75.872727,
		"PLATTS - Refinery - Cuba - Santiago - Cupet",
		28,
		30.06,
		3.84,
		1400,
		4.12,
		111.7,
		121.76,
		19.65,
		5358.34,
		21.35,
		1,
		null,
		0.15,
		54.24,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.7,
		255.61,
		null,
		34.39,
		38.29,
		5.51,
		1684.92,
		6.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.55,
		201.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cupet_PDVSA",
		"51_49",
		null,
		"Active",
		null,
		4.51,
		1.02,
		7,
		0.59,
		-0.16,
		0,
		32.21428571,
		7.28571429,
		50,
		4.21428571,
		-1.14285714,
		0,
		12.96,
	],
	[
		"REFSHVSUK-PFR",
		51.514022,
		0.478172,
		"PLATTS - Refinery - United Kingdom - Shell Haven - Shell UK",
		null,
		null,
		null,
		null,
		null,
		0,
		0.02,
		-0.03,
		0.01,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSIASMR-PFR",
		35.03985,
		-120.590638,
		"PLATTS - Refinery - United States - Santa Maria - Santa Maria Refining Company",
		null,
		null,
		null,
		null,
		null,
		22.43,
		23.94,
		3.3,
		1206.16,
		3.54,
		3.93,
		null,
		0.58,
		213.02,
		null,
		0,
		null,
		0,
		0,
		null,
		3.93,
		null,
		0.58,
		213.02,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saba Petroleum",
		"100",
		null,
		"Active",
		null,
		0.58,
		0.67,
		1.33,
		0.48,
		-0.12,
		0,
		12.31422505,
		14.22505308,
		28.23779193,
		10.1910828,
		-2.5477707,
		0,
		2.93,
	],
	[
		"REFSIDMNY-PFR",
		33.491293,
		35.337896,
		"PLATTS - Refinery - Lebanon - Sidon - Mediterranean Refining Company",
		null,
		null,
		null,
		null,
		null,
		0.01,
		0.02,
		-0.02,
		0,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lebanese Government",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSINJKH-PFR",
		50.293612,
		143.795278,
		"PLATTS - Refinery - Russia - Sakhalin - JSC Petrosakh",
		null,
		null,
		null,
		null,
		null,
		4,
		4.29,
		0.55,
		200,
		0.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		4.29,
		0.55,
		200,
		0.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Urals Energy PCL",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPRSATS-PFR",
		51.874297,
		4.258513,
		"PLATTS - Refinery - Netherlands - Pernis - Air Products",
		null,
		null,
		null,
		null,
		null,
		160,
		169.28,
		160,
		160,
		169.28,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSITBHC-PFR",
		26.114287,
		50.606846,
		"PLATTS - Refinery - Bahrain - Sitra - Bahrain Petroleum Co.",
		null,
		null,
		null,
		null,
		null,
		1524.7,
		1664.45,
		491.23,
		62306.18,
		529.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		224,
		null,
		30.9,
		11277.24,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		224,
		null,
		30.9,
		11277.24,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Bahrain National Oil Co.",
		"100",
		null,
		"Active",
		null,
		82.66,
		19.24,
		43.35,
		70.79,
		4.6,
		36.92,
		30.87208217,
		7.18580766,
		16.19047619,
		26.4388422,
		1.71802054,
		13.78898226,
		257.56,
	],
	[
		"REFSKSAIP-PFR",
		30.165303,
		-84.205315,
		"PLATTS - Refinery - United States - Saint Marks - American International Petrol. Corp",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Young Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPTYP66-PFR",
		36.689011,
		-97.088051,
		"PLATTS - Refinery - United States - Ponca City - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		701.05,
		738.27,
		138.86,
		31922.57,
		146.41,
		173.54,
		null,
		25.79,
		9412.13,
		null,
		0,
		null,
		0,
		0,
		null,
		193,
		null,
		28.34,
		10342.32,
		null,
		null,
		null,
		null,
		null,
		null,
		5.05,
		null,
		0.68,
		246.45,
		null,
		14.41,
		null,
		1.87,
		683.73,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		85.06,
		102.85,
		2.07,
		7.22,
		3.71,
		0.01,
		39.20538348,
		47.40505162,
		0.95409292,
		3.32780236,
		1.70999263,
		0.00460914,
		200.92,
	],
	[
		"REFSKUTAI-PFR",
		34.051671,
		132.858328,
		"PLATTS - Refinery - Japan - Shikoku - Taiyo Oil - {Kikuma}",
		6,
		6.35,
		0.71,
		257.65,
		0.75,
		460.13,
		485.17,
		98.58,
		20286.71,
		103.56,
		1.64,
		null,
		0.24,
		89.19,
		null,
		4.64,
		null,
		0.69,
		251.52,
		null,
		93.66,
		null,
		12.4,
		4526.76,
		null,
		null,
		null,
		null,
		null,
		null,
		9.29,
		null,
		1.24,
		453.27,
		null,
		68.79,
		null,
		8.95,
		3265.12,
		null,
		9.29,
		null,
		1.28,
		467.65,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Taiyo Oil",
		"100",
		null,
		"Active",
		null,
		34.8,
		35.93,
		3.58,
		19.49,
		1.55,
		16.32,
		30.85106383,
		31.85283688,
		3.17375887,
		17.27836879,
		1.37411348,
		14.46808511,
		111.67,
	],
	[
		"REFPUDREN-PFR",
		-34.655778,
		-58.326581,
		"PLATTS - Refinery - Argentina - Puerto Dock Sud - Raizen - {Buenos Aires, Shell CAPSA}",
		-23,
		-25.34,
		-3.34,
		-1218.86,
		-3.68,
		270.53,
		296.22,
		37.93,
		13732.89,
		41.47,
		0,
		null,
		0,
		0,
		null,
		13.9,
		null,
		2.06,
		752.88,
		null,
		76,
		null,
		10.6,
		3868.22,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		6.48,
		null,
		0.84,
		307.94,
		null,
		0,
		null,
		0,
		0,
		null,
		55.6,
		null,
		7.7,
		2807.4,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Cosan",
		"50_50",
		null,
		"Active",
		null,
		31.7,
		22.8,
		4.28,
		5.24,
		2.34,
		8.16,
		38.65853659,
		27.80487805,
		5.2195122,
		6.3902439,
		2.85365854,
		9.95121951,
		74.52,
	],
	[
		"REFSLAALL-PFR",
		58.919321,
		5.587331,
		"PLATTS - Refinery - Norway - Sola - A/S Norske Shell",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		-0.01,
		0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPURMVA-PFR",
		29.886254,
		-93.961144,
		"PLATTS - Refinery - United States - Port Arthur - Motiva",
		30,
		31.28,
		4.1,
		1500,
		4.28,
		2442.35,
		2567.71,
		472.05,
		114331.42,
		495.38,
		64.07,
		null,
		9.52,
		3474.98,
		null,
		2.47,
		null,
		0.37,
		133.7,
		null,
		511.77,
		null,
		68.74,
		25090.35,
		null,
		340,
		354.57,
		46.58,
		17000,
		48.57,
		0,
		null,
		0,
		0,
		null,
		323.9,
		null,
		42.12,
		15373.69,
		null,
		121.32,
		null,
		16.73,
		6107.97,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		165,
		217.26,
		3.19,
		57.84,
		26.02,
		4.6,
		30.26023805,
		39.84448072,
		0.58503127,
		10.6075889,
		4.77194784,
		0.84361876,
		473.9,
	],
	[
		"REFSLISHO-PFR",
		45.79257013,
		126.6976832,
		"PLATTS - Refinery - China - Shengli - Shengli Heavy Oil Plant",
		null,
		null,
		null,
		null,
		null,
		129.31,
		139.4,
		18.15,
		6510.79,
		19.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPURTOT-PFR",
		29.960715,
		-93.890089,
		"PLATTS - Refinery - United States - Port Arthur - Total",
		null,
		null,
		null,
		null,
		null,
		717.28,
		754.59,
		101.84,
		35884.76,
		107.11,
		13.86,
		null,
		2.06,
		751.53,
		null,
		0,
		null,
		0,
		0,
		null,
		113.98,
		null,
		15.08,
		5503.74,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		100.12,
		null,
		13.02,
		4752.21,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		37.66,
		62.45,
		2.01,
		14.66,
		11.96,
		2.04,
		26.38178634,
		43.74781086,
		1.40805604,
		10.26970228,
		8.37828371,
		1.4290718,
		130.78,
	],
	[
		"REFSLLERY-PFR",
		33.810422,
		-118.171211,
		"PLATTS - Refinery - United States - Signal Hill - Eco Petroleum Refinery",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Grant Trading Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPUZPDV-PFR",
		10.222889,
		-64.617036,
		"PLATTS - Refinery - Venezuela - Puerto La Cruz - PDVSA - {RPLC}",
		null,
		null,
		null,
		null,
		null,
		517.9,
		568.31,
		69.39,
		25262.08,
		76.12,
		1.25,
		null,
		0.19,
		67.79,
		null,
		0,
		null,
		0,
		0,
		null,
		8,
		null,
		1.12,
		407.62,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.75,
		null,
		0.93,
		339.83,
		null,
		0,
		null,
		0,
		0,
		null,
		482.06,
		519.97,
		301.13,
		11611.78,
		323.62,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		1.89,
		1.44,
		3.75,
		0.57,
		0.24,
		0.01,
		23.625,
		18,
		46.875,
		7.125,
		3,
		0.125,
		7.91,
	],
	[
		"REFSN2GLP-PFR",
		37.9565,
		-8.869,
		"PLATTS - Refinery - Portugal - Sines (2) - GALP",
		217.93,
		229.15,
		71.57,
		8695.62,
		75.55,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Grupo Amorim_Portugese Government_ENI_Other Investors",
		"38.3_30_21.6_10.1",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQD2QRE-PFR",
		36.21537823,
		120.36399247,
		"PLATTS - Refinery - China - Qingdao (2) - Qingdao Refining and Chemical - {Qingdao Petrochemical Works}",
		20,
		21.17,
		2.74,
		1000,
		2.89,
		924.49,
		995.74,
		284.29,
		38026.49,
		303.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		217,
		null,
		29.93,
		10924.82,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		217,
		null,
		29.93,
		10924.82,
		null,
		0,
		null,
		0,
		0,
		null,
		1315.31,
		1413.8,
		323.13,
		58055.96,
		344.91,
		"Sinopec_Shandong ITIC_Qingdao ITIC",
		"85_10_5",
		0,
		"Active",
		null,
		79.24,
		58.92,
		0.49,
		11.91,
		17.6,
		17.69,
		43.06521739,
		32.02173913,
		0.26630435,
		6.47282609,
		9.56521739,
		9.61413043,
		185.86,
	],
	[
		"REFSNABRI-PFR",
		14.2656,
		-89.6433,
		"PLATTS - Refinery - Guatemala - Santa Elena - Basic Resources International",
		null,
		null,
		null,
		null,
		null,
		8.5,
		9.12,
		1.22,
		446,
		1.31,
		1,
		null,
		0.15,
		54.23,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.15,
		54.23,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Union Pacific",
		"100",
		null,
		"Active",
		null,
		0.2,
		0.1,
		0.3,
		0.1,
		0,
		0,
		20,
		10,
		30,
		10,
		0,
		0,
		0.7,
	],
	[
		"REFQDOQKS-PFR",
		36.05854,
		120.22107,
		"PLATTS - Refinery - China - Qingdao - Qingdao Petrochemical Works",
		null,
		null,
		null,
		null,
		null,
		255.26,
		275.74,
		36.22,
		12955.11,
		39.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		42,
		null,
		5.79,
		2114.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		42,
		null,
		5.79,
		2114.48,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec_Shandong ITIC_Qingdao ITIC",
		"85_10_5",
		null,
		"Active",
		null,
		13.18,
		22.06,
		0.52,
		3.23,
		5.87,
		9.01,
		24.86792453,
		41.62264151,
		0.98113208,
		6.09433962,
		11.0754717,
		17,
		53.87,
	],
	[
		"REFQNDQES-PFR",
		-22.1647,
		144.5845,
		"PLATTS - Refinery - Australia - Queensland - Queensland Energy Resources",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		8,
		8.34,
		1.1,
		400,
		1.14,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Queensland Energy Resources",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSNNONO-PFR",
		37.959655,
		-8.805522,
		"PLATTS - Refinery - Portugal - Sines - Octano",
		null,
		null,
		null,
		null,
		null,
		1.15,
		1.23,
		0.15,
		50.05,
		0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Fortum_Petrogal_Finpetro_Total",
		"65_26.25_4.55_4.2",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRAMOON-PFR",
		51.9229,
		4.4632,
		"PLATTS - Refinery - Netherlands - Rotterdam - Odfjell Pet Ind Distillation",
		null,
		null,
		null,
		null,
		null,
		14,
		14.6,
		1.92,
		700,
		2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Odfjell SE",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRAOSSS-PFR",
		35.4151,
		119.5215,
		"PLATTS - Refinery - China - Rizhao - Shandong Shi Da Science and Technlgy",
		null,
		null,
		null,
		null,
		null,
		93,
		100.66,
		12.73,
		4646.48,
		13.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Shi Da Science and Technlgy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPROPBF-PFR",
		39.83787,
		-75.25639,
		"PLATTS - Refinery - United States - Paulsboro - PBF Energy Company LLC",
		7,
		7.3,
		0.95,
		350,
		1,
		347.07,
		364.83,
		119.94,
		13673.28,
		125.8,
		10.58,
		null,
		1.57,
		574,
		null,
		0,
		null,
		0,
		0,
		null,
		100,
		null,
		13.82,
		5044.18,
		null,
		null,
		null,
		null,
		null,
		null,
		2.15,
		null,
		0.29,
		104.88,
		null,
		10.08,
		null,
		1.31,
		478.32,
		null,
		70.87,
		null,
		9.78,
		3567.9,
		null,
		6.32,
		null,
		0.87,
		319.08,
		null,
		null,
		null,
		null,
		null,
		null,
		"PBF Energy Company LLC",
		"100",
		null,
		"Active",
		null,
		39.78,
		65.73,
		1.82,
		11.54,
		2.26,
		0,
		29.59381044,
		48.89897337,
		1.35396518,
		8.58503199,
		1.68129743,
		0,
		121.14,
	],
	[
		"REFRAUODC-PFR",
		-1.678475,
		101.472183,
		"PLATTS - Refinery - Indonesia - Riau - Oman Refinery Company Ltd.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		810.4,
		886.22,
		109.44,
		39795.59,
		119.45,
		"ORPIC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPRTPFE-PFR",
		54.267548,
		-128.537637,
		"PLATTS - Refinery - Canada - Prince Rupert - Pacific Future Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		5124.5,
		5392.3,
		2145.7,
		182755.9,
		2262.2,
		"Pacific Future Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRDIADR-PFR",
		33.553241,
		73.073258,
		"PLATTS - Refinery - Pakistan - Rawalpindi - Attock Refinery Ltd.",
		null,
		null,
		null,
		null,
		null,
		112.42,
		121.83,
		37.03,
		4232.59,
		39.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		38.64,
		null,
		5.03,
		1834.01,
		null,
		87.41,
		95.4,
		47.16,
		2501.92,
		50.82,
		0,
		null,
		0,
		0,
		null,
		38.64,
		null,
		5.03,
		1834.01,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Attock Oil Co._Pakistan State Oil Co._Other Investors",
		"49_26_25",
		null,
		"Active",
		null,
		13.03,
		9.19,
		8.2,
		4.61,
		1.19,
		2.55,
		31.02380952,
		21.88095238,
		19.52380952,
		10.97619048,
		2.83333333,
		6.07142857,
		38.76,
	],
	[
		"REFREACCR-PFR",
		50.48508,
		-104.576185,
		"PLATTS - Refinery - Canada - Regina - Consumers Co-Op. Ref. Ltd.",
		null,
		null,
		null,
		null,
		null,
		557.13,
		586.9,
		184.04,
		21399.28,
		194.33,
		64.56,
		null,
		9.59,
		3501.16,
		null,
		0,
		null,
		0,
		0,
		null,
		84,
		null,
		12.15,
		4435.82,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		15.56,
		null,
		2.02,
		738.33,
		null,
		0,
		null,
		0,
		0,
		null,
		3.89,
		null,
		0.54,
		196.33,
		null,
		null,
		null,
		null,
		null,
		null,
		"Consumers Co-Op. Ref. Ltd.",
		"100",
		null,
		"Active",
		null,
		25.05,
		48.59,
		18.89,
		6.04,
		8.87,
		0,
		23.19444444,
		44.99074074,
		17.49074074,
		5.59259259,
		8.21296296,
		0,
		107.43,
	],
	[
		"REFPTIPBZ-PFR",
		44.87464,
		26.01009,
		"PLATTS - Refinery - Romania - Ploiesti - Petrobrazi S.A.",
		111.41,
		117.73,
		39.43,
		4417.96,
		41.72,
		1143.76,
		1199.71,
		848.5,
		18194.38,
		885.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71,
		null,
		9.79,
		3574.49,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71,
		null,
		9.79,
		3574.49,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"OMV_Soc. Natl. A Petrol_Other Investors_EBRD",
		"51_40.75_6.25_2",
		null,
		"Active",
		null,
		32.44,
		36.02,
		3,
		4.19,
		4.89,
		3.95,
		37.28735632,
		41.40229885,
		3.44827586,
		4.81609195,
		5.62068966,
		4.54022989,
		84.49,
	],
	[
		"REFRNGIRP-PFR",
		12.65426,
		101.29944,
		"PLATTS - Refinery - Thailand - Rayong - IRPC - {Muang}",
		91.8,
		96.89,
		36.64,
		3181.15,
		38.73,
		657.81,
		693.45,
		262.57,
		22960.49,
		274.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		175.31,
		null,
		23.53,
		8587.17,
		null,
		null,
		null,
		null,
		null,
		null,
		15.16,
		null,
		2.03,
		739.77,
		null,
		75.05,
		null,
		9.76,
		3562.06,
		null,
		79.92,
		null,
		11.02,
		4023.36,
		null,
		5.19,
		null,
		0.72,
		261.98,
		null,
		null,
		null,
		null,
		null,
		null,
		"IRPC",
		"100",
		null,
		"Active",
		null,
		75.69,
		22.12,
		5.62,
		19.16,
		15.14,
		39.57,
		37.10294118,
		10.84313725,
		2.75490196,
		9.39215686,
		7.42156863,
		19.39705882,
		177.3,
	],
	[
		"REFPUCEXM-PFR",
		1.268,
		103.697828,
		"PLATTS - Refinery - Singapore - Pulau Ayer Chawan - ExxonMobil - {Jurong Island}",
		null,
		null,
		null,
		null,
		null,
		2068.04,
		2185.04,
		686.69,
		79363.01,
		721.06,
		0,
		null,
		0,
		0,
		null,
		11.06,
		null,
		1.64,
		599.06,
		null,
		402.92,
		null,
		54.11,
		19748.56,
		null,
		null,
		null,
		null,
		null,
		null,
		155.49,
		null,
		20.79,
		7587.48,
		null,
		117.89,
		null,
		15.33,
		5595.56,
		null,
		104.67,
		null,
		14.44,
		5269.47,
		null,
		13.81,
		null,
		1.91,
		696.99,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		85.8,
		95.56,
		62.6,
		106.84,
		3.86,
		7.69,
		20.57109976,
		22.9111223,
		15.00875111,
		25.61557458,
		0.92545973,
		1.84372677,
		362.36,
	],
	[
		"REFRRAAR2-PFR",
		26.7074,
		50.0674,
		"PLATTS - Refinery - Saudi Arabia - Ras Tanura - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1145,
		1251.69,
		160.72,
		58668.05,
		175.61,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPULPNA-PFR",
		-38.9338,
		-69.1987,
		"PLATTS - Refinery - Argentina - Plaza Huincul - Petrolera Argentina",
		42.97,
		47.17,
		5.69,
		2068.82,
		6.25,
		9.65,
		10.58,
		1.25,
		452.82,
		1.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.28,
		100.97,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.28,
		100.97,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrolera Argentina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQDOQLT-PFR",
		36.0638,
		120.3781,
		"PLATTS - Refinery - China - Qingdao - Qingdao Guangyuanfa Asphalt",
		87.76,
		97.05,
		13.12,
		4511.92,
		14.47,
		29,
		31.13,
		4.38,
		1600.11,
		4.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ChemChina_Qingdao Guangyuanfa Asphalt_Blackstone Group",
		"47_33_20",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQUOQRC-PFR",
		45.1093,
		124.8257,
		"PLATTS - Refinery - China - Qianguo - Qiangu Refinery Co.",
		null,
		null,
		null,
		null,
		null,
		119.28,
		127.59,
		17.01,
		6210.3,
		18.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Songyuan Municipal Government",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSOAFUJ-PFR",
		35.465953,
		140.00945,
		"PLATTS - Refinery - Japan - Sodegaura - Fuji Oil Company, Ltd.",
		null,
		null,
		null,
		null,
		null,
		549.57,
		581.01,
		86.01,
		26634.64,
		90.93,
		0.1,
		null,
		0.01,
		4.47,
		null,
		1.71,
		null,
		0.26,
		92.61,
		null,
		92.73,
		null,
		12.56,
		4587.71,
		null,
		null,
		null,
		null,
		null,
		null,
		52,
		null,
		6.96,
		2537.68,
		null,
		2.66,
		null,
		0.35,
		126.27,
		null,
		36.28,
		null,
		5.01,
		1826.67,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Tokyo Electric_Fidelity_Kuwait National Petroleum Corp._Saudi Aramco",
		"58.6_8.74_7.73_7.43_7.43",
		0,
		"Active",
		null,
		43.3,
		32.53,
		0.5,
		18.99,
		7.37,
		13.72,
		38.21037769,
		28.70631839,
		0.44122838,
		16.75785387,
		6.50370632,
		12.10730674,
		116.41,
	],
	[
		"REFQZUFTD-PFR",
		24.8755,
		118.6724,
		"PLATTS - Refinery - China - Quanzhou - Fujian Petrochem. Co. Ltd",
		642.54,
		690.13,
		166.23,
		28017.12,
		177.32,
		949.39,
		1015.48,
		432.72,
		30141.43,
		459.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		186.96,
		null,
		25.79,
		9412.63,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		186.96,
		null,
		25.79,
		9412.63,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec_ExxonMobil_Saudi Aramco",
		"50_25_25",
		null,
		"Active",
		null,
		59.67,
		69.37,
		11.87,
		20.68,
		15.01,
		22.85,
		29.96083551,
		34.83129142,
		5.96003213,
		10.38361117,
		7.53665395,
		11.47318739,
		199.44,
	],
	[
		"REFSOLSNY-PFR",
		5.3759505,
		-75.0651147,
		"PLATTS - Refinery - Colombia - Sebastopol - Sebastopol Company",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		442.16,
		478.78,
		169.4,
		16274.82,
		180.73,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sebastopol Company",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRTAOSK-PFR",
		48.3862,
		20.0409,
		"PLATTS - Refinery - Slovakia - Rimavska Sobota - Oil Prod and Trade OPT Sk",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		133.08,
		140.8,
		18.24,
		6623.34,
		19.27,
		"Oil Prod and Trade OPT Sk",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFORDORY-PFR",
		34.195449,
		-119.125795,
		"PLATTS - Refinery - United States - Oxnard - Oxnard Refinery",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tenby Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQZUSIO-PFR",
		24.86308,
		118.67354,
		"PLATTS - Refinery - China - Quanzhou - Sinochem",
		null,
		null,
		null,
		null,
		null,
		962.24,
		1036.77,
		218.39,
		42777.65,
		233.67,
		34.69,
		null,
		5.15,
		1880.86,
		null,
		34.69,
		null,
		5.14,
		1878.08,
		null,
		231.19,
		null,
		32.62,
		11906.74,
		null,
		847.52,
		912.24,
		164.49,
		39665.41,
		176.09,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		161.84,
		null,
		22.32,
		8147.8,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinochem_Kuwait Petroleum Corp._Total",
		"51_24.5_24.5",
		null,
		"Active",
		null,
		53.54,
		91.51,
		36.29,
		16.29,
		23.14,
		14.05,
		21.88343007,
		37.40292651,
		14.83282923,
		6.65821957,
		9.45802338,
		5.74266329,
		234.82,
	],
	[
		"REFRTTPUS-PFR",
		48.66036,
		7.763643,
		"PLATTS - Refinery - France - Reichstett - Petroplus",
		null,
		null,
		null,
		null,
		null,
		-0.02,
		0.03,
		0.01,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroplus",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFOTAJNO-PFR",
		33.273188,
		131.687585,
		"PLATTS - Refinery - Japan - Oita - ENEOS",
		null,
		null,
		null,
		null,
		null,
		568.27,
		598.56,
		195.99,
		21574.36,
		205.22,
		0.09,
		null,
		0.01,
		4.69,
		null,
		1.79,
		null,
		0.27,
		97.14,
		null,
		97.33,
		null,
		13.21,
		4820.51,
		null,
		null,
		null,
		null,
		null,
		null,
		56,
		null,
		7.49,
		2732.62,
		null,
		0,
		null,
		0,
		0,
		null,
		38.05,
		null,
		5.25,
		1915.63,
		null,
		1.4,
		null,
		0.19,
		70.44,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon",
		"100",
		null,
		"Active",
		null,
		26.91,
		25.08,
		24.48,
		20.12,
		9.15,
		10.83,
		22.88459903,
		21.32834425,
		20.81809678,
		17.11029849,
		7.78127392,
		9.20996683,
		116.58,
	],
	[
		"REFRANVES-PFR",
		26.8106,
		73.7685,
		"PLATTS - Refinery - India - Rajasthan - Vedanta Resources",
		604.3,
		664.38,
		82.39,
		29963.78,
		90.49,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vedanta Resources",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSOSPTS-PFR",
		-23.190845,
		-45.820716,
		"PLATTS - Refinery - Brazil - Sao Jose Dos Campos - Petrobras - {REVAP - Henrique Lage}",
		null,
		null,
		null,
		null,
		null,
		775.72,
		815.8,
		116.97,
		38437.07,
		123.04,
		138.51,
		null,
		20.58,
		7511.96,
		null,
		0,
		null,
		0,
		0,
		null,
		195,
		null,
		28.14,
		10270.3,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		29.99,
		null,
		3.9,
		1423.32,
		null,
		21.81,
		null,
		3.01,
		1097.83,
		null,
		4.7,
		null,
		0.65,
		237.19,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		75.99,
		49.85,
		13.02,
		11.49,
		17.19,
		11.78,
		40.65810594,
		26.67201712,
		6.96629213,
		6.14767255,
		9.19743178,
		6.30283574,
		179.32,
	],
	[
		"REFPATRLS-PFR",
		5.2727,
		115.3174,
		"PLATTS - Refinery - Malaysia - Pulau Daat - RG Gas and Chemicals",
		85.04,
		89.92,
		11.72,
		4262.9,
		12.4,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"RG Gas and Chemicals_Zhuhai Winbase International",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRUFLCO-PFR",
		30.479104,
		18.567941,
		"PLATTS - Refinery - Libya - Ras Lanuf - LERCO",
		null,
		null,
		null,
		null,
		null,
		0,
		0.02,
		-0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		737.58,
		807.4,
		101.78,
		36617.86,
		111.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company_Al Ghurair Trasta Energy",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSRDATS-PFR",
		53.794672,
		-113.113241,
		"PLATTS - Refinery - Canada - Scotford - Air Products",
		null,
		null,
		null,
		null,
		null,
		150,
		158.7,
		150,
		150,
		158.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPAYNRC-PFR",
		47.8845,
		-54.2133,
		"PLATTS - Refinery - Canada - Placentia Bay - NLRC",
		851.81,
		892.87,
		177.94,
		38812.97,
		187.15,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NLRC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRW3ABO-PFR",
		24.0897,
		52.6482,
		"PLATTS - Refinery - United Arab Emirates - Ruwais (3) - Abu Dhabi Oil Refining Co - {Ruwais#2}",
		640.6,
		704.98,
		89.23,
		31987.18,
		98.09,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"ADNOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSRDSCL-PFR",
		53.795771,
		-113.097285,
		"PLATTS - Refinery - Canada - Scotford - Shell Canada Ltd. - {Ft. Saskatchewan}",
		null,
		null,
		null,
		null,
		null,
		497.26,
		524.07,
		257.09,
		13759.06,
		271.73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		72.29,
		null,
		10,
		3649.61,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		72.29,
		null,
		10,
		3649.61,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		0,
		"Active",
		null,
		46.4,
		25.38,
		0,
		4.93,
		3.14,
		5.08,
		58,
		31.725,
		0,
		6.1625,
		3.925,
		6.35,
		84.93,
	],
	[
		"REFPBASHL-PFR",
		-27.419492,
		153.127072,
		"PLATTS - Refinery - Australia - Pinkenba - Shell",
		null,
		null,
		null,
		null,
		null,
		8.8,
		9.36,
		1.36,
		492.38,
		1.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRERNIP-PFR",
		53.843174,
		-113.124305,
		"PLATTS - Refinery - Canada - Redwater - North West Redwater Partnership",
		531.16,
		561.46,
		290.89,
		15115.56,
		307.39,
		505.16,
		531.8,
		286.73,
		13597.16,
		302.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45,
		null,
		6.22,
		2271.78,
		null,
		505.16,
		531.8,
		286.73,
		13597.16,
		302.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45,
		null,
		6.22,
		2271.78,
		null,
		null,
		null,
		null,
		null,
		null,
		"North West Redwater Partnership",
		"100",
		null,
		"Active",
		null,
		18.85,
		2.05,
		0.5,
		1.52,
		0.65,
		1.55,
		75.4,
		8.2,
		2,
		6.08,
		2.6,
		6.2,
		25.12,
	],
	[
		"REFSSIPRT-PFR",
		-3.6447,
		119.9472,
		"PLATTS - Refinery - Indonesia - South Sulawesi - Pertamina",
		700.4,
		764.48,
		96.88,
		35355.84,
		105.6,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp._Pertamina",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPBOSMS-PFR",
		5.8216,
		-55.177,
		"PLATTS - Refinery - Suriname - Paramaribo - Staatsolie Maatschappij Suriname N.",
		null,
		null,
		null,
		null,
		null,
		78.13,
		85.15,
		28.32,
		3042.77,
		30.58,
		10,
		null,
		1.49,
		542.35,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		null,
		1.49,
		542.35,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Staatsolie Maatschappij Suriname N.",
		"100",
		null,
		"Active",
		null,
		3.8,
		1.4,
		3.9,
		0,
		0,
		0,
		38,
		14,
		39,
		0,
		0,
		0,
		9.1,
	],
	[
		"REFSAAATS-PFR",
		42.902467,
		-82.45515,
		"PLATTS - Refinery - Canada - Sarnia - Air Products",
		null,
		null,
		null,
		null,
		null,
		80,
		84.64,
		80,
		80,
		84.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSUEPDV-PFR",
		9.301333,
		-64.686652,
		"PLATTS - Refinery - Venezuela - San Roque - PDVSA",
		null,
		null,
		null,
		null,
		null,
		7.35,
		7.89,
		1.03,
		375.29,
		1.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRGHPGH-PFR",
		22.718295,
		39.015714,
		"PLATTS - Refinery - Saudi Arabia - Rabigh - Petro Rabigh - {Rabigh Refining and Petrochemical Company}",
		null,
		null,
		null,
		null,
		null,
		1545.1,
		1694.15,
		327.45,
		69262.6,
		354.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		307.86,
		null,
		42.46,
		15498.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		307.86,
		null,
		42.46,
		15498.86,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco_Sumitomo Group_Other Investors",
		"37.5_37.5_25",
		null,
		"Active",
		null,
		88.69,
		83.07,
		83.26,
		41.65,
		-5.65,
		27.09,
		25.46221865,
		23.84875976,
		23.9033073,
		11.9573955,
		-1.62207166,
		7.77733119,
		318.13,
	],
	[
		"REFPBYPUY-PFR",
		-9.4743,
		147.16,
		"PLATTS - Refinery - Papua New Guinea - Port Moresby - Puma Energy - {Napa Napa}",
		null,
		null,
		null,
		null,
		null,
		43,
		45.89,
		5.69,
		2074.34,
		6.07,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		27,
		null,
		3.51,
		1281.53,
		null,
		26,
		27.76,
		3.43,
		1254.61,
		3.67,
		0,
		null,
		0,
		0,
		null,
		27,
		null,
		3.51,
		1281.53,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Trafigura_Sonangol_Other Investors",
		"49_30_21",
		null,
		"Active",
		null,
		14.67,
		4.16,
		3.33,
		2.39,
		-0.2,
		1.35,
		56.42307692,
		16,
		12.80769231,
		9.19230769,
		-0.76923077,
		5.19230769,
		25.69,
	],
	[
		"REFSAANOV-PFR",
		42.882281,
		-82.406601,
		"PLATTS - Refinery - Canada - Sarnia - Nova Chemicals",
		null,
		null,
		null,
		null,
		null,
		217.16,
		228.95,
		30.43,
		11108.8,
		32.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		28.63,
		null,
		3.72,
		1359.01,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		28.63,
		null,
		3.72,
		1359.01,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nova Chemicals",
		"100",
		null,
		"Active",
		null,
		5.55,
		12.08,
		1.97,
		1.71,
		0.45,
		6.64,
		18.5,
		40.26666667,
		6.56666667,
		5.7,
		1.5,
		22.13333333,
		28.4,
	],
	[
		"REFSUNPTC-PFR",
		30.9971,
		105.8819,
		"PLATTS - Refinery - China - Sichun - PetroChina",
		3,
		3.17,
		0.41,
		150,
		0.43,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRKAINA-PFR",
		45.283375,
		14.537173,
		"PLATTS - Refinery - Croatia - Rijeka - INA",
		null,
		null,
		null,
		null,
		null,
		381.72,
		417.22,
		113.06,
		15910.35,
		122.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31.37,
		null,
		4.19,
		1527.83,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		18,
		null,
		2.34,
		854.35,
		null,
		13.38,
		null,
		1.85,
		673.49,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"MOL_Croatia State Co._Other Investors",
		"47.15_44.84_8.01",
		null,
		"Active",
		null,
		15.1,
		12.23,
		7.38,
		1.6,
		3.16,
		0.27,
		38.71794872,
		31.35897436,
		18.92307692,
		4.1025641,
		8.1025641,
		0.69230769,
		39.74,
	],
	[
		"REFPCOPOL-PFR",
		-13.71,
		-76.203,
		"PLATTS - Refinery - Peru - Pisco - Pluspetrol - {La Pampilla}",
		null,
		null,
		null,
		null,
		null,
		55,
		59.04,
		6.47,
		2361.76,
		6.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pluspetrol",
		"100",
		null,
		"Active",
		null,
		2.88,
		6.77,
		0.44,
		1.55,
		0.1,
		7.56,
		14.4,
		33.85,
		2.2,
		7.75,
		0.5,
		37.8,
		19.29,
	],
	[
		"REFSAASC2-PFR",
		42.90319,
		-82.451123,
		"PLATTS - Refinery - Canada - Sarnia - Shell Canada Ltd.",
		951.27,
		1000.56,
		332.55,
		37200.74,
		351.05,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSYOSOG-PFR",
		-6.1334,
		12.3718,
		"PLATTS - Refinery - Angola - Soyo - Sonangol",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		293,
		320.56,
		39.79,
		14312.05,
		43.56,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonangol",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRLTSLV-PFR",
		40.2994,
		-109.9888,
		"PLATTS - Refinery - United States - Roosevelt - Silver Eagle Refining",
		null,
		null,
		null,
		null,
		null,
		19.58,
		20.66,
		2.62,
		950.04,
		2.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pennzoil-Quaker State Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPEIARS-PFR",
		44.795808,
		24.932331,
		"PLATTS - Refinery - Romania - Pitesti - Arpechim S.A.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.02,
		3.08,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"OMV_Soc. Natl. A Petrol_Other Investors_EBRD",
		"51_40.75_6.25_2",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSAASCL-PFR",
		42.90319,
		-82.451123,
		"PLATTS - Refinery - Canada - Sarnia - Shell Canada Ltd.",
		15,
		15.64,
		2.05,
		750,
		2.14,
		166.38,
		174.85,
		22.75,
		8268.9,
		23.88,
		3.82,
		null,
		0.57,
		207.05,
		null,
		0,
		null,
		0,
		0,
		null,
		46.77,
		null,
		6.21,
		2268.45,
		null,
		null,
		null,
		null,
		null,
		null,
		17.18,
		null,
		2.3,
		838.3,
		null,
		25.77,
		null,
		3.35,
		1223.11,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		13.03,
		19.72,
		5.76,
		2.87,
		4.03,
		3.88,
		26.59183673,
		40.24489796,
		11.75510204,
		5.85714286,
		8.2244898,
		7.91836735,
		49.29,
	],
	[
		"REFSYSPHX-PFR",
		39.386561,
		-81.206039,
		"PLATTS - Refinery - United States - Saint Marys - Phoenix Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phoenix Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRNASRR-PFR",
		44.429004,
		12.229764,
		"PLATTS - Refinery - Italy - Ravenna - Sarom Raffinazione",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPEYQIL-PFR",
		2.89,
		101.3586,
		"PLATTS - Refinery - Malaysia - Pulau Carey - Qingdao TopOil",
		606.4,
		643.03,
		80.95,
		29398.93,
		85.77,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qingdao TopOil_Global PLB",
		"60_40",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSAHSNE-PFR",
		17.0149,
		54.0957,
		"PLATTS - Refinery - Oman - Salalah - Salalah Free Zone",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		327.15,
		359.97,
		44.54,
		16202.16,
		49,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Salalah Free Zone",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSZUTKK-PFR",
		35.026675,
		138.493844,
		"PLATTS - Refinery - Japan - Shimizu - Tonengeneral Sekiyu K.K.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tonen_Exxon Corp._Mobil",
		"50_25_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSASRVN-PFR",
		12.43048,
		-69.89942,
		"PLATTS - Refinery - Aruba - San Nicholas - Refineria di Aruba N.V. - {CITGO Aruba}",
		800.48,
		874.71,
		200.42,
		36581.59,
		217.39,
		1.7,
		1.83,
		1.7,
		1.71,
		1.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		363.13,
		394.11,
		109.49,
		15163.92,
		118.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Government of Aruba",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPILGNY-PFR",
		-0.7149,
		8.7797,
		"PLATTS - Refinery - Gabon - Port Gentil - Gabon Oil Company",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		165.1,
		181.12,
		22.37,
		8131.25,
		24.55,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gabon Oil Company",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTAACNY-PFR",
		30.793482,
		30.957611,
		"PLATTS - Refinery - Egypt - Tanta - Cairo Oil Refining Company",
		null,
		null,
		null,
		null,
		null,
		40,
		43.59,
		5.48,
		2000,
		5.97,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31,
		null,
		4.28,
		1560.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		31,
		null,
		4.28,
		1560.69,
		null,
		0,
		null,
		0,
		0,
		null,
		176.06,
		193.03,
		93.64,
		5036.09,
		102.19,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		5.22,
		0,
		14.48,
		3.45,
		0,
		7.3,
		16.87681862,
		0,
		46.81538959,
		11.1542192,
		0,
		23.60168122,
		30.45,
	],
	[
		"REFSAYVRO-PFR",
		35.951,
		-101.8785,
		"PLATTS - Refinery - United States - Sunray - Valero - {McKee}",
		null,
		null,
		null,
		null,
		null,
		661.23,
		696.48,
		114.8,
		30937.42,
		121.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		161.28,
		null,
		20.97,
		7655.13,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		161.28,
		null,
		20.97,
		7655.13,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		62.04,
		103.5,
		1.01,
		10.56,
		5.08,
		0,
		34.3902439,
		57.37250554,
		0.55986696,
		5.85365854,
		2.81596452,
		0,
		182.2,
	],
	[
		"REFPIMTAR-PFR",
		24.77536,
		67.35881,
		"PLATTS - Refinery - Pakistan - Port Qasim - TransAsia Refinery Ltd.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		263.89,
		289.67,
		35.45,
		12913.06,
		38.89,
		"IPIC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTAHFRP-PFR",
		38.05854,
		-117.0967,
		"PLATTS - Refinery - United States - Tonopah - Foreland Corp",
		null,
		null,
		null,
		null,
		null,
		11,
		11.65,
		1.6,
		587.35,
		1.7,
		3.17,
		null,
		0.47,
		172.01,
		null,
		0,
		null,
		0,
		0,
		null,
		3.17,
		null,
		0.47,
		172.01,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Energy Income Fund",
		"100",
		null,
		"Active",
		null,
		0.52,
		0.38,
		1.02,
		0.39,
		0,
		0,
		13.68421053,
		10,
		26.84210526,
		10.26315789,
		0,
		0,
		2.31,
	],
	[
		"REFSCHSAS-PFR",
		39.07774,
		9.021814,
		"PLATTS - Refinery - Italy - Sarroch - Saras Raffinerie Sarde",
		70,
		74.05,
		9.34,
		3411.21,
		9.89,
		1590.26,
		1667.1,
		806.59,
		46250.84,
		843.69,
		12.13,
		null,
		1.8,
		657.62,
		null,
		0.8,
		null,
		0.12,
		43.78,
		null,
		232,
		null,
		30.89,
		11277.48,
		null,
		6,
		6.84,
		0.96,
		350.4,
		1.1,
		4.04,
		null,
		0.54,
		197.23,
		null,
		155.39,
		null,
		20.21,
		7375.81,
		null,
		51.54,
		null,
		7.11,
		2594.95,
		null,
		8.08,
		null,
		1.11,
		408.1,
		null,
		null,
		null,
		null,
		null,
		null,
		"Moratti Group_Other Investors_Rosneft",
		"50.02_28.98_21",
		null,
		"Active",
		null,
		144.72,
		81.57,
		9.04,
		13.75,
		5.22,
		25.53,
		50.42508711,
		28.42160279,
		3.14982578,
		4.79094077,
		1.81881533,
		8.89547038,
		279.82,
	],
	[
		"REFPIPPIR-PFR",
		20.2869,
		86.674,
		"PLATTS - Refinery - India - Paradip - Praxair",
		null,
		null,
		null,
		null,
		null,
		90,
		96.62,
		90,
		90,
		96.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTCEPBF-PFR",
		33.8555,
		-118.3367,
		"PLATTS - Refinery - United States - Torrance - PBF Energy Company LLC",
		null,
		null,
		null,
		null,
		null,
		747.56,
		788,
		236.8,
		30709.31,
		250.12,
		107.15,
		null,
		15.92,
		5811.04,
		null,
		0,
		null,
		0,
		0,
		null,
		107.9,
		null,
		16.02,
		5848.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0.75,
		null,
		0.1,
		37.84,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PBF Energy Company LLC",
		"100",
		null,
		"Active",
		null,
		26.04,
		73.44,
		1.26,
		24.59,
		-0.98,
		0,
		20.14232673,
		56.80693069,
		0.97462871,
		19.0207302,
		-0.75804455,
		0,
		124.34,
	],
	[
		"REFSCSATS-PFR",
		29.91957,
		-90.35289,
		"PLATTS - Refinery - United States - Saint Charles - Air Products",
		null,
		null,
		null,
		null,
		null,
		300,
		317.39,
		300,
		300,
		317.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPIRPRA-PFR",
		-3.7933,
		119.6529,
		"PLATTS - Refinery - Indonesia - Pinrang - PT Kilang Parepare Nusantara",
		625.4,
		677.08,
		193.3,
		24916.06,
		206.5,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PT Kilang Parepare Nusantara_Arrow Development",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTDEPUS-PFR",
		54.600835,
		-1.185052,
		"PLATTS - Refinery - United Kingdom - Teesside - Petroplus",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		-0.02,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroplus",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSCSVRO-PFR",
		29.994449,
		-90.393875,
		"PLATTS - Refinery - United States - Saint Charles - Valero",
		55.45,
		58.15,
		8.21,
		2834.45,
		8.63,
		1244.35,
		1311.05,
		216.91,
		59166.17,
		228.75,
		27.13,
		null,
		4.03,
		1471.14,
		null,
		0,
		null,
		0,
		0,
		null,
		123,
		null,
		17.25,
		6297.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		95.87,
		null,
		13.22,
		4826.79,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		64.28,
		101.94,
		2.82,
		11.05,
		7,
		1.53,
		68.82963915,
		109.1551558,
		3.01959525,
		11.83210194,
		7.49544919,
		1.63829104,
		188.62,
	],
	[
		"REFPJNPEL-PFR",
		41.1169,
		122.0655,
		"PLATTS - Refinery - China - Panjin - Panjin North Asphalt Fuel",
		null,
		null,
		null,
		null,
		null,
		489,
		528.12,
		70.01,
		24822.14,
		75.54,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Panjin North Asphalt Fuel",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSCZRRO-PFR",
		-17.3333,
		-61.5,
		"PLATTS - Refinery - Bolivia - Santa Cruz - Refineria Oro Negro",
		null,
		null,
		null,
		null,
		null,
		6.95,
		7.64,
		0.88,
		321.55,
		0.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3,
		null,
		0.39,
		142.39,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		3,
		null,
		0.39,
		142.39,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Refineria Oro Negro",
		"100",
		null,
		"Active",
		null,
		0.76,
		1.28,
		0.29,
		0.3,
		0.15,
		0.08,
		25.33333333,
		42.66666667,
		9.66666667,
		10,
		5,
		2.66666667,
		2.86,
	],
	[
		"REFPKIDSS-PFR",
		59.3491,
		24.0802,
		"PLATTS - Refinery - Estonia - Paldiski - DMSS",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		356.8,
		391.96,
		50.11,
		17632.54,
		54.95,
		"DMSS",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSENPTC-PFR",
		22.5555,
		114.0543,
		"PLATTS - Refinery - China - Shenzhen - PetroChina",
		1122.95,
		1205.34,
		314.41,
		48523.88,
		335.13,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._PDVSA",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPLRKAM-PFR",
		52.370806,
		76.912632,
		"PLATTS - Refinery - Kazakhstan - Pavlodar - KazMunayGaz",
		null,
		null,
		null,
		null,
		null,
		626.59,
		688.56,
		140.81,
		28597.22,
		153.31,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		88.2,
		null,
		12.17,
		4440.38,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		88.2,
		null,
		12.17,
		4440.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KazMunayGaz_Samruk-Kazyna",
		"58_42",
		null,
		"Active",
		null,
		31.08,
		35.87,
		15.52,
		3.93,
		5.48,
		-0.07,
		31.00868004,
		35.78768832,
		15.48438591,
		3.92098174,
		5.46742492,
		-0.06983937,
		91.8,
	],
	[
		"REFTDOBBP-PFR",
		41.67858,
		-83.453356,
		"PLATTS - Refinery - United States - Toledo - BP",
		null,
		null,
		null,
		null,
		null,
		639.58,
		672.87,
		146.86,
		29175.6,
		154.87,
		115.36,
		null,
		17.14,
		6256.06,
		null,
		0,
		null,
		0,
		0,
		null,
		135.22,
		null,
		19.84,
		7242.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5.54,
		null,
		0.72,
		262.54,
		null,
		0.7,
		null,
		0.1,
		35.34,
		null,
		13.64,
		null,
		1.88,
		688.56,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_Husky Oil",
		"50_50",
		0,
		"Active",
		null,
		29.44,
		74.28,
		2.58,
		8.94,
		3,
		0,
		23.2433286,
		58.64519185,
		2.03694931,
		7.05826622,
		2.36854571,
		0,
		118.22,
	],
	[
		"REFSETSOM-PFR",
		37.07175,
		-84.60932,
		"PLATTS - Refinery - United States - Somerset - Somerset Refinery",
		null,
		null,
		null,
		null,
		null,
		15.38,
		16.2,
		2.03,
		739.87,
		2.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Continental Refining Company",
		"100",
		null,
		"Active",
		null,
		1.18,
		1.97,
		1.42,
		0.43,
		0.23,
		0.11,
		20.70175439,
		34.56140351,
		24.9122807,
		7.54385965,
		4.03508772,
		1.92982456,
		5.33,
	],
	[
		"REFTDOBOC-PFR",
		41.635823,
		-83.500948,
		"PLATTS - Refinery - United States - Toledo - BOC",
		null,
		null,
		null,
		null,
		null,
		120,
		126.96,
		120,
		120,
		126.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSGISPC-PFR",
		31.463531,
		121.403254,
		"PLATTS - Refinery - China - Shanghai - Shanghai Petrochemical Co.",
		null,
		null,
		null,
		null,
		null,
		1188.04,
		1280.67,
		338.87,
		49594.41,
		361.79,
		29.44,
		null,
		4.37,
		1596.68,
		null,
		0,
		null,
		0,
		0,
		null,
		294.4,
		null,
		40.34,
		14724.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		73.6,
		null,
		9.57,
		3493.39,
		null,
		191.36,
		null,
		26.39,
		9634.04,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec_Other Investors",
		"57.64_42.36",
		null,
		"Active",
		null,
		106.09,
		89.87,
		6.45,
		26.23,
		37.07,
		33.55,
		34.9129562,
		29.57514727,
		2.12261822,
		8.63198078,
		12.19929575,
		11.04090565,
		299.25,
	],
	[
		"REFPMACSL-PFR",
		35.1777426,
		-119.1626079,
		"PLATTS - Refinery - United States - Paloma - Coastal Petroleum Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Coastal Petroleum Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRNDCHN-PFR",
		37.939814,
		-122.389547,
		"PLATTS - Refinery - United States - Richmond - Chevron",
		11.4,
		9.57,
		1.35,
		493.01,
		1.14,
		1388.58,
		1467.39,
		427.82,
		56232.71,
		451.12,
		3.4,
		null,
		0.5,
		184.15,
		null,
		0,
		null,
		0,
		0,
		null,
		196.99,
		null,
		27.07,
		9878.83,
		null,
		null,
		null,
		null,
		null,
		null,
		22.96,
		null,
		3.07,
		1120.18,
		null,
		5.67,
		null,
		0.74,
		269.28,
		null,
		164.26,
		null,
		22.66,
		8269.64,
		null,
		0.7,
		null,
		0.1,
		35.58,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron",
		"100",
		null,
		"Active",
		null,
		43.12,
		137.78,
		4.02,
		52.8,
		-11.14,
		1.65,
		18.26963817,
		58.37640878,
		1.70324549,
		22.37098551,
		-4.71993899,
		0.6990933,
		228.23,
	],
	[
		"REFSHAEST-PFR",
		13.112304,
		100.903051,
		"PLATTS - Refinery - Thailand - Sriracha - Esso Thailand",
		null,
		null,
		null,
		null,
		null,
		503.88,
		533.63,
		110.26,
		22007.6,
		116.08,
		0.84,
		null,
		0.12,
		45.61,
		null,
		0.92,
		null,
		0.14,
		50.1,
		null,
		106.23,
		null,
		14.09,
		5143.15,
		null,
		null,
		null,
		null,
		null,
		null,
		27.09,
		null,
		3.62,
		1321.61,
		null,
		59.36,
		null,
		7.72,
		2817.71,
		null,
		9.61,
		null,
		1.32,
		483.83,
		null,
		8.41,
		null,
		1.17,
		424.29,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Other Investors",
		"66_34",
		null,
		"Active",
		null,
		51.67,
		37.55,
		13.97,
		13.12,
		7.91,
		11.8,
		44.54310345,
		32.37068966,
		12.04310345,
		11.31034483,
		6.81896552,
		10.17241379,
		136.02,
	],
	[
		"REFRNGTIP-PFR",
		12.7944,
		101.3705,
		"PLATTS - Refinery - Thailand - Rayong - Thai International Petroleum Corp. - {Map Ta Phut}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Thai International Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPNDAON-PFR",
		45.562084,
		-122.73826,
		"PLATTS - Refinery - United States - Portland - Alon",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Alon",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTMASOD-PFR",
		47.2768,
		-122.3855,
		"PLATTS - Refinery - United States - Tacoma - Sound Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Crysen Refining Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSHBICO-PFR",
		30.8028,
		47.6014,
		"PLATTS - Refinery - Iraq - Shahban - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		4.5,
		4.83,
		0.62,
		225,
		0.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRRORPA-PFR",
		-22.88669,
		-43.237241,
		"PLATTS - Refinery - Brazil - Rio De Janeiro - Refinaria De Petr. De Manguinhos Sa",
		171.2,
		178.32,
		196.12,
		-1217.93,
		204.48,
		28.79,
		30.24,
		3.88,
		1417.93,
		4.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		9.9,
		null,
		1.29,
		469.9,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		9.9,
		null,
		1.29,
		469.9,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Grupo Andrade Slim",
		"100",
		null,
		"Active",
		null,
		5.14,
		1.85,
		1.15,
		0.6,
		0.66,
		0.33,
		51.91919192,
		18.68686869,
		11.61616162,
		6.06060606,
		6.66666667,
		3.33333333,
		9.74,
	],
	[
		"REFTNAROL-PFR",
		41.177684,
		1.222277,
		"PLATTS - Refinery - Spain - Tarragona - Repsol",
		8.66,
		9.17,
		2.31,
		377.39,
		2.44,
		581.33,
		609.9,
		196.63,
		22545.04,
		206.3,
		15,
		null,
		2.23,
		813.32,
		null,
		0,
		null,
		0,
		0,
		null,
		114.68,
		null,
		15.31,
		5589.3,
		null,
		null,
		null,
		null,
		null,
		null,
		6.17,
		null,
		0.83,
		301.32,
		null,
		81.16,
		null,
		10.55,
		3852.04,
		null,
		6.17,
		null,
		0.85,
		310.88,
		null,
		6.17,
		null,
		0.85,
		311.74,
		null,
		null,
		null,
		null,
		null,
		null,
		"Repsol",
		"100",
		null,
		"Active",
		null,
		68.11,
		20.12,
		12.72,
		20.63,
		3.71,
		0,
		52.39230769,
		15.47692308,
		9.78461538,
		15.86923077,
		2.85384615,
		0,
		125.29,
	],
	[
		"REFTHEXIN-PFR",
		52.7162,
		124.6607,
		"PLATTS - Refinery - China - Tahe - Xinjiang Luntai Tianyuan Chemical",
		null,
		null,
		null,
		null,
		null,
		38,
		40.2,
		5.39,
		1967.2,
		5.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xinjiang Luntai Tianyuan Chemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPOMSEP-PFR",
		1.232481,
		103.766927,
		"PLATTS - Refinery - Singapore - Pulau Bukom - Shell Eastern Petroleum",
		null,
		null,
		null,
		null,
		null,
		924.31,
		983.94,
		162.02,
		44068.21,
		172.26,
		0,
		null,
		0,
		0,
		null,
		8.04,
		null,
		1.19,
		435.13,
		null,
		286.81,
		null,
		38.54,
		14066.98,
		null,
		null,
		null,
		null,
		null,
		null,
		112.94,
		null,
		15.1,
		5511.17,
		null,
		79.78,
		null,
		10.38,
		3786.93,
		null,
		76.03,
		null,
		10.49,
		3827.49,
		null,
		10.03,
		null,
		1.39,
		506.26,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		100.46,
		81.95,
		0,
		76.95,
		5.22,
		17.77,
		32.95715504,
		26.88471885,
		0,
		25.24440654,
		1.71248606,
		5.82966997,
		282.35,
	],
	[
		"REFRSAYNY-PFR",
		15.24543216,
		42.61534189,
		"PLATTS - Refinery - Yemen - Ras Issa - Yemeni Gulf Oil Services Company",
		76.05,
		83.18,
		10.14,
		3682.49,
		11.08,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yemeni Gulf Oil Services Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTOSTPR-PFR",
		47.909469,
		21.032691,
		"PLATTS - Refinery - Hungary - Tiszaujvaros - Tisza Petroleum Refining",
		null,
		null,
		null,
		null,
		null,
		14.73,
		15.8,
		1.97,
		712.95,
		2.12,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_MOL",
		"55.7_44.3",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTIZNIO-PFR",
		38.059211,
		46.161217,
		"PLATTS - Refinery - Iran - Tabriz - National Iranian Oil Co.",
		34,
		36.5,
		4.66,
		1700,
		5,
		519.68,
		569.3,
		154.52,
		21023.79,
		166.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		96,
		null,
		13.09,
		4777.8,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		19.2,
		null,
		2.5,
		911.31,
		null,
		76.8,
		null,
		10.59,
		3866.48,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		45.87,
		22.26,
		4.87,
		6.46,
		4.44,
		3.73,
		45.87,
		22.26,
		4.87,
		6.46,
		4.44,
		3.73,
		87.63,
	],
	[
		"REFPOONST-PFR",
		60.31176,
		25.50854,
		"PLATTS - Refinery - Finland - Porvoo - Neste Oil",
		null,
		null,
		null,
		null,
		null,
		1008.73,
		1062.45,
		348.24,
		38643.22,
		367.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		220,
		null,
		30.05,
		10969.7,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		37,
		null,
		4.81,
		1756.18,
		null,
		180,
		null,
		24.83,
		9062.07,
		null,
		3,
		null,
		0.41,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Neste Oil",
		"100",
		null,
		"Active",
		null,
		108.74,
		78.15,
		24.14,
		17.06,
		8.36,
		3.11,
		45.49790795,
		32.69874477,
		10.10041841,
		7.13807531,
		3.49790795,
		1.30125523,
		239.57,
	],
	[
		"REFSAEJIL-PFR",
		59.4035,
		27.7292,
		"PLATTS - Refinery - Estonia - Sillamae - Jukon Oil",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		60,
		64.41,
		8.22,
		3000,
		8.82,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jukon Oil",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTRKKHE-PFR",
		37.783,
		36.8307,
		"PLATTS - Refinery - Turkey - Kahramanmaras - Ersan Petrol",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		59.03,
		61.75,
		7.69,
		2791.86,
		8.04,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ersan Petrol",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSAJGAL-PFR",
		25.447712,
		55.505283,
		"PLATTS - Refinery - United Arab Emirates - Sharjah - Gulf Petrochemical",
		null,
		null,
		null,
		null,
		null,
		3.6,
		3.86,
		0.49,
		180,
		0.53,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gulf Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPRISGP-PFR",
		12.8643,
		99.8223,
		"PLATTS - Refinery - Thailand - Phetchaburi - Siam Gulf Petrochemical Co.",
		30,
		31.29,
		4.11,
		1500,
		4.29,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Siam Gulf Petrochemical Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTRTRLI-PFR",
		45.440559,
		8.791745,
		"PLATTS - Refinery - Italy - Trecate - Raff. Padana Olii Minerali",
		null,
		null,
		null,
		null,
		null,
		351.73,
		370.1,
		46.57,
		16947.1,
		49.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		96,
		null,
		12.54,
		4578.36,
		null,
		null,
		null,
		null,
		null,
		null,
		1.86,
		null,
		0.24,
		90.96,
		null,
		87.62,
		null,
		11.4,
		4158.42,
		null,
		2.79,
		null,
		0.39,
		140.77,
		null,
		3.72,
		null,
		0.51,
		188.21,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_TotalErg",
		"74.14_25.86",
		null,
		"Active",
		null,
		34.34,
		37.3,
		12.75,
		4.9,
		9.02,
		2.75,
		33.33980583,
		36.21359223,
		12.37864078,
		4.75728155,
		8.75728155,
		2.66990291,
		101.07,
	],
	[
		"REFTJNPTC-PFR",
		39.0861,
		117.20653,
		"PLATTS - Refinery - China - Tianjin - PetroChina",
		476.23,
		512.1,
		67.1,
		24245.66,
		72.14,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._PDVSA",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSAZNIO-PFR",
		29.734995,
		52.654662,
		"PLATTS - Refinery - Iran - Shiraz - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		153.99,
		168.15,
		35.44,
		6729.05,
		38.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		47,
		null,
		6.33,
		2312.05,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		18.8,
		null,
		2.44,
		892.33,
		null,
		28.2,
		null,
		3.89,
		1419.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		20.92,
		12.59,
		6.92,
		3.07,
		1.57,
		0.61,
		43.58333333,
		26.22916667,
		14.41666667,
		6.39583333,
		3.27083333,
		1.27083333,
		45.69,
	],
	[
		"REFTSAHER-PFR",
		36.13862,
		-96.01843,
		"PLATTS - Refinery - United States - Tulsa - Holly-Frontier",
		235.14,
		248.25,
		120.81,
		7191.53,
		127.77,
		460.14,
		483.94,
		106.76,
		20569.78,
		112.53,
		31.32,
		null,
		4.65,
		1698.53,
		null,
		0,
		null,
		0,
		0,
		null,
		117.76,
		null,
		16.37,
		5974.15,
		null,
		null,
		null,
		null,
		null,
		null,
		1.58,
		null,
		0.21,
		76.99,
		null,
		25.62,
		null,
		3.33,
		1215.94,
		null,
		59.25,
		null,
		8.17,
		2982.69,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Holly-Frontier",
		"100",
		null,
		"Active",
		null,
		55.28,
		55.5,
		1.27,
		4.57,
		0.96,
		-0.01,
		42.87597921,
		43.04661444,
		0.98503064,
		3.54455906,
		0.74459009,
		-0.00775615,
		117.57,
	],
	[
		"REFTKIHEL-PFR",
		40.678714,
		22.879039,
		"PLATTS - Refinery - Greece - Thessaloniki - Hellenic Petroleum",
		9,
		9.52,
		1.25,
		454.99,
		1.32,
		560.54,
		585.93,
		412.27,
		8480.52,
		430.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		52.34,
		null,
		6.94,
		2531.29,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		36,
		null,
		4.68,
		1708.71,
		null,
		16.34,
		null,
		2.25,
		822.58,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hellenic Petroleum",
		"100",
		null,
		"Active",
		null,
		11.25,
		9.32,
		17.93,
		7.08,
		1.45,
		3.58,
		22.29046959,
		18.46641569,
		35.52605508,
		14.02813553,
		2.87299386,
		7.09332277,
		50.61,
	],
	[
		"REFSBAKBP-PFR",
		26.071316,
		50.599579,
		"PLATTS - Refinery - Bahrain - South Alba - KB Petrochemical",
		null,
		null,
		null,
		null,
		null,
		1,
		1.12,
		0.14,
		51.63,
		0.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KB Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSCAPMX-PFR",
		20.580633,
		-101.179906,
		"PLATTS - Refinery - Mexico - Salamanca - PEMEX - {Refineria Ingeniero Antonio M Amor}",
		null,
		null,
		null,
		null,
		null,
		1129.16,
		1216.87,
		577.27,
		32176.66,
		614.45,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		96.5,
		null,
		13.22,
		4826.64,
		null,
		889.02,
		955.86,
		641.98,
		15188.72,
		681.37,
		20.57,
		null,
		2.75,
		1003.87,
		null,
		0,
		null,
		0,
		0,
		null,
		75.93,
		null,
		10.47,
		3822.77,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		21.87,
		19.25,
		28.68,
		3.09,
		2.59,
		6.98,
		23.54904706,
		20.72789921,
		30.88187789,
		3.32723161,
		2.78884462,
		7.51588242,
		82.46,
	],
	[
		"REFTNAATS-PFR",
		41.17126,
		1.225597,
		"PLATTS - Refinery - Spain - Tarragona - Air Products",
		null,
		null,
		null,
		null,
		null,
		60,
		63.48,
		60,
		60,
		63.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSCSPIR-PFR",
		29.994449,
		-90.393875,
		"PLATTS - Refinery - United States - Saint Charles - Praxair",
		null,
		null,
		null,
		null,
		null,
		135,
		142.83,
		135,
		135,
		142.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTYPIR-PFR",
		29.370196,
		-94.941024,
		"PLATTS - Refinery - United States - Texas City - Praxair",
		null,
		null,
		null,
		null,
		null,
		234,
		247.57,
		234,
		234,
		247.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTNGCNL-PFR",
		31.94663244,
		120.34542582,
		"PLATTS - Refinery - China - Taicang - CNPC Lubricant Corp",
		null,
		null,
		null,
		null,
		null,
		2,
		2.21,
		0.28,
		103.25,
		0.31,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNPC Lubricant Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSDECOS-PFR",
		34.353175,
		133.832965,
		"PLATTS - Refinery - Japan - Sakaide - Cosmo Oil",
		null,
		null,
		null,
		null,
		null,
		0.79,
		0.82,
		0.13,
		38.08,
		0.07,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Maruzen_Daikyo Oil_Abu Dhabi IPIC",
		"39.6_39.55_20.85",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTUASEC-PFR",
		1.273173,
		103.619427,
		"PLATTS - Refinery - Singapore - Tuas - Sinopec",
		null,
		null,
		null,
		null,
		null,
		8,
		8.41,
		1.19,
		434.07,
		1.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTONDLC-PFR",
		48.081437,
		-103.800595,
		"PLATTS - Refinery - United States - Trenton - Dakota Oil Processing LLC",
		157.01,
		164.6,
		42.28,
		6692.29,
		44.52,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Dakota Oil Processing LLC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTYGGRS-PFR",
		29.396,
		-94.9175,
		"PLATTS - Refinery - United States - Texas City (Galveston Bay) - GCC Bunkers, LLC",
		null,
		null,
		null,
		null,
		null,
		50,
		52.14,
		6.85,
		2500,
		7.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Texas International Terminal",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTREGEI-PFR",
		30.549884,
		-88.128118,
		"PLATTS - Refinery - United States - Theodore - Gamxx Energy Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gamxx Energy Inc.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSDTPDT-PFR",
		53.10011,
		14.23605,
		"PLATTS - Refinery - Germany - Schwedt - Petrolchem. and Kraftst. Schwedt",
		null,
		null,
		null,
		null,
		null,
		1055.41,
		1109.36,
		343.47,
		41469.34,
		359.77,
		20,
		null,
		2.97,
		1084.51,
		null,
		0,
		null,
		0,
		0,
		null,
		192.99,
		null,
		26.36,
		9620.75,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		7.81,
		2847.39,
		null,
		112.99,
		null,
		15.58,
		5688.85,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_BP_Rosneft_Total_ENI",
		"37.5_18.75_18.75_16.67_8.33",
		null,
		"Active",
		null,
		81.06,
		64.95,
		21.89,
		11.07,
		6.24,
		12.94,
		41.99564812,
		33.64936276,
		11.3407937,
		5.73515698,
		3.23282561,
		6.7039685,
		198.14,
	],
	[
		"REFTSERFT-PFR",
		44.107601,
		39.104291,
		"PLATTS - Refinery - Russia - Tuapse - Rosneft",
		null,
		null,
		null,
		null,
		null,
		1210.89,
		1308.59,
		651.09,
		33337.78,
		694.45,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		165.22,
		null,
		21.49,
		7842.09,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		165.22,
		null,
		21.49,
		7842.09,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Other Investors_Unknown",
		"80.1_10.5_9.4",
		null,
		"Active",
		null,
		54.15,
		29.68,
		59.33,
		11.45,
		2.28,
		7.34,
		29.87751048,
		16.37607592,
		32.73559921,
		6.31758994,
		1.25800044,
		4.04987861,
		164.23,
	],
	[
		"REFSEBLIB-PFR",
		27.0192,
		14.4911,
		"PLATTS - Refinery - Libya - Sebha - Libyan National Oil Company",
		30.7,
		33.8,
		4,
		1458.93,
		4.4,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUAEFUE-PFR",
		25.1212,
		56.334,
		"PLATTS - Refinery - United Arab Emirates - Fujairah - Uniper Energy DMCC",
		null,
		null,
		null,
		null,
		null,
		80,
		85.88,
		10.96,
		4000,
		11.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Uniper Energy DMCC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTOAPS-PFR",
		40.49268,
		17.19532,
		"PLATTS - Refinery - Italy - Taranto - Agip Petroli S.P.A.",
		null,
		null,
		null,
		null,
		null,
		419.7,
		442.34,
		98.91,
		19219.21,
		104.41,
		21.02,
		null,
		3.12,
		1139.77,
		null,
		0,
		null,
		0,
		0,
		null,
		67,
		null,
		9.39,
		3427.08,
		null,
		null,
		null,
		null,
		null,
		null,
		4.9,
		null,
		0.66,
		239.28,
		null,
		7.01,
		null,
		0.91,
		332.49,
		null,
		34.08,
		null,
		4.7,
		1715.54,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		40.33,
		17.51,
		36.17,
		4.03,
		2.72,
		3.09,
		42.16854872,
		18.30823923,
		37.81890422,
		4.21371811,
		2.84399833,
		3.23086575,
		103.85,
	],
	[
		"REFSEMSNR-PFR",
		34.227745,
		-5.727688,
		"PLATTS - Refinery - Morocco - Sidi Kacem - S A Maroc. De L'ind. Du Raffin.",
		null,
		null,
		null,
		null,
		null,
		0.01,
		-0.02,
		0.03,
		0.01,
		-0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Corral Petroleum Holdings_Total_B.M.R.P.M._Other Investors",
		"66.5_23.1_7.4_3",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUANSOI-PFR",
		35.5392,
		129.3119,
		"PLATTS - Refinery - South Korea - Ulsan - S-Oil - {Onsan}",
		null,
		null,
		null,
		null,
		null,
		2029.56,
		2151.72,
		496.99,
		88344.15,
		526.45,
		17.63,
		null,
		2.62,
		956.07,
		null,
		0,
		null,
		0,
		0,
		null,
		586.15,
		null,
		79.7,
		29090.53,
		null,
		null,
		null,
		null,
		null,
		null,
		282.05,
		null,
		37.71,
		13763.37,
		null,
		17.63,
		null,
		2.29,
		836.72,
		null,
		268.83,
		null,
		37.08,
		13534.37,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Arabian Oil Co._Other Investors",
		"63.4_36.6",
		0,
		"Active",
		null,
		210.44,
		102.02,
		40.19,
		117.95,
		21.89,
		127.86,
		33.03040291,
		16.0129334,
		6.30817284,
		18.51328656,
		3.43582741,
		20.06874794,
		620.35,
	],
	[
		"REFSEOHO2-PFR",
		36.7845,
		126.4503,
		"PLATTS - Refinery - South Korea - Seosan - Hyundai Oil Refinery Co., Ltd. - {Lotte Chemical}",
		null,
		null,
		null,
		null,
		null,
		130,
		135.58,
		15.3,
		5582.36,
		15.94,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hyundai Oil Refinery Co., Ltd._Lotte Chemical",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPRSAT2-PFR",
		51.869786,
		4.283715,
		"PLATTS - Refinery - Netherlands - Pernis - Air Products",
		null,
		null,
		null,
		null,
		null,
		100,
		105.8,
		100,
		100,
		105.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTUESIU-PFR",
		43.2987,
		68.263,
		"PLATTS - Refinery - Kazakhstan - Turkestan - Sinur Oil",
		null,
		null,
		null,
		null,
		null,
		0.5,
		0.54,
		0.07,
		25,
		0.07,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0.41,
		null,
		0.05,
		19.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0.41,
		null,
		0.05,
		19.6,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinur Oil",
		"100",
		null,
		"Active",
		null,
		0.09,
		0.11,
		0,
		0.09,
		0,
		0.19,
		19.14893617,
		23.40425532,
		0,
		19.14893617,
		0,
		40.42553191,
		0.48,
	],
	[
		"REFSEZENS-PFR",
		29.960748,
		32.52953,
		"PLATTS - Refinery - Egypt - Suez - El-Nasr Petroleum Company - {El Nasr}",
		115.02,
		126.67,
		80.66,
		2134.26,
		88.09,
		317.76,
		348.81,
		44.04,
		16008.37,
		48.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		85,
		null,
		11.72,
		4279.31,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		85,
		null,
		11.72,
		4279.31,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		23.24,
		17.95,
		17.76,
		7.41,
		2.87,
		2.47,
		29.22167735,
		22.57009933,
		22.33119578,
		9.31723878,
		3.60870112,
		3.10574626,
		71.7,
	],
	[
		"REFPRSSNF-PFR",
		51.87784,
		4.338956,
		"PLATTS - Refinery - Netherlands - Pernis - Shell Nederland Raff",
		null,
		null,
		null,
		null,
		null,
		1313.29,
		1380.95,
		351.55,
		56771,
		370.81,
		12,
		null,
		1.78,
		650.82,
		null,
		0,
		null,
		0,
		0,
		null,
		298.3,
		null,
		40.49,
		14778.19,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		null,
		1.34,
		487.97,
		null,
		95,
		null,
		12.35,
		4509.1,
		null,
		161.3,
		null,
		22.25,
		8120.62,
		null,
		20,
		null,
		2.77,
		1009.68,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		115.56,
		69.46,
		49.85,
		38.53,
		7.65,
		36.86,
		34.89446508,
		20.97412205,
		15.05269197,
		11.63450796,
		2.30999185,
		11.13023523,
		317.91,
	],
	[
		"REFTUKLI2-PFR",
		32.0774,
		23.96,
		"PLATTS - Refinery - Libya - Tobruk (2) - Libyan National Oil Company - {Tobruk 2}",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		858.45,
		942.44,
		117.14,
		42591.02,
		128.63,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSEZSUC-PFR",
		29.958632,
		32.520235,
		"PLATTS - Refinery - Egypt - Suez - Suez Oil Processing Company - {El Suez}",
		null,
		null,
		null,
		null,
		null,
		148.53,
		165.11,
		21,
		7457.36,
		23.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		44,
		null,
		6.07,
		2215.17,
		null,
		127.7,
		139.86,
		18.22,
		6648,
		19.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		44,
		null,
		6.07,
		2215.17,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		14.07,
		10.95,
		7.71,
		4.16,
		2.52,
		1.14,
		31.83257919,
		24.77375566,
		17.44343891,
		9.41176471,
		5.70135747,
		2.57918552,
		40.54,
	],
	[
		"REFPRSTEX-PFR",
		51.94327,
		4.107049,
		"PLATTS - Refinery - Netherlands - Pernis - Texaco",
		null,
		null,
		null,
		null,
		null,
		0.04,
		0.01,
		0.02,
		1.95,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The British Petroleum Co_Texaco Inc.",
		"65_35",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTYNCPC-PFR",
		25.03403,
		121.309355,
		"PLATTS - Refinery - Taiwan - Tao-Yuan - CPC Corporation",
		null,
		null,
		null,
		null,
		null,
		999.17,
		1064.2,
		271.46,
		42018.81,
		287.65,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		118.23,
		null,
		15.8,
		5766.46,
		null,
		null,
		null,
		null,
		null,
		null,
		15.18,
		null,
		2.03,
		740.88,
		null,
		56.27,
		null,
		7.32,
		2670.79,
		null,
		46.77,
		null,
		6.45,
		2354.8,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CPC Corporation",
		"100",
		null,
		"Active",
		null,
		43.34,
		45.89,
		3.83,
		12.39,
		6.88,
		27.04,
		29.89584052,
		31.65482514,
		2.64192592,
		8.54659585,
		4.74580948,
		18.65213492,
		139.37,
	],
	[
		"REFPSAATS-PFR",
		29.71701,
		-95.19116,
		"PLATTS - Refinery - United States - Pasadena - Air Products",
		null,
		null,
		null,
		null,
		null,
		80,
		84.64,
		80,
		80,
		84.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUFANKY-PFR",
		54.861394,
		56.085333,
		"PLATTS - Refinery - Russia - Ufa - Novoufimsky - {Novoil - Novo Ufa}",
		40,
		44.92,
		5.64,
		2059.23,
		6.34,
		751.14,
		821.17,
		246.39,
		29627.12,
		266.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		133,
		null,
		18.08,
		6597.92,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		34,
		null,
		4.43,
		1613.79,
		null,
		98.99,
		null,
		13.66,
		4984.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Sistema_Bashkir Capital_Other Investors",
		"42.7_25.6_18.9_12.8",
		null,
		"Active",
		null,
		59.6,
		22.22,
		19.6,
		3.93,
		4.77,
		12.81,
		43.58318099,
		16.24862888,
		14.33272395,
		2.8738574,
		3.488117,
		9.36745887,
		122.92,
	],
	[
		"REFSGSCNR-PFR",
		33.933561,
		-118.069001,
		"PLATTS - Refinery - United States - Santa Fe Springs - Cenco Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Castle Energy Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPSATPT-PFR",
		29.69973,
		-95.256084,
		"PLATTS - Refinery - United States - Pasadena - Texas Petrochemicals",
		null,
		null,
		null,
		null,
		null,
		23.27,
		24.63,
		2.76,
		1003.98,
		2.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Texas Petrochemicals",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUGAUSC-PFR",
		59.665,
		28.2821,
		"PLATTS - Refinery - Russia - Ust-Luga - Ust Luga OJSC",
		597.3,
		656.41,
		81.49,
		29634.7,
		89.46,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ust Luga OJSC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSIRSRG-PFR",
		27.584504,
		21.603298,
		"PLATTS - Refinery - Libya - Sarir - Sarir Refining",
		null,
		null,
		null,
		null,
		null,
		10,
		10.9,
		1.37,
		500,
		1.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.26,
		94.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.26,
		94.93,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sarir Refining",
		"100",
		null,
		"Active",
		null,
		1.8,
		0.14,
		1.62,
		0.2,
		0,
		1.95,
		36,
		2.8,
		32.4,
		4,
		0,
		39,
		5.7,
	],
	[
		"REFSILPTX-PFR",
		44.1192,
		27.2614,
		"PLATTS - Refinery - Bulgaria - Silistra - Petromaxx Energy Group",
		120.53,
		129.18,
		61.36,
		3452.94,
		65.15,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petromaxx Energy Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSKDEFF-PFR",
		36.873106,
		6.974377,
		"PLATTS - Refinery - Algeria - Skikda - Enterprise National De Raff - {NAFTEC}",
		null,
		null,
		null,
		null,
		null,
		1272.68,
		1393.77,
		295.93,
		55124.63,
		323.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		290,
		null,
		37.71,
		13764.63,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		290,
		null,
		37.71,
		13764.63,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		121.57,
		46.14,
		79.51,
		18.33,
		15.28,
		40.03,
		36.61746988,
		13.89759036,
		23.94879518,
		5.52108434,
		4.60240964,
		12.05722892,
		320.87,
	],
	[
		"REFSINGOM-PFR",
		50.1595,
		143.0264,
		"PLATTS - Refinery - Russia - Sakhalin - Gazprom",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		320.2,
		348.58,
		106.07,
		12438.95,
		114.5,
		"Gazprom",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSLHHOR-PFR",
		6.1249,
		81.1243,
		"PLATTS - Refinery - Sri Lanka - Hambantota - Hambantota Oil Refinery PVT Ltd.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1250.6,
		1374.24,
		170.22,
		61911.03,
		186.85,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sugih Energy International Pte Ltd",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPULYPF-PFR",
		-38.927178,
		-69.18378,
		"PLATTS - Refinery - Argentina - Plaza Huincul - YPF",
		null,
		null,
		null,
		null,
		null,
		88.39,
		95.43,
		46.35,
		2356.65,
		49.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		19.14,
		null,
		2.65,
		966.16,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		19.14,
		null,
		2.65,
		966.16,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF",
		"100",
		null,
		"Active",
		null,
		6.75,
		3.78,
		10.31,
		1.34,
		0.1,
		1.51,
		28.125,
		15.75,
		42.95833333,
		5.58333333,
		0.41666667,
		6.29166667,
		23.79,
	],
	[
		"REFSIOCAC-PFR",
		29.34739,
		-98.45981,
		"PLATTS - Refinery - United States - San Antonio - Lazarus Energy",
		null,
		null,
		null,
		null,
		null,
		40.45,
		42.57,
		5.31,
		1940.81,
		5.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15.77,
		null,
		2.05,
		748.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		15.77,
		null,
		2.05,
		748.69,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Calumet Lubricants Co.",
		"100",
		null,
		"Active",
		null,
		5.37,
		5.65,
		2.32,
		1.63,
		0.79,
		0.16,
		30.44217687,
		32.02947846,
		13.15192744,
		9.24036281,
		4.47845805,
		0.90702948,
		15.92,
	],
	[
		"REFSNGSEM-PFR",
		36.8762,
		118.7323,
		"PLATTS - Refinery - China - Shouguang - Shouguang Lianmeng Petrochem - {Weifang}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shouguang Lianmeng Petrochem",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPUNWZA-PFR",
		35.7215,
		45.165,
		"PLATTS - Refinery - Iraq - Piramagrun - WZA",
		null,
		null,
		null,
		null,
		null,
		2.4,
		2.58,
		0.33,
		120,
		0.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.13,
		48.8,
		null,
		null,
		null,
		null,
		null,
		null,
		1,
		null,
		0.13,
		48.8,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"WZA",
		"100",
		null,
		"Active",
		null,
		0.3,
		0.09,
		0.42,
		0.09,
		0,
		0.09,
		30,
		9,
		42,
		9,
		0,
		9,
		0.99,
	],
	[
		"REFSISPTS-PFR",
		-2.5635,
		-44.2449,
		"PLATTS - Refinery - Brazil - Sao Luis - Petrobras",
		1909.38,
		2004.76,
		455.62,
		85723.26,
		479.98,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSNNGLP-PFR",
		37.959655,
		-8.805522,
		"PLATTS - Refinery - Portugal - Sines - GALP",
		null,
		null,
		null,
		null,
		null,
		833.08,
		875.57,
		298.36,
		31606.55,
		313.81,
		19.55,
		null,
		2.9,
		1060.42,
		null,
		0,
		null,
		0,
		0,
		null,
		141.27,
		null,
		19.43,
		7091.26,
		null,
		null,
		null,
		null,
		null,
		null,
		4.89,
		null,
		0.66,
		238.53,
		null,
		32.75,
		null,
		4.26,
		1554.63,
		null,
		48.88,
		null,
		6.74,
		2460.92,
		null,
		35.19,
		null,
		4.86,
		1776.76,
		null,
		null,
		null,
		null,
		null,
		null,
		"Grupo Amorim_Portugese Government_ENI_Other Investors",
		"38.3_30_21.6_10.1",
		null,
		"Active",
		null,
		71.1,
		38.33,
		9.53,
		15.77,
		5.54,
		15.54,
		49.20755762,
		26.52778739,
		6.59561215,
		10.91425012,
		3.83417538,
		10.75506955,
		155.84,
	],
	[
		"REFPURBSF-PFR",
		29.955036,
		-93.885573,
		"PLATTS - Refinery - United States - Port Arthur - BASF FINA Petrochemicals",
		null,
		null,
		null,
		null,
		null,
		60,
		62.57,
		7.06,
		2576.47,
		7.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		57.97,
		null,
		7.54,
		2751.35,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		57.97,
		null,
		7.54,
		2751.35,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BASF_Total",
		"60_40",
		null,
		"Active",
		null,
		6.92,
		3.13,
		1.85,
		6.18,
		1.47,
		43.28,
		11.20466321,
		5.06800518,
		2.99546632,
		10.00647668,
		2.38018135,
		70.07772021,
		62.82,
	],
	[
		"REFSJ2IOC-PFR",
		45.280816,
		-66.012431,
		"PLATTS - Refinery - Canada - Saint John (2) - Irving Oil.",
		891.9,
		935.28,
		182.78,
		40542.92,
		192.22,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Irving Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSOWESS-PFR",
		53.2685,
		-2.854471,
		"PLATTS - Refinery - United Kingdom - Stanlow - Essar Oil",
		null,
		null,
		null,
		null,
		null,
		669.17,
		702.19,
		91.78,
		33399.74,
		96.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		169.2,
		null,
		22.07,
		8055.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		161.2,
		null,
		20.96,
		7651.23,
		null,
		0,
		null,
		0,
		0,
		null,
		8,
		null,
		1.11,
		403.87,
		null,
		41.8,
		44.84,
		8.2,
		2337.8,
		8.77,
		"Essar Oil",
		"100",
		0,
		"Active",
		null,
		35.4,
		49.75,
		13.88,
		29.61,
		5.71,
		11.99,
		23.44370861,
		32.94701987,
		9.19205298,
		19.60927152,
		3.78145695,
		7.94039735,
		146.33,
	],
	[
		"REFQHMNIO-PFR",
		26.7688,
		55.8477,
		"PLATTS - Refinery - Iran - Qeshm - Pasargad Energy Development Co.",
		null,
		null,
		null,
		null,
		null,
		660,
		700.75,
		522.75,
		8808.16,
		553.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pasargad Energy Development Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSNESCL-PFR",
		49.284565,
		-122.968243,
		"PLATTS - Refinery - Canada - Shelburne - Shell Canada Ltd.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSQOELI-PFR",
		44.479488,
		8.898637,
		"PLATTS - Refinery - Italy - San Quirico - Erg Petroli",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Erg Petroli",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQOUGLT-PFR",
		21.76831657,
		108.60588196,
		"PLATTS - Refinery - China - Qinzhou - Guangxi Dongyou Asphalt",
		null,
		null,
		null,
		null,
		null,
		41,
		43.85,
		5.86,
		2138.46,
		6.27,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Guangxi Dongyou Asphalt",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSNYP66-PFR",
		29.07385,
		-95.74904,
		"PLATTS - Refinery - United States - Sweeny - Phillips 66 Co. - {Old Ocean}",
		63.05,
		65.94,
		7.73,
		2804.31,
		8.08,
		1012.54,
		1065.76,
		287.08,
		42934.8,
		302.99,
		103.97,
		null,
		15.45,
		5638.52,
		null,
		0,
		null,
		0,
		0,
		null,
		199.52,
		null,
		27.9,
		10183.31,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		92.25,
		null,
		12,
		4378.38,
		null,
		3.31,
		null,
		0.46,
		166.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		61.21,
		103.15,
		4.66,
		23.79,
		11.39,
		9.13,
		25.58839513,
		43.12110698,
		1.94807909,
		9.9452364,
		4.76150663,
		3.81673007,
		213.33,
	],
	[
		"REFSRGNRS-PFR",
		-26.806285,
		27.855918,
		"PLATTS - Refinery - South Africa - Sasolburg - National Petroleum Refiners - {NATREF}",
		-12,
		-13.07,
		-1.65,
		-600,
		-1.79,
		327.34,
		360.12,
		66.09,
		14788.19,
		72.47,
		0,
		null,
		0,
		0,
		null,
		4.4,
		null,
		0.66,
		238.28,
		null,
		44,
		null,
		6,
		2190.51,
		null,
		null,
		null,
		null,
		null,
		null,
		2.2,
		null,
		0.3,
		107.35,
		null,
		13.2,
		null,
		1.71,
		626.53,
		null,
		24.2,
		null,
		3.33,
		1218.34,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sasol_Total",
		"63.64_36.36",
		null,
		"Active",
		null,
		28.53,
		31.93,
		12.7,
		11.12,
		1.62,
		0,
		32.42045455,
		36.28409091,
		14.43181818,
		12.63636364,
		1.84090909,
		0,
		85.89,
	],
	[
		"REFQOUPTC-PFR",
		21.97217,
		108.640416,
		"PLATTS - Refinery - China - Qinzhou - PetroChina",
		40,
		42.32,
		5.48,
		2000,
		5.8,
		996.85,
		1074.85,
		319.23,
		39786.43,
		340.54,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		183.7,
		null,
		25.41,
		9273.93,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		183.7,
		null,
		25.41,
		9273.93,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		62.27,
		80.29,
		1.11,
		12.43,
		3.57,
		14.12,
		33.62311015,
		43.35313175,
		0.59935205,
		6.71166307,
		1.92764579,
		7.62419006,
		173.79,
	],
	[
		"REFSORHUS-PFR",
		46.68949,
		-92.07024,
		"PLATTS - Refinery - United States - Superior - Cenovus",
		748.92,
		786.38,
		191.17,
		32577.01,
		201.46,
		139.65,
		147.65,
		19.18,
		7003.04,
		20.31,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cenovus",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQOUTTD-PFR",
		21.9647,
		108.6209,
		"PLATTS - Refinery - China - Qinzhou - Taixing Petroleum and Chem. Co Ltd",
		null,
		null,
		null,
		null,
		null,
		3,
		3.32,
		0.42,
		154.88,
		0.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Taixing Petroleum and Chem. Co Ltd",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSOWHYG-PFR",
		53.2783,
		-2.8411,
		"PLATTS - Refinery - United Kingdom - Stanlow - Hydrodec Group",
		30,
		31.44,
		4.43,
		1618.99,
		4.65,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hydrodec Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSSDPTE-PFR",
		10.4584,
		32.5466,
		"PLATTS - Refinery - South Sudan - Paloich - Trinity Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		200,
		217.91,
		27.4,
		10000,
		29.85,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Trinity Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFQZ2PTC-PFR",
		21.9647,
		108.6209,
		"PLATTS - Refinery - China - Qinzhou (2) - PetroChina",
		600.8,
		647.32,
		81.15,
		29543.14,
		87.38,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSPGPRT-PFR",
		1.328,
		102.1234,
		"PLATTS - Refinery - Indonesia - Sungai Pakning - Pertamina",
		null,
		null,
		null,
		null,
		null,
		50,
		53.68,
		6.84,
		2500,
		7.36,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		37.72,
		null,
		5.22,
		1904.26,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		37.72,
		null,
		5.22,
		1904.26,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		7.43,
		6.94,
		19.97,
		4.19,
		-0.34,
		1.06,
		17.69047619,
		16.52380952,
		47.54761905,
		9.97619048,
		-0.80952381,
		2.52380952,
		39.25,
	],
	[
		"REFSSESLU-PFR",
		29.947447,
		-90.327705,
		"PLATTS - Refinery - United States - Saint Rose - Shell Oil Co. USA",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0.05,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0.54,
		0.07,
		0.6,
		0.17,
		-0.02,
		0.01,
		20.76923077,
		2.69230769,
		23.07692308,
		6.53846154,
		-0.76923077,
		0.38461538,
		1.37,
	],
	[
		"REFQZUSEC-PFR",
		36.765513,
		118.057066,
		"PLATTS - Refinery - China - Quanzhou - Sinopec",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		908.1,
		977.74,
		264.72,
		37613.88,
		282.44,
		"Saudi Aramco_Sinopec",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSTDEOR-PFR",
		58.075778,
		11.850744,
		"PLATTS - Refinery - Sweden - Stenungsund - Equinor",
		null,
		null,
		null,
		null,
		null,
		1.11,
		1.17,
		0.13,
		47.89,
		0.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Statoil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSRAPRT-PFR",
		-0.58972,
		101.34311,
		"PLATTS - Refinery - Indonesia - Sumatra - Pertamina",
		950.6,
		1033.22,
		224.71,
		41755.77,
		241.26,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pertamina",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSUZPMX-PFR",
		16.210017,
		-95.173402,
		"PLATTS - Refinery - Mexico - Salina Cruz - PEMEX - {Refineria Ingeniero Antonio Dovali Jaime}",
		-50,
		-56.15,
		-6.68,
		-2436.58,
		-7.5,
		942.43,
		1031.04,
		165.19,
		45114.79,
		179.91,
		42.6,
		null,
		6.33,
		2310.4,
		null,
		0,
		null,
		0,
		0,
		null,
		125.46,
		null,
		17.72,
		6466.25,
		null,
		52.25,
		58.57,
		10.25,
		2922.25,
		11.4,
		10.11,
		null,
		1.35,
		493.41,
		null,
		0,
		null,
		0,
		0,
		null,
		72.75,
		null,
		10.03,
		3662.44,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		36.17,
		33.26,
		38.01,
		5.11,
		-0.08,
		9.62,
		28.9128697,
		26.58673062,
		30.38369305,
		4.08473221,
		-0.06394884,
		7.68984812,
		122.08,
	],
	[
		"REFRAOSUH-PFR",
		35.50241265,
		118.66913074,
		"PLATTS - Refinery - China - Rizhao - Sunrise Chemical (Chenxi)",
		null,
		null,
		null,
		null,
		null,
		82,
		87.33,
		11.31,
		4126.61,
		12.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sunrise Chemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSVLSCE-PFR",
		45.0433,
		41.9691,
		"PLATTS - Refinery - Russia - Stavropol - Stavropol Province",
		67.04,
		73.3,
		8.92,
		3245.24,
		9.76,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR_Stavropol Province",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRASNOG-PFR",
		42.311688,
		130.349694,
		"PLATTS - Refinery - North Korea - Rason - North Korean Government Co.",
		12.04,
		13.52,
		1.7,
		606.69,
		1.9,
		57.7,
		63.37,
		7.62,
		2776.19,
		8.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4.95,
		null,
		0.69,
		249.21,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4.95,
		null,
		0.69,
		249.21,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"North Korean Government Co._HBOil JSC",
		"80_20",
		null,
		"Active",
		null,
		1.9,
		2,
		0.9,
		0.4,
		0.1,
		0,
		34.54545455,
		36.36363636,
		16.36363636,
		7.27272727,
		1.81818182,
		0,
		5.3,
	],
	[
		"REFSROAPS-PFR",
		45.099571,
		8.875927,
		"PLATTS - Refinery - Italy - San Nazzaro - Agip Petroli S.P.A.",
		null,
		null,
		null,
		null,
		null,
		1717.63,
		1798.97,
		1170.03,
		33446.6,
		1222.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		136,
		null,
		18.42,
		6722.37,
		null,
		null,
		null,
		null,
		null,
		null,
		3,
		null,
		0.4,
		146.57,
		null,
		42.05,
		null,
		5.47,
		1995.95,
		null,
		81.93,
		null,
		11.3,
		4124.93,
		null,
		9.01,
		null,
		1.25,
		454.92,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		112.81,
		65.98,
		11.32,
		12.5,
		7.11,
		15.44,
		49.82993948,
		29.14439684,
		5.00022086,
		5.52144529,
		3.14059808,
		6.82008923,
		225.16,
	],
	[
		"REFSWLSAB-PFR",
		32.255405,
		-93.825833,
		"PLATTS - Refinery - United States - Stonewall - Sabine Resources Group",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Port Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFREOP66-PFR",
		38.04869,
		-122.258904,
		"PLATTS - Refinery - United States - Rodeo - Phillips 66 Co.",
		null,
		null,
		null,
		null,
		null,
		-24.3,
		-25.68,
		-63.03,
		2218.31,
		-66.71,
		35.87,
		null,
		5.33,
		1945.56,
		null,
		0,
		null,
		0,
		0,
		null,
		91.77,
		null,
		12.96,
		4729.67,
		null,
		null,
		null,
		null,
		null,
		null,
		2.96,
		null,
		0.4,
		144.32,
		null,
		9.07,
		null,
		1.18,
		430.42,
		null,
		38.12,
		null,
		5.26,
		1919.16,
		null,
		5.75,
		null,
		0.8,
		290.22,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		26.35,
		55.59,
		0.01,
		24,
		5.98,
		0,
		23.96543884,
		50.55934516,
		0.00909504,
		21.82810368,
		5.43883583,
		0,
		111.92,
	],
	[
		"REFSRTCAC-PFR",
		32.46705,
		-93.79277,
		"PLATTS - Refinery - United States - Shreveport - Calumet Lubricants Co.",
		null,
		null,
		null,
		null,
		null,
		151.83,
		159.57,
		31.49,
		7038.19,
		33.17,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		34.78,
		null,
		4.7,
		1713.75,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		12.95,
		null,
		1.68,
		614.55,
		null,
		21.83,
		null,
		3.01,
		1099.2,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Calumet Lubricants Co.",
		"100",
		null,
		"Active",
		null,
		14.02,
		11.76,
		0,
		1.26,
		-0.3,
		0,
		34.11192214,
		28.61313869,
		0,
		3.06569343,
		-0.72992701,
		0,
		26.74,
	],
	[
		"REFSYGSTD-PFR",
		41.6745,
		123.4583,
		"PLATTS - Refinery - China - Shenyang - Shenyang Paraffin Chemical Co. Ltd",
		null,
		null,
		null,
		null,
		null,
		0.9,
		0.95,
		0.11,
		38.83,
		0.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shenyang Paraffin Chemical Co. Ltd",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRFEPTS-PFR",
		-8.0585,
		-34.8848,
		"PLATTS - Refinery - Brazil - Recife - Petrobras - {RNEST - Abreu e Lima}",
		null,
		null,
		null,
		null,
		null,
		575.96,
		605.74,
		302.86,
		16285.11,
		318,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		84,
		null,
		11.62,
		4240.66,
		null,
		475.96,
		502.22,
		159.74,
		18648.23,
		168.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		84,
		null,
		11.62,
		4240.66,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		23.84,
		0,
		33.02,
		0,
		0,
		12.1,
		28.65384615,
		0,
		39.6875,
		0,
		0,
		14.54326923,
		68.96,
	],
	[
		"REFSTELAY-PFR",
		33.946472,
		-118.166918,
		"PLATTS - Refinery - United States - South Gate - Lunday-Thagard Oil Co.",
		null,
		null,
		null,
		null,
		null,
		26.32,
		27.92,
		3.9,
		1423.19,
		4.13,
		3.57,
		null,
		0.53,
		193.51,
		null,
		0,
		null,
		0,
		0,
		null,
		3.57,
		null,
		0.53,
		193.51,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lunday-Thagard Oil Co.",
		"100",
		null,
		"Active",
		null,
		0.65,
		0.54,
		1.28,
		0.54,
		-0.13,
		0,
		15.18691589,
		12.61682243,
		29.90654206,
		12.61682243,
		-3.03738318,
		0,
		2.88,
	],
	[
		"REFSZTDOC-PFR",
		47.28354,
		18.90078,
		"PLATTS - Refinery - Hungary - Szazhalombatta - Danube Petr. Refining Co.",
		860,
		896.85,
		860,
		860,
		896.85,
		857.86,
		909.92,
		286.32,
		33635.63,
		303.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		134.6,
		null,
		18.47,
		6741.98,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		11.96,
		null,
		1.55,
		567.42,
		null,
		122.65,
		null,
		16.91,
		6174.57,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_APV rt_OMV_MOL_BNP Paribas",
		"60.3_11.7_11_9_8",
		null,
		"Active",
		null,
		66.34,
		24.6,
		1.28,
		6.76,
		4.21,
		24.18,
		48.42335766,
		17.95620438,
		0.93430657,
		4.93430657,
		3.0729927,
		17.64963504,
		127.37,
	],
	[
		"REFSTGEAP-PFR",
		-52.622553,
		-70.200293,
		"PLATTS - Refinery - Chile - St. Gregorio - ENAP",
		null,
		null,
		null,
		null,
		null,
		15.8,
		16.48,
		2.16,
		790,
		2.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENAP",
		"100",
		null,
		"Active",
		null,
		1.33,
		0,
		2.42,
		0.51,
		0.2,
		1.54,
		22.16666667,
		0,
		40.33333333,
		8.5,
		3.33333333,
		25.66666667,
		6,
	],
	[
		"REFRISAB3-PFR",
		24.0897,
		52.6482,
		"PLATTS - Refinery - United Arab Emirates - Ruwais - Abu Dhabi Oil Refining Co - {cancelled}",
		164.5,
		184.76,
		19.87,
		7252.92,
		22.31,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ADNOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTAQGJI-PFR",
		35.5459,
		44.0693,
		"PLATTS - Refinery - Iraq - Taq Taq - Genel Enerji",
		156.08,
		170.31,
		20.75,
		7547.84,
		22.62,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Genel Enerji",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSUGSSC-PFR",
		30.58489525,
		105.27727548,
		"PLATTS - Refinery - China - Suining - Sichuan Shengma Chemical",
		null,
		null,
		null,
		null,
		null,
		180.42,
		192.68,
		27.42,
		9672.58,
		29.3,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sichuan Shengma Chemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRISABO-PFR",
		24.124625,
		52.719881,
		"PLATTS - Refinery - United Arab Emirates - Ruwais - Abu Dhabi Oil Refining Co",
		null,
		null,
		null,
		null,
		null,
		3464.02,
		3768.98,
		1396.96,
		116513.49,
		1494.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		557,
		null,
		73.66,
		26886.65,
		null,
		null,
		null,
		null,
		null,
		null,
		337,
		null,
		45.05,
		16444.52,
		null,
		220,
		null,
		28.61,
		10442.14,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ADNOC_ENI_OMV",
		"65_20_15",
		null,
		"Active",
		null,
		286.47,
		154.79,
		48.84,
		67.2,
		22.29,
		76.43,
		42.25221239,
		22.83038348,
		7.20353982,
		9.91150442,
		3.28761062,
		11.27286136,
		656.03,
	],
	[
		"REFTDETNG-PFR",
		54.5704,
		-1.2351,
		"PLATTS - Refinery - United Kingdom - Teesside - Teeside Refining",
		130832.64,
		138412.7,
		130361.44,
		159041.5,
		137918.06,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"GE Oil and Gas_Penergis",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSZOYPF-PFR",
		-32.721114,
		-60.744507,
		"PLATTS - Refinery - Argentina - San Lorenzo - YPF - {Oil Combustibles}",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Oil Combustibles S.A.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTAKCON-PFR",
		42.8177,
		75.319,
		"PLATTS - Refinery - Kyrgyzstan - Tokmak - Chui Oblast Administration",
		30.1,
		32.32,
		4.37,
		1592.44,
		4.68,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sintszyanskaya",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRNAALP-PFR",
		44.47945,
		12.25849,
		"PLATTS - Refinery - Italy - Ravenna - Alma Petroli S.P.A.",
		null,
		null,
		null,
		null,
		null,
		22,
		23.34,
		3.22,
		1174.69,
		3.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Corelli And Serena",
		"100",
		null,
		"Active",
		null,
		0.93,
		0,
		2.31,
		0.23,
		0,
		0.72,
		21.18451025,
		0,
		52.61958998,
		5.23917995,
		0,
		16.40091116,
		4.18,
	],
	[
		"REFTEATRC-PFR",
		5.668207,
		0.005287,
		"PLATTS - Refinery - Ghana - Tema - Tema Oil Refinery Company",
		109,
		119.76,
		15.05,
		5491.23,
		16.54,
		9.99,
		11.23,
		1.39,
		505.53,
		1.55,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		-192.21,
		-211.37,
		-26.32,
		-9599.7,
		-28.93,
		"Ghanaian Govt.",
		"100",
		0,
		"Active",
		null,
		1.48,
		1.82,
		0.5,
		0.77,
		0.4,
		0,
		29.6,
		36.4,
		10,
		15.4,
		8,
		0,
		4.97,
	],
	[
		"REFTCOPMX-PFR",
		17.9508,
		-92.4831,
		"PLATTS - Refinery - Mexico - Tabasco - PEMEX - {Dos Bocas}",
		null,
		null,
		null,
		null,
		null,
		1176.6,
		1285.15,
		348.25,
		47899.49,
		375.42,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRNGRPC-PFR",
		12.7944,
		101.3705,
		"PLATTS - Refinery - Thailand - Rayong - RPC - {Map Ta Phut}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"RPC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTHITAZ-PFR",
		40.027236,
		52.957434,
		"PLATTS - Refinery - Turkmenistan - Turkmenbashi - Turkmenneftegaz",
		null,
		null,
		null,
		null,
		null,
		893.17,
		976.03,
		233.82,
		38570.81,
		251.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		137.69,
		null,
		19.04,
		6951.02,
		null,
		45,
		50.54,
		6.05,
		2207.62,
		6.79,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		137.69,
		null,
		19.04,
		6951.02,
		null,
		null,
		null,
		null,
		null,
		null,
		"Turkmenneftegaz",
		"100",
		null,
		"Active",
		null,
		41.5,
		55.91,
		18.39,
		8.67,
		11.84,
		0,
		30.14016995,
		40.60570848,
		13.35608977,
		6.29675358,
		8.5990268,
		0,
		136.31,
	],
	[
		"REFTERDRL-PFR",
		32.36026,
		-95.28196,
		"PLATTS - Refinery - United States - Tyler - Delek Refining Ltd.",
		5,
		5.21,
		0.68,
		250,
		0.71,
		204.13,
		214.18,
		27.52,
		9900.71,
		28.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		61.7,
		null,
		8.02,
		2928.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		61.7,
		null,
		8.02,
		2928.6,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Delek Group",
		"100",
		0,
		"Active",
		null,
		21.05,
		37.74,
		0.54,
		6.05,
		1.65,
		1.16,
		29.90056818,
		53.60795455,
		0.76704545,
		8.59375,
		2.34375,
		1.64772727,
		68.19,
	],
	[
		"REFRNTFHR-PFR",
		44.76817,
		-93.0372,
		"PLATTS - Refinery - United States - Rosemount - Flint Hills Resources - {Pine Bend}",
		65,
		68.32,
		8.21,
		2995.9,
		8.63,
		1388.23,
		1461.64,
		391.92,
		58715.09,
		413.09,
		266.73,
		null,
		39.63,
		14465.89,
		null,
		0,
		null,
		0,
		0,
		null,
		284.12,
		null,
		41.91,
		15297.31,
		null,
		30.59,
		32.83,
		5.39,
		1752.59,
		5.77,
		0,
		null,
		0,
		0,
		null,
		15.46,
		null,
		2.01,
		733.65,
		null,
		0,
		null,
		0,
		0,
		null,
		1.94,
		null,
		0.27,
		97.77,
		null,
		null,
		null,
		null,
		null,
		null,
		"Koch Industries",
		"100",
		null,
		"Active",
		null,
		102.53,
		151.26,
		4.16,
		18.63,
		7.03,
		-0.09,
		33.37347829,
		49.23507584,
		1.35407851,
		6.06405833,
		2.28826248,
		-0.02929497,
		283.51,
	],
	[
		"REFTHSVON-PFR",
		35.695387,
		-98.6627,
		"PLATTS - Refinery - United States - Thomas - Ventura Refining and Transmission",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ventura Refining and Transmission_Chesapeake Energy Corp.",
		"75_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTETSCH-PFR",
		35.35076685,
		1.32054255,
		"PLATTS - Refinery - Algeria - Tiaret - Sonatrach",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		304.7,
		333.91,
		69.31,
		13387.52,
		75.77,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRT2ARM-PFR",
		26.7074,
		50.0674,
		"PLATTS - Refinery - Saudi Arabia - Ras Tanura (2) - Saudi Aramco",
		240.1,
		264.68,
		29.2,
		10623.24,
		32.21,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTIARAF-PFR",
		50.16095,
		19.44745,
		"PLATTS - Refinery - Poland - Trzebinia - Rafineria Trzebinia",
		null,
		null,
		null,
		null,
		null,
		16.01,
		16.71,
		2.29,
		831.9,
		2.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PKN Orlen_Other Investors_Polish State Company",
		"76.96_13.75_9.29",
		null,
		"Active",
		null,
		1.69,
		0.88,
		1.1,
		0.19,
		0.16,
		0.21,
		33.8,
		17.6,
		22,
		3.8,
		3.2,
		4.2,
		4.24,
	],
	[
		"REFTFTATS-PFR",
		29.98735,
		-90.44201,
		"PLATTS - Refinery - United States - Taft - Air Products",
		null,
		null,
		null,
		null,
		null,
		21,
		22.22,
		21,
		21,
		22.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRUFWES-PFR",
		30.5869,
		18.4178,
		"PLATTS - Refinery - Libya - Ras Lanuf - Winfield Resources",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		840.6,
		921.08,
		203.79,
		35941.57,
		222.75,
		"Winfield Resources",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRYNTRT-PFR",
		54.562507,
		39.754647,
		"PLATTS - Refinery - Russia - Ryazan - TNK-Rosneft",
		null,
		null,
		null,
		null,
		null,
		1322.16,
		1448.22,
		362.14,
		56149.16,
		392.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		240.58,
		null,
		33.18,
		12112.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		240.58,
		null,
		33.18,
		12112.34,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Tyumen Oil",
		"50_50",
		null,
		"Active",
		null,
		91.22,
		71.26,
		80.38,
		25.34,
		-1.32,
		20.46,
		28.67110888,
		22.39753583,
		25.2640181,
		7.96454614,
		-0.41488559,
		6.43072668,
		287.36,
	],
	[
		"REFSAAIMP-PFR",
		42.952393,
		-82.4162,
		"PLATTS - Refinery - Canada - Sarnia - Imperial Oil",
		null,
		null,
		null,
		null,
		null,
		616.44,
		647.31,
		313.55,
		17621.12,
		328.59,
		24.22,
		null,
		3.6,
		1313.93,
		null,
		0,
		null,
		0,
		0,
		null,
		94,
		null,
		12.88,
		4701.42,
		null,
		null,
		null,
		null,
		null,
		null,
		21.7,
		null,
		2.9,
		1059.24,
		null,
		32.56,
		null,
		4.23,
		1545.48,
		null,
		0,
		null,
		0,
		0,
		null,
		15.51,
		null,
		2.15,
		782.76,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Imperial Oil",
		"69.9_30.1",
		null,
		"Active",
		null,
		26.12,
		41.35,
		3,
		6.31,
		8.63,
		7.98,
		26.92783505,
		42.62886598,
		3.09278351,
		6.50515464,
		8.89690722,
		8.22680412,
		93.39,
	],
	[
		"REFTKAOGC-PFR",
		16.50185,
		81.89561,
		"PLATTS - Refinery - India - Tatipaka - ONGC",
		2,
		2.15,
		0.27,
		100,
		0.29,
		1.65,
		1.77,
		0.23,
		82.5,
		0.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.63,
		null,
		0.21,
		77.19,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		1.63,
		null,
		0.21,
		77.19,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ONGC",
		"100",
		null,
		"Active",
		null,
		0.23,
		0,
		0.32,
		0.11,
		0,
		0.25,
		23,
		0,
		32,
		11,
		0,
		25,
		0.92,
	],
	[
		"REFSAFRBS-PFR",
		-28.7708,
		32.0578,
		"PLATTS - Refinery - South Africa - Richards Bay - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		895.45,
		982.62,
		121.87,
		44315.39,
		133.76,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSAKINA-PFR",
		45.45433,
		16.406609,
		"PLATTS - Refinery - Croatia - Sisak - INA",
		103.8,
		113.65,
		45.2,
		3584.63,
		48.87,
		128.02,
		139.38,
		17.36,
		6213.38,
		18.84,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.74,
		null,
		1.19,
		434.37,
		null,
		-138.46,
		-151.07,
		-18.43,
		-6607.09,
		-20.03,
		0,
		null,
		0,
		0,
		null,
		2,
		null,
		0.26,
		94.93,
		null,
		6.74,
		null,
		0.93,
		339.45,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"MOL_Croatia State Co._Other Investors",
		"47.15_44.84_8.01",
		null,
		"Active",
		null,
		3.28,
		5.02,
		1.97,
		0.6,
		2.48,
		0,
		22.11732974,
		33.85030344,
		13.28388402,
		4.045853,
		16.72285907,
		0,
		13.36,
	],
	[
		"REFTMAPPR-PFR",
		47.255412,
		-122.395448,
		"PLATTS - Refinery - United States - Tacoma - Par Petroleum",
		null,
		null,
		null,
		null,
		null,
		94.25,
		99.64,
		13.11,
		4782.1,
		13.87,
		10.33,
		null,
		1.54,
		560.45,
		null,
		0,
		null,
		0,
		0,
		null,
		26.38,
		null,
		3.64,
		1326.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0.37,
		null,
		0.05,
		18.17,
		null,
		14.19,
		null,
		1.85,
		673.46,
		null,
		1.49,
		null,
		0.2,
		74.81,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Time Oil",
		"100",
		null,
		"Active",
		null,
		4.82,
		5.07,
		9.99,
		4.04,
		0.37,
		0,
		15.24833913,
		16.03922809,
		31.60392281,
		12.78076558,
		1.17051566,
		0,
		24.3,
	],
	[
		"REFSARODC-PFR",
		24.49371,
		56.62216,
		"PLATTS - Refinery - Oman - Sohar - QQ (Oman Oil + ORPIC)",
		null,
		null,
		null,
		null,
		null,
		806.53,
		884.73,
		224.98,
		34633.8,
		244.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		131,
		null,
		17.51,
		6391.05,
		null,
		null,
		null,
		null,
		null,
		null,
		130,
		null,
		17.38,
		6343.58,
		null,
		1,
		null,
		0.13,
		47.46,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ORPIC",
		"100",
		null,
		"Active",
		null,
		42.68,
		69.83,
		8.56,
		13.83,
		8.95,
		8.4,
		28.45333333,
		46.55333333,
		5.70666667,
		9.22,
		5.96666667,
		5.6,
		152.25,
	],
	[
		"REFSEESHC-PFR",
		30.37384,
		-94.17094,
		"PLATTS - Refinery - United States - Silsbee - South Hampton Co.",
		null,
		null,
		null,
		null,
		null,
		6.27,
		6.65,
		0.74,
		274.7,
		0.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Arabian Shield Developmnt Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTOAILL-PFR",
		34.0401,
		131.815962,
		"PLATTS - Refinery - Japan - Tokuyama - Idemitsu Showa Shell - {Idemitsu Kosan Company}",
		null,
		null,
		null,
		null,
		null,
		86.66,
		91.69,
		29.67,
		3486.58,
		31.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Idemitsu Kosan Company",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSEOHYU-PFR",
		36.994598,
		126.349404,
		"PLATTS - Refinery - South Korea - Seosan - Hyundai Business Group - {Daesan}",
		130,
		135.57,
		15.29,
		5582.35,
		15.95,
		1619.32,
		1720.08,
		361.5,
		73458.42,
		383.43,
		51.3,
		null,
		7.63,
		2782.36,
		null,
		0,
		null,
		0,
		0,
		null,
		447.2,
		null,
		61.24,
		22354.55,
		null,
		null,
		null,
		null,
		null,
		null,
		228.44,
		null,
		30.54,
		11147.13,
		null,
		1.94,
		null,
		0.25,
		91.89,
		null,
		165.52,
		null,
		22.83,
		8333.18,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hyundai Business Group_Saudi Aramco",
		"83_17",
		null,
		"Active",
		null,
		193.9,
		66.12,
		28.14,
		94.7,
		23.25,
		119.96,
		37.28846154,
		12.71538462,
		5.41153846,
		18.21153846,
		4.47115385,
		23.06923077,
		526.08,
	],
	[
		"REFTORPDA-PFR",
		56.15063,
		-120.673832,
		"PLATTS - Refinery - Canada - Taylor - Petro-Canada",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Canada",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSERCOR-PFR",
		33.36394,
		-92.71368,
		"PLATTS - Refinery - United States - Smackover - Cross Oil and Ref.Co.",
		null,
		null,
		null,
		null,
		null,
		23,
		24.3,
		5.45,
		1081.15,
		5.77,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.56,
		null,
		1.04,
		380.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.56,
		null,
		1.04,
		380.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Moore and Munger",
		"100",
		null,
		"Active",
		null,
		2.53,
		0.41,
		0,
		0.14,
		-0.16,
		0.97,
		36.45533141,
		5.90778098,
		0,
		2.01729107,
		-2.3054755,
		13.97694524,
		3.89,
	],
	[
		"REFTRKUSR-PFR",
		38.0466,
		29.4515,
		"PLATTS - Refinery - Turkey - Unknown - SOCAR",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		796.33,
		837,
		281.29,
		30481.67,
		296.07,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTRSVRO-PFR",
		28.45824,
		-98.18851,
		"PLATTS - Refinery - United States - Three Rivers - Valero",
		null,
		null,
		null,
		null,
		null,
		357.78,
		376.14,
		62.18,
		16970.18,
		65.45,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		79.48,
		null,
		10.34,
		3772.4,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		79.48,
		null,
		10.34,
		3772.4,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		35.17,
		44.89,
		0.55,
		6.87,
		2.22,
		0.72,
		39.56130484,
		50.49493813,
		0.61867267,
		7.72778403,
		2.49718785,
		0.80989876,
		90.43,
	],
	[
		"REFPRSEXM-PFR",
		51.873046,
		4.296264,
		"PLATTS - Refinery - Netherlands - Pernis - ExxonMobil",
		null,
		null,
		null,
		null,
		null,
		589.17,
		620.14,
		81.97,
		29733.92,
		86.27,
		17,
		null,
		2.53,
		921.99,
		null,
		0,
		null,
		0,
		0,
		null,
		211.85,
		null,
		29.4,
		10731.68,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		194.85,
		null,
		26.88,
		9809.69,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil",
		"100",
		null,
		"Active",
		null,
		94.53,
		31.02,
		9.72,
		37.5,
		11.5,
		13,
		47.265,
		15.51,
		4.86,
		18.75,
		5.75,
		6.5,
		197.27,
	],
	[
		"REFTTEMLL-PFR",
		45.59828,
		13.79956,
		"PLATTS - Refinery - Italy - Trieste - Monteshell",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPSAPRC-PFR",
		29.752046,
		-95.123154,
		"PLATTS - Refinery - United States - Pasadena - Petromax Refining Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petromax Refining Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTITUK-PFR",
		53.515,
		49.4076,
		"PLATTS - Refinery - Russia - Togliatti - Togliattikauchuk",
		null,
		null,
		null,
		null,
		null,
		3,
		3.22,
		0.35,
		129.43,
		0.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Togliattikauchuk",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPSKZIN-PFR",
		60.3667,
		28.6167,
		"PLATTS - Refinery - Russia - Primorsk - Zhasmin",
		585.3,
		641.65,
		102.91,
		27985.06,
		112.21,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zhasmin",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTYMUM-PFR",
		29.37542,
		-94.934133,
		"PLATTS - Refinery - United States - Texas City - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		173.04,
		181.83,
		23.56,
		8583.64,
		24.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		81.09,
		null,
		10.55,
		3848.94,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		81.09,
		null,
		10.55,
		3848.94,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		21.47,
		49.75,
		6.08,
		8.32,
		-3.23,
		1.61,
		24.84953704,
		57.58101852,
		7.03703704,
		9.62962963,
		-3.73842593,
		1.86342593,
		83.99,
	],
	[
		"REFPSNSU2-PFR",
		19.6192,
		37.2117,
		"PLATTS - Refinery - North Sudan - Port Sudan - Sudanese Government",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		130,
		142.14,
		18,
		6566.52,
		19.66,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sudanese Government_Energy Link International",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTU2PMX-PFR",
		20.049014,
		-99.28016,
		"PLATTS - Refinery - Mexico - Tula (2) - PEMEX",
		1397.34,
		1537.09,
		369.65,
		60178.73,
		401.87,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPTIAAS-PFR",
		44.918011,
		26.025232,
		"PLATTS - Refinery - Romania - Ploiesti - Astra S.A.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.02,
		-0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rafirom",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTUBTPI-PFR",
		-6.9594,
		111.893,
		"PLATTS - Refinery - Indonesia - Tuban - TPPI",
		null,
		null,
		null,
		null,
		null,
		220,
		239.04,
		26.44,
		9640.8,
		28.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		75,
		null,
		9.74,
		3559.81,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		75,
		null,
		9.74,
		3559.81,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tuban Petro_Siam Cement_Pertamina_Itochu Corp._Sojitz",
		"59.5_17_15_4.25_4.25",
		null,
		"Active",
		null,
		20,
		15.95,
		0.91,
		10.75,
		4,
		19.91,
		26.66666667,
		21.26666667,
		1.21333333,
		14.33333333,
		5.33333333,
		26.54666667,
		71.49,
	],
	[
		"REFPTILUK-PFR",
		44.94591,
		26.07463,
		"PLATTS - Refinery - Romania - Ploiesti - Lukoil",
		null,
		null,
		null,
		null,
		null,
		274.51,
		291.18,
		100.49,
		10136.19,
		105.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		55.4,
		null,
		7.64,
		2789.11,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		55.4,
		null,
		7.64,
		2789.11,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil_ConocoPhillips_Other Investors",
		"74.4_18.6_7",
		null,
		"Active",
		null,
		20.2,
		16.71,
		3.61,
		1.2,
		6.17,
		0.09,
		40.4,
		33.42,
		7.22,
		2.4,
		12.34,
		0.18,
		47.99,
	],
	[
		"REFTUOPTC-PFR",
		1.8078,
		-78.7706,
		"PLATTS - Refinery - Colombia - Tumaco - PetroChina",
		30,
		32.21,
		4.11,
		1500,
		4.41,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPVONVO-PFR",
		44.83277,
		20.68841,
		"PLATTS - Refinery - Serbia - Pancevo - Nis-Rafinerija Nafte Pancevo",
		5,
		5.62,
		0.59,
		216.23,
		0.66,
		449.05,
		493.06,
		97.41,
		20695.32,
		106.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		59.09,
		null,
		8.15,
		2975.39,
		null,
		84.45,
		88.33,
		11.12,
		4053.37,
		11.59,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		59.09,
		null,
		8.15,
		2975.39,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazpromneft_Petroleum Industry Of Serbia_Other Investors",
		"56.15_29.87_13.98",
		null,
		"Active",
		null,
		32.4,
		14.26,
		13.18,
		3.08,
		3.44,
		1.19,
		46.27910299,
		20.36851878,
		18.82588202,
		4.39937152,
		4.91358377,
		1.69975718,
		67.55,
	],
	[
		"REFQDOSAO-PFR",
		36.0638,
		120.3781,
		"PLATTS - Refinery - China - Qingdao - Shandong Huachao",
		null,
		null,
		null,
		null,
		null,
		4,
		4.23,
		0.47,
		172.58,
		0.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Huachao",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUADQCO-PFR",
		24.940606,
		51.573405,
		"PLATTS - Refinery - Qatar - Umm Saead - Qatar Fuel Additives Co",
		null,
		null,
		null,
		null,
		null,
		14.14,
		15.19,
		1.67,
		610.06,
		1.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qatar Petroleum_Chinese Petroleum Corp._International Octane_Other Investors",
		"50_20_15_15",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQS2NIO-PFR",
		26.952,
		56.2664,
		"PLATTS - Refinery - Iran - Qeshm (2) - National Iranian Oil Co.",
		306.12,
		337.85,
		36.7,
		13346.41,
		40.51,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUAEFJE-PFR",
		25.1212,
		56.334,
		"PLATTS - Refinery - United Arab Emirates - Fujairah - Ecomar",
		null,
		null,
		null,
		null,
		null,
		71,
		76.52,
		14.02,
		3300.57,
		15.11,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ecomar",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFQTORTO-PFR",
		-0.2202,
		-78.5123,
		"PLATTS - Refinery - Ecuador - Quito - Refineria de Quito",
		45.33,
		49.43,
		6.02,
		2187.86,
		6.55,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUALURZ-PFR",
		65.0332,
		60.1154,
		"PLATTS - Refinery - Russia - Ural - Uraineftegaz",
		null,
		null,
		null,
		null,
		null,
		3.07,
		3.35,
		0.4,
		147.16,
		0.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0.95,
		null,
		0.13,
		47.95,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0.95,
		null,
		0.13,
		47.95,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		null,
		"Active",
		null,
		0.24,
		0.08,
		0.44,
		0.08,
		0,
		0.08,
		23.76237624,
		7.92079208,
		43.56435644,
		7.92079208,
		0,
		7.92079208,
		0.91,
	],
	[
		"REFRCHCHN-PFR",
		47.781749,
		-122.395129,
		"PLATTS - Refinery - United States - Richmond Beach - Chevron",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron Corp",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUGANEK-PFR",
		59.709534,
		28.434842,
		"PLATTS - Refinery - Russia - Ust-Luga - Novatek",
		null,
		null,
		null,
		null,
		null,
		460.8,
		503.99,
		175.01,
		14798.76,
		189.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		125,
		null,
		16.25,
		5933.03,
		null,
		137.7,
		151.16,
		17.25,
		6036.92,
		18.94,
		0,
		null,
		0,
		0,
		null,
		125,
		null,
		16.25,
		5933.03,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Novatek_Total",
		"80.6_19.4",
		null,
		"Active",
		null,
		33.08,
		0,
		5.52,
		0,
		6.43,
		83.26,
		25.51484767,
		0,
		4.25761666,
		0,
		4.95950636,
		64.21905129,
		128.29,
	],
	[
		"REFRDEPTS-PFR",
		-32.045729,
		-52.089814,
		"PLATTS - Refinery - Brazil - Rio Grande - Petrobras - {Riograndense - Shale Industrialization Unit - SIX}",
		null,
		null,
		null,
		null,
		null,
		84.4,
		88.77,
		11.39,
		4155.61,
		11.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		null,
		1.56,
		569.57,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		12,
		null,
		1.56,
		569.57,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras",
		"100",
		null,
		"Active",
		null,
		4.79,
		4.17,
		0.6,
		0.73,
		1.44,
		0,
		39.91666667,
		34.75,
		5,
		6.08333333,
		12,
		0,
		11.72,
	],
	[
		"REFREASEG-PFR",
		52.1306,
		-106.6594,
		"PLATTS - Refinery - Canada - Regina - SHEC Energy",
		null,
		null,
		null,
		null,
		null,
		3.28,
		3.47,
		3.28,
		3.28,
		3.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SHEC Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFREOADE-PFR",
		38.047145,
		-122.255421,
		"PLATTS - Refinery - United States - Rodeo - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		120,
		126.96,
		120,
		120,
		126.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRLECAC-PFR",
		41.466758,
		-79.692156,
		"PLATTS - Refinery - United States - Rouseville - Calumet Lubricants Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.01,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Pennzoil-Quaker State Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRLNQAS-PFR",
		25.89083,
		51.54077,
		"PLATTS - Refinery - Qatar - Ras Laffan - Qatargas",
		null,
		null,
		null,
		null,
		null,
		680.1,
		748.85,
		104.33,
		28963.8,
		114.33,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		268,
		null,
		34.86,
		12720.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		268,
		null,
		34.86,
		12720.41,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qatar Petroleum_Total_Cosmo Oil_Idemitsu Kosan Company_Marubeni",
		"84_10_2_2_1",
		null,
		"Active",
		null,
		29.8,
		53.97,
		5.4,
		48.39,
		9.73,
		119.08,
		11.07806691,
		20.06319703,
		2.00743494,
		17.98884758,
		3.61710037,
		44.26765799,
		266.38,
	],
	[
		"REFRNAEEL-PFR",
		44.443442,
		12.236657,
		"PLATTS - Refinery - Italy - Ravenna - Ecofuel",
		null,
		null,
		null,
		null,
		null,
		3.23,
		3.41,
		0.38,
		139.35,
		0.41,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRRAARM-PFR",
		26.698075,
		50.095294,
		"PLATTS - Refinery - Saudi Arabia - Ras Tanura - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		1621.62,
		1776.63,
		341.28,
		69728.66,
		368.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		435.21,
		null,
		58.45,
		21334.48,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		200,
		null,
		26.01,
		9492.85,
		null,
		235.21,
		null,
		32.44,
		11841.63,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		138.24,
		86.4,
		65.8,
		41.86,
		18.79,
		69.35,
		28.07302561,
		17.545641,
		13.3623053,
		8.50070061,
		3.81577077,
		14.08321995,
		420.44,
	],
	[
		"REFRROPTS-PFR",
		-22.665403,
		-42.858124,
		"PLATTS - Refinery - Brazil - Rio De Janeiro - Petrobras - {Comperj}",
		1245.25,
		1310.8,
		360.96,
		52962.02,
		380.96,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrobras_China National Chemical Corporation",
		"80_20",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSAASUR-PFR",
		42.931148,
		-82.440056,
		"PLATTS - Refinery - Canada - Sarnia - Suncor",
		null,
		null,
		null,
		null,
		null,
		370.2,
		390.35,
		135.65,
		13405.47,
		143.33,
		6.68,
		null,
		0.99,
		362.33,
		null,
		0,
		null,
		0,
		0,
		null,
		65.85,
		null,
		9.09,
		3318.79,
		null,
		null,
		null,
		null,
		null,
		null,
		4.96,
		null,
		0.66,
		242.17,
		null,
		7.44,
		null,
		0.97,
		353.34,
		null,
		0,
		null,
		0,
		0,
		null,
		46.77,
		null,
		6.47,
		2360.94,
		null,
		null,
		null,
		null,
		null,
		null,
		"Suncor",
		"100",
		null,
		"Active",
		null,
		26.52,
		31.01,
		2.48,
		4.29,
		0.22,
		4.31,
		38.43478261,
		44.94202899,
		3.5942029,
		6.2173913,
		0.31884058,
		6.24637681,
		68.84,
	],
	[
		"REFSAIJNO-PFR",
		38.279715,
		141.036554,
		"PLATTS - Refinery - Japan - Sendai - ENEOS",
		null,
		null,
		null,
		null,
		null,
		587.8,
		621.15,
		129.67,
		26532.75,
		137.13,
		1.74,
		null,
		0.26,
		94.6,
		null,
		1.88,
		null,
		0.28,
		101.82,
		null,
		104,
		null,
		14.15,
		5166.57,
		null,
		null,
		null,
		null,
		null,
		null,
		54.68,
		null,
		7.31,
		2668.35,
		null,
		0,
		null,
		0,
		0,
		null,
		37.36,
		null,
		5.15,
		1880.79,
		null,
		8.34,
		null,
		1.15,
		421.02,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon",
		"100",
		0,
		"Active",
		null,
		35.49,
		42.07,
		13.56,
		21.2,
		-0.71,
		13.47,
		27.9911665,
		33.18085022,
		10.69484975,
		16.72056156,
		-0.55998107,
		10.62386624,
		125.1,
	],
	[
		"REFSANMAL-PFR",
		42.2914,
		90.6423,
		"PLATTS - Refinery - China - Shanshan - Meihuite Petrochemical",
		null,
		null,
		null,
		null,
		null,
		142.57,
		154.14,
		29.35,
		6864.46,
		31.53,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Meihuite Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSARMUP-PFR",
		24.3446,
		56.7425,
		"PLATTS - Refinery - Oman - Sohar - Mashael Group",
		null,
		null,
		null,
		null,
		null,
		65.3,
		70.09,
		9.61,
		3506.56,
		10.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mashael Group",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSATSAN-PFR",
		53.421559,
		55.890701,
		"PLATTS - Refinery - Russia - Salavat - Salavatnefteorgsintez",
		40,
		42.95,
		5.48,
		2000,
		5.88,
		746.14,
		821.08,
		121.45,
		35083.15,
		133.06,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		131,
		null,
		17.56,
		6413.7,
		null,
		490.9,
		522.61,
		422.41,
		4608.52,
		447.39,
		0,
		null,
		0,
		0,
		null,
		63,
		null,
		8.18,
		2990.23,
		null,
		68,
		null,
		9.38,
		3423.45,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom_Other Investors_DKK_Promtechnivest_Aram Ekavyan",
		"69_18_6_5.3_1.7",
		null,
		"Active",
		null,
		33.14,
		38.08,
		10.61,
		7.51,
		6.61,
		26.55,
		24.62841855,
		28.29964328,
		7.88495838,
		5.58115339,
		4.91230678,
		19.73097503,
		122.49,
	],
	[
		"REFSCRSIN-PFR",
		41.78309,
		-107.1077,
		"PLATTS - Refinery - United States - Sinclair - Sinclair",
		null,
		null,
		null,
		null,
		null,
		255.36,
		268.92,
		36.31,
		12885.27,
		38.23,
		48.33,
		null,
		7.18,
		2621.09,
		null,
		0,
		null,
		0,
		0,
		null,
		69.01,
		null,
		10.01,
		3652.01,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4.41,
		null,
		0.57,
		209.53,
		null,
		0,
		null,
		0,
		0,
		null,
		16.27,
		null,
		2.25,
		821.39,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinclair",
		"100",
		null,
		"Active",
		null,
		30.62,
		38.93,
		0.43,
		1.51,
		1.2,
		0,
		40.29477563,
		51.23042506,
		0.56586393,
		1.98710357,
		1.57915515,
		0,
		72.69,
	],
	[
		"REFSCTOMV-PFR",
		48.14367,
		16.49486,
		"PLATTS - Refinery - Austria - Schwechat - OMV",
		null,
		null,
		null,
		null,
		null,
		1029.36,
		1081.92,
		555.58,
		28003.89,
		584.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		163,
		null,
		21.46,
		7832.23,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		130,
		null,
		16.91,
		6170.35,
		null,
		29.42,
		null,
		4.06,
		1481.02,
		null,
		3.58,
		null,
		0.5,
		180.86,
		null,
		null,
		null,
		null,
		null,
		null,
		"OMV",
		"100",
		null,
		"Active",
		null,
		83.74,
		46.25,
		12.5,
		18.13,
		3.84,
		24.11,
		46.01098901,
		25.41208791,
		6.86813187,
		9.96153846,
		2.10989011,
		13.24725275,
		188.58,
	],
	[
		"REFSCZEBN-PFR",
		-17.3333,
		-61.5,
		"PLATTS - Refinery - Bolivia - Santa Cruz - Empresa Boliviana de Refinacion",
		null,
		null,
		null,
		null,
		null,
		45.6,
		49.97,
		5.83,
		2128.12,
		6.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		20,
		null,
		2.6,
		949.28,
		null,
		9,
		10.11,
		1.25,
		457.52,
		1.41,
		0,
		null,
		0,
		0,
		null,
		20,
		null,
		2.6,
		949.28,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF Bolivianos",
		"100",
		null,
		"Active",
		null,
		4.88,
		7.92,
		1.91,
		1.8,
		1.6,
		0.41,
		24.4,
		39.6,
		9.55,
		9,
		8,
		2.05,
		18.53,
	],
	[
		"REFSDACPN-PFR",
		6.9674,
		79.95,
		"PLATTS - Refinery - Sri Lanka - Sapugaskanda - Ceylon Petroleum Corporation",
		null,
		null,
		null,
		null,
		null,
		115.45,
		126.27,
		15.83,
		5777.14,
		17.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		35,
		null,
		4.71,
		1718.72,
		null,
		200.58,
		219.58,
		61.19,
		8112.6,
		66.26,
		28,
		null,
		3.74,
		1366.31,
		null,
		0,
		null,
		0,
		0,
		null,
		7,
		null,
		0.97,
		352.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ceylon Petroleum Corporation",
		"100",
		null,
		"Active",
		null,
		12.67,
		3.94,
		7.61,
		4.42,
		0.88,
		2.65,
		36.2,
		11.25714286,
		21.74285714,
		12.62857143,
		2.51428571,
		7.57142857,
		32.16,
	],
	[
		"REFSDIPEC-PFR",
		-0.1932,
		-76.645224,
		"PLATTS - Refinery - Ecuador - Shushufindi - Petroecuador",
		38,
		40.79,
		5.46,
		1992.45,
		5.86,
		43.01,
		46.8,
		12.63,
		1692.89,
		13.52,
		16,
		null,
		2.38,
		867.76,
		null,
		0,
		null,
		0,
		0,
		null,
		16,
		null,
		2.38,
		867.76,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroecuador",
		"100",
		null,
		"Active",
		null,
		5.1,
		5.54,
		6.3,
		1.08,
		0.71,
		0,
		27.77777778,
		30.17429194,
		34.31372549,
		5.88235294,
		3.8671024,
		0,
		18.73,
	],
	[
		"REFSGSGWR-PFR",
		33.911099,
		-118.046468,
		"PLATTS - Refinery - United States - Santa Fe Springs - Golden West Refng Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Thrifty Oil Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSHNIRV-PFR",
		45.280816,
		-66.012431,
		"PLATTS - Refinery - Canada - Saint John - Irving Oil",
		15.7,
		16.84,
		3.1,
		876.7,
		3.32,
		864.19,
		909.64,
		158.43,
		40634.15,
		166.91,
		1.96,
		null,
		0.29,
		106.15,
		null,
		0,
		null,
		0,
		0,
		null,
		275,
		null,
		36.71,
		13398.57,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		157.56,
		null,
		20.49,
		7478.57,
		null,
		115.48,
		null,
		15.93,
		5813.84,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Irving Oil",
		"100",
		null,
		"Active",
		null,
		92.41,
		140.89,
		16.31,
		15.22,
		-1.45,
		8.56,
		32.886121,
		50.13879004,
		5.80427046,
		5.41637011,
		-0.51601423,
		3.04626335,
		271.94,
	],
	[
		"REFSHUKNP-PFR",
		29.031224,
		48.146535,
		"PLATTS - Refinery - Kuwait - Shuaiba - Kuwait National Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.02,
		0.02,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSITBAH-PFR",
		26.120083,
		50.601816,
		"PLATTS - Refinery - Bahrain - Sitra - Bahrain National Oil Co.",
		null,
		null,
		null,
		null,
		null,
		19.7,
		21.54,
		2.91,
		1059.16,
		3.17,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Noga Holding_Neste Oil",
		"55_45",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSKAUYA-PFR",
		49.55322,
		36.63082,
		"PLATTS - Refinery - Ukraine - Shebelinka - UkrGazVydobuvannya",
		85.6,
		93.84,
		9.83,
		3589.98,
		10.78,
		48,
		52.78,
		5.71,
		2080.46,
		6.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8.97,
		null,
		1.17,
		425.96,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		8.97,
		null,
		1.17,
		425.96,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Naftogaz Ukrayiny",
		"100",
		0,
		"Active",
		null,
		1.56,
		3.37,
		0.44,
		0.19,
		0.12,
		1.02,
		22.70742358,
		49.05385735,
		6.40465793,
		2.76564774,
		1.74672489,
		14.84716157,
		6.7,
	],
	[
		"REFSKICOS-PFR",
		34.569049,
		135.431908,
		"PLATTS - Refinery - Japan - Sakai - Cosmo Oil",
		null,
		null,
		null,
		null,
		null,
		368.8,
		390.49,
		76.57,
		17198.77,
		80.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71.45,
		null,
		9.68,
		3532.85,
		null,
		null,
		null,
		null,
		null,
		null,
		40.38,
		null,
		5.4,
		1970.18,
		null,
		0.68,
		null,
		0.09,
		32.44,
		null,
		30.39,
		null,
		4.19,
		1530.23,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mubadala Investment Company",
		"20.8",
		0,
		"Active",
		null,
		26.26,
		32.32,
		2.47,
		15.57,
		-1.95,
		8.75,
		30.66682238,
		37.74378139,
		2.88450309,
		18.18287983,
		-2.27723929,
		10.21838141,
		83.41,
	],
	[
		"REFSKYPMO-PFR",
		50.042911,
		15.20935,
		"PLATTS - Refinery - Czech Republic - Stredocesky - PARAMO",
		null,
		null,
		null,
		null,
		null,
		2.5,
		2.68,
		0.35,
		129.07,
		0.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unipetrol",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSLEHRC-PFR",
		31.81795,
		-89.00834,
		"PLATTS - Refinery - United States - Sandersville - Hunt Refining Consolidated",
		null,
		null,
		null,
		null,
		null,
		21.55,
		22.85,
		3.14,
		1144.18,
		3.33,
		2.44,
		null,
		0.36,
		132.46,
		null,
		0,
		null,
		0,
		0,
		null,
		5.74,
		null,
		0.82,
		298.39,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.3,
		null,
		0.45,
		165.93,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vermont Gas Systems",
		"100",
		null,
		"Active",
		null,
		1.66,
		0.33,
		0.32,
		0.13,
		-0.13,
		0.6,
		31.49905123,
		6.26185958,
		6.07210626,
		2.46679317,
		-2.46679317,
		11.38519924,
		2.91,
	],
	[
		"REFSNSBRO-PFR",
		33.41761,
		-93.05659,
		"PLATTS - Refinery - United States - Stephens - Berry Petroleum Co",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.02,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Crystal Oil Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSOVTRT-PFR",
		51.456674,
		45.936915,
		"PLATTS - Refinery - Russia - Saratov - TNK-Rosneft",
		null,
		null,
		null,
		null,
		null,
		424.35,
		464.37,
		58.61,
		21340.9,
		64.04,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		118.7,
		null,
		16.35,
		5962.46,
		null,
		28.99,
		32.26,
		4.21,
		1534.47,
		4.68,
		0,
		null,
		0,
		0,
		null,
		4.72,
		null,
		0.62,
		224.64,
		null,
		113.97,
		null,
		15.73,
		5737.82,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Tyumen Oil_Other Investors",
		"46.8_46.8_6.4",
		null,
		"Active",
		null,
		42.01,
		21.9,
		28.25,
		7.82,
		5.11,
		9.96,
		33.43680357,
		17.43075454,
		22.48487743,
		6.22413244,
		4.06717606,
		7.92741165,
		115.04,
	],
	[
		"REFSRKMUM-PFR",
		44.85207,
		-92.99734,
		"PLATTS - Refinery - United States - Saint Paul Park - Marathon Petroleum",
		null,
		null,
		null,
		null,
		null,
		312.51,
		329.75,
		50.7,
		15006.09,
		53.54,
		25.53,
		null,
		3.79,
		1384.77,
		null,
		0,
		null,
		0,
		0,
		null,
		92.32,
		null,
		12.56,
		4584.57,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		56.82,
		null,
		7.39,
		2696.85,
		null,
		2.14,
		null,
		0.29,
		107.67,
		null,
		7.83,
		null,
		1.08,
		395.28,
		null,
		null,
		null,
		null,
		null,
		null,
		"Andeavor",
		"100",
		null,
		"Active",
		null,
		29.68,
		54.34,
		2.17,
		5.84,
		-2.42,
		0.23,
		29.73054192,
		54.43253531,
		2.17369528,
		5.84994491,
		-2.42412101,
		0.23039167,
		89.84,
	],
	[
		"REFSSKSCO-PFR",
		45.2591,
		38.1245,
		"PLATTS - Refinery - Russia - Slavyansk - Slavyansk Eco",
		null,
		null,
		null,
		null,
		null,
		60,
		64.41,
		8.22,
		3000,
		8.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		37.61,
		null,
		5.09,
		1857.6,
		null,
		80,
		85.88,
		10.96,
		4000,
		11.76,
		0,
		null,
		0,
		0,
		null,
		12.45,
		null,
		1.62,
		590.86,
		null,
		25.16,
		null,
		3.47,
		1266.74,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Slavyansk Eco",
		"100",
		null,
		"Active",
		null,
		11.67,
		6.01,
		13.03,
		2.37,
		0.85,
		2.43,
		29.31424265,
		15.09670937,
		32.73046973,
		5.95327807,
		2.13514192,
		6.10399397,
		36.35,
	],
	[
		"REFSTYBOC-PFR",
		40.825465,
		-111.926581,
		"PLATTS - Refinery - United States - Salt Lake City - BOC",
		null,
		null,
		null,
		null,
		null,
		26,
		27.51,
		26,
		26,
		27.51,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSTYMUM-PFR",
		40.79425,
		-111.9088,
		"PLATTS - Refinery - United States - Salt Lake City - Marathon Petroleum",
		2,
		2.09,
		0.27,
		100,
		0.29,
		159.84,
		168.2,
		34.18,
		7008.67,
		35.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		54.58,
		null,
		7.17,
		2615.35,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		46.37,
		null,
		6.03,
		2200.9,
		null,
		0,
		null,
		0,
		0,
		null,
		8.21,
		null,
		1.14,
		414.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tesoro",
		"100",
		null,
		"Active",
		null,
		15.84,
		36.94,
		1.33,
		5.46,
		-3.33,
		0,
		26.35607321,
		61.46422629,
		2.21297837,
		9.08485857,
		-5.54076539,
		0,
		56.25,
	],
	[
		"REFSUSLCA-PFR",
		42.4648,
		-71.0101,
		"PLATTS - Refinery - United States - Saugus - Lubrication Co. America",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lubrication Co. America",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSVHAXS-PFR",
		32.108129,
		-81.128011,
		"PLATTS - Refinery - United States - Savannah - Axeon Specialty Products",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0.01,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NuStar Energy_Lindsay Goldberg LLC",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSVKTBP-PFR",
		56.8391,
		60.6083,
		"PLATTS - Refinery - Russia - Sverdlovsk - TNK-BP",
		1032.52,
		1128.74,
		214.3,
		48173.72,
		232.74,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_Tyumen Oil",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSYAPUZ-PFR",
		37.9521,
		67.1266,
		"PLATTS - Refinery - Uzbekistan - Surkhandarya - Petromaruz",
		null,
		null,
		null,
		null,
		null,
		11.88,
		12.8,
		2.18,
		607.04,
		2.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petromaruz_Jarkurganneft",
		"55_45",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSYGSCC-PFR",
		41.7279897,
		123.17574412,
		"PLATTS - Refinery - China - Shenyang - Shenyang Chemical Co.",
		216.15,
		234.93,
		30.04,
		10912.67,
		32.66,
		44,
		47.22,
		6.11,
		2231.04,
		6.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ChemChina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSZ2NIO-PFR",
		29.606,
		52.5378,
		"PLATTS - Refinery - Iran - Shiraz (2) - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		49.03,
		53.77,
		5.96,
		2164.29,
		6.54,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC_Petrofield",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSZGSOC-PFR",
		38.042319,
		114.495317,
		"PLATTS - Refinery - China - Shijiazhuang - Shijiazhuang Ref-Chem Co.",
		null,
		null,
		null,
		null,
		null,
		908.16,
		986.19,
		165.17,
		43394.49,
		178.24,
		72.5,
		null,
		10.77,
		3932.02,
		null,
		0,
		null,
		0,
		0,
		null,
		145,
		null,
		20.36,
		7432.71,
		null,
		null,
		null,
		null,
		null,
		null,
		29,
		null,
		3.88,
		1415.11,
		null,
		36.25,
		null,
		4.71,
		1720.58,
		null,
		7.25,
		null,
		1,
		365,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		56.21,
		36.69,
		1.23,
		11.2,
		15.82,
		16.03,
		38.29019074,
		24.99318801,
		0.83787466,
		7.62942779,
		10.77656676,
		10.91961853,
		137.19,
	],
	[
		"REFTANXSC-PFR",
		41.8004,
		85.5691,
		"PLATTS - Refinery - China - Tiemenguan - Xinjiang Shengxing Chemical",
		219.55,
		234.87,
		27.81,
		9950.02,
		29.71,
		22,
		23.37,
		3.11,
		1134.07,
		3.3,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTAOPRP-PFR",
		13.72086,
		121.068866,
		"PLATTS - Refinery - Philippines - Tabangao - Pilipinas Shell Petroleum Corp",
		null,
		null,
		null,
		null,
		null,
		10.68,
		11.4,
		1.59,
		553.17,
		1.65,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30.4,
		null,
		4.08,
		1490.8,
		null,
		null,
		null,
		null,
		null,
		null,
		10,
		null,
		1.34,
		487.97,
		null,
		8.4,
		null,
		1.09,
		398.7,
		null,
		12,
		null,
		1.65,
		604.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Other Investors",
		"67.1_32.9",
		null,
		"Active",
		null,
		29.25,
		11.22,
		9.73,
		6.63,
		2.7,
		6.71,
		41.78571429,
		16.02857143,
		13.9,
		9.47142857,
		3.85714286,
		9.58571429,
		66.26,
	],
	[
		"REFTCAHRC-PFR",
		33.199977,
		-87.610315,
		"PLATTS - Refinery - United States - Tuscaloosa - Hunt Refining Consolidated",
		null,
		null,
		null,
		null,
		null,
		252.14,
		266.21,
		47.64,
		11968.71,
		50.4,
		23.38,
		null,
		3.47,
		1268.19,
		null,
		0,
		null,
		0,
		0,
		null,
		70.94,
		null,
		10.03,
		3662.39,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		47.56,
		null,
		6.56,
		2394.19,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hunt Refining Consolidated",
		"100",
		null,
		"Active",
		null,
		30.42,
		20.67,
		0,
		2.73,
		4.03,
		0.74,
		46.7209338,
		31.74627553,
		0,
		4.19290432,
		6.18952542,
		1.13653817,
		58.58,
	],
	[
		"REFTENADE-PFR",
		51.333349,
		3.776454,
		"PLATTS - Refinery - Netherlands - Terneuzen - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		8.5,
		8.99,
		8.5,
		8.5,
		8.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTFEAIC-PFR",
		28.452893,
		-16.263342,
		"PLATTS - Refinery - Spain - Tenerife - Abu Dhabi IPIC",
		202.9,
		214.43,
		28.3,
		10323.54,
		29.91,
		26,
		27.5,
		3.58,
		1314.45,
		3.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Abu Dhabi IPIC_Other Investors",
		"95.89_4.11",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTFOBEM-PFR",
		-29.9408,
		-51.7192,
		"PLATTS - Refinery - Brazil - Triunfo - Braskem",
		null,
		null,
		null,
		null,
		null,
		3,
		3.17,
		0.35,
		129.43,
		0.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Braskem",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTIKARO-PFR",
		59.6443,
		33.5419,
		"PLATTS - Refinery - Russia - Tikhvin - Avro",
		20.5,
		22.43,
		2.59,
		943.56,
		2.82,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Avro",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTINVOL-PFR",
		5.4461,
		100.3053,
		"PLATTS - Refinery - Malaysia - Tanjung Bin - Vitol",
		null,
		null,
		null,
		null,
		null,
		30,
		31.29,
		4.11,
		1500,
		4.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vitol",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTJNSST-PFR",
		39.3033,
		117.4164,
		"PLATTS - Refinery - China - Tianjin - Sinopec Sabic Tianjin Petrochemical",
		0,
		0,
		-0.96,
		-352.94,
		-1.02,
		1007.82,
		1084.23,
		301.14,
		41743.72,
		321.18,
		44.5,
		null,
		6.62,
		2413.44,
		null,
		17.8,
		null,
		2.64,
		963.94,
		null,
		178,
		null,
		24.72,
		9022.84,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		62.3,
		null,
		8.1,
		2957.02,
		null,
		53.4,
		null,
		7.36,
		2688.42,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC_Sinopec",
		"50_50",
		null,
		"Active",
		null,
		87.48,
		70.66,
		1.12,
		15.98,
		27.98,
		38.94,
		35.90248707,
		28.99942543,
		0.4596569,
		6.55831897,
		11.48321432,
		15.9812854,
		242.18,
	],
	[
		"REFTMKZPZ-PFR",
		58.6124,
		82.0475,
		"PLATTS - Refinery - Russia - Tomsk - ZapSib NPZ",
		190.52,
		209.54,
		26.87,
		9439.35,
		29.52,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ZapSib NPZ",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTNAAES-PFR",
		41.10692,
		1.213989,
		"PLATTS - Refinery - Spain - Tarragona - Asfaltos Espanoles S.A.",
		null,
		null,
		null,
		null,
		null,
		63.42,
		67.64,
		9.4,
		3428.34,
		10.04,
		28.36,
		null,
		4.22,
		1537.96,
		null,
		0,
		null,
		0,
		0,
		null,
		29.36,
		null,
		4.36,
		1588.32,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1,
		null,
		0.14,
		50.34,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Cepsa_Repsol",
		"50_50",
		null,
		"Active",
		null,
		5.36,
		0,
		9.02,
		5.06,
		0.16,
		3.18,
		16.75,
		0,
		28.1875,
		15.8125,
		0.5,
		9.9375,
		22.76,
	],
	[
		"REFTNOEAP-PFR",
		-36.779642,
		-73.123493,
		"PLATTS - Refinery - Chile - Talcahuano - ENAP - {Bio-Bio - Concepcion}",
		null,
		null,
		null,
		null,
		null,
		417.34,
		438.45,
		144.45,
		16376.74,
		151.43,
		26.58,
		null,
		3.95,
		1441.39,
		null,
		0,
		null,
		0,
		0,
		null,
		66.44,
		null,
		9.46,
		3453.95,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		39.87,
		null,
		5.51,
		2012.56,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENAP",
		"100",
		null,
		"Active",
		null,
		30.17,
		26.06,
		7.26,
		7.52,
		7.52,
		0.69,
		37.22393584,
		32.15299198,
		8.95743368,
		9.27822332,
		9.27822332,
		0.85132634,
		79.22,
	],
	[
		"REFTOUTZT-PFR",
		32.4586,
		119.9181,
		"PLATTS - Refinery - China - Taizhou - Taizhou Mun. Gov't",
		-10,
		-10.58,
		-1.37,
		-500,
		-1.45,
		391.6,
		421.49,
		91.37,
		17695.93,
		97.67,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTRAPET-PFR",
		-4.583043,
		-81.283606,
		"PLATTS - Refinery - Peru - Talara - Petroperu",
		null,
		null,
		null,
		null,
		null,
		415.51,
		450.45,
		170.97,
		14681.86,
		182.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroperu",
		"100",
		null,
		"Active",
		null,
		10.45,
		16.25,
		14.87,
		3.51,
		2.62,
		1.55,
		21.17527862,
		32.92806484,
		30.13171226,
		7.11246201,
		5.30901722,
		3.1408308,
		49.25,
	],
	[
		"REFTSASIN-PFR",
		36.115858,
		-96.001764,
		"PLATTS - Refinery - United States - Tulsa - Sinclair",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.02,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Holly-Frontier",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTOATS-PFR",
		40.5488,
		17.0806,
		"PLATTS - Refinery - Italy - Taranto - Air Products",
		null,
		null,
		null,
		null,
		null,
		38.5,
		40.73,
		38.5,
		38.5,
		40.73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTUNTBP-PFR",
		57.1535,
		65.5423,
		"PLATTS - Refinery - Russia - Tyumen - TNK-BP - {Chernogorneft}",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"TNK-BP",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTURGIT-PFR",
		15.8629,
		49.1308,
		"PLATTS - Refinery - Yemen - Tasour - Govt - Yemen Diesel Prod. Unit",
		null,
		null,
		null,
		null,
		null,
		1.5,
		1.61,
		0.21,
		75,
		0.22,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Govt - Yemen Diesel Prod. Unit",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTYANIH-PFR",
		36.755759,
		137.208292,
		"PLATTS - Refinery - Japan - Toyama - Nihonkai Oil Company Ltd",
		null,
		null,
		null,
		null,
		null,
		-0.03,
		0.04,
		0,
		0.01,
		0.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon_Hokuriku Electric_Other Investors",
		"66_28_6",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTYGMUM-PFR",
		29.375523,
		-94.907012,
		"PLATTS - Refinery - United States - Texas City (Galveston Bay) - Marathon Petroleum",
		22.9,
		24.23,
		3.33,
		1216.67,
		3.53,
		1825.78,
		1921.51,
		304.55,
		88142.11,
		320.77,
		33.14,
		null,
		4.92,
		1797.21,
		null,
		0,
		null,
		0,
		0,
		null,
		379.47,
		null,
		50.18,
		18314.15,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		319.13,
		null,
		41.5,
		15147.09,
		null,
		27.21,
		null,
		3.75,
		1369.85,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		0,
		"Active",
		null,
		162.09,
		254.39,
		7.31,
		48.6,
		-5.02,
		9.02,
		32.40439016,
		50.85664021,
		1.46138622,
		9.71591931,
		-1.0035785,
		1.80324264,
		476.39,
	],
	[
		"REFUAHEET-PFR",
		40.1943,
		-109.5771,
		"PLATTS - Refinery - United States - Uintah - Eesti Energia",
		120.05,
		126.25,
		33.2,
		4817.85,
		35.01,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Eesti Energia",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUFAUIM-PFR",
		54.880348,
		56.083913,
		"PLATTS - Refinery - Russia - Ufa - Ufaneftekhim",
		null,
		null,
		null,
		null,
		null,
		589.23,
		643.34,
		143.39,
		26045.91,
		155.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		135,
		null,
		18.35,
		6695.72,
		null,
		4,
		4.49,
		0.55,
		199.72,
		0.62,
		0,
		null,
		0,
		0,
		null,
		34.99,
		null,
		4.55,
		1661.25,
		null,
		100,
		null,
		13.79,
		5034.49,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Sistema_Other Investors_Bashkir Capital",
		"32.7_29_23.8_14.5",
		null,
		"Active",
		null,
		62.44,
		33.58,
		8.06,
		4.01,
		8.15,
		11.77,
		44.88211616,
		24.13743531,
		5.79355952,
		2.88240368,
		5.85825187,
		8.46032202,
		128.02,
	],
	[
		"REFUIAUFT-PFR",
		57.1961,
		52.696,
		"PLATTS - Refinery - Russia - Udmurtia - Udmurtneft",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		546.65,
		599.49,
		76.77,
		27422.95,
		84.1,
		"Rosneft_Sinopec",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRW2ABO-PFR",
		24.117024,
		52.722186,
		"PLATTS - Refinery - United Arab Emirates - Ruwais (2) - Abu Dhabi Oil Refining Co",
		null,
		null,
		null,
		null,
		null,
		35.6,
		39.1,
		5.29,
		1928.25,
		5.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ADNOC_Neste Oil",
		"55_45",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSADLDE-PFR",
		30.79035,
		-88.05646,
		"PLATTS - Refinery - United States - Saraland - Linde",
		null,
		null,
		null,
		null,
		null,
		10,
		10.58,
		10,
		10,
		10.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Linde",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSAFNIO-PFR",
		27.6649,
		52.348,
		"PLATTS - Refinery - Iran - Siraf - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		571.64,
		629.55,
		69.98,
		25439.21,
		77.08,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		567.64,
		622.08,
		68.5,
		24904.36,
		75.08,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSAMMRE-PFR",
		16.605267,
		96.221366,
		"PLATTS - Refinery - Myanmar - Syriam - Myanmar Petrochemical Enterpr.",
		null,
		null,
		null,
		null,
		null,
		40.92,
		44.17,
		10.88,
		1744.68,
		11.65,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.3,
		null,
		0.87,
		318.05,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.3,
		null,
		0.87,
		318.05,
		null,
		null,
		null,
		null,
		null,
		null,
		"Myanmar Petrochemical Enterpr.",
		"100",
		null,
		"Active",
		null,
		2.41,
		0.7,
		2.42,
		0.8,
		0.29,
		0,
		34.42857143,
		10,
		34.57142857,
		11.42857143,
		4.14285714,
		0,
		6.61,
	],
	[
		"REFSASLGO-PFR",
		12.428378,
		-69.891645,
		"PLATTS - Refinery - Aruba - San Nicholas - Lago Oil And Transport Company",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Exxon Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSCZRUZ-PFR",
		-17.875366,
		-63.202521,
		"PLATTS - Refinery - Bolivia - Santa Cruz - Reficruz",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Reficruz",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSDOPMA-PFR",
		-7.7986,
		114.2646,
		"PLATTS - Refinery - Indonesia - Situbondo - PT Petrogas Jatim Utama",
		795,
		859.58,
		111.32,
		40627.48,
		120.18,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_PT Petrogas Jatim Utama",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSEABSP-PFR",
		4.619646,
		114.3433,
		"PLATTS - Refinery - Brunei - Seria - Brunei Shell Petroleum Co.Bhd.",
		null,
		null,
		null,
		null,
		null,
		20.26,
		21.78,
		2.56,
		934.76,
		2.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		4,
		null,
		0.52,
		189.86,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Brunei Govt._Shell",
		"50_50",
		null,
		"Active",
		null,
		1.44,
		0.64,
		0.72,
		0.96,
		0.16,
		0,
		36,
		16,
		18,
		24,
		4,
		0,
		3.92,
	],
	[
		"REFSEZUWN-PFR",
		29.9745,
		32.5371,
		"PLATTS - Refinery - Egypt - Suez - Unknown",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		91,
		100.65,
		13.75,
		5017.37,
		15.2,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSGIPTC-PFR",
		31.2323,
		121.4692,
		"PLATTS - Refinery - China - Shanghai - PetroChina",
		681,
		731.91,
		181.45,
		29278.3,
		193.51,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._PDVSA",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUOLEIL-PFR",
		45.4343,
		46.8541,
		"PLATTS - Refinery - Russia - Ulan Khol - EvroSibOil",
		20,
		21.47,
		2.74,
		1000,
		2.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EvroSibOil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSGISEC-PFR",
		31.33117,
		121.56537,
		"PLATTS - Refinery - China - Shanghai - Sinopec",
		921.64,
		985.73,
		345.3,
		33986.59,
		366.77,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec_Shanghai Chemical Industry Park",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUOYGOM-PFR",
		66.106951,
		76.855598,
		"PLATTS - Refinery - Russia - Urengoy - Gazprom",
		null,
		null,
		null,
		null,
		null,
		9,
		9.66,
		1.06,
		386.47,
		1.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.29,
		null,
		0.82,
		298.56,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		6.29,
		null,
		0.82,
		298.56,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom",
		"100",
		null,
		"Active",
		null,
		1.54,
		0,
		0.25,
		0,
		0.33,
		4.55,
		23.12312312,
		0,
		3.75375375,
		0,
		4.95495495,
		68.31831832,
		6.67,
	],
	[
		"REFSHATOC-PFR",
		13.102776,
		100.889018,
		"PLATTS - Refinery - Thailand - Sriracha - Thai Oil Company Ltd.",
		null,
		null,
		null,
		null,
		null,
		1403.7,
		1484.27,
		440.25,
		55953.79,
		463.3,
		0,
		null,
		0,
		0,
		null,
		3.97,
		null,
		0.59,
		214.97,
		null,
		240.51,
		null,
		32.22,
		11758.29,
		null,
		null,
		null,
		null,
		null,
		null,
		160.37,
		null,
		21.44,
		7825.72,
		null,
		41.14,
		null,
		5.35,
		1952.97,
		null,
		27.33,
		null,
		3.77,
		1375.6,
		null,
		7.7,
		null,
		1.06,
		389.04,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_PTT",
		"50.9_49.1",
		null,
		"Active",
		null,
		117.7,
		36.36,
		22.91,
		61.71,
		16.64,
		31.41,
		40.86805556,
		12.625,
		7.95486111,
		21.42708333,
		5.77777778,
		10.90625,
		286.72,
	],
	[
		"REFUQIUPC-PFR",
		43.863438,
		87.362395,
		"PLATTS - Refinery - China - Urumqi - Urumqi Gen. Petrochem. Corp.",
		null,
		null,
		null,
		null,
		null,
		600.32,
		649.44,
		86.35,
		30670.8,
		93.42,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		125.21,
		null,
		16.85,
		6151.01,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		56.34,
		null,
		7.33,
		2674.37,
		null,
		0,
		null,
		0,
		0,
		null,
		68.87,
		null,
		9.53,
		3476.64,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		50.75,
		28.86,
		0.81,
		7.63,
		8.3,
		10.73,
		44.68609668,
		25.4116404,
		0.71321652,
		6.7183235,
		7.30826803,
		9.44791758,
		107.08,
	],
	[
		"REFSHATSE-PFR",
		13.1512,
		101.0111,
		"PLATTS - Refinery - Thailand - Sriracha - Thai Lube Base",
		null,
		null,
		null,
		null,
		null,
		44.1,
		46.53,
		6.64,
		2423.35,
		7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Thai Lube Base",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNAPT-PFR",
		44.122148,
		9.918223,
		"PLATTS - Refinery - Italy - Unknown - Arcola Petrolifera Spa.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Moratti Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNCOC-PFR",
		3.4651,
		101.7242,
		"PLATTS - Refinery - Malaysia - Unknown - CNOOC",
		140.1,
		148.34,
		19.38,
		7035.13,
		20.51,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNCSM-PFR",
		23.7346,
		89.6569,
		"PLATTS - Refinery - Bangladesh - Unknown - Cosmopolitan Group",
		823.6,
		903.36,
		112.74,
		40931.36,
		123.54,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hi-Tech International Group_Cosmopolitan Group",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNGNT-PFR",
		15.65342495,
		-89.10325413,
		"PLATTS - Refinery - Guatemala - Unknown - Guatemala Government",
		1451.68,
		1560.97,
		887.07,
		34513.23,
		942.58,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Guatemala Government",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNJOC-PFR",
		32.12249993,
		36.11360152,
		"PLATTS - Refinery - Jordan - Unknown - Jordan Petroleum Refinery Co.",
		276.19,
		301.85,
		52.26,
		13183.22,
		56.82,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jordanian Govt.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNMMP-PFR",
		59.3702,
		17.9044,
		"PLATTS - Refinery - Mauritius - Unknown - Mangalore Refinery And Petrochem.",
		251.49,
		276.01,
		35.57,
		12438.4,
		39.04,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ONGC_Hindustan Petroleum_Other Investors",
		"72_17_11",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNNI3-PFR",
		-3.8341,
		-32.4001,
		"PLATTS - Refinery - Brazil - Unknown - National Iranian Oil Co.",
		895.44,
		939,
		121.88,
		44315.4,
		127.78,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co_Unknown",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSIXLLS-PFR",
		17.70781,
		-64.75179,
		"PLATTS - Refinery - US Virgin Islands - St. Croix - Limetree Bay Terminals",
		1474.75,
		1551.17,
		528.45,
		54297.08,
		554.99,
		-0.01,
		-0.01,
		0.01,
		-0.06,
		0.08,
		8.02,
		null,
		1.19,
		434.95,
		null,
		0,
		null,
		0,
		0,
		null,
		29,
		null,
		4.04,
		1474.69,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		5.99,
		null,
		0.78,
		284.04,
		null,
		9.77,
		null,
		1.35,
		491.81,
		null,
		5.23,
		null,
		0.72,
		263.89,
		null,
		null,
		null,
		null,
		null,
		null,
		"ArcLight Capital Partners_Freepoint Commodities",
		"80_20",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNPEP-PFR",
		24.9591,
		95.803,
		"PLATTS - Refinery - Myanmar - Unknown - PTTEP",
		448.2,
		488.89,
		61.28,
		22293.44,
		66.76,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PTTEP",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSJEOAS-PFR",
		42.004127,
		21.655451,
		"PLATTS - Refinery - Macedonia - Skopje - Okta Ad Skopje S.A.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.02,
		0,
		-0.04,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hellenic Petroleum_Macedonian State Co.",
		"54_46",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSK2EFF-PFR",
		36.86816,
		6.976121,
		"PLATTS - Refinery - Algeria - Skikda (2) - Enterprise National De Raff - {NAFTEC}",
		null,
		null,
		null,
		null,
		null,
		170.1,
		185.86,
		35.62,
		6772.38,
		38.86,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		78,
		null,
		10.14,
		3702.22,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		78,
		null,
		10.14,
		3702.22,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Sonatrach",
		"50_50",
		null,
		"Active",
		null,
		20.04,
		8.58,
		4.66,
		4.04,
		2.28,
		33.28,
		27.08108108,
		11.59459459,
		6.2972973,
		5.45945946,
		3.08108108,
		44.97297297,
		72.9,
	],
	[
		"REFUWNVCI-PFR",
		46.4037,
		-64.1214,
		"PLATTS - Refinery - Canada - Unknown - Value Creation Inc.",
		568.4,
		598.72,
		320.84,
		15037.16,
		339.08,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Value Creation Inc.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSKIJNO-PFR",
		34.549616,
		135.435315,
		"PLATTS - Refinery - Japan - Sakai - ENEOS",
		7,
		7.41,
		0.96,
		349.52,
		1.01,
		547.46,
		579.48,
		73.95,
		26852.38,
		78.22,
		0.09,
		null,
		0.01,
		4.64,
		null,
		1.78,
		null,
		0.26,
		96.24,
		null,
		96.15,
		null,
		13.04,
		4759.21,
		null,
		null,
		null,
		null,
		null,
		null,
		48.38,
		null,
		6.47,
		2360.78,
		null,
		4.84,
		null,
		0.63,
		229.83,
		null,
		37.7,
		null,
		5.2,
		1897.89,
		null,
		3.36,
		null,
		0.47,
		169.82,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		0,
		"Active",
		null,
		23.45,
		34.71,
		19.14,
		20.1,
		12.75,
		7.36,
		20.00682536,
		29.61351421,
		16.3296647,
		17.14870745,
		10.87791144,
		6.2793277,
		117.53,
	],
	[
		"REFVADLUK-PFR",
		48.504954,
		44.650741,
		"PLATTS - Refinery - Russia - Volgograd - Lukoil",
		81.42,
		91.44,
		10.79,
		3937.35,
		12.11,
		1009.75,
		1104.71,
		322.43,
		40511.86,
		348.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		280,
		null,
		38.52,
		14059.1,
		null,
		165,
		179.11,
		109.51,
		3570.61,
		117.84,
		0,
		null,
		0,
		0,
		null,
		13,
		null,
		1.69,
		617.04,
		null,
		267,
		null,
		36.83,
		13442.07,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		0,
		"Active",
		null,
		96.79,
		45.77,
		61.29,
		25.25,
		7.86,
		18.65,
		33.86397033,
		16.01357498,
		21.44356588,
		8.83423133,
		2.74998251,
		6.52508572,
		255.6,
	],
	[
		"REFSLLCHM-PFR",
		33.793341,
		-118.171381,
		"PLATTS - Refinery - United States - Signal Hill - Chemoil Refining Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.01,
		0,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chemoil Refining Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFVIOLOL-PFR",
		4.1315,
		-73.6207,
		"PLATTS - Refinery - Colombia - Villavicencio - Llanopetrol",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		68.04,
		74.44,
		9.07,
		3297.41,
		9.92,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Meta Government",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSMAPFT-PFR",
		53.1986,
		50.114,
		"PLATTS - Refinery - Russia - Samara - Petroneft",
		120.05,
		131.95,
		16.35,
		5951.27,
		17.96,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroneft",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFVNGPEX-PFR",
		13.9199,
		108.936,
		"PLATTS - Refinery - Vietnam - Van Phong - Petrolimex",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		647.4,
		705.64,
		211.12,
		25227.48,
		228.04,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petrolimex_Daelim Industrial Co._JX Nippon Oil and Energy",
		"34_33_33",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFSMARFT-PFR",
		55.427837,
		78.32097,
		"PLATTS - Refinery - Russia - Samara - Rosneft - {Kuibyshev}",
		null,
		null,
		null,
		null,
		null,
		644.98,
		709.03,
		173.26,
		27479.31,
		188.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		97.03,
		null,
		13.36,
		4876.55,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		2.83,
		null,
		0.37,
		134.53,
		null,
		94.19,
		null,
		12.99,
		4742.02,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		null,
		"Active",
		null,
		44.05,
		25.89,
		8.06,
		6.84,
		7.95,
		4.66,
		42.89191821,
		25.20934761,
		7.84810127,
		6.66017527,
		7.74099318,
		4.53748783,
		97.45,
	],
	[
		"REFVNOTER-PFR",
		49.094133,
		140.313615,
		"PLATTS - Refinery - Russia - Vanino - Transbunker",
		null,
		null,
		null,
		null,
		null,
		44,
		47.68,
		10.32,
		1948.35,
		11.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		21.9,
		null,
		3.02,
		1102.46,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		21.9,
		null,
		3.02,
		1102.46,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Transbunker",
		"100",
		null,
		"Active",
		null,
		6.85,
		0,
		9.92,
		0,
		0.21,
		4.87,
		29.55133736,
		0,
		42.79551337,
		0,
		0.90595341,
		21.00949094,
		21.85,
	],
	[
		"REFVYEMLY-PFR",
		58.8617,
		60.8093,
		"PLATTS - Refinery - Russia - Verkhoturye - Moravske Naftove Doly",
		70,
		75.15,
		9.59,
		3500,
		10.29,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Moravske Naftove Doly",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSNNNST-PFR",
		37.986183,
		-8.828974,
		"PLATTS - Refinery - Portugal - Sines - Neste Oil",
		null,
		null,
		null,
		null,
		null,
		1.15,
		1.22,
		0.14,
		49.62,
		0.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Fortum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYLAMRY-PFR",
		56.981346,
		47.730163,
		"PLATTS - Refinery - Russia - Yoshkar Ola - Mari El Refinery - {Mariysky}",
		-40,
		-42.94,
		-5.72,
		-2090.1,
		-6.15,
		50.1,
		54.04,
		7.17,
		2616.61,
		7.74,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		28,
		null,
		3.87,
		1409.66,
		null,
		32.02,
		34.99,
		4.42,
		1603.34,
		4.81,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		28,
		null,
		3.87,
		1409.66,
		null,
		0,
		null,
		0,
		0,
		null,
		306.18,
		333.28,
		68.09,
		13862.68,
		73.29,
		"New Stream_Mari El Refinery",
		"99.3_0.7",
		null,
		"Active",
		null,
		8.86,
		0,
		10.81,
		0,
		0.23,
		6.7,
		30.65743945,
		0,
		37.40484429,
		0,
		0.79584775,
		23.183391,
		26.6,
	],
	[
		"REFSOYRFT-PFR",
		60.835278,
		77.150486,
		"PLATTS - Refinery - Russia - Strezhevoy - Rosneft",
		null,
		null,
		null,
		null,
		null,
		8,
		8.7,
		1.11,
		401.11,
		1.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.15,
		null,
		0.43,
		155.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0.94,
		null,
		0.12,
		44.76,
		null,
		2.21,
		null,
		0.3,
		111.1,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		null,
		"Active",
		null,
		1.12,
		0,
		1.38,
		0,
		0,
		0.76,
		33.63363363,
		0,
		41.44144144,
		0,
		0,
		22.82282282,
		3.26,
	],
	[
		"REFSTAGUA-PFR",
		13.417993,
		144.690927,
		"PLATTS - Refinery - Guam - Santa Rita - Guam Oil And Refining Company",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZEGZOC-PFR",
		46.81889,
		16.855873,
		"PLATTS - Refinery - Hungary - Zalaegerszeg - Zala Pertroleum Refining Co.",
		null,
		null,
		null,
		null,
		null,
		10.49,
		11.01,
		1.62,
		593.1,
		1.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_MOL",
		"55.7_44.3",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSTSKUW-PFR",
		55.203188,
		11.26613,
		"PLATTS - Refinery - Denmark - Stignaes - Kuwait Petroleum Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.01,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZGNZNT-PFR",
		35.75843919,
		114.98377711,
		"PLATTS - Refinery - China - Zhongyuan - Zhongyuan Oilfield Plant",
		null,
		null,
		null,
		null,
		null,
		48.04,
		51.4,
		6.75,
		2450.37,
		7.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSTYCHN-PFR",
		40.8233,
		-111.9218,
		"PLATTS - Refinery - United States - Salt Lake City - Chevron",
		null,
		null,
		null,
		null,
		null,
		129.65,
		136.23,
		18.26,
		6547.52,
		19.21,
		7.66,
		null,
		1.14,
		415.62,
		null,
		0,
		null,
		0,
		0,
		null,
		49.06,
		null,
		6.84,
		2498.09,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		2.39,
		null,
		0.31,
		113.5,
		null,
		0,
		null,
		0,
		0,
		null,
		39,
		null,
		5.39,
		1968.96,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron",
		"100",
		null,
		"Active",
		null,
		14.44,
		25.88,
		2.12,
		10.89,
		-1.24,
		0,
		26.73084043,
		47.90818215,
		3.92447242,
		20.1592003,
		-2.29544613,
		0,
		52.1,
	],
	[
		"REFUTAOKA-PFR",
		63.64043,
		53.818958,
		"PLATTS - Refinery - Russia - Ukhta - Oao Lukoil-Ukhtanefteperabotka",
		20,
		21.47,
		2.74,
		1000,
		2.94,
		281.52,
		307.05,
		48.65,
		13402.7,
		52.84,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		41.61,
		null,
		5.41,
		1974.85,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		41.61,
		null,
		5.41,
		1974.85,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Lukoil",
		"100",
		null,
		"Active",
		null,
		14.72,
		6.49,
		12.53,
		1.52,
		1.79,
		3.27,
		33.42415985,
		14.73660309,
		28.45140781,
		3.45140781,
		4.06448683,
		7.42506812,
		40.32,
	],
	[
		"REFZJGZDX-PFR",
		44.363973,
		84.863797,
		"PLATTS - Refinery - China - Zhanjiang - Zhanjiang Dongxing Refining Co.",
		null,
		null,
		null,
		null,
		null,
		356.71,
		386.3,
		48.4,
		17671.9,
		52.38,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		100.81,
		null,
		13.92,
		5080.95,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60.49,
		null,
		8.35,
		3045.2,
		null,
		40.32,
		null,
		5.57,
		2035.75,
		null,
		846.9,
		912.91,
		170.53,
		39352.31,
		182.77,
		"Sinopec_Unknown",
		"75_25",
		null,
		"Active",
		null,
		19.21,
		25.13,
		10.77,
		9.64,
		8.72,
		7.64,
		23.96756082,
		31.35371179,
		13.43730505,
		12.02744853,
		10.87960075,
		9.53212726,
		81.12,
	],
	[
		"REFVZHLIL-PFR",
		51.6606,
		39.2006,
		"PLATTS - Refinery - Russia - Voronezh - LLC Omega Oil",
		null,
		null,
		null,
		null,
		null,
		1,
		1.07,
		0.14,
		50,
		0.15,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"LLC Omega Oil",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSUTGOM-PFR",
		61.254,
		73.3964,
		"PLATTS - Refinery - Russia - Surgut - Gazprom",
		275.16,
		303.06,
		33.29,
		12090.72,
		36.67,
		378.66,
		417.33,
		45.24,
		16454.4,
		49.88,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80,
		null,
		10.4,
		3797.14,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		80,
		null,
		10.4,
		3797.14,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom",
		"100",
		null,
		"Active",
		null,
		15.72,
		31.42,
		2.03,
		5.54,
		2.61,
		23.26,
		18.86022795,
		37.69646071,
		2.4355129,
		6.64667067,
		3.13137373,
		27.90641872,
		80.58,
	],
	[
		"REFZOUGEM-PFR",
		24.5165,
		117.6425,
		"PLATTS - Refinery - China - Zhangzhou - Gulei Petrochem",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1040.48,
		1123.04,
		141.4,
		51419.74,
		152.48,
		"Sinopec_Fujian Gov._Ho Tung Holding Corp._LCY Chemical Corp_USI Corp",
		"25_25_12.5_12.5_12.5",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUORVAZ-PFR",
		47.9498,
		106.9667,
		"PLATTS - Refinery - Mongolia - Ulan Bator - Vostokneftegaz",
		114.08,
		123.61,
		39.45,
		4543.79,
		42.52,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Vostokneftegaz",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWANENS-PFR",
		28.734541,
		33.221611,
		"PLATTS - Refinery - Egypt - Wadi Feiran - El-Nasr Petroleum Company",
		null,
		null,
		null,
		null,
		null,
		10,
		10.9,
		1.37,
		500,
		1.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		8,
		null,
		1.04,
		379.71,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		8,
		null,
		1.04,
		379.71,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC",
		"100",
		null,
		"Active",
		null,
		2.46,
		0,
		2.4,
		0.78,
		0,
		1.96,
		31.8240621,
		0,
		31.04786546,
		10.09055627,
		0,
		25.35575679,
		7.6,
	],
	[
		"REFSYNRFT-PFR",
		53.089278,
		48.387805,
		"PLATTS - Refinery - Russia - Syzran - Rosneft",
		3.4,
		3.65,
		0.47,
		170,
		0.5,
		712,
		783.29,
		151.18,
		32402.75,
		164.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		119.05,
		null,
		16.42,
		5993.54,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		119.05,
		null,
		16.42,
		5993.54,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft",
		"100",
		0,
		"Active",
		null,
		38.46,
		24.45,
		19.42,
		10.32,
		11.54,
		11.09,
		31.30901986,
		19.90394008,
		15.80918268,
		8.40117226,
		9.39433409,
		9.02800391,
		115.29,
	],
	[
		"REFUWNCST-PFR",
		25.1957,
		55.2781,
		"PLATTS - Refinery - United Arab Emirates - Unknown - Chelyabinsk Oblast",
		1469,
		1605.98,
		338.8,
		65419.42,
		367.5,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Quality Energy Petro Holding_Chelyabinsk Oblast",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFSZNSGH-PFR",
		52.3183,
		7.347193,
		"PLATTS - Refinery - Germany - Salzbergen - Schmierstoff Raffinerie Salzburgh",
		null,
		null,
		null,
		null,
		null,
		10.8,
		11.31,
		1.56,
		570.2,
		1.64,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Badische Anilin and Soda Fabrik",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNJNA-PFR",
		41.1757,
		68.7927,
		"PLATTS - Refinery - Kazakhstan - Unknown - JSC Samruk-Kazyna",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		299.8,
		328.67,
		41.67,
		14558.86,
		45.62,
		"JSC Samruk-Kazyna",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWDRP66-PFR",
		38.837689,
		-90.065719,
		"PLATTS - Refinery - United States - Wood River - Cenovus",
		null,
		null,
		null,
		null,
		null,
		1322.01,
		1392.33,
		264.36,
		61510.62,
		278.85,
		257.38,
		null,
		38.24,
		13959.32,
		null,
		0,
		null,
		0,
		0,
		null,
		265.76,
		null,
		39.38,
		14371.64,
		null,
		null,
		null,
		null,
		null,
		null,
		1.82,
		null,
		0.24,
		89.02,
		null,
		2.2,
		null,
		0.28,
		104.48,
		null,
		2.52,
		null,
		0.34,
		126.98,
		null,
		1.82,
		null,
		0.26,
		91.82,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co._Cenovus",
		"50_50",
		null,
		"Active",
		null,
		88.54,
		168.1,
		2.48,
		26.12,
		2.46,
		4.4,
		27.32716049,
		51.88271605,
		0.7654321,
		8.0617284,
		0.75925926,
		1.35802469,
		292.12,
	],
	[
		"REFTASNCE-PFR",
		23.9892,
		-98.7027,
		"PLATTS - Refinery - Mexico - Tamaulipas - National Standard Finance, LLC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		356.2,
		390.51,
		48.9,
		17776.49,
		53.58,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"National Standard Finance, LLC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWKEPIR-PFR",
		30.227542,
		-93.297139,
		"PLATTS - Refinery - United States - Westlake - Praxair",
		null,
		null,
		null,
		null,
		null,
		35,
		37.03,
		35,
		35,
		37.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTATTAZ-PFR",
		39.088514,
		63.572686,
		"PLATTS - Refinery - Turkmenistan - Turkmenabat - Turkmenneftegaz - {Seydi - Chardzhou - Seidi}",
		-221.5,
		-232.07,
		-98.07,
		-6773.25,
		-103.31,
		364.22,
		395.33,
		117.86,
		13900.01,
		125.95,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		30.36,
		null,
		3.95,
		1440.99,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		30.36,
		null,
		3.95,
		1440.99,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Turkmenneftegaz",
		"100",
		null,
		"Active",
		null,
		10.28,
		7.21,
		10.48,
		1.96,
		0.88,
		0,
		33.86034256,
		23.7483531,
		34.51910408,
		6.45586298,
		2.89855072,
		0,
		30.81,
	],
	[
		"REFUWNNO3-PFR",
		-29.7703,
		30.9624,
		"PLATTS - Refinery - South Africa - Unknown - NIOC",
		20,
		21.79,
		2.74,
		1000,
		2.99,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNNRV-PFR",
		9.9242,
		13.237,
		"PLATTS - Refinery - Nigeria - Unknown - Nigerian Petr Ref and Strategic Resrv",
		330.18,
		362.04,
		43.56,
		15834.3,
		47.76,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nigerian Petr Ref and Strategic Resrv",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWODCVR-PFR",
		34.6337,
		-97.16549,
		"PLATTS - Refinery - United States - Wynnewood - CVR Energy",
		0,
		0,
		0.04,
		17.61,
		0.05,
		324.7,
		341.62,
		95.06,
		13216.27,
		100.3,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71,
		null,
		9.24,
		3369.96,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		71,
		null,
		9.24,
		3369.96,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Icahn Enterprises_Other Investors",
		"80_20",
		null,
		"Active",
		null,
		25.31,
		41.11,
		0.44,
		2.72,
		0.04,
		0.03,
		34.57650273,
		56.16120219,
		0.6010929,
		3.71584699,
		0.05464481,
		0.04098361,
		69.65,
	],
	[
		"REFUWNBNT-PFR",
		17.5001,
		-88.2003,
		"PLATTS - Refinery - Belize - Unknown - Belize Government",
		11.7,
		12.8,
		1.58,
		568.14,
		1.7,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_Belize Government",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTB2NIO-PFR",
		38.074,
		46.2962,
		"PLATTS - Refinery - Iran - Tabriz (2) - National Iranian Oil Co.",
		472.7,
		519.22,
		64.89,
		23605.64,
		71.18,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNNPC-PFR",
		9.23722832,
		29.79746009,
		"PLATTS - Refinery - South Sudan - Unknown - Nilepet Corp.",
		60,
		65.38,
		8.22,
		3000,
		8.96,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nilepet Corp._South Africa Central Energy Fund",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNPD2-PFR",
		18.3548,
		-73.6337,
		"PLATTS - Refinery - Haiti - Unknown - PDVSA",
		33.2,
		36.38,
		4.39,
		1602.49,
		4.82,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWSSHER-PFR",
		40.88599,
		-111.9064,
		"PLATTS - Refinery - United States - Woods Cross - Holly-Frontier",
		80.5,
		84.78,
		45.63,
		2099.69,
		48.24,
		128.73,
		135.64,
		17.46,
		6328.18,
		18.38,
		1.85,
		null,
		0.28,
		100.47,
		null,
		1.82,
		null,
		0.27,
		98.36,
		null,
		35.2,
		null,
		4.88,
		1781.8,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		2.97,
		null,
		0.39,
		141.17,
		null,
		0,
		null,
		0,
		0,
		null,
		28.56,
		null,
		3.95,
		1441.8,
		null,
		null,
		null,
		null,
		null,
		null,
		"Holly-Frontier",
		"100",
		null,
		"Active",
		null,
		15.62,
		24.18,
		0.25,
		0.19,
		-1.71,
		0,
		40.29927761,
		62.38390093,
		0.64499484,
		0.49019608,
		-4.41176471,
		0,
		38.54,
	],
	[
		"REFTBIUWN-PFR",
		-8.0348,
		15.0935,
		"PLATTS - Refinery - Angola - Tabi - Unknown",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		985.18,
		1079.6,
		204.99,
		45636.71,
		221.34,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNYOS-PFR",
		-34.6151,
		-58.4731,
		"PLATTS - Refinery - Bolivia - Unknown - YPF Bolivianos",
		244.14,
		267.29,
		33.15,
		12047.78,
		36.27,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"YPF Bolivianos",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNSCH-PFR",
		36.7754,
		3.0602,
		"PLATTS - Refinery - Algeria - Unknown - Sonatrach",
		675.35,
		741.26,
		93.45,
		33986.01,
		102.63,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sonatrach",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWTEIRV-PFR",
		51.82054,
		-8.244617,
		"PLATTS - Refinery - Ireland - Whitegate - Irving Oil",
		-126.92,
		-133.27,
		-16.3,
		-5954.85,
		-17.13,
		126.92,
		133.27,
		16.3,
		5954.85,
		17.13,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		57.1,
		null,
		7.47,
		2726.72,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		51.63,
		null,
		6.71,
		2450.61,
		null,
		0,
		null,
		0,
		0,
		null,
		5.47,
		null,
		0.76,
		276.12,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		19.91,
		12.09,
		12.07,
		3.63,
		1.28,
		1.15,
		38.14176245,
		23.16091954,
		23.12260536,
		6.95402299,
		2.45210728,
		2.20306513,
		50.13,
	],
	[
		"REFTBNMRE-PFR",
		16.638094,
		97.352501,
		"PLATTS - Refinery - Myanmar - Thanbayakan - Myanmar Petrochemical Enterpr. - {Mann}",
		43.05,
		46.72,
		5.6,
		2025.29,
		6.06,
		39.5,
		42.72,
		5.54,
		1950.66,
		5.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.3,
		null,
		0.87,
		318.05,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		6.3,
		null,
		0.87,
		318.05,
		null,
		null,
		null,
		null,
		null,
		null,
		"Myanmar Petrochemical Enterpr.",
		"100",
		null,
		"Active",
		null,
		1.87,
		1.4,
		2.6,
		0.8,
		0.11,
		0,
		26.71428571,
		20,
		37.14285714,
		11.42857143,
		1.57142857,
		0,
		6.79,
	],
	[
		"REFVAUPAM-PFR",
		10.3486,
		107.0765,
		"PLATTS - Refinery - Vietnam - Vung Tau - Petro-Vietnam",
		null,
		null,
		null,
		null,
		null,
		5,
		5.37,
		0.59,
		214.71,
		0.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		3.6,
		null,
		0.47,
		170.87,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		3.6,
		null,
		0.47,
		170.87,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro-Vietnam",
		"100",
		null,
		"Active",
		null,
		0.42,
		3,
		0.05,
		0.46,
		0.2,
		0,
		10.5,
		75,
		1.25,
		11.5,
		5,
		0,
		4.13,
	],
	[
		"REFWTGBBP-PFR",
		41.66972,
		-87.47836,
		"PLATTS - Refinery - United States - Whiting - BP",
		null,
		null,
		null,
		null,
		null,
		1843.28,
		1944.44,
		466.89,
		80825.15,
		493.11,
		257.44,
		null,
		38.25,
		13962.15,
		null,
		0,
		null,
		0,
		0,
		null,
		361.2,
		null,
		52.07,
		19006.59,
		null,
		null,
		null,
		null,
		null,
		null,
		13.53,
		null,
		1.81,
		660.27,
		null,
		55.88,
		null,
		7.27,
		2652.47,
		null,
		14.82,
		null,
		2.04,
		746.11,
		null,
		19.52,
		null,
		2.7,
		985.6,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP",
		"100",
		null,
		"Active",
		null,
		97.86,
		225.23,
		2.88,
		34.59,
		7.88,
		1.52,
		24.64739069,
		56.72728189,
		0.72536772,
		8.71196857,
		1.98468668,
		0.38283296,
		369.97,
	],
	[
		"REFUWNTOC-PFR",
		9.4818,
		99.981,
		"PLATTS - Refinery - Thailand - Unknown - Thai Oil Company Ltd.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		597.3,
		633.28,
		81.49,
		29634.7,
		86.36,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Thai Oil Company Ltd.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNKP2-PFR",
		29.3797,
		47.9736,
		"PLATTS - Refinery - Kuwait - Unknown - Kuwait Petroleum Corp.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		430,
		461.62,
		58.9,
		21500,
		63.24,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		300,
		322.06,
		41.1,
		15000,
		44.12,
		"Kuwait Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTBUCOL-PFR",
		8.637895,
		-72.739397,
		"PLATTS - Refinery - Colombia - Tibu - Colombian Petroleum Company",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENOC_Mobil",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWACVRO-PFR",
		33.778684,
		-118.235952,
		"PLATTS - Refinery - United States - Wilmington (CA) - Valero",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWTGPIR-PFR",
		41.66907,
		-87.47063,
		"PLATTS - Refinery - United States - Whiting - Praxair",
		null,
		null,
		null,
		null,
		null,
		220,
		232.75,
		220,
		220,
		232.75,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNUNT-PFR",
		0.4901,
		34.0476,
		"PLATTS - Refinery - Uganda - Unknown - Uganda Government",
		323.59,
		354.57,
		44.16,
		16048.23,
		48.4,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Uganda Government",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWADRAO-PFR",
		12.13466,
		-68.92869,
		"PLATTS - Refinery - Netherlands Antilles - Willemstad - Refineria Isla Curazao - {Curacao}",
		null,
		null,
		null,
		null,
		null,
		0,
		-0.04,
		0.01,
		-0.03,
		-0.03,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1171.71,
		1285.07,
		210.09,
		56699.03,
		229.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Curacao Government",
		"100",
		null,
		"Active",
		null,
		1.31,
		1.14,
		1.44,
		0.41,
		0.04,
		0.25,
		26.2,
		22.8,
		28.8,
		8.2,
		0.8,
		5,
		4.59,
	],
	[
		"REFVDDRVI-PFR",
		48.766288,
		11.596028,
		"PLATTS - Refinery - Germany - Vohburg An Der Donau - RVI",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		-0.01,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The British Petroleum Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNNI4-PFR",
		30.0666,
		79.5448,
		"PLATTS - Refinery - India - Unknown - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1329,
		1463.18,
		186.02,
		66433.58,
		204.58,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"National Iranian Oil Co._Unknown",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTDIUWN-PFR",
		4.8874,
		-1.7519,
		"PLATTS - Refinery - Ghana - Takoradi - Unknown",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		444.2,
		488.52,
		60.04,
		21845.14,
		66.02,
		"Ghanaian Govt._Unknown",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWERMGY-PFR",
		31.8865,
		-103.1001,
		"PLATTS - Refinery - United States - Winkler - Meridian Energy",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		60,
		62.57,
		8.22,
		3000,
		8.57,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Meridian Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFXAOLTS-PFR",
		22.8439,
		113.537,
		"PLATTS - Refinery - China - Xiaohudao - Luroda Lubricants",
		null,
		null,
		null,
		null,
		null,
		67.7,
		72,
		9.59,
		3500.24,
		10.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Luroda Lubricants",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFVENTLN-PFR",
		51.445223,
		3.728722,
		"PLATTS - Refinery - Netherlands - Vlissingen - Total Fina Raff. Nederl. - {Zeeland}",
		null,
		null,
		null,
		null,
		null,
		621.65,
		652.86,
		194.06,
		25195.74,
		204.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		103.55,
		null,
		14.03,
		5120.16,
		null,
		null,
		null,
		null,
		null,
		null,
		5,
		null,
		0.67,
		243.98,
		null,
		30,
		null,
		3.91,
		1423.93,
		null,
		60.55,
		null,
		8.35,
		3048.38,
		null,
		8,
		null,
		1.11,
		403.87,
		null,
		null,
		null,
		null,
		null,
		null,
		"Total_Lukoil",
		"55_45",
		null,
		"Active",
		null,
		60.86,
		36,
		29.51,
		22.67,
		6.4,
		7.31,
		41.12162162,
		24.32432432,
		19.93918919,
		15.31756757,
		4.32432432,
		4.93918919,
		162.74,
	],
	[
		"REFUWNNIA-PFR",
		6.4026,
		43.3984,
		"PLATTS - Refinery - Ethiopia - Unknown - National Oil Ethiopia",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		657.3,
		718.68,
		141.49,
		29694.7,
		152.09,
		"National Oil Ethiopia",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTDOPBF-PFR",
		41.66224,
		-83.50174,
		"PLATTS - Refinery - United States - Toledo - PBF Energy Company LLC",
		44,
		46.25,
		6.17,
		2253.22,
		6.49,
		500.55,
		527.07,
		113.06,
		22217.75,
		119.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		128,
		null,
		16.93,
		6179.31,
		null,
		null,
		null,
		null,
		null,
		null,
		0.29,
		null,
		0.04,
		14.06,
		null,
		93.36,
		null,
		12.14,
		4431.13,
		null,
		1.71,
		null,
		0.24,
		86.21,
		null,
		32.64,
		null,
		4.51,
		1647.91,
		null,
		null,
		null,
		null,
		null,
		null,
		"PBF Energy Company LLC",
		"100",
		null,
		"Active",
		null,
		34.78,
		87.35,
		1.52,
		12.91,
		6.07,
		3.01,
		23.78444916,
		59.73466457,
		1.03945839,
		8.82855775,
		4.15099501,
		2.05840115,
		145.64,
	],
	[
		"REFWKEATS-PFR",
		30.24158,
		-93.28369,
		"PLATTS - Refinery - United States - Westlake - Air Products",
		null,
		null,
		null,
		null,
		null,
		100,
		105.8,
		100,
		100,
		105.8,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYANBAO-PFR",
		38.17370072,
		106.59125246,
		"PLATTS - Refinery - China - Yinchuan - Baota Petrochemical Group",
		60,
		63.48,
		8.22,
		3000,
		8.7,
		235.15,
		251.67,
		54.23,
		10637.53,
		57.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Baota Petrochemical Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFVIAAPS-PFR",
		45.46149,
		12.2649,
		"PLATTS - Refinery - Italy - Venezia - Agip Petroli S.P.A.",
		133.05,
		139.47,
		66.5,
		4235.04,
		69.64,
		12.6,
		13.34,
		1.74,
		640.52,
		1.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTEEIND-PFR",
		8.5764,
		81.2345,
		"PLATTS - Refinery - Sri Lanka - Trincomalee - Indian Oil Corp.",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		334.25,
		367.9,
		47.26,
		16798.35,
		51.97,
		"Indian Oil Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWKEP66-PFR",
		30.241597,
		-93.275538,
		"PLATTS - Refinery - United States - Westlake - Phillips 66 Co. - {Lake Charles}",
		67.12,
		70.53,
		9.89,
		3566.3,
		10.39,
		1083.41,
		1136.63,
		439.64,
		37262.16,
		460.66,
		37.28,
		null,
		5.54,
		2021.78,
		null,
		0,
		null,
		0,
		0,
		null,
		190,
		null,
		25.99,
		9484.76,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		78.43,
		null,
		10.2,
		3722.5,
		null,
		73.23,
		null,
		10.1,
		3686.72,
		null,
		1.06,
		null,
		0.15,
		53.75,
		null,
		null,
		null,
		null,
		null,
		null,
		"Phillips 66 Co.",
		"100",
		null,
		"Active",
		null,
		78.71,
		82.32,
		17.61,
		28.03,
		15.51,
		0.4,
		31.82130584,
		33.28077623,
		7.11946634,
		11.33212048,
		6.27046695,
		0.16171417,
		222.59,
	],
	[
		"REFVLSBES-PFR",
		57.3904,
		21.5636,
		"PLATTS - Refinery - Latvia - Ventspils - Baltic New Technologies",
		40,
		42.94,
		5.48,
		2000,
		5.88,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Baltic New Technologies",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNPDV-PFR",
		6.3331,
		5.6221,
		"PLATTS - Refinery - Benin - Unknown - PDVSA",
		1400.5,
		1535.74,
		239.26,
		68942.62,
		260.06,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA_Benin Government",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTEHNIO-PFR",
		35.538869,
		51.427948,
		"PLATTS - Refinery - Iran - Tehran - National Iranian Oil Co.",
		null,
		null,
		null,
		null,
		null,
		843.96,
		923.21,
		208.61,
		37149.72,
		226.2,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		188,
		null,
		25.63,
		9356.52,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		37.6,
		null,
		4.89,
		1784.66,
		null,
		150.4,
		null,
		20.74,
		7571.86,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		75.55,
		40.43,
		24.27,
		12.5,
		7.09,
		4.05,
		38.74358974,
		20.73333333,
		12.44615385,
		6.41025641,
		3.63589744,
		2.07692308,
		163.89,
	],
	[
		"REFVROTSR-PFR",
		12.715,
		109.3943,
		"PLATTS - Refinery - Vietnam - Vung Ro - Technostar",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		649.54,
		710.04,
		200.58,
		26339.83,
		215.68,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Technostar",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNREP-PFR",
		10.6069,
		-61.1142,
		"PLATTS - Refinery - Trinidad and Tobago - Unknown - Reliance Petroleum",
		239,
		252.98,
		34.29,
		12517.57,
		36.37,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Reliance Petroleum",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWTACRM-PFR",
		37.725663,
		-97.320749,
		"PLATTS - Refinery - United States - Wichita - Coastal Refining and Marketing Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.02,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The Coastal Corporation",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTEHPAR-PFR",
		35.738025,
		51.10357,
		"PLATTS - Refinery - Iran - Tehran - Pars Oil",
		null,
		null,
		null,
		null,
		null,
		3.2,
		3.61,
		0.44,
		166.23,
		0.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC_Shell",
		"75_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYKULHC-PFR",
		40.6747,
		122.2358,
		"PLATTS - Refinery - China - Yingkou - Liaoning Huajin Chemical Industry",
		null,
		null,
		null,
		null,
		null,
		420.65,
		452.53,
		99.34,
		18549.53,
		106.12,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Norinco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNTNT-PFR",
		37.9518,
		58.3724,
		"PLATTS - Refinery - Turkmenistan - Unknown - Turkmenistan Government",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		454.25,
		498.73,
		62.51,
		22725.35,
		68.58,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Turkmenistan Government",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFTGZSKC-PFR",
		28.6582,
		121.4164,
		"PLATTS - Refinery - China - Taizhou (Zhejiang) - SK Corporation",
		20,
		21.16,
		2.74,
		1000,
		2.9,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SK Corporation_Taizhou Mun. Gov't",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFXNGCQC-PFR",
		34.361093,
		108.758727,
		"PLATTS - Refinery - China - Xianyang - Changqing Petrochemical Company",
		null,
		null,
		null,
		null,
		null,
		275.04,
		296.46,
		37.89,
		13814.27,
		40.85,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		83.44,
		null,
		11.54,
		4212.42,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		83.44,
		null,
		11.54,
		4212.42,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		23.07,
		21.65,
		9.31,
		5.2,
		8.88,
		8.81,
		30.07038582,
		28.21949948,
		12.1350365,
		6.77789364,
		11.57455683,
		11.48331595,
		76.93,
	],
	[
		"REFYKUYJP-PFR",
		40.63790147,
		122.17659303,
		"PLATTS - Refinery - China - Yingkou - Yingkou Jiafu Petrochemical",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yingkou Jiafu Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNYNT-PFR",
		15.888388,
		47.489887,
		"PLATTS - Refinery - Yemen - Unknown - Yemen Government",
		646.75,
		705.69,
		198.34,
		26252.38,
		214.42,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yemen Government",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTHETAH-PFR",
		43.870247,
		87.376633,
		"PLATTS - Refinery - China - Tahe - Tahe Petrochemical",
		null,
		null,
		null,
		null,
		null,
		364.8,
		393.32,
		59.66,
		18255.19,
		64.16,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		65.75,
		null,
		9.09,
		3319.19,
		null,
		409.28,
		440.55,
		65.78,
		19899.88,
		70.57,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		65.75,
		null,
		9.09,
		3319.19,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		21.38,
		18.3,
		8.43,
		6.44,
		3.42,
		1.16,
		29.08843537,
		24.89795918,
		11.46938776,
		8.76190476,
		4.65306122,
		1.57823129,
		59.13,
	],
	[
		"REFYBULEF-PFR",
		23.943586,
		38.31571,
		"PLATTS - Refinery - Saudi Arabia - Yanbu - LUBEREF - {Saudi Aramco Lubricating Oil Refining Company}",
		4.7,
		5.27,
		0.67,
		242.64,
		0.74,
		144.19,
		157.38,
		64.13,
		5173.67,
		69.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco_Jadwa Industrial Investment",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYNNYOR-PFR",
		35.65075,
		109.3608,
		"PLATTS - Refinery - China - Yanan - Yanlian Oil Refining Company",
		null,
		null,
		null,
		null,
		null,
		389.5,
		420.71,
		53.14,
		19393.1,
		57.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		90.53,
		null,
		12.52,
		4570.34,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		90.53,
		null,
		12.52,
		4570.34,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yanchang Petroleum Group",
		"100",
		0,
		"Active",
		null,
		28.54,
		31.13,
		5.93,
		7.04,
		17.23,
		14.32,
		27.00605602,
		29.45685087,
		5.61127933,
		6.66161998,
		16.30393641,
		13.55034065,
		104.19,
	],
	[
		"REFWEGUBK-PFR",
		50.84378,
		6.957178,
		"PLATTS - Refinery - Germany - Wesseling - Union Rheinische B.K.",
		353,
		368.13,
		353,
		353,
		368.13,
		-0.01,
		0.02,
		0,
		-0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFVAMAED-PFR",
		17.7231,
		83.3013,
		"PLATTS - Refinery - India - Visakhapatnam - Amerind Petroleum Private Limited",
		855.4,
		939.94,
		117.98,
		42911.96,
		129.6,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Amerind Petroleum Private Limited_American Industrial Corporation",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTIRMOE-PFR",
		39.82008,
		-75.40269,
		"PLATTS - Refinery - United States - Trainer - Monroe Energy",
		null,
		null,
		null,
		null,
		null,
		577.64,
		605.5,
		77.25,
		28069.94,
		80.97,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		127,
		null,
		16.57,
		6048.39,
		null,
		null,
		null,
		null,
		null,
		null,
		4,
		null,
		0.53,
		195.19,
		null,
		118,
		null,
		15.34,
		5600.78,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.69,
		252.42,
		null,
		null,
		null,
		null,
		null,
		null,
		"Delta Airlines",
		"100",
		null,
		"Active",
		null,
		50.74,
		83.37,
		9.88,
		28.33,
		0.84,
		0.05,
		28.71208692,
		47.17632413,
		5.59076505,
		16.03100951,
		0.4753282,
		0.02829335,
		173.2,
	],
	[
		"REFYOASCY-PFR",
		18.047046,
		-65.853522,
		"PLATTS - Refinery - Puerto Rico - Yabucoa - Shell Chemical Yabucoa Inc.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		-0.01,
		0,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTJNBAR-PFR",
		38.82590444,
		117.39235958,
		"PLATTS - Refinery - China - Tianjin - Blue Star",
		150.09,
		162.07,
		39.79,
		6480.01,
		42.55,
		65.4,
		70.07,
		8.51,
		3105.7,
		9.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ChemChina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYRGVRY-PFR",
		56.8391,
		60.6083,
		"PLATTS - Refinery - Russia - Yekaterinburg - Verkhotursky Oil Refinery",
		198.5,
		218.56,
		27.54,
		9873.02,
		30.3,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Verkhotursky Oil Refinery_TransCreditBank",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYTIPTC-PFR",
		37.4619,
		121.4425,
		"PLATTS - Refinery - China - Yantai - Yulong Petrochemical",
		null,
		null,
		null,
		null,
		null,
		1769.6,
		1907.36,
		478.84,
		76855.15,
		511.62,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._PDVSA",
		"70_30",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTJNENY-PFR",
		39.3033,
		117.4164,
		"PLATTS - Refinery - China - Tianjin - Eastern Petrochemical Company",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		1015.09,
		1095.49,
		141.49,
		50882.29,
		152.67,
		"China National Petroleum Corp._Rosneft",
		"51_49",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFYTSPGY-PFR",
		67.1472,
		74.3415,
		"PLATTS - Refinery - Russia - Yamalo-Nenets - Petroleum Energy",
		20,
		21.47,
		2.74,
		1000,
		2.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroleum Energy",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFPSACHN-PFR",
		29.72428,
		-95.20617,
		"PLATTS - Refinery - United States - Pasadena - Chevron",
		306.17,
		321.52,
		60.72,
		14819.65,
		63.91,
		364.96,
		383.14,
		48.42,
		17486.69,
		50.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		79.3,
		null,
		10.31,
		3763.95,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		79.3,
		null,
		10.31,
		3763.95,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron",
		"100",
		null,
		"Active",
		null,
		22.73,
		45.18,
		1.52,
		7.8,
		-1.04,
		1.35,
		26.90259202,
		53.47378388,
		1.79902947,
		9.23186176,
		-1.2309149,
		1.59782223,
		77.53,
	],
	[
		"REFYUGCHC-PFR",
		29.372625,
		113.162943,
		"PLATTS - Refinery - China - Yueyang - Changling Petrochemical",
		-70,
		-74.06,
		-9.59,
		-3500,
		-10.14,
		871.28,
		942.23,
		126.11,
		43839.91,
		136.29,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		131.84,
		null,
		17.8,
		6496.47,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		52.74,
		null,
		6.86,
		2503.04,
		null,
		0,
		null,
		0,
		0,
		null,
		79.1,
		null,
		10.94,
		3993.44,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		40.75,
		41.21,
		1.82,
		8.38,
		13.58,
		15.27,
		33.06556313,
		33.43881857,
		1.47679325,
		6.79974034,
		11.01914963,
		12.39045764,
		121.01,
	],
	[
		"REFPSNPSR-PFR",
		19.5563,
		37.2343,
		"PLATTS - Refinery - North Sudan - Port Sudan - Port Sudan Refinery Ltd.",
		25,
		27.24,
		3.42,
		1250,
		3.73,
		-0.03,
		0.01,
		-0.01,
		-0.01,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sudanese Government",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYVLCRK-PFR",
		57.6264,
		39.8934,
		"PLATTS - Refinery - Russia - Yaroslavl - CJSC Industrial Technology Park",
		53.3,
		58.4,
		7.48,
		2622.93,
		8.17,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CJSC Industrial Technology Park",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPTIVGA-PFR",
		44.96014,
		26.0244,
		"PLATTS - Refinery - Romania - Ploiesti - Vega",
		null,
		null,
		null,
		null,
		null,
		13.84,
		14.49,
		1.97,
		721.96,
		2.09,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.28,
		null,
		1,
		366.37,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.28,
		null,
		1,
		366.37,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rompetrol Group_OMV",
		"75_25",
		null,
		"Active",
		null,
		1.83,
		0.12,
		2.07,
		0.35,
		0.23,
		1.42,
		22.875,
		1.5,
		25.875,
		4.375,
		2.875,
		17.75,
		6.02,
	],
	[
		"REFYVLYRV-PFR",
		57.6264,
		39.8934,
		"PLATTS - Refinery - Russia - Yaroslavl - Yaroslavl Refinery - {Mendeleev Refinery - Rusoil}",
		222.51,
		243.25,
		73.09,
		8424.32,
		78.99,
		0.02,
		-0.01,
		-0.02,
		-0.38,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mendeleev Group_Gazprom_Rosneft_Tyumen Oil_Other Investors",
		"51_23.8_12.5_12.5_0.25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPUAHOR-PFR",
		35.18,
		129.0752,
		"PLATTS - Refinery - South Korea - Pusan - Hyundai Oil Refinery Co., Ltd. - {Busan}",
		null,
		null,
		null,
		null,
		null,
		24.36,
		25.58,
		3.56,
		1291.57,
		3.73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hyundai Business Group_Han Jin Group",
		"85.9_14.1",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYWNWER-PFR",
		37.211909,
		-76.452203,
		"PLATTS - Refinery - United States - Yorktown - Western Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0.02,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Western Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPUDDEO-PFR",
		-34.6522,
		-58.3471,
		"PLATTS - Refinery - Argentina - Puerto Dock Sud - Destilera Argentina De Petroleo",
		null,
		null,
		null,
		null,
		null,
		7.95,
		8.59,
		1.16,
		425.16,
		1.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"DAPSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYNNYPR-PFR",
		37.00279838,
		109.85058713,
		"PLATTS - Refinery - China - Yanan - Yonping Refinery Company",
		6,
		6.35,
		0.82,
		300,
		0.87,
		249.88,
		268.83,
		33.49,
		12196.64,
		35.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60.35,
		null,
		8.35,
		3046.89,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60.35,
		null,
		8.35,
		3046.89,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yanchang Petroleum Group",
		"100",
		null,
		"Active",
		null,
		19.03,
		20.68,
		2.05,
		4.71,
		11.79,
		10.29,
		27.01206529,
		29.35415188,
		2.90986515,
		6.68559262,
		16.73527324,
		14.60610362,
		68.55,
	],
	[
		"REFYZIYZC-PFR",
		32.244419,
		118.802374,
		"PLATTS - Refinery - China - Yangzi - Yangzi Petrochem. Corp.",
		null,
		null,
		null,
		null,
		null,
		927.22,
		1002.43,
		129.33,
		46485.93,
		139.78,
		43.46,
		null,
		6.46,
		2356.81,
		null,
		43.46,
		null,
		6.45,
		2353.31,
		null,
		217.28,
		null,
		30.89,
		11273.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		130.37,
		null,
		17.98,
		6563.3,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		91.02,
		51.46,
		9.54,
		20.59,
		24.19,
		26.97,
		40.24940302,
		22.75581498,
		4.21862563,
		9.10497922,
		10.69691342,
		11.92624038,
		223.78,
	],
	[
		"REFWEITOR-PFR",
		-35.843598,
		174.493552,
		"PLATTS - Refinery - New Zealand - Whangarei - The New Zealand Refining Co.",
		null,
		null,
		null,
		null,
		null,
		-0.1,
		-0.07,
		0.04,
		0.01,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		81.99,
		null,
		10.89,
		3976.2,
		null,
		null,
		null,
		null,
		null,
		null,
		48.02,
		null,
		6.41,
		2342.25,
		null,
		27,
		null,
		3.51,
		1281.52,
		null,
		7,
		null,
		0.98,
		352.41,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"BP_ExxonMobil_Other Investors_Greenstone Energy Holdings_Chevron",
		"23.66_19.2_19.18_17.14_12.7",
		null,
		"Active",
		null,
		41.87,
		35.71,
		9.85,
		29.28,
		2.19,
		0.09,
		35.74355472,
		30.48488988,
		8.40874168,
		24.9957316,
		1.86955779,
		0.07683114,
		118.95,
	],
	[
		"REFVAMHND-PFR",
		17.704802,
		83.244653,
		"PLATTS - Refinery - India - Visakhapatnam - Hindustan Petroleum",
		null,
		null,
		null,
		null,
		null,
		1207.75,
		1318.74,
		411.15,
		47573.1,
		444.17,
		0,
		null,
		0,
		0,
		null,
		3.72,
		null,
		0.55,
		201.27,
		null,
		184.9,
		null,
		24.45,
		8927.41,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		137.51,
		null,
		17.88,
		6527.06,
		null,
		39.96,
		null,
		5.51,
		2011.47,
		null,
		3.72,
		null,
		0.51,
		187.63,
		null,
		null,
		null,
		null,
		null,
		null,
		"Indian Government_Other Investors",
		"51_49",
		null,
		"Active",
		null,
		66.92,
		42.41,
		9.8,
		18.41,
		18.26,
		10.73,
		36.56430991,
		23.17233089,
		5.35460605,
		10.05900994,
		9.97705169,
		5.86274724,
		166.55,
	],
	[
		"REFPURATS-PFR",
		29.86679,
		-93.96546,
		"PLATTS - Refinery - United States - Port Arthur - Air Products",
		null,
		null,
		null,
		null,
		null,
		315,
		331.76,
		315,
		315,
		331.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWENUNG-PFR",
		41.827334,
		-79.122873,
		"PLATTS - Refinery - United States - Warren - United Refining",
		39.6,
		41.89,
		6.27,
		2071.72,
		6.63,
		228.3,
		241.04,
		48.37,
		10346.77,
		51.13,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		59.62,
		null,
		8.22,
		3001.8,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		59.62,
		null,
		8.22,
		3001.8,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"United Refining",
		"100",
		null,
		"Active",
		null,
		14.07,
		25.95,
		0.89,
		0,
		0.14,
		0.02,
		22.85946385,
		42.16084484,
		1.44597888,
		0,
		0.22745735,
		0.03249391,
		41.08,
	],
	[
		"REFYOUYAL-PFR",
		32.397,
		119.4077,
		"PLATTS - Refinery - China - Yangzhou - Yangzhou Shi You Chemical",
		null,
		null,
		null,
		null,
		null,
		50.02,
		54.36,
		24.5,
		1658.06,
		26.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yangzhou Shi You Chemical_Kingboard Chemical Holdings",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZ22QPC-PFR",
		36.8048,
		118.0444,
		"PLATTS - Refinery - China - Zibo (2) - Qilu Petrochemical Co.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYUGYEM-PFR",
		29.3595,
		113.1229,
		"PLATTS - Refinery - China - Yueyang - Yueyang Xingchang Petrochem",
		null,
		null,
		null,
		null,
		null,
		3.5,
		3.7,
		0.42,
		151,
		0.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yueyang Xingchang Petrochem",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPURPIR-PFR",
		29.9702,
		-93.94129,
		"PLATTS - Refinery - United States - Port Arthur - Praxair",
		null,
		null,
		null,
		null,
		null,
		235,
		248.63,
		235,
		235,
		248.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWNCCGA-PFR",
		34.22497,
		-77.948995,
		"PLATTS - Refinery - United States - Wilmington (NC) - City Gas and Transmission Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"City Gas and Transmission Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZAIBAO-PFR",
		22.27071,
		113.57673,
		"PLATTS - Refinery - China - Zhuhai - Baota Petrochemical Group",
		321.19,
		347.06,
		47.56,
		16192.48,
		51.32,
		58.3,
		62.89,
		10.76,
		2833.9,
		11.56,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10,
		10.58,
		1.37,
		500,
		1.45,
		"Zhonggu Qilong",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFPURVRO-PFR",
		29.86441,
		-93.96759,
		"PLATTS - Refinery - United States - Port Arthur - Valero",
		null,
		null,
		null,
		null,
		null,
		1825.8,
		1926.73,
		648.33,
		69281.27,
		685.25,
		120.76,
		null,
		17.94,
		6549.3,
		null,
		0,
		null,
		0,
		0,
		null,
		290.48,
		null,
		40.37,
		14734.08,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		124.95,
		null,
		16.25,
		5930.55,
		null,
		44.78,
		null,
		6.18,
		2254.22,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		110.87,
		117.54,
		6.07,
		28.91,
		18.28,
		5.97,
		37.10012047,
		39.33208406,
		2.03118726,
		9.67407308,
		6.11698568,
		1.99772453,
		287.64,
	],
	[
		"REFZBOQPC-PFR",
		36.78258823,
		118.25785158,
		"PLATTS - Refinery - China - Zibo - Qilu Petrochemical Co.",
		null,
		null,
		null,
		null,
		null,
		1050.46,
		1133.96,
		296.36,
		45147.2,
		316.79,
		68.97,
		null,
		10.25,
		3740.57,
		null,
		68.97,
		null,
		10.23,
		3735.02,
		null,
		209,
		null,
		30.28,
		11053.1,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		71.06,
		null,
		9.8,
		3577.5,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		95.12,
		54.59,
		1.72,
		23.68,
		25.39,
		31.29,
		39.76089955,
		22.81904443,
		0.71897337,
		9.89842411,
		10.61321741,
		13.07946328,
		231.8,
	],
	[
		"REFWNGCGL-PFR",
		36.64421835,
		119.24766846,
		"PLATTS - Refinery - China - Weifang - Changyi Petrochemical",
		null,
		null,
		null,
		null,
		null,
		424.5,
		459.96,
		60.73,
		21617.46,
		65.82,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ChemChina",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZANMUY-PFR",
		44.4896,
		110.0462,
		"PLATTS - Refinery - Mongolia - Zuunbayan - Mongolsekiuy",
		6,
		6.44,
		0.82,
		300,
		0.88,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mongolsekiuy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFQAOQGC-PFR",
		39.9396,
		119.5894,
		"PLATTS - Refinery - China - Qinhuangdao - Qinhuangdao Guanga Chemical",
		null,
		null,
		null,
		null,
		null,
		17,
		17.99,
		2.33,
		850,
		2.46,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qinhuangdao Guanga Chemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZBOQPL-PFR",
		36.77996726,
		118.16535468,
		"PLATTS - Refinery - China - Zibo - Qingyuan Petrochemical - {Qingyishan}",
		-36,
		-38.09,
		-4.93,
		-1800,
		-5.22,
		238.92,
		254.56,
		34.48,
		12286.48,
		36.75,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qingyuan Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWNGWEI-PFR",
		36.80955796,
		118.53820397,
		"PLATTS - Refinery - China - Weifang - Weifang Hongrun Petrochemical",
		null,
		null,
		null,
		null,
		null,
		582.88,
		627.91,
		89.72,
		28692.69,
		96.44,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		452.7,
		483.51,
		68.33,
		23961.98,
		73,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinochem_Weifang Hongrun Petrochemical",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZBOZXP-PFR",
		36.92656755,
		118.31076379,
		"PLATTS - Refinery - China - Zibo - Zibo Xintai Petrochemical",
		null,
		null,
		null,
		null,
		null,
		115.06,
		124.42,
		18.08,
		5483.29,
		19.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zibo Xintai Petrochemical",
		"100",
		0,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZBOSDE-PFR",
		36.8048,
		118.0444,
		"PLATTS - Refinery - China - Zibo - Shandong Qisheng Industry and Trade",
		null,
		null,
		null,
		null,
		null,
		5,
		5.53,
		0.71,
		258.14,
		0.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shandong Qisheng Industry and Trade",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWONFLJ-PFR",
		48.132221,
		-103.56104,
		"PLATTS - Refinery - United States - Williston - Flying J",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Flying J",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZHIZDC-PFR",
		29.98442,
		121.68038,
		"PLATTS - Refinery - China - Zhenhai - Zhenhai Refining and Chemical Co.Ltd.",
		null,
		null,
		null,
		null,
		null,
		2304.5,
		2483.98,
		373,
		112713.33,
		400.9,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		394.28,
		null,
		54.38,
		19850.07,
		null,
		213,
		225.35,
		30.21,
		11024.92,
		31.96,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		394.28,
		null,
		54.38,
		19850.07,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		113.42,
		109.47,
		11.24,
		55.53,
		44.95,
		62.36,
		25.78958139,
		24.89142545,
		2.55576525,
		12.62648082,
		10.22078719,
		14.17949476,
		396.98,
	],
	[
		"REFQGGSEC-PFR",
		33.57922386,
		118.97947892,
		"PLATTS - Refinery - China - Qingjiang - Sinopec",
		null,
		null,
		null,
		null,
		null,
		31.52,
		33.81,
		4.31,
		1568.51,
		4.63,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZBOZIB-PFR",
		37.04588707,
		117.87911907,
		"PLATTS - Refinery - China - Zibo - Zibo Jincheng Petrochemical",
		null,
		null,
		null,
		null,
		null,
		299.99,
		323.1,
		46.58,
		15147.31,
		50.07,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zibo Jincheng Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWRINNP-PFR",
		5.567897,
		5.716853,
		"PLATTS - Refinery - Nigeria - Warri - NNPC - {WRPC}",
		null,
		null,
		null,
		null,
		null,
		230.89,
		253.59,
		31.48,
		11493.04,
		34.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NNPC",
		"100",
		null,
		"Active",
		null,
		2.79,
		2.96,
		1.55,
		0.94,
		0.49,
		0,
		31,
		32.88888889,
		17.22222222,
		10.44444444,
		5.44444444,
		0,
		8.72,
	],
	[
		"REFQNGJEM-PFR",
		29.4363,
		108.7027,
		"PLATTS - Refinery - China - Qianjiang - Jin'ao Science and Technology Chem",
		null,
		null,
		null,
		null,
		null,
		204.9,
		220.14,
		58.79,
		8752.23,
		62.68,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jin'ao Science and Technology Chem",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZQAJOC-PFR",
		32.122952,
		36.111627,
		"PLATTS - Refinery - Jordan - Zarqa - Jordan Petroleum Refinery Co.",
		null,
		null,
		null,
		null,
		null,
		273.56,
		298.48,
		51.64,
		12831.42,
		56.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		8.28,
		3020.68,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		60,
		null,
		8.28,
		3020.68,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jordanian Govt._Other Investors",
		"50_50",
		null,
		"Active",
		null,
		19.74,
		15.3,
		13.22,
		7.62,
		1.64,
		0,
		32.9,
		25.5,
		22.03333333,
		12.7,
		2.73333333,
		0,
		57.52,
	],
	[
		"REFWRTBPP-PFR",
		-38.349978,
		145.212099,
		"PLATTS - Refinery - Australia - Westernport - The British Petroleum Co",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"The British Petroleum Co",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZBOZIQ-PFR",
		36.8048,
		118.0444,
		"PLATTS - Refinery - China - Zibo - Zibo Qixiang Petrochemical",
		null,
		null,
		null,
		null,
		null,
		0.69,
		0.73,
		0.08,
		29.77,
		0.09,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zibo Qixiang Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZRKHUP-PFR",
		35.0888,
		113.6537,
		"PLATTS - Refinery - China - Zhongie Industrial Park - Hebei Zhongjie Petrochemical Group",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		80.54,
		86.21,
		41.26,
		2310.4,
		43.81,
		"Hebei Zhongjie Petrochemical Group",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRDHRIY-PFR",
		24.518523,
		46.86798,
		"PLATTS - Refinery - Saudi Arabia - Riyadh - Riyadh Oil Refining Company",
		null,
		null,
		null,
		null,
		null,
		563.9,
		618.4,
		164.72,
		23448.19,
		178.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		104.24,
		null,
		14.38,
		5247.78,
		null,
		3.01,
		3.38,
		0.31,
		111.48,
		0.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		104.24,
		null,
		14.38,
		5247.78,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		46.1,
		30.65,
		18.76,
		6.45,
		5.12,
		0.25,
		39.0876717,
		25.9877904,
		15.90639308,
		5.46888248,
		4.34119044,
		0.21197219,
		107.34,
	],
	[
		"REFWXISTL-PFR",
		31.4933,
		120.3074,
		"PLATTS - Refinery - China - Wuxi - Shell Tongyi Petrochemical",
		null,
		null,
		null,
		null,
		null,
		28,
		29.8,
		3.84,
		1406.5,
		4.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_Wuxi Oil Refinery/Quaker Products",
		"75_25",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZUBINO-PFR",
		30.3918,
		47.7027,
		"PLATTS - Refinery - Iraq - Zubair - Iraq National Oil Co",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		300,
		322.06,
		41.1,
		15000,
		44.12,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Iraq National Oil Co",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFZEBINA-PFR",
		45.798212,
		16.070231,
		"PLATTS - Refinery - Croatia - Zagreb - INA",
		null,
		null,
		null,
		null,
		null,
		0.02,
		-0.01,
		0,
		0.7,
		0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"MOL_Croatia State Co._Other Investors",
		"47.15_44.84_8.01",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRHOAPS-PFR",
		45.519313,
		9.016374,
		"PLATTS - Refinery - Italy - Rho - Agip Petroli S.P.A.",
		null,
		null,
		null,
		null,
		null,
		0,
		0.01,
		0.01,
		0,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENI",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYBUAR2-PFR",
		24.0889,
		38.0667,
		"PLATTS - Refinery - Saudi Arabia - Yanbu - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		760,
		824.82,
		107.76,
		39323.62,
		116.92,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"SABIC_Saudi Aramco",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFZYLKAM-PFR",
		40.8574,
		68.5418,
		"PLATTS - Refinery - Kazakhstan - Zhambyl - KazMunayGaz",
		null,
		null,
		null,
		null,
		null,
		6.96,
		7.6,
		0.85,
		305.53,
		0.93,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		2.48,
		null,
		0.32,
		117.59,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		2.48,
		null,
		0.32,
		117.59,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"KazMunayGaz",
		"100",
		null,
		"Active",
		null,
		0.29,
		0.64,
		0.09,
		0.38,
		0,
		1.42,
		10.28368794,
		22.69503546,
		3.19148936,
		13.4751773,
		0,
		50.35460993,
		2.82,
	],
	[
		"REFZJGCOC-PFR",
		21.2745,
		110.3541,
		"PLATTS - Refinery - China - Zhanjiang - CNOOC",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		116.6,
		123.92,
		16.79,
		6128.95,
		17.84,
		"CNOOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFRLNQUM-PFR",
		25.8977,
		51.5332,
		"PLATTS - Refinery - Qatar - Ras Laffan - Qatar Petroleum",
		681,
		744.44,
		140.74,
		30984.4,
		152.8,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qatar Petroleum",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFYBUARM-PFR",
		23.958778,
		38.293613,
		"PLATTS - Refinery - Saudi Arabia - Yanbu - Saudi Aramco",
		null,
		null,
		null,
		null,
		null,
		414,
		453.06,
		54.48,
		19887.24,
		59.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		226.31,
		null,
		31.22,
		11393.51,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		226.31,
		null,
		31.22,
		11393.51,
		null,
		0,
		null,
		0,
		0,
		null,
		490.25,
		537.04,
		66.89,
		24325.17,
		73.24,
		"Saudi Aramco",
		"100",
		null,
		"Active",
		null,
		69.05,
		35.86,
		104.72,
		24.79,
		8.11,
		10.33,
		26.96633601,
		14.00453019,
		40.89666484,
		9.68132469,
		3.16722643,
		4.03421073,
		252.86,
	],
	[
		"REFRMETRG-PFR",
		41.856217,
		12.32407,
		"PLATTS - Refinery - Italy - Rome - TotalErg",
		null,
		null,
		null,
		null,
		null,
		-0.05,
		0.01,
		0.02,
		0.02,
		0.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"TotalErg",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZJGSEC-PFR",
		21.1583,
		110.37803,
		"PLATTS - Refinery - China - Zhanjiang - Sinopec",
		null,
		null,
		null,
		null,
		null,
		783.4,
		846.2,
		178.48,
		35879.28,
		191.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1111.6,
		1198.3,
		258.5,
		50461.1,
		276.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kuwait National Petroleum Corp._Sinopec",
		"50_50",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFZJGZZP-PFR",
		21.2745,
		110.3541,
		"PLATTS - Refinery - China - Zhanjiang - Zhanjiang Zhongxing Petrochemical",
		null,
		null,
		null,
		null,
		null,
		26.5,
		29.22,
		5.43,
		1252.31,
		5.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Zhanjiang Zhongxing Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRNDPIR-PFR",
		37.939814,
		-122.389547,
		"PLATTS - Refinery - United States - Richmond - Praxair",
		260,
		275.07,
		260,
		260,
		275.07,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Praxair",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYKANON-PFR",
		35.487316,
		139.662488,
		"PLATTS - Refinery - Japan - Yokohama - Nippon",
		null,
		null,
		null,
		null,
		null,
		10.96,
		11.69,
		1.51,
		551.94,
		1.61,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Nippon",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZNGJYE-PFR",
		32.1901,
		119.4201,
		"PLATTS - Refinery - China - Zhenjiang - Jinhai Hongye",
		null,
		null,
		null,
		null,
		null,
		73.7,
		79.17,
		11.39,
		3901.59,
		12.23,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jinhai Hongye",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYKHGFT-PFR",
		39.7398,
		44.8282,
		"PLATTS - Refinery - Armenia - Yeraskh - Gazpromneft",
		263.15,
		288.1,
		34.74,
		12625.4,
		37.99,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazpromneft",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZQ2JOC-PFR",
		32.122687,
		36.111811,
		"PLATTS - Refinery - Jordan - Zarqa (2) - Jordan Petroleum Refinery Co.",
		null,
		null,
		null,
		null,
		null,
		0.5,
		0.56,
		0.07,
		25.81,
		0.08,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Jordan Petroleum Refinery Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFRNGSTP-PFR",
		12.696951,
		101.148067,
		"PLATTS - Refinery - Thailand - Rayong - Star Petroleum - {Map Ta Phut}",
		null,
		null,
		null,
		null,
		null,
		405.3,
		428.72,
		56.43,
		20497.48,
		59.64,
		0,
		null,
		0,
		0,
		null,
		6.14,
		null,
		0.91,
		332.3,
		null,
		132.13,
		null,
		17.87,
		6523.23,
		null,
		null,
		null,
		null,
		null,
		null,
		30.69,
		null,
		4.11,
		1497.25,
		null,
		36.47,
		null,
		4.74,
		1730.86,
		null,
		55.08,
		null,
		7.6,
		2773.28,
		null,
		3.75,
		null,
		0.52,
		189.55,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron_PTT",
		"64_36",
		null,
		"Active",
		null,
		56.55,
		25.81,
		15.33,
		12.41,
		13.27,
		20.64,
		39,
		17.8,
		10.57241379,
		8.55862069,
		9.15172414,
		14.23448276,
		144.02,
	],
	[
		"REFRONMUM-PFR",
		39.00128,
		-87.72461,
		"PLATTS - Refinery - United States - Robinson - Marathon Petroleum",
		511.83,
		537.94,
		103.8,
		24119.9,
		109.34,
		698.32,
		733.53,
		94.9,
		33940.52,
		99.66,
		162.65,
		null,
		24.17,
		8821.21,
		null,
		0,
		null,
		0,
		0,
		null,
		224.09,
		null,
		32.43,
		11836.93,
		null,
		null,
		null,
		null,
		null,
		null,
		3.7,
		null,
		0.49,
		180.51,
		null,
		26.36,
		null,
		3.43,
		1251.12,
		null,
		2.98,
		null,
		0.41,
		149.97,
		null,
		28.41,
		null,
		3.93,
		1434.13,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		57.26,
		144.17,
		4.5,
		19.91,
		7.01,
		1.46,
		23.24524013,
		58.52717899,
		1.82681768,
		8.08265335,
		2.84577599,
		0.59270085,
		234.31,
	],
	[
		"REFRRIHND-PFR",
		17.2826,
		73.457,
		"PLATTS - Refinery - India - Ratnagiri - Hindustan Petroleum",
		1207.4,
		1329.04,
		168.52,
		60270.66,
		185.28,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hindustan Petroleum",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTLAPMX-PFR",
		20.049014,
		-99.28016,
		"PLATTS - Refinery - Mexico - Tula - PEMEX - {Refineria Miguel Hidalgo}",
		-49.99,
		-57.13,
		-6.6,
		-2410.73,
		-7.55,
		1815.49,
		1965.87,
		869.27,
		56213.32,
		926.92,
		21.47,
		null,
		3.19,
		1164.46,
		null,
		0,
		null,
		0,
		0,
		null,
		97.68,
		null,
		13.59,
		4961.27,
		null,
		230,
		258.3,
		29.34,
		10710.08,
		32.96,
		25.84,
		null,
		3.45,
		1260.93,
		null,
		0,
		null,
		0,
		0,
		null,
		50.37,
		null,
		6.95,
		2535.88,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PEMEX",
		"100",
		null,
		"Active",
		null,
		33.89,
		34.45,
		28.03,
		5.58,
		2.76,
		9.89,
		27.97358646,
		28.43582336,
		23.13660751,
		4.6058605,
		2.27816756,
		8.16343376,
		114.6,
	],
	[
		"REFTLILIB-PFR",
		32.8967,
		13.1778,
		"PLATTS - Refinery - Libya - Tripoli - Libyan National Oil Company",
		635.4,
		696.41,
		199.6,
		25020.82,
		218.04,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"JX Nippon Oil and Energy",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTLNCPC-PFR",
		22.532916,
		120.344668,
		"PLATTS - Refinery - Taiwan - Ta-Lin - CPC Corporation",
		null,
		null,
		null,
		null,
		null,
		1183.3,
		1256.97,
		264.77,
		52983.86,
		280.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		181.31,
		null,
		24.35,
		8889.19,
		null,
		null,
		null,
		null,
		null,
		null,
		22.77,
		null,
		3.04,
		1111.31,
		null,
		70.59,
		null,
		9.18,
		3350.63,
		null,
		87.94,
		null,
		12.13,
		4427.25,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CPC Corporation",
		"100",
		0,
		"Active",
		null,
		66.59,
		77.1,
		23.46,
		19.93,
		4.48,
		23.84,
		29.95232098,
		34.67974091,
		10.55235696,
		8.9645556,
		2.01511335,
		10.72328176,
		215.4,
	],
	[
		"REFTSKTIM-PFR",
		58.1998,
		68.2513,
		"PLATTS - Refinery - Russia - Tobolsk - Tobolsk Neftekhim",
		null,
		null,
		null,
		null,
		null,
		2.5,
		2.68,
		0.3,
		107.86,
		0.32,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tobolsk Neftekhim",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTALIN-PFR",
		23.7004,
		120.1945,
		"PLATTS - Refinery - Taiwan - Ta-Lin - CPC-Shell Lubricant Co.",
		null,
		null,
		null,
		null,
		null,
		4,
		4.29,
		0.57,
		206.51,
		0.61,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Shell_CPC Corporation",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFTTYVRO-PFR",
		29.368546,
		-94.908562,
		"PLATTS - Refinery - United States - Texas City - Valero",
		null,
		null,
		null,
		null,
		null,
		936.12,
		984.83,
		222.2,
		42221.25,
		233.99,
		15.65,
		null,
		2.33,
		848.66,
		null,
		0,
		null,
		0,
		0,
		null,
		212.34,
		null,
		27.96,
		10204.07,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		190.2,
		null,
		24.73,
		9027.91,
		null,
		0,
		null,
		0,
		0,
		null,
		6.49,
		null,
		0.9,
		327.5,
		null,
		null,
		null,
		null,
		null,
		null,
		"Valero",
		"100",
		null,
		"Active",
		null,
		55.36,
		98.2,
		4.74,
		19.56,
		5.95,
		10.43,
		27.01410238,
		47.91880154,
		2.31298492,
		9.54472259,
		2.90343044,
		5.08954277,
		194.23,
	],
	[
		"REFTUKLIB-PFR",
		32.044897,
		23.975664,
		"PLATTS - Refinery - Libya - Tobruk - Libyan National Oil Company",
		null,
		null,
		null,
		null,
		null,
		31,
		34.08,
		4,
		1460.05,
		4.4,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		-31,
		-34.08,
		-4,
		-1460.05,
		-4.4,
		0,
		null,
		0,
		0,
		null,
		5,
		null,
		0.65,
		237.32,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		5.3,
		2.48,
		5.14,
		0.5,
		0.31,
		0,
		35.33333333,
		16.53333333,
		34.26666667,
		3.33333333,
		2.06666667,
		0,
		13.73,
	],
	[
		"REFTUNANG-PFR",
		57.16667,
		65.5,
		"PLATTS - Refinery - Russia - Tyumen - Antipinsky Refining",
		null,
		null,
		null,
		null,
		null,
		572.57,
		627.32,
		126.88,
		25713.52,
		137.91,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		128,
		null,
		17.65,
		6444.14,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		128,
		null,
		17.65,
		6444.14,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SOCAR Energoresurs_Other Investors_SOCAR",
		"70.4_20_9.6",
		null,
		"Active",
		null,
		41.99,
		17.2,
		31.5,
		8.45,
		3.99,
		19.56,
		31.64041896,
		12.96059076,
		23.73596564,
		6.36726697,
		3.00655565,
		14.73890438,
		122.69,
	],
	[
		"REFUADNOD-PFR",
		24.9656,
		51.544722,
		"PLATTS - Refinery - Qatar - Umm Saead - National Oil Distrib. Co.",
		null,
		null,
		null,
		null,
		null,
		313.84,
		345.68,
		40.9,
		14925.67,
		45.05,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		100,
		null,
		13.19,
		4813.05,
		null,
		null,
		null,
		null,
		null,
		null,
		50,
		null,
		6.68,
		2439.84,
		null,
		50,
		null,
		6.5,
		2373.21,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Qatar Petroleum",
		"100",
		null,
		"Active",
		null,
		27.64,
		36.62,
		5.72,
		15.98,
		7.53,
		5.84,
		27.64,
		36.62,
		5.72,
		15.98,
		7.53,
		5.84,
		99.32,
	],
	[
		"REFUANSKG-PFR",
		35.501923,
		129.354543,
		"PLATTS - Refinery - South Korea - Ulsan - SK Energy - {Onsan}",
		null,
		null,
		null,
		null,
		null,
		2862.17,
		3033.84,
		1028.28,
		107478.45,
		1088.74,
		96.03,
		null,
		14.27,
		5208.08,
		null,
		11.69,
		null,
		1.73,
		633.09,
		null,
		705.6,
		null,
		96.99,
		35400.6,
		null,
		null,
		null,
		null,
		null,
		null,
		319.82,
		null,
		42.76,
		15606.01,
		null,
		15.87,
		null,
		2.06,
		753.05,
		null,
		262.2,
		null,
		36.17,
		13200.38,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"SK Holdings",
		"100",
		0,
		"Active",
		null,
		250.39,
		120.05,
		38.29,
		131.54,
		17.19,
		174.96,
		32.40036232,
		15.53442029,
		4.95471014,
		17.02122153,
		2.22437888,
		22.63975155,
		732.43,
	],
	[
		"REFUARUWN-PFR",
		55.81,
		94.3278,
		"PLATTS - Refinery - Russia - Uyar - Unknown",
		776.28,
		845.62,
		262.29,
		29818.42,
		283.15,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUFAUKY-PFR",
		54.85132,
		56.106495,
		"PLATTS - Refinery - Russia - Ufa - Ufimsky - {UNPZ}",
		null,
		null,
		null,
		null,
		null,
		537.58,
		588.78,
		119.17,
		24725.15,
		129.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		97,
		null,
		13.11,
		4785.5,
		null,
		20.9,
		23.43,
		4.1,
		1168.9,
		4.55,
		0,
		null,
		0,
		0,
		null,
		34,
		null,
		4.42,
		1613.79,
		null,
		62.99,
		null,
		8.7,
		3171.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rosneft_Other Investors_Sistema_Bashkir Capital",
		"38.5_23.5_20.9_17.1",
		null,
		"Active",
		null,
		42.97,
		31.05,
		6.38,
		3.4,
		11.43,
		6.57,
		42.67977751,
		30.84028605,
		6.33690902,
		3.37703615,
		11.35280095,
		6.52562574,
		101.82,
	],
	[
		"REFVAMVKR-PFR",
		17.7231,
		83.3013,
		"PLATTS - Refinery - India - Visakhapatnam - Visakhapatnam Refinery",
		871.36,
		955.61,
		169.36,
		40708.21,
		184.53,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Hindustan Petroleum_GAIL",
		"49_25.5_25.5",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFVEZPST-PFR",
		61.081674,
		-146.382092,
		"PLATTS - Refinery - United States - Valdez - Petro Star Inc.",
		null,
		null,
		null,
		null,
		null,
		93.05,
		97.57,
		30.08,
		3678.36,
		31.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45.49,
		null,
		6.27,
		2290.05,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		45.49,
		null,
		6.27,
		2290.05,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petro Star Inc.",
		"100",
		null,
		"Active",
		null,
		6.15,
		0,
		0,
		13.6,
		0,
		0,
		11.28440367,
		0,
		0,
		24.95412844,
		0,
		0,
		19.75,
	],
	[
		"REFVKYOFT-PFR",
		52.7165,
		37.2543,
		"PLATTS - Refinery - Russia - Verkhovsky - Orelneft",
		287.15,
		316.29,
		38.96,
		14162.06,
		42.86,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Orelneft",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFVRGERG-PFR",
		32.38768,
		-90.90827,
		"PLATTS - Refinery - United States - Vicksburg - Ergon",
		null,
		null,
		null,
		null,
		null,
		93.76,
		99.51,
		20.17,
		4550.78,
		21.37,
		13.12,
		null,
		1.95,
		711.36,
		null,
		0,
		null,
		0,
		0,
		null,
		24.01,
		null,
		3.45,
		1259.86,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		10.89,
		null,
		1.5,
		548.5,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Ergon",
		"100",
		null,
		"Active",
		null,
		3.86,
		1.38,
		0,
		0.53,
		-0.76,
		1.16,
		17.51361162,
		6.26134301,
		0,
		2.40471869,
		-3.44827586,
		5.26315789,
		6.18,
	],
	[
		"REFULEBNO-PFR",
		9,
		33,
		"PLATTS - Refinery - South Sudan - Upper Nile - Black Rhino",
		169.42,
		185.27,
		36.6,
		7745.81,
		39.38,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Black Rhino",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFVSAPOS-PFR",
		-25.386157,
		-57.604762,
		"PLATTS - Refinery - Paraguay - Villa Elisa - Petroleos Paraguayos",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		7.5,
		8.05,
		1.03,
		375,
		1.1,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Petroleos Paraguayos",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWAIPTC-PFR",
		37.5121,
		122.1153,
		"PLATTS - Refinery - China - Weihai - PetroChina",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		502.2,
		539.39,
		71.05,
		25130.84,
		76.27,
		"China National Petroleum Corp._PDVSA",
		"60_40",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUQIXUA-PFR",
		43.4198,
		87.3195,
		"PLATTS - Refinery - China - Urumqi - Xinjiang Tahua",
		null,
		null,
		null,
		null,
		null,
		149.58,
		161.71,
		32.07,
		7125.08,
		34.43,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xinjiang Tahua",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWAWWON-PFR",
		52.232,
		21.0067,
		"PLATTS - Refinery - Poland - Warsaw - Warter Aviation",
		null,
		null,
		null,
		null,
		null,
		1,
		1.04,
		0.14,
		50,
		0.14,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Warter Aviation",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFURILIB-PFR",
		26.5909,
		12.7696,
		"PLATTS - Refinery - Libya - Ubari - Libyan National Oil Company",
		30,
		32.69,
		4.11,
		1500,
		4.48,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWINHYE-PFR",
		53.61466,
		8.095722,
		"PLATTS - Refinery - Germany - Wilhelmshaven - Hes International",
		528.25,
		553.44,
		167.76,
		22190.16,
		175.88,
		103,
		107.42,
		15.55,
		5678.95,
		16.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Hes International",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWMAJNO-PFR",
		34.108254,
		135.115646,
		"PLATTS - Refinery - Japan - Wakayama - ENEOS",
		null,
		null,
		null,
		null,
		null,
		-0.04,
		-0.05,
		-0.05,
		-0.02,
		-0.05,
		0.08,
		null,
		0.01,
		4.39,
		null,
		1.68,
		null,
		0.25,
		90.89,
		null,
		90.81,
		null,
		12.31,
		4494.81,
		null,
		null,
		null,
		null,
		null,
		null,
		45.69,
		null,
		6.11,
		2229.62,
		null,
		4.57,
		null,
		0.59,
		217.07,
		null,
		35.6,
		null,
		4.91,
		1792.46,
		null,
		3.18,
		null,
		0.44,
		160.39,
		null,
		null,
		null,
		null,
		null,
		null,
		"ENEOS",
		"100",
		null,
		"Active",
		null,
		31.94,
		33.22,
		6.71,
		18.69,
		1.45,
		10.35,
		28.85536182,
		30.01174451,
		6.06197488,
		16.88499413,
		1.30996477,
		9.35043816,
		102.37,
	],
	[
		"REFWNGSHG-PFR",
		36.7072,
		119.1557,
		"PLATTS - Refinery - China - Weifang - Shandong Haihua Group",
		67,
		71.21,
		9.04,
		3299.18,
		9.59,
		153.76,
		165.37,
		22.69,
		8002.73,
		24.37,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"CNOOC_Shandong Local Investors",
		"51_49",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNDRE-PFR",
		9.9186,
		-85.1033,
		"PLATTS - Refinery - Dominica - Unknown - Dominica Refining Company",
		14,
		15.24,
		1.85,
		672.27,
		2,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNESS-PFR",
		26.7684,
		33.8114,
		"PLATTS - Refinery - Egypt - Unknown - Essar Oil",
		954.6,
		1046.02,
		325.6,
		36717,
		355.56,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"EGPC_Essar Oil",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFXANXEX-PFR",
		34.249655,
		108.885787,
		"PLATTS - Refinery - China - Xian - Xi'an Petrochem Complex",
		null,
		null,
		null,
		null,
		null,
		6,
		6.64,
		0.7,
		256.44,
		0.78,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYBUADE-PFR",
		23.960056,
		38.283906,
		"PLATTS - Refinery - Saudi Arabia - Yanbu - Air Liquide",
		null,
		null,
		null,
		null,
		null,
		262,
		281.26,
		262,
		262,
		281.26,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Liquide",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYINFPC-PFR",
		23.6991,
		120.5246,
		"PLATTS - Refinery - Taiwan - Yun-Lin - Formosa Petrochemical Co.",
		1588.62,
		1682.27,
		221.73,
		80935.39,
		234.8,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Formosa Petrochemical Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYNGYFU-PFR",
		33.40637016,
		120.10379546,
		"PLATTS - Refinery - China - Yancheng - Yancheng Lianfu",
		null,
		null,
		null,
		null,
		null,
		4.8,
		5.08,
		0.66,
		240,
		0.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yancheng Lianfu",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNLI3-PFR",
		35.9097,
		14.4362,
		"PLATTS - Refinery - Libya - Unknown - Libyan National Oil Company",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		161.1,
		176.36,
		40.26,
		6648.48,
		43.05,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Libyan National Oil Company",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFYONDIC-PFR",
		35.4815,
		127.4659,
		"PLATTS - Refinery - South Korea - Yocheon - Daelim Industrial Co.",
		null,
		null,
		null,
		null,
		null,
		2,
		2.15,
		0.24,
		86.29,
		0.25,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Daelim Industrial Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYSUGEX-PFR",
		34.853978,
		127.706795,
		"PLATTS - Refinery - South Korea - Yeosu - GS-Caltex - {Yeocheon}",
		101,
		105.96,
		15.58,
		5323.08,
		16.36,
		2224.73,
		2357.55,
		529.04,
		97844.43,
		560.04,
		86.5,
		null,
		12.86,
		4691.8,
		null,
		0,
		null,
		0,
		0,
		null,
		695.06,
		null,
		94.8,
		34604.96,
		null,
		null,
		null,
		null,
		null,
		null,
		445.48,
		null,
		59.56,
		21737.58,
		null,
		11.94,
		null,
		1.56,
		566.36,
		null,
		151.14,
		null,
		20.84,
		7609.22,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Chevron_GS",
		"50_50",
		null,
		"Active",
		null,
		289.02,
		139.58,
		12.12,
		132.76,
		17.5,
		125.98,
		39.92871353,
		19.28326702,
		1.67440318,
		18.34106985,
		2.41766136,
		17.40439876,
		716.96,
	],
	[
		"REFUWNMUM-PFR",
		48.2723,
		-121.7469,
		"PLATTS - Refinery - United States - Unknown - Marathon Petroleum",
		25,
		26.45,
		2.78,
		1013.89,
		2.94,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Marathon Petroleum",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNNI2-PFR",
		33.478,
		51.1496,
		"PLATTS - Refinery - Iran - Unknown - National Iranian Oil Co.",
		10,
		10.74,
		1.18,
		429.41,
		1.26,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFUWNNO2-PFR",
		-13.0054,
		20.4582,
		"PLATTS - Refinery - Angola - Unknown - NIOC",
		20,
		21.79,
		2.74,
		1000,
		2.99,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"NIOC",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFUWNUWN-PFR",
		12.2833,
		124.4487,
		"PLATTS - Refinery - Philippines - Unknown - Unknown",
		440.2,
		466.55,
		60.34,
		21951.52,
		63.91,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFVOVVOV-PFR",
		59.9276,
		32.3277,
		"PLATTS - Refinery - Russia - Volkhov - Volkhov-Eco - {Volkhovneftekhim}",
		75.05,
		82.3,
		9.97,
		3619.73,
		10.91,
		17.01,
		18.62,
		2.28,
		823.94,
		2.48,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.89,
		null,
		0.26,
		95.13,
		null,
		24.01,
		26.28,
		3.19,
		1160.64,
		3.5,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		1.89,
		null,
		0.26,
		95.13,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Volkhov-Eco",
		"100",
		null,
		"Active",
		null,
		0.6,
		0.31,
		0.98,
		0,
		0.03,
		0.04,
		30,
		15.5,
		49,
		0,
		1.5,
		2,
		1.96,
	],
	[
		"REFVRGBAC-PFR",
		32.285126,
		-90.919322,
		"PLATTS - Refinery - United States - Vicksburg - Barrett Refining Corp.",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Barrett Refining Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWACATS-PFR",
		33.78017,
		-118.2407,
		"PLATTS - Refinery - United States - Wilmington (CA) - Air Products",
		null,
		null,
		null,
		null,
		null,
		86,
		90.99,
		86,
		86,
		90.99,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Air Products",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWAYUWN-PFR",
		-22.9543,
		14.5075,
		"PLATTS - Refinery - Namibia - Walvis Bay - Unknown",
		982.45,
		1075.22,
		211.51,
		44273.24,
		227.51,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		"Unknown",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFWKEEES-PFR",
		30.241597,
		-93.275538,
		"PLATTS - Refinery - United States - Westlake - Excel Paralubes",
		null,
		null,
		null,
		null,
		null,
		124.44,
		130.68,
		18.64,
		6732.62,
		19.58,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ConocoPhillips_Koch Industries",
		"50_50",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWLESUN-PFR",
		39.8667,
		-75.15318,
		"PLATTS - Refinery - United States - Westville - Sunoco",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0.01,
		-0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sunoco",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWNTKNR-PFR",
		48.113043,
		-105.51677,
		"PLATTS - Refinery - United States - Wolf Point - Kenco Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Kenco Refining",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWSSSLV-PFR",
		40.86656,
		-111.91,
		"PLATTS - Refinery - United States - Woods Cross - Silver Eagle Refining",
		null,
		null,
		null,
		null,
		null,
		27.71,
		29.14,
		3.79,
		1382.41,
		3.98,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.62,
		null,
		0.78,
		283.88,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		5.62,
		null,
		0.78,
		283.88,
		null,
		null,
		null,
		null,
		null,
		null,
		"Silver Eagle Refining",
		"100",
		null,
		"Active",
		null,
		1.79,
		0.73,
		1.53,
		0,
		-0.11,
		0,
		28.91760905,
		11.79321486,
		24.71728595,
		0,
		-1.77705977,
		0,
		3.93,
	],
	[
		"REFWTTRNG-PFR",
		31.563002,
		-103.015019,
		"PLATTS - Refinery - United States - Wickett - Rattlesnake Refining",
		null,
		null,
		null,
		null,
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Three B Oil Co.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFWUNWOC-PFR",
		30.652331,
		114.429014,
		"PLATTS - Refinery - China - Wuhan - Wuhan Phoenix Co.",
		null,
		null,
		null,
		null,
		null,
		601.26,
		651.89,
		125.09,
		27969.47,
		134.52,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		115.06,
		null,
		15.79,
		5764.23,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		11.51,
		null,
		1.5,
		546.11,
		null,
		69.03,
		null,
		9.52,
		3475.54,
		null,
		34.52,
		null,
		4.77,
		1742.58,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		64.41,
		52.03,
		1.24,
		12.62,
		15.33,
		15.52,
		39.73473165,
		32.0974707,
		0.7649599,
		7.78531771,
		9.45712523,
		9.57433683,
		161.15,
	],
	[
		"REFXENDCS-PFR",
		24.4801,
		118.0853,
		"PLATTS - Refinery - China - Xiamen - Dragon Aromatics",
		90,
		95.22,
		10.59,
		3864.71,
		11.2,
		555.2,
		597.18,
		174.36,
		19886.64,
		185.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Xiang Lu Group",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYBUSEF-PFR",
		23.94383,
		38.315366,
		"PLATTS - Refinery - Saudi Arabia - Yanbu - SAMREF - {Saudi Aramco Mobil Refinery Company}",
		58,
		65.12,
		8.52,
		3108.92,
		9.56,
		1172.72,
		1283.04,
		196.28,
		55778.8,
		213.92,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		352.82,
		null,
		48.66,
		17762.7,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		352.82,
		null,
		48.66,
		17762.7,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"ExxonMobil_Saudi Aramco",
		"50_50",
		null,
		"Active",
		null,
		118.96,
		138.02,
		70.7,
		37.08,
		-2.46,
		23.9,
		29.7995992,
		34.5741483,
		17.71042084,
		9.28857715,
		-0.61623246,
		5.98697395,
		386.22,
	],
	[
		"REFYBUYEF-PFR",
		23.963979,
		38.281357,
		"PLATTS - Refinery - Saudi Arabia - Yanbu - YASREF - {Yanbu Aramco Sinopec Refining Company}",
		null,
		null,
		null,
		null,
		null,
		1220.5,
		1340.18,
		175.78,
		61424.89,
		192.76,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		331.31,
		null,
		45.7,
		16679.84,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		331.31,
		null,
		45.7,
		16679.84,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Saudi Aramco_Sinopec",
		"62.5_37.5",
		null,
		"Active",
		null,
		201.39,
		95.65,
		8.91,
		35.92,
		25.53,
		6.37,
		53.72119078,
		25.51483141,
		2.37676056,
		9.58173282,
		6.81017926,
		1.69921041,
		373.76,
	],
	[
		"REFYENPTC-PFR",
		39.824779,
		97.558566,
		"PLATTS - Refinery - China - Yumen - PetroChina",
		null,
		null,
		null,
		null,
		null,
		183.96,
		199.26,
		30.3,
		9147.73,
		32.71,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		47.21,
		null,
		6.53,
		2383.49,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		47.21,
		null,
		6.53,
		2383.49,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		16.7,
		12.3,
		0.52,
		3.51,
		6.94,
		6.51,
		32.09686719,
		23.64020757,
		0.99942341,
		6.74610801,
		13.33845858,
		12.5120123,
		46.48,
	],
	[
		"REFYHICOS-PFR",
		34.969373,
		136.64381,
		"PLATTS - Refinery - Japan - Yokkaichi - Cosmo Oil",
		null,
		null,
		null,
		null,
		null,
		389.11,
		411.28,
		84.23,
		17960.56,
		88.7,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		61.35,
		null,
		8.28,
		3024.14,
		null,
		null,
		null,
		null,
		null,
		null,
		38.16,
		null,
		5.1,
		1861.97,
		null,
		1.98,
		null,
		0.25,
		93.96,
		null,
		21.21,
		null,
		2.93,
		1068.21,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Mubadala Investment Company",
		"20.8",
		null,
		"Active",
		null,
		17.31,
		18.13,
		6.57,
		12.79,
		6.89,
		7.85,
		23.07692308,
		24.17011065,
		8.75883216,
		17.05105986,
		9.18544194,
		10.4652713,
		69.56,
	],
	[
		"REFYHISKK-PFR",
		34.933916,
		136.633894,
		"PLATTS - Refinery - Japan - Yokkaichi - Showa Yokkaichi Sekiyu K.K.",
		null,
		null,
		null,
		null,
		null,
		748.52,
		792.91,
		101.75,
		37046.23,
		107.84,
		1,
		null,
		0.15,
		54.24,
		null,
		1,
		null,
		0.15,
		54.16,
		null,
		176.75,
		null,
		24.01,
		8763.42,
		null,
		null,
		null,
		null,
		null,
		null,
		85,
		null,
		11.36,
		4147.74,
		null,
		4,
		null,
		0.52,
		189.85,
		null,
		79.54,
		null,
		10.97,
		4004.2,
		null,
		6.2,
		null,
		0.85,
		313.24,
		null,
		null,
		null,
		null,
		null,
		null,
		"Showa Shell_Mitsubishi_Other Investors",
		"75_20_5",
		null,
		"Active",
		null,
		47.19,
		80.39,
		28.61,
		36.99,
		-6.34,
		14.12,
		21.8786221,
		37.2710835,
		13.26440725,
		17.14961287,
		-2.93940377,
		6.54643238,
		200.97,
	],
	[
		"REFYKKYRY-PFR",
		62.0273,
		129.7321,
		"PLATTS - Refinery - Russia - Yakutsk - Yakutsk Refinery",
		null,
		null,
		null,
		null,
		null,
		10,
		10.74,
		1.37,
		500,
		1.47,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yakutsk Refinery",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYLNYUP-PFR",
		37.58225,
		108.82824,
		"PLATTS - Refinery - China - Yulin - Yanchang Petroleum Group",
		null,
		null,
		null,
		null,
		null,
		485,
		519.98,
		101.81,
		21733.24,
		108.66,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		88.12,
		null,
		12.19,
		4448.46,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		88.12,
		null,
		12.19,
		4448.46,
		null,
		null,
		null,
		null,
		null,
		null,
		"Yanchang Petroleum Group",
		"100",
		null,
		"Active",
		null,
		35.03,
		28.92,
		4.49,
		6.89,
		12.17,
		13.42,
		34.05599844,
		28.11588567,
		4.36515652,
		6.69842504,
		11.83161579,
		13.04685981,
		100.92,
	],
	[
		"REFYMAAFC-PFR",
		32.6651,
		-114.476,
		"PLATTS - Refinery - United States - Yuma - Arizona Fuels Corp.",
		609.21,
		640.72,
		187.96,
		24115.94,
		198.32,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Arizona Fuels Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFYMISSK-PFR",
		33.940866,
		131.183642,
		"PLATTS - Refinery - Japan - Yamaguchi - Seibu Sekiyu K.K. - {Ube}",
		null,
		null,
		null,
		null,
		null,
		-0.01,
		0.04,
		0.03,
		0.07,
		-0.12,
		0.08,
		null,
		0,
		3.73,
		null,
		1.42,
		null,
		0.21,
		77.19,
		null,
		76.61,
		null,
		10.39,
		3793.03,
		null,
		null,
		null,
		null,
		null,
		null,
		38,
		null,
		5.08,
		1854.28,
		null,
		3.89,
		null,
		0.5,
		184.33,
		null,
		30.24,
		null,
		4.17,
		1522.07,
		null,
		3,
		null,
		0.42,
		151.45,
		null,
		null,
		null,
		null,
		null,
		null,
		"Other Investors_Idemitsu Kosan Company_Ube Kosan_Chubu Electric",
		"40.2_38_11_10.8",
		null,
		"Active",
		null,
		20.9,
		26.71,
		6.54,
		17.03,
		8.9,
		5.21,
		22.13279678,
		28.28550249,
		6.92576512,
		18.03452293,
		9.42497088,
		5.51731441,
		85.3,
	],
	[
		"REFYSKNIS-PFR",
		56.12277,
		86.13939,
		"PLATTS - Refinery - Russia - Yaisk - Neftekhimservis - {Yaya - Yeisk}",
		42.54,
		46.27,
		6.99,
		2355.42,
		7.6,
		193.89,
		212.75,
		39.01,
		9109.46,
		42.49,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		54,
		null,
		7.45,
		2718.62,
		null,
		90,
		98.1,
		12.25,
		4471.75,
		13.35,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		54,
		null,
		7.45,
		2718.62,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Neftekhimservis",
		"100",
		null,
		"Active",
		null,
		16.07,
		0,
		23.67,
		0,
		0.5,
		11.75,
		28.75805297,
		0,
		42.35862563,
		0,
		0.89477452,
		21.02720115,
		51.99,
	],
	[
		"REFYUGBRC-PFR",
		29.49899699,
		113.32468326,
		"PLATTS - Refinery - China - Yueyang - Baling Refining and Chemical Co.Ltd.",
		80,
		84.64,
		10.96,
		4000,
		11.59,
		258.2,
		280.32,
		36.06,
		13123.68,
		39.19,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		44.46,
		null,
		6.15,
		2244.6,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		44.46,
		null,
		6.15,
		2244.6,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		15.35,
		17.19,
		13.15,
		4.18,
		7.51,
		7,
		23.73222016,
		26.57699443,
		20.33085962,
		6.46258503,
		11.61100804,
		10.82251082,
		64.4,
	],
	[
		"REFYSNYPC-PFR",
		39.911158,
		116.186332,
		"PLATTS - Refinery - China - Yanshan - Yanshan Petrochemical Corp.",
		null,
		null,
		null,
		null,
		null,
		996.17,
		1075.06,
		216.49,
		45333.44,
		231.94,
		45.75,
		null,
		6.8,
		2481.24,
		null,
		17.5,
		null,
		2.6,
		947.7,
		null,
		157,
		null,
		22.2,
		8104.73,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		17.5,
		null,
		2.28,
		830.62,
		null,
		30.5,
		null,
		4.21,
		1535.52,
		null,
		45.75,
		null,
		6.33,
		2309.65,
		null,
		null,
		null,
		null,
		null,
		null,
		"Sinopec",
		"100",
		null,
		"Active",
		null,
		57.42,
		57.94,
		2.53,
		37.35,
		16.41,
		3.45,
		30.44861597,
		30.72436101,
		1.34160568,
		19.80591791,
		8.70187719,
		1.8294623,
		175.09,
	],
	[
		"REFYVLSFT-PFR",
		57.557526,
		39.785123,
		"PLATTS - Refinery - Russia - Yaroslavl - Slavneft - {Yanos}",
		49.49,
		55.57,
		6.56,
		2218.29,
		7.34,
		1020.85,
		1116.41,
		275.81,
		43925.46,
		298.87,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		295,
		null,
		40.68,
		14851.72,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		295,
		null,
		40.68,
		14851.72,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Gazprom_Rosneft_Tyumen Oil",
		"50_25_25",
		null,
		"Active",
		null,
		81.91,
		61.37,
		74.07,
		21.48,
		16.76,
		16.36,
		27.11802682,
		20.31782817,
		24.52243006,
		7.1114054,
		5.54875021,
		5.4163218,
		271.93,
	],
	[
		"REFZBOHPC-PFR",
		36.89795045,
		118.095989,
		"PLATTS - Refinery - China - Zibo - Huifeng Petrochemical - {Wonfull Petrochemical}",
		null,
		null,
		null,
		null,
		null,
		290.9,
		314.86,
		57.71,
		13420.2,
		62.02,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Huifeng Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZAIHUF-PFR",
		21.97899712,
		113.21581471,
		"PLATTS - Refinery - China - Zhuhai - Huafeng Petrochemical",
		null,
		null,
		null,
		null,
		null,
		73,
		78.34,
		10.62,
		3873.65,
		11.39,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Huafeng Petrochemical",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZHNZAL-PFR",
		29.9873,
		122.203,
		"PLATTS - Refinery - China - Zhoushan - Zhejiang Petrochemical",
		null,
		null,
		null,
		null,
		null,
		2100.6,
		2270.4,
		285.23,
		103525.08,
		308.24,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		438.9,
		null,
		60.66,
		22142.19,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		109.73,
		null,
		15.13,
		5524.09,
		null,
		329.18,
		null,
		45.53,
		16618.1,
		null,
		null,
		null,
		null,
		null,
		null,
		"Rongsheng Petrochemical_Saudi Aramco",
		"91_9",
		null,
		"Active",
		null,
		27.37,
		0,
		48.43,
		8.92,
		0.59,
		22.37,
		23,
		0,
		40.69747899,
		7.49579832,
		0.49579832,
		18.79831933,
		107.69,
	],
	[
		"REFZAIPTC-PFR",
		22.2305,
		113.5462,
		"PLATTS - Refinery - China - Zhuhai - PetroChina",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		677,
		727.43,
		180.09,
		28823.21,
		192.04,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFZPUPTC-PFR",
		38.06295434,
		77.17726941,
		"PLATTS - Refinery - China - Zepu - PetroChina",
		null,
		null,
		null,
		null,
		null,
		15.4,
		16.52,
		2.05,
		745.37,
		2.18,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp.",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZERPTC-PFR",
		14.186533,
		8.78512,
		"PLATTS - Refinery - Niger - Zinder - PetroChina",
		null,
		null,
		null,
		null,
		null,
		61.34,
		67.24,
		8.52,
		3095.17,
		9.34,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		1.95,
		711.97,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		15,
		null,
		1.95,
		711.97,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"China National Petroleum Corp._Gov. of Niger",
		"60_40",
		null,
		"Active",
		null,
		4.78,
		5.72,
		2.06,
		1.4,
		1.03,
		0,
		31.86666667,
		38.13333333,
		13.73333333,
		9.33333333,
		6.86666667,
		0,
		15,
	],
	[
		"REFZHGTYI-PFR",
		22.5214,
		113.3656,
		"PLATTS - Refinery - China - Zhongshan - Tianyi",
		null,
		null,
		null,
		null,
		null,
		55.32,
		58.93,
		8.28,
		2904.37,
		8.83,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Tianyi",
		"100",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
	[
		"REFZIAPDV-PFR",
		10.46734925,
		-71.9540226,
		"PLATTS - Refinery - Venezuela - Zulia - PDVSA",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		800.37,
		875.52,
		223.85,
		33879.57,
		242.46,
		"PDVSA",
		"100",
		null,
		"Active",
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	],
	[
		"REFZTZHHG-PFR",
		51.07119,
		12.200557,
		"PLATTS - Refinery - Germany - Zeitz - Hydrierwerke Zeitz Gmbh.",
		null,
		null,
		null,
		null,
		null,
		-0.01,
		-0.02,
		0,
		-0.01,
		-0.01,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		0,
		null,
		0,
		0,
		null,
		null,
		null,
		null,
		null,
		null,
		"Elf_Thyssen Handelsunion",
		"66.66_33.34",
		null,
		"Active",
		null,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
	],
];

const arrayLen = PlattsData.length;
const index_1_to_60_perc = Math.round(arrayLen * 0.6);
const index_40_to_100_perc = Math.round(arrayLen * 0.4);

export const PlattsData_1_60 = PlattsData.slice(0, index_1_to_60_perc);
export const PlattsData_40_100 = PlattsData.slice(index_40_to_100_perc);
